"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn2, res) => function __init() {
  return fn2 && (res = (0, fn2[__getOwnPropNames(fn2)[0]])(fn2 = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// node_modules/tsup/assets/cjs_shims.js
var init_cjs_shims = __esm({
  "node_modules/tsup/assets/cjs_shims.js"() {
  }
});

// ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";
    init_cjs_shims();
    var b = "function" === typeof Symbol && Symbol.for;
    var c = b ? Symbol.for("react.element") : 60103;
    var d = b ? Symbol.for("react.portal") : 60106;
    var e = b ? Symbol.for("react.fragment") : 60107;
    var f = b ? Symbol.for("react.strict_mode") : 60108;
    var g = b ? Symbol.for("react.profiler") : 60114;
    var h = b ? Symbol.for("react.provider") : 60109;
    var k = b ? Symbol.for("react.context") : 60110;
    var l = b ? Symbol.for("react.async_mode") : 60111;
    var m = b ? Symbol.for("react.concurrent_mode") : 60111;
    var n = b ? Symbol.for("react.forward_ref") : 60112;
    var p = b ? Symbol.for("react.suspense") : 60113;
    var q = b ? Symbol.for("react.suspense_list") : 60120;
    var r = b ? Symbol.for("react.memo") : 60115;
    var t = b ? Symbol.for("react.lazy") : 60116;
    var v = b ? Symbol.for("react.block") : 60121;
    var w = b ? Symbol.for("react.fundamental") : 60117;
    var x = b ? Symbol.for("react.responder") : 60118;
    var y = b ? Symbol.for("react.scope") : 60119;
    function z(a) {
      if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch (u) {
          case c:
            switch (a = a.type, a) {
              case l:
              case m:
              case e:
              case g:
              case f:
              case p:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case k:
                  case n:
                  case t:
                  case r:
                  case h:
                    return a;
                  default:
                    return u;
                }
            }
          case d:
            return u;
        }
      }
    }
    function A(a) {
      return z(a) === m;
    }
    exports.AsyncMode = l;
    exports.ConcurrentMode = m;
    exports.ContextConsumer = k;
    exports.ContextProvider = h;
    exports.Element = c;
    exports.ForwardRef = n;
    exports.Fragment = e;
    exports.Lazy = t;
    exports.Memo = r;
    exports.Portal = d;
    exports.Profiler = g;
    exports.StrictMode = f;
    exports.Suspense = p;
    exports.isAsyncMode = function(a) {
      return A(a) || z(a) === l;
    };
    exports.isConcurrentMode = A;
    exports.isContextConsumer = function(a) {
      return z(a) === k;
    };
    exports.isContextProvider = function(a) {
      return z(a) === h;
    };
    exports.isElement = function(a) {
      return "object" === typeof a && null !== a && a.$$typeof === c;
    };
    exports.isForwardRef = function(a) {
      return z(a) === n;
    };
    exports.isFragment = function(a) {
      return z(a) === e;
    };
    exports.isLazy = function(a) {
      return z(a) === t;
    };
    exports.isMemo = function(a) {
      return z(a) === r;
    };
    exports.isPortal = function(a) {
      return z(a) === d;
    };
    exports.isProfiler = function(a) {
      return z(a) === g;
    };
    exports.isStrictMode = function(a) {
      return z(a) === f;
    };
    exports.isSuspense = function(a) {
      return z(a) === p;
    };
    exports.isValidElementType = function(a) {
      return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    };
    exports.typeOf = z;
  }
});

// ../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    init_cjs_shims();
    if (process.env.NODE_ENV !== "production") {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object2) {
          if (typeof object2 === "object" && object2 !== null) {
            var $$typeof = object2.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object2.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element3 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment22 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal2 = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object2) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object2) {
          return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object2) {
          return typeOf(object2) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object2) {
          return typeOf(object2) === REACT_PROVIDER_TYPE;
        }
        function isElement2(object2) {
          return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object2) {
          return typeOf(object2) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object2) {
          return typeOf(object2) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object2) {
          return typeOf(object2) === REACT_LAZY_TYPE;
        }
        function isMemo(object2) {
          return typeOf(object2) === REACT_MEMO_TYPE;
        }
        function isPortal(object2) {
          return typeOf(object2) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object2) {
          return typeOf(object2) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object2) {
          return typeOf(object2) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object2) {
          return typeOf(object2) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element3;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment22;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal2;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement2;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/prop-types/node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/prop-types/node_modules/react-is/index.js"(exports, module2) {
    "use strict";
    init_cjs_shims();
    if (process.env.NODE_ENV === "production") {
      module2.exports = require_react_is_production_min();
    } else {
      module2.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../../node_modules/object-assign/index.js"(exports, module2) {
    "use strict";
    init_cjs_shims();
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module2.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module2) {
    "use strict";
    init_cjs_shims();
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module2.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "../../node_modules/prop-types/lib/has.js"(exports, module2) {
    init_cjs_shims();
    module2.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "../../node_modules/prop-types/checkPropTypes.js"(exports, module2) {
    "use strict";
    init_cjs_shims();
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has4 = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has4;
    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (process.env.NODE_ENV !== "production") {
        for (var typeSpecName in typeSpecs) {
          if (has4(typeSpecs, typeSpecName)) {
            var error2;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error2 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error2 = ex;
            }
            if (error2 && !(error2 instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
              loggedTypeFailures[error2.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location + " type: " + error2.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (process.env.NODE_ENV !== "production") {
        loggedTypeFailures = {};
      }
    };
    module2.exports = checkPropTypes;
  }
});

// ../../node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "../../node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module2) {
    "use strict";
    init_cjs_shims();
    var ReactIs = require_react_is();
    var assign = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has4 = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module2.exports = function(isValidElement, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x, y) {
        if (x === y) {
          return x !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== "production") {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error2 = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error2 instanceof Error) {
              return error2;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== "production") {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has4(propValue, key)) {
              var error2 = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error2 instanceof Error) {
                return error2;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has4(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error2) {
              return error2;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has4(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error2) {
              return error2;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/factoryWithThrowingShims.js
var require_factoryWithThrowingShims = __commonJS({
  "../../node_modules/prop-types/factoryWithThrowingShims.js"(exports, module2) {
    "use strict";
    init_cjs_shims();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    function emptyFunction() {
    }
    function emptyFunctionWithReset() {
    }
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    module2.exports = function() {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
          return;
        }
        var err = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        err.name = "Invariant Violation";
        throw err;
      }
      ;
      shim.isRequired = shim;
      function getShim() {
        return shim;
      }
      ;
      var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/prop-types/index.js"(exports, module2) {
    init_cjs_shims();
    if (process.env.NODE_ENV !== "production") {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module2.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module2.exports = require_factoryWithThrowingShims()();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// ../../node_modules/classnames/index.js
var require_classnames = __commonJS({
  "../../node_modules/classnames/index.js"(exports, module2) {
    init_cjs_shims();
    (function() {
      "use strict";
      var hasOwn = {}.hasOwnProperty;
      var nativeCodeString = "[native code]";
      function classNames2() {
        var classes = [];
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (!arg)
            continue;
          var argType = typeof arg;
          if (argType === "string" || argType === "number") {
            classes.push(arg);
          } else if (Array.isArray(arg)) {
            if (arg.length) {
              var inner = classNames2.apply(null, arg);
              if (inner) {
                classes.push(inner);
              }
            }
          } else if (argType === "object") {
            if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
              classes.push(arg.toString());
              continue;
            }
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          }
        }
        return classes.join(" ");
      }
      if (typeof module2 !== "undefined" && module2.exports) {
        classNames2.default = classNames2;
        module2.exports = classNames2;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("classnames", [], function() {
          return classNames2;
        });
      } else {
        window.classNames = classNames2;
      }
    })();
  }
});

// ../../node_modules/react-popper/node_modules/react-fast-compare/index.js
var require_react_fast_compare = __commonJS({
  "../../node_modules/react-popper/node_modules/react-fast-compare/index.js"(exports, module2) {
    init_cjs_shims();
    var hasElementType = typeof Element !== "undefined";
    var hasMap = typeof Map === "function";
    var hasSet = typeof Set === "function";
    var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
    function equal(a, b) {
      if (a === b)
        return true;
      if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor)
          return false;
        var length, i, keys;
        if (Array.isArray(a)) {
          length = a.length;
          if (length != b.length)
            return false;
          for (i = length; i-- !== 0; )
            if (!equal(a[i], b[i]))
              return false;
          return true;
        }
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
          if (a.size !== b.size)
            return false;
          it = a.entries();
          while (!(i = it.next()).done)
            if (!b.has(i.value[0]))
              return false;
          it = a.entries();
          while (!(i = it.next()).done)
            if (!equal(i.value[1], b.get(i.value[0])))
              return false;
          return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
          if (a.size !== b.size)
            return false;
          it = a.entries();
          while (!(i = it.next()).done)
            if (!b.has(i.value[0]))
              return false;
          return true;
        }
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
          length = a.length;
          if (length != b.length)
            return false;
          for (i = length; i-- !== 0; )
            if (a[i] !== b[i])
              return false;
          return true;
        }
        if (a.constructor === RegExp)
          return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf)
          return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString)
          return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length)
          return false;
        for (i = length; i-- !== 0; )
          if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
            return false;
        if (hasElementType && a instanceof Element)
          return false;
        for (i = length; i-- !== 0; ) {
          if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) {
            continue;
          }
          if (!equal(a[keys[i]], b[keys[i]]))
            return false;
        }
        return true;
      }
      return a !== a && b !== b;
    }
    module2.exports = function isEqual2(a, b) {
      try {
        return equal(a, b);
      } catch (error2) {
        if ((error2.message || "").match(/stack|recursion/i)) {
          console.warn("react-fast-compare cannot handle circular refs");
          return false;
        }
        throw error2;
      }
    };
  }
});

// ../../node_modules/warning/warning.js
var require_warning = __commonJS({
  "../../node_modules/warning/warning.js"(exports, module2) {
    "use strict";
    init_cjs_shims();
    var __DEV__ = process.env.NODE_ENV !== "production";
    var warning2 = function() {
    };
    if (__DEV__) {
      printWarning = function printWarning2(format2, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for (var key = 1; key < len; key++) {
          args[key - 1] = arguments[key];
        }
        var argIndex = 0;
        var message = "Warning: " + format2.replace(/%s/g, function() {
          return args[argIndex++];
        });
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
      warning2 = function(condition, format2, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for (var key = 2; key < len; key++) {
          args[key - 2] = arguments[key];
        }
        if (format2 === void 0) {
          throw new Error(
            "`warning(condition, format, ...args)` requires a warning message argument"
          );
        }
        if (!condition) {
          printWarning.apply(null, [format2].concat(args));
        }
      };
    }
    var printWarning;
    module2.exports = warning2;
  }
});

// ../../node_modules/@babel/runtime/helpers/extends.js
var require_extends = __commonJS({
  "../../node_modules/@babel/runtime/helpers/extends.js"(exports, module2) {
    init_cjs_shims();
    function _extends14() {
      module2.exports = _extends14 = Object.assign ? Object.assign.bind() : function(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
      return _extends14.apply(this, arguments);
    }
    module2.exports = _extends14, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js
var require_objectWithoutPropertiesLoose = __commonJS({
  "../../node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js"(exports, module2) {
    init_cjs_shims();
    function _objectWithoutPropertiesLoose5(source, excluded) {
      if (source == null)
        return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;
      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0)
          continue;
        target[key] = source[key];
      }
      return target;
    }
    module2.exports = _objectWithoutPropertiesLoose5, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.esm.js
var import_react4, index, use_isomorphic_layout_effect_esm_default;
var init_use_isomorphic_layout_effect_esm = __esm({
  "../../node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.esm.js"() {
    init_cjs_shims();
    import_react4 = require("react");
    index = typeof document !== "undefined" ? import_react4.useLayoutEffect : import_react4.useEffect;
    use_isomorphic_layout_effect_esm_default = index;
  }
});

// ../../node_modules/use-latest/dist/use-latest.esm.js
var use_latest_esm_exports = {};
__export(use_latest_esm_exports, {
  default: () => useLatest
});
var React9, useLatest;
var init_use_latest_esm = __esm({
  "../../node_modules/use-latest/dist/use-latest.esm.js"() {
    init_cjs_shims();
    React9 = __toESM(require("react"));
    init_use_isomorphic_layout_effect_esm();
    useLatest = function useLatest2(value) {
      var ref = React9.useRef(value);
      use_isomorphic_layout_effect_esm_default(function() {
        ref.current = value;
      });
      return ref;
    };
  }
});

// ../../node_modules/use-composed-ref/dist/use-composed-ref.esm.js
var use_composed_ref_esm_exports = {};
__export(use_composed_ref_esm_exports, {
  default: () => use_composed_ref_esm_default
});
var import_react5, updateRef, useComposedRef, use_composed_ref_esm_default;
var init_use_composed_ref_esm = __esm({
  "../../node_modules/use-composed-ref/dist/use-composed-ref.esm.js"() {
    init_cjs_shims();
    import_react5 = require("react");
    updateRef = function updateRef2(ref, value) {
      if (typeof ref === "function") {
        ref(value);
        return;
      }
      ref.current = value;
    };
    useComposedRef = function useComposedRef2(libRef, userRef) {
      var prevUserRef = (0, import_react5.useRef)();
      return (0, import_react5.useCallback)(function(instance) {
        libRef.current = instance;
        if (prevUserRef.current) {
          updateRef(prevUserRef.current, null);
        }
        prevUserRef.current = userRef;
        if (!userRef) {
          return;
        }
        updateRef(userRef, instance);
      }, [userRef]);
    };
    use_composed_ref_esm_default = useComposedRef;
  }
});

// ../../node_modules/react-textarea-autosize/dist/react-textarea-autosize.cjs.prod.js
var require_react_textarea_autosize_cjs_prod = __commonJS({
  "../../node_modules/react-textarea-autosize/dist/react-textarea-autosize.cjs.prod.js"(exports) {
    "use strict";
    init_cjs_shims();
    Object.defineProperty(exports, "__esModule", { value: true });
    var _extends14 = require_extends();
    var _objectWithoutPropertiesLoose5 = require_objectWithoutPropertiesLoose();
    var React92 = require("react");
    var useLatest3 = (init_use_latest_esm(), __toCommonJS(use_latest_esm_exports));
    var useComposedRef3 = (init_use_composed_ref_esm(), __toCommonJS(use_composed_ref_esm_exports));
    function _interopDefault(e) {
      return e && e.__esModule ? e : { "default": e };
    }
    var useLatest__default = /* @__PURE__ */ _interopDefault(useLatest3);
    var useComposedRef__default = /* @__PURE__ */ _interopDefault(useComposedRef3);
    var HIDDEN_TEXTAREA_STYLE = {
      "min-height": "0",
      "max-height": "none",
      height: "0",
      visibility: "hidden",
      overflow: "hidden",
      position: "absolute",
      "z-index": "-1000",
      top: "0",
      right: "0"
    };
    var forceHiddenStyles = function forceHiddenStyles2(node) {
      Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function(key) {
        node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], "important");
      });
    };
    var hiddenTextarea = null;
    var getHeight = function getHeight2(node, sizingData) {
      var height = node.scrollHeight;
      if (sizingData.sizingStyle.boxSizing === "border-box") {
        return height + sizingData.borderSize;
      }
      return height - sizingData.paddingSize;
    };
    function calculateNodeHeight(sizingData, value, minRows, maxRows) {
      if (minRows === void 0) {
        minRows = 1;
      }
      if (maxRows === void 0) {
        maxRows = Infinity;
      }
      if (!hiddenTextarea) {
        hiddenTextarea = document.createElement("textarea");
        hiddenTextarea.setAttribute("tabindex", "-1");
        hiddenTextarea.setAttribute("aria-hidden", "true");
        forceHiddenStyles(hiddenTextarea);
      }
      if (hiddenTextarea.parentNode === null) {
        document.body.appendChild(hiddenTextarea);
      }
      var paddingSize = sizingData.paddingSize, borderSize = sizingData.borderSize, sizingStyle = sizingData.sizingStyle;
      var boxSizing = sizingStyle.boxSizing;
      Object.keys(sizingStyle).forEach(function(_key) {
        var key = _key;
        hiddenTextarea.style[key] = sizingStyle[key];
      });
      forceHiddenStyles(hiddenTextarea);
      hiddenTextarea.value = value;
      var height = getHeight(hiddenTextarea, sizingData);
      hiddenTextarea.value = "x";
      var rowHeight = hiddenTextarea.scrollHeight - paddingSize;
      var minHeight = rowHeight * minRows;
      if (boxSizing === "border-box") {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
      var maxHeight = rowHeight * maxRows;
      if (boxSizing === "border-box") {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      height = Math.min(maxHeight, height);
      return [height, rowHeight];
    }
    var noop4 = function noop5() {
    };
    var pick2 = function pick3(props, obj) {
      return props.reduce(function(acc, prop) {
        acc[prop] = obj[prop];
        return acc;
      }, {});
    };
    var SIZING_STYLE = [
      "borderBottomWidth",
      "borderLeftWidth",
      "borderRightWidth",
      "borderTopWidth",
      "boxSizing",
      "fontFamily",
      "fontSize",
      "fontStyle",
      "fontWeight",
      "letterSpacing",
      "lineHeight",
      "paddingBottom",
      "paddingLeft",
      "paddingRight",
      "paddingTop",
      "tabSize",
      "textIndent",
      "textRendering",
      "textTransform",
      "width",
      "wordBreak"
    ];
    var isIE = typeof document !== "undefined" ? !!document.documentElement.currentStyle : false;
    var getSizingData = function getSizingData2(node) {
      var style = window.getComputedStyle(node);
      if (style === null) {
        return null;
      }
      var sizingStyle = pick2(SIZING_STYLE, style);
      var boxSizing = sizingStyle.boxSizing;
      if (boxSizing === "") {
        return null;
      }
      if (isIE && boxSizing === "border-box") {
        sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + "px";
      }
      var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
      var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
      return {
        sizingStyle,
        paddingSize,
        borderSize
      };
    };
    var useWindowResizeListener = function useWindowResizeListener2(listener) {
      var latestListener = useLatest__default["default"](listener);
      React92.useLayoutEffect(function() {
        var handler = function handler2(event) {
          latestListener.current(event);
        };
        window.addEventListener("resize", handler);
        return function() {
          window.removeEventListener("resize", handler);
        };
      }, []);
    };
    var TextareaAutosize2 = function TextareaAutosize3(_ref, userRef) {
      var cacheMeasurements = _ref.cacheMeasurements, maxRows = _ref.maxRows, minRows = _ref.minRows, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? noop4 : _ref$onChange, _ref$onHeightChange = _ref.onHeightChange, onHeightChange = _ref$onHeightChange === void 0 ? noop4 : _ref$onHeightChange, props = _objectWithoutPropertiesLoose5(_ref, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]);
      var isControlled = props.value !== void 0;
      var libRef = React92.useRef(null);
      var ref = useComposedRef__default["default"](libRef, userRef);
      var heightRef = React92.useRef(0);
      var measurementsCacheRef = React92.useRef();
      var resizeTextarea = function resizeTextarea2() {
        var node = libRef.current;
        var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : getSizingData(node);
        if (!nodeSizingData) {
          return;
        }
        measurementsCacheRef.current = nodeSizingData;
        var _calculateNodeHeight = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || "x", minRows, maxRows), height = _calculateNodeHeight[0], rowHeight = _calculateNodeHeight[1];
        if (heightRef.current !== height) {
          heightRef.current = height;
          node.style.setProperty("height", height + "px", "important");
          onHeightChange(height, {
            rowHeight
          });
        }
      };
      var handleChange = function handleChange2(event) {
        if (!isControlled) {
          resizeTextarea();
        }
        onChange(event);
      };
      if (typeof document !== "undefined") {
        React92.useLayoutEffect(resizeTextarea);
        useWindowResizeListener(resizeTextarea);
      }
      return /* @__PURE__ */ React92.createElement("textarea", _extends14({}, props, {
        onChange: handleChange,
        ref
      }));
    };
    var index2 = /* @__PURE__ */ React92.forwardRef(TextareaAutosize2);
    exports.default = index2;
  }
});

// ../../node_modules/react-textarea-autosize/dist/react-textarea-autosize.cjs.dev.js
var require_react_textarea_autosize_cjs_dev = __commonJS({
  "../../node_modules/react-textarea-autosize/dist/react-textarea-autosize.cjs.dev.js"(exports) {
    "use strict";
    init_cjs_shims();
    Object.defineProperty(exports, "__esModule", { value: true });
    var _extends14 = require_extends();
    var _objectWithoutPropertiesLoose5 = require_objectWithoutPropertiesLoose();
    var React92 = require("react");
    var useLatest3 = (init_use_latest_esm(), __toCommonJS(use_latest_esm_exports));
    var useComposedRef3 = (init_use_composed_ref_esm(), __toCommonJS(use_composed_ref_esm_exports));
    function _interopDefault(e) {
      return e && e.__esModule ? e : { "default": e };
    }
    var useLatest__default = /* @__PURE__ */ _interopDefault(useLatest3);
    var useComposedRef__default = /* @__PURE__ */ _interopDefault(useComposedRef3);
    var HIDDEN_TEXTAREA_STYLE = {
      "min-height": "0",
      "max-height": "none",
      height: "0",
      visibility: "hidden",
      overflow: "hidden",
      position: "absolute",
      "z-index": "-1000",
      top: "0",
      right: "0"
    };
    var forceHiddenStyles = function forceHiddenStyles2(node) {
      Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function(key) {
        node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], "important");
      });
    };
    var hiddenTextarea = null;
    var getHeight = function getHeight2(node, sizingData) {
      var height = node.scrollHeight;
      if (sizingData.sizingStyle.boxSizing === "border-box") {
        return height + sizingData.borderSize;
      }
      return height - sizingData.paddingSize;
    };
    function calculateNodeHeight(sizingData, value, minRows, maxRows) {
      if (minRows === void 0) {
        minRows = 1;
      }
      if (maxRows === void 0) {
        maxRows = Infinity;
      }
      if (!hiddenTextarea) {
        hiddenTextarea = document.createElement("textarea");
        hiddenTextarea.setAttribute("tabindex", "-1");
        hiddenTextarea.setAttribute("aria-hidden", "true");
        forceHiddenStyles(hiddenTextarea);
      }
      if (hiddenTextarea.parentNode === null) {
        document.body.appendChild(hiddenTextarea);
      }
      var paddingSize = sizingData.paddingSize, borderSize = sizingData.borderSize, sizingStyle = sizingData.sizingStyle;
      var boxSizing = sizingStyle.boxSizing;
      Object.keys(sizingStyle).forEach(function(_key) {
        var key = _key;
        hiddenTextarea.style[key] = sizingStyle[key];
      });
      forceHiddenStyles(hiddenTextarea);
      hiddenTextarea.value = value;
      var height = getHeight(hiddenTextarea, sizingData);
      hiddenTextarea.value = "x";
      var rowHeight = hiddenTextarea.scrollHeight - paddingSize;
      var minHeight = rowHeight * minRows;
      if (boxSizing === "border-box") {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
      var maxHeight = rowHeight * maxRows;
      if (boxSizing === "border-box") {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      height = Math.min(maxHeight, height);
      return [height, rowHeight];
    }
    var noop4 = function noop5() {
    };
    var pick2 = function pick3(props, obj) {
      return props.reduce(function(acc, prop) {
        acc[prop] = obj[prop];
        return acc;
      }, {});
    };
    var SIZING_STYLE = [
      "borderBottomWidth",
      "borderLeftWidth",
      "borderRightWidth",
      "borderTopWidth",
      "boxSizing",
      "fontFamily",
      "fontSize",
      "fontStyle",
      "fontWeight",
      "letterSpacing",
      "lineHeight",
      "paddingBottom",
      "paddingLeft",
      "paddingRight",
      "paddingTop",
      "tabSize",
      "textIndent",
      "textRendering",
      "textTransform",
      "width",
      "wordBreak"
    ];
    var isIE = typeof document !== "undefined" ? !!document.documentElement.currentStyle : false;
    var getSizingData = function getSizingData2(node) {
      var style = window.getComputedStyle(node);
      if (style === null) {
        return null;
      }
      var sizingStyle = pick2(SIZING_STYLE, style);
      var boxSizing = sizingStyle.boxSizing;
      if (boxSizing === "") {
        return null;
      }
      if (isIE && boxSizing === "border-box") {
        sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + "px";
      }
      var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
      var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
      return {
        sizingStyle,
        paddingSize,
        borderSize
      };
    };
    var useWindowResizeListener = function useWindowResizeListener2(listener) {
      var latestListener = useLatest__default["default"](listener);
      React92.useLayoutEffect(function() {
        var handler = function handler2(event) {
          latestListener.current(event);
        };
        window.addEventListener("resize", handler);
        return function() {
          window.removeEventListener("resize", handler);
        };
      }, []);
    };
    var TextareaAutosize2 = function TextareaAutosize3(_ref, userRef) {
      var cacheMeasurements = _ref.cacheMeasurements, maxRows = _ref.maxRows, minRows = _ref.minRows, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? noop4 : _ref$onChange, _ref$onHeightChange = _ref.onHeightChange, onHeightChange = _ref$onHeightChange === void 0 ? noop4 : _ref$onHeightChange, props = _objectWithoutPropertiesLoose5(_ref, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]);
      if (process.env.NODE_ENV !== "production" && props.style) {
        if ("maxHeight" in props.style) {
          throw new Error("Using `style.maxHeight` for <TextareaAutosize/> is not supported. Please use `maxRows`.");
        }
        if ("minHeight" in props.style) {
          throw new Error("Using `style.minHeight` for <TextareaAutosize/> is not supported. Please use `minRows`.");
        }
      }
      var isControlled = props.value !== void 0;
      var libRef = React92.useRef(null);
      var ref = useComposedRef__default["default"](libRef, userRef);
      var heightRef = React92.useRef(0);
      var measurementsCacheRef = React92.useRef();
      var resizeTextarea = function resizeTextarea2() {
        var node = libRef.current;
        var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : getSizingData(node);
        if (!nodeSizingData) {
          return;
        }
        measurementsCacheRef.current = nodeSizingData;
        var _calculateNodeHeight = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || "x", minRows, maxRows), height = _calculateNodeHeight[0], rowHeight = _calculateNodeHeight[1];
        if (heightRef.current !== height) {
          heightRef.current = height;
          node.style.setProperty("height", height + "px", "important");
          onHeightChange(height, {
            rowHeight
          });
        }
      };
      var handleChange = function handleChange2(event) {
        if (!isControlled) {
          resizeTextarea();
        }
        onChange(event);
      };
      if (typeof document !== "undefined") {
        React92.useLayoutEffect(resizeTextarea);
        useWindowResizeListener(resizeTextarea);
      }
      return /* @__PURE__ */ React92.createElement("textarea", _extends14({}, props, {
        onChange: handleChange,
        ref
      }));
    };
    var index2 = /* @__PURE__ */ React92.forwardRef(TextareaAutosize2);
    exports.default = index2;
  }
});

// ../../node_modules/react-textarea-autosize/dist/react-textarea-autosize.cjs.js
var require_react_textarea_autosize_cjs = __commonJS({
  "../../node_modules/react-textarea-autosize/dist/react-textarea-autosize.cjs.js"(exports, module2) {
    "use strict";
    init_cjs_shims();
    if (process.env.NODE_ENV === "production") {
      module2.exports = require_react_textarea_autosize_cjs_prod();
    } else {
      module2.exports = require_react_textarea_autosize_cjs_dev();
    }
  }
});

// ../../node_modules/tslib/tslib.js
var require_tslib = __commonJS({
  "../../node_modules/tslib/tslib.js"(exports, module2) {
    init_cjs_shims();
    var __extends2;
    var __assign2;
    var __rest2;
    var __decorate2;
    var __param2;
    var __metadata2;
    var __awaiter2;
    var __generator2;
    var __exportStar2;
    var __values2;
    var __read2;
    var __spread2;
    var __spreadArrays2;
    var __spreadArray2;
    var __await2;
    var __asyncGenerator2;
    var __asyncDelegator2;
    var __asyncValues2;
    var __makeTemplateObject2;
    var __importStar2;
    var __importDefault2;
    var __classPrivateFieldGet2;
    var __classPrivateFieldSet2;
    var __classPrivateFieldIn2;
    var __createBinding2;
    (function(factory) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module2 === "object" && typeof module2.exports === "object") {
        factory(createExporter(root, createExporter(module2.exports)));
      } else {
        factory(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v) {
          return exports2[id] = previous ? previous(id, v) : v;
        };
      }
    })(function(exporter) {
      var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
        d.__proto__ = b;
      } || function(d, b) {
        for (var p in b)
          if (Object.prototype.hasOwnProperty.call(b, p))
            d[p] = b[p];
      };
      __extends2 = function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
      __assign2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      __rest2 = function(s, e) {
        var t = {};
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
          }
        return t;
      };
      __decorate2 = function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
              r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };
      __param2 = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata2 = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter2 = function(thisArg, _arguments, P, generator) {
        function adopt(value) {
          return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
          });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e) {
              reject(e);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e) {
              reject(e);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator2 = function(thisArg, body) {
        var _ = { label: 0, sent: function() {
          if (t[0] & 1)
            throw t[1];
          return t[1];
        }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
          return this;
        }), g;
        function verb(n) {
          return function(v) {
            return step([n, v]);
          };
        }
        function step(op) {
          if (f)
            throw new TypeError("Generator is already executing.");
          while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                return t;
              if (y = 0, t)
                op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return { value: op[1], done: false };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2])
                    _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __exportStar2 = function(m, o) {
        for (var p in m)
          if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p))
            __createBinding2(o, m, p);
      };
      __createBinding2 = Object.create ? function(o, m, k, k2) {
        if (k2 === void 0)
          k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
          desc = { enumerable: true, get: function() {
            return m[k];
          } };
        }
        Object.defineProperty(o, k2, desc);
      } : function(o, m, k, k2) {
        if (k2 === void 0)
          k2 = k;
        o[k2] = m[k];
      };
      __values2 = function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m)
          return m.call(o);
        if (o && typeof o.length === "number")
          return {
            next: function() {
              if (o && i >= o.length)
                o = void 0;
              return { value: o && o[i++], done: !o };
            }
          };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read2 = function(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m)
          return o;
        var i = m.call(o), r, ar = [], e;
        try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
            ar.push(r.value);
        } catch (error2) {
          e = { error: error2 };
        } finally {
          try {
            if (r && !r.done && (m = i["return"]))
              m.call(i);
          } finally {
            if (e)
              throw e.error;
          }
        }
        return ar;
      };
      __spread2 = function() {
        for (var ar = [], i = 0; i < arguments.length; i++)
          ar = ar.concat(__read2(arguments[i]));
        return ar;
      };
      __spreadArrays2 = function() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++)
          s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
        return r;
      };
      __spreadArray2 = function(to, from, pack) {
        if (pack || arguments.length === 2)
          for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
              if (!ar)
                ar = Array.prototype.slice.call(from, 0, i);
              ar[i] = from[i];
            }
          }
        return to.concat(ar || Array.prototype.slice.call(from));
      };
      __await2 = function(v) {
        return this instanceof __await2 ? (this.v = v, this) : new __await2(v);
      };
      __asyncGenerator2 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
          return this;
        }, i;
        function verb(n) {
          if (g[n])
            i[n] = function(v) {
              return new Promise(function(a, b) {
                q.push([n, v, a, b]) > 1 || resume(n, v);
              });
            };
        }
        function resume(n, v) {
          try {
            step(g[n](v));
          } catch (e) {
            settle(q[0][3], e);
          }
        }
        function step(r) {
          r.value instanceof __await2 ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f, v) {
          if (f(v), q.shift(), q.length)
            resume(q[0][0], q[0][1]);
        }
      };
      __asyncDelegator2 = function(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function(e) {
          throw e;
        }), verb("return"), i[Symbol.iterator] = function() {
          return this;
        }, i;
        function verb(n, f) {
          i[n] = o[n] ? function(v) {
            return (p = !p) ? { value: __await2(o[n](v)), done: n === "return" } : f ? f(v) : v;
          } : f;
        }
      };
      __asyncValues2 = function(o) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values2 === "function" ? __values2(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
          return this;
        }, i);
        function verb(n) {
          i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
              v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
          };
        }
        function settle(resolve, reject, d, v) {
          Promise.resolve(v).then(function(v2) {
            resolve({ value: v2, done: d });
          }, reject);
        }
      };
      __makeTemplateObject2 = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      var __setModuleDefault = Object.create ? function(o, v) {
        Object.defineProperty(o, "default", { enumerable: true, value: v });
      } : function(o, v) {
        o["default"] = v;
      };
      __importStar2 = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k in mod)
            if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
              __createBinding2(result, mod, k);
        }
        __setModuleDefault(result, mod);
        return result;
      };
      __importDefault2 = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet2 = function(receiver, state, kind, f) {
        if (kind === "a" && !f)
          throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
          throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
      };
      __classPrivateFieldSet2 = function(receiver, state, value, kind, f) {
        if (kind === "m")
          throw new TypeError("Private method is not writable");
        if (kind === "a" && !f)
          throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
          throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
      };
      __classPrivateFieldIn2 = function(state, receiver) {
        if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function")
          throw new TypeError("Cannot use 'in' operator on non-object");
        return typeof state === "function" ? receiver === state : state.has(receiver);
      };
      exporter("__extends", __extends2);
      exporter("__assign", __assign2);
      exporter("__rest", __rest2);
      exporter("__decorate", __decorate2);
      exporter("__param", __param2);
      exporter("__metadata", __metadata2);
      exporter("__awaiter", __awaiter2);
      exporter("__generator", __generator2);
      exporter("__exportStar", __exportStar2);
      exporter("__createBinding", __createBinding2);
      exporter("__values", __values2);
      exporter("__read", __read2);
      exporter("__spread", __spread2);
      exporter("__spreadArrays", __spreadArrays2);
      exporter("__spreadArray", __spreadArray2);
      exporter("__await", __await2);
      exporter("__asyncGenerator", __asyncGenerator2);
      exporter("__asyncDelegator", __asyncDelegator2);
      exporter("__asyncValues", __asyncValues2);
      exporter("__makeTemplateObject", __makeTemplateObject2);
      exporter("__importStar", __importStar2);
      exporter("__importDefault", __importDefault2);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet2);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet2);
      exporter("__classPrivateFieldIn", __classPrivateFieldIn2);
    });
  }
});

// ../../node_modules/attr-accept/dist/es/index.js
var require_es = __commonJS({
  "../../node_modules/attr-accept/dist/es/index.js"(exports) {
    "use strict";
    init_cjs_shims();
    exports.__esModule = true;
    exports.default = function(file, acceptedFiles) {
      if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        var fileName = file.name || "";
        var mimeType = (file.type || "").toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
          var validType = type.trim().toLowerCase();
          if (validType.charAt(0) === ".") {
            return fileName.toLowerCase().endsWith(validType);
          } else if (validType.endsWith("/*")) {
            return baseMimeType === validType.replace(/\/.*$/, "");
          }
          return mimeType === validType;
        });
      }
      return true;
    };
  }
});

// ../../node_modules/lodash/_baseHas.js
var require_baseHas = __commonJS({
  "../../node_modules/lodash/_baseHas.js"(exports, module2) {
    init_cjs_shims();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function baseHas(object2, key) {
      return object2 != null && hasOwnProperty.call(object2, key);
    }
    module2.exports = baseHas;
  }
});

// ../../node_modules/lodash/isArray.js
var require_isArray = __commonJS({
  "../../node_modules/lodash/isArray.js"(exports, module2) {
    init_cjs_shims();
    var isArray = Array.isArray;
    module2.exports = isArray;
  }
});

// ../../node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "../../node_modules/lodash/_freeGlobal.js"(exports, module2) {
    init_cjs_shims();
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module2.exports = freeGlobal;
  }
});

// ../../node_modules/lodash/_root.js
var require_root = __commonJS({
  "../../node_modules/lodash/_root.js"(exports, module2) {
    init_cjs_shims();
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module2.exports = root;
  }
});

// ../../node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "../../node_modules/lodash/_Symbol.js"(exports, module2) {
    init_cjs_shims();
    var root = require_root();
    var Symbol2 = root.Symbol;
    module2.exports = Symbol2;
  }
});

// ../../node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "../../node_modules/lodash/_getRawTag.js"(exports, module2) {
    init_cjs_shims();
    var Symbol2 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module2.exports = getRawTag;
  }
});

// ../../node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "../../node_modules/lodash/_objectToString.js"(exports, module2) {
    init_cjs_shims();
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module2.exports = objectToString;
  }
});

// ../../node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "../../node_modules/lodash/_baseGetTag.js"(exports, module2) {
    init_cjs_shims();
    var Symbol2 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module2.exports = baseGetTag;
  }
});

// ../../node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "../../node_modules/lodash/isObjectLike.js"(exports, module2) {
    init_cjs_shims();
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module2.exports = isObjectLike;
  }
});

// ../../node_modules/lodash/isSymbol.js
var require_isSymbol = __commonJS({
  "../../node_modules/lodash/isSymbol.js"(exports, module2) {
    init_cjs_shims();
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module2.exports = isSymbol;
  }
});

// ../../node_modules/lodash/_isKey.js
var require_isKey = __commonJS({
  "../../node_modules/lodash/_isKey.js"(exports, module2) {
    init_cjs_shims();
    var isArray = require_isArray();
    var isSymbol = require_isSymbol();
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
    var reIsPlainProp = /^\w*$/;
    function isKey(value, object2) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object2 != null && value in Object(object2);
    }
    module2.exports = isKey;
  }
});

// ../../node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "../../node_modules/lodash/isObject.js"(exports, module2) {
    init_cjs_shims();
    function isObject4(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module2.exports = isObject4;
  }
});

// ../../node_modules/lodash/isFunction.js
var require_isFunction = __commonJS({
  "../../node_modules/lodash/isFunction.js"(exports, module2) {
    init_cjs_shims();
    var baseGetTag = require_baseGetTag();
    var isObject4 = require_isObject();
    var asyncTag = "[object AsyncFunction]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var proxyTag = "[object Proxy]";
    function isFunction2(value) {
      if (!isObject4(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module2.exports = isFunction2;
  }
});

// ../../node_modules/lodash/_coreJsData.js
var require_coreJsData = __commonJS({
  "../../node_modules/lodash/_coreJsData.js"(exports, module2) {
    init_cjs_shims();
    var root = require_root();
    var coreJsData = root["__core-js_shared__"];
    module2.exports = coreJsData;
  }
});

// ../../node_modules/lodash/_isMasked.js
var require_isMasked = __commonJS({
  "../../node_modules/lodash/_isMasked.js"(exports, module2) {
    init_cjs_shims();
    var coreJsData = require_coreJsData();
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module2.exports = isMasked;
  }
});

// ../../node_modules/lodash/_toSource.js
var require_toSource = __commonJS({
  "../../node_modules/lodash/_toSource.js"(exports, module2) {
    init_cjs_shims();
    var funcProto = Function.prototype;
    var funcToString = funcProto.toString;
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    module2.exports = toSource;
  }
});

// ../../node_modules/lodash/_baseIsNative.js
var require_baseIsNative = __commonJS({
  "../../node_modules/lodash/_baseIsNative.js"(exports, module2) {
    init_cjs_shims();
    var isFunction2 = require_isFunction();
    var isMasked = require_isMasked();
    var isObject4 = require_isObject();
    var toSource = require_toSource();
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    function baseIsNative(value) {
      if (!isObject4(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    module2.exports = baseIsNative;
  }
});

// ../../node_modules/lodash/_getValue.js
var require_getValue = __commonJS({
  "../../node_modules/lodash/_getValue.js"(exports, module2) {
    init_cjs_shims();
    function getValue(object2, key) {
      return object2 == null ? void 0 : object2[key];
    }
    module2.exports = getValue;
  }
});

// ../../node_modules/lodash/_getNative.js
var require_getNative = __commonJS({
  "../../node_modules/lodash/_getNative.js"(exports, module2) {
    init_cjs_shims();
    var baseIsNative = require_baseIsNative();
    var getValue = require_getValue();
    function getNative(object2, key) {
      var value = getValue(object2, key);
      return baseIsNative(value) ? value : void 0;
    }
    module2.exports = getNative;
  }
});

// ../../node_modules/lodash/_nativeCreate.js
var require_nativeCreate = __commonJS({
  "../../node_modules/lodash/_nativeCreate.js"(exports, module2) {
    init_cjs_shims();
    var getNative = require_getNative();
    var nativeCreate = getNative(Object, "create");
    module2.exports = nativeCreate;
  }
});

// ../../node_modules/lodash/_hashClear.js
var require_hashClear = __commonJS({
  "../../node_modules/lodash/_hashClear.js"(exports, module2) {
    init_cjs_shims();
    var nativeCreate = require_nativeCreate();
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    module2.exports = hashClear;
  }
});

// ../../node_modules/lodash/_hashDelete.js
var require_hashDelete = __commonJS({
  "../../node_modules/lodash/_hashDelete.js"(exports, module2) {
    init_cjs_shims();
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    module2.exports = hashDelete;
  }
});

// ../../node_modules/lodash/_hashGet.js
var require_hashGet = __commonJS({
  "../../node_modules/lodash/_hashGet.js"(exports, module2) {
    init_cjs_shims();
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    module2.exports = hashGet;
  }
});

// ../../node_modules/lodash/_hashHas.js
var require_hashHas = __commonJS({
  "../../node_modules/lodash/_hashHas.js"(exports, module2) {
    init_cjs_shims();
    var nativeCreate = require_nativeCreate();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    module2.exports = hashHas;
  }
});

// ../../node_modules/lodash/_hashSet.js
var require_hashSet = __commonJS({
  "../../node_modules/lodash/_hashSet.js"(exports, module2) {
    init_cjs_shims();
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    module2.exports = hashSet;
  }
});

// ../../node_modules/lodash/_Hash.js
var require_Hash = __commonJS({
  "../../node_modules/lodash/_Hash.js"(exports, module2) {
    init_cjs_shims();
    var hashClear = require_hashClear();
    var hashDelete = require_hashDelete();
    var hashGet = require_hashGet();
    var hashHas = require_hashHas();
    var hashSet = require_hashSet();
    function Hash(entries) {
      var index2 = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    module2.exports = Hash;
  }
});

// ../../node_modules/lodash/_listCacheClear.js
var require_listCacheClear = __commonJS({
  "../../node_modules/lodash/_listCacheClear.js"(exports, module2) {
    init_cjs_shims();
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    module2.exports = listCacheClear;
  }
});

// ../../node_modules/lodash/eq.js
var require_eq = __commonJS({
  "../../node_modules/lodash/eq.js"(exports, module2) {
    init_cjs_shims();
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    module2.exports = eq;
  }
});

// ../../node_modules/lodash/_assocIndexOf.js
var require_assocIndexOf = __commonJS({
  "../../node_modules/lodash/_assocIndexOf.js"(exports, module2) {
    init_cjs_shims();
    var eq = require_eq();
    function assocIndexOf(array2, key) {
      var length = array2.length;
      while (length--) {
        if (eq(array2[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    module2.exports = assocIndexOf;
  }
});

// ../../node_modules/lodash/_listCacheDelete.js
var require_listCacheDelete = __commonJS({
  "../../node_modules/lodash/_listCacheDelete.js"(exports, module2) {
    init_cjs_shims();
    var assocIndexOf = require_assocIndexOf();
    var arrayProto = Array.prototype;
    var splice = arrayProto.splice;
    function listCacheDelete(key) {
      var data = this.__data__, index2 = assocIndexOf(data, key);
      if (index2 < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index2 == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index2, 1);
      }
      --this.size;
      return true;
    }
    module2.exports = listCacheDelete;
  }
});

// ../../node_modules/lodash/_listCacheGet.js
var require_listCacheGet = __commonJS({
  "../../node_modules/lodash/_listCacheGet.js"(exports, module2) {
    init_cjs_shims();
    var assocIndexOf = require_assocIndexOf();
    function listCacheGet(key) {
      var data = this.__data__, index2 = assocIndexOf(data, key);
      return index2 < 0 ? void 0 : data[index2][1];
    }
    module2.exports = listCacheGet;
  }
});

// ../../node_modules/lodash/_listCacheHas.js
var require_listCacheHas = __commonJS({
  "../../node_modules/lodash/_listCacheHas.js"(exports, module2) {
    init_cjs_shims();
    var assocIndexOf = require_assocIndexOf();
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    module2.exports = listCacheHas;
  }
});

// ../../node_modules/lodash/_listCacheSet.js
var require_listCacheSet = __commonJS({
  "../../node_modules/lodash/_listCacheSet.js"(exports, module2) {
    init_cjs_shims();
    var assocIndexOf = require_assocIndexOf();
    function listCacheSet(key, value) {
      var data = this.__data__, index2 = assocIndexOf(data, key);
      if (index2 < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index2][1] = value;
      }
      return this;
    }
    module2.exports = listCacheSet;
  }
});

// ../../node_modules/lodash/_ListCache.js
var require_ListCache = __commonJS({
  "../../node_modules/lodash/_ListCache.js"(exports, module2) {
    init_cjs_shims();
    var listCacheClear = require_listCacheClear();
    var listCacheDelete = require_listCacheDelete();
    var listCacheGet = require_listCacheGet();
    var listCacheHas = require_listCacheHas();
    var listCacheSet = require_listCacheSet();
    function ListCache(entries) {
      var index2 = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    module2.exports = ListCache;
  }
});

// ../../node_modules/lodash/_Map.js
var require_Map = __commonJS({
  "../../node_modules/lodash/_Map.js"(exports, module2) {
    init_cjs_shims();
    var getNative = require_getNative();
    var root = require_root();
    var Map2 = getNative(root, "Map");
    module2.exports = Map2;
  }
});

// ../../node_modules/lodash/_mapCacheClear.js
var require_mapCacheClear = __commonJS({
  "../../node_modules/lodash/_mapCacheClear.js"(exports, module2) {
    init_cjs_shims();
    var Hash = require_Hash();
    var ListCache = require_ListCache();
    var Map2 = require_Map();
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    module2.exports = mapCacheClear;
  }
});

// ../../node_modules/lodash/_isKeyable.js
var require_isKeyable = __commonJS({
  "../../node_modules/lodash/_isKeyable.js"(exports, module2) {
    init_cjs_shims();
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    module2.exports = isKeyable;
  }
});

// ../../node_modules/lodash/_getMapData.js
var require_getMapData = __commonJS({
  "../../node_modules/lodash/_getMapData.js"(exports, module2) {
    init_cjs_shims();
    var isKeyable = require_isKeyable();
    function getMapData(map9, key) {
      var data = map9.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    module2.exports = getMapData;
  }
});

// ../../node_modules/lodash/_mapCacheDelete.js
var require_mapCacheDelete = __commonJS({
  "../../node_modules/lodash/_mapCacheDelete.js"(exports, module2) {
    init_cjs_shims();
    var getMapData = require_getMapData();
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    module2.exports = mapCacheDelete;
  }
});

// ../../node_modules/lodash/_mapCacheGet.js
var require_mapCacheGet = __commonJS({
  "../../node_modules/lodash/_mapCacheGet.js"(exports, module2) {
    init_cjs_shims();
    var getMapData = require_getMapData();
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    module2.exports = mapCacheGet;
  }
});

// ../../node_modules/lodash/_mapCacheHas.js
var require_mapCacheHas = __commonJS({
  "../../node_modules/lodash/_mapCacheHas.js"(exports, module2) {
    init_cjs_shims();
    var getMapData = require_getMapData();
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    module2.exports = mapCacheHas;
  }
});

// ../../node_modules/lodash/_mapCacheSet.js
var require_mapCacheSet = __commonJS({
  "../../node_modules/lodash/_mapCacheSet.js"(exports, module2) {
    init_cjs_shims();
    var getMapData = require_getMapData();
    function mapCacheSet(key, value) {
      var data = getMapData(this, key), size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    module2.exports = mapCacheSet;
  }
});

// ../../node_modules/lodash/_MapCache.js
var require_MapCache = __commonJS({
  "../../node_modules/lodash/_MapCache.js"(exports, module2) {
    init_cjs_shims();
    var mapCacheClear = require_mapCacheClear();
    var mapCacheDelete = require_mapCacheDelete();
    var mapCacheGet = require_mapCacheGet();
    var mapCacheHas = require_mapCacheHas();
    var mapCacheSet = require_mapCacheSet();
    function MapCache(entries) {
      var index2 = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index2 < length) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    module2.exports = MapCache;
  }
});

// ../../node_modules/lodash/memoize.js
var require_memoize = __commonJS({
  "../../node_modules/lodash/memoize.js"(exports, module2) {
    init_cjs_shims();
    var MapCache = require_MapCache();
    var FUNC_ERROR_TEXT = "Expected a function";
    function memoize(func, resolver) {
      if (typeof func != "function" || resolver != null && typeof resolver != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache)();
      return memoized;
    }
    memoize.Cache = MapCache;
    module2.exports = memoize;
  }
});

// ../../node_modules/lodash/_memoizeCapped.js
var require_memoizeCapped = __commonJS({
  "../../node_modules/lodash/_memoizeCapped.js"(exports, module2) {
    init_cjs_shims();
    var memoize = require_memoize();
    var MAX_MEMOIZE_SIZE = 500;
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });
      var cache = result.cache;
      return result;
    }
    module2.exports = memoizeCapped;
  }
});

// ../../node_modules/lodash/_stringToPath.js
var require_stringToPath = __commonJS({
  "../../node_modules/lodash/_stringToPath.js"(exports, module2) {
    init_cjs_shims();
    var memoizeCapped = require_memoizeCapped();
    var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reEscapeChar = /\\(\\)?/g;
    var stringToPath = memoizeCapped(function(string2) {
      var result = [];
      if (string2.charCodeAt(0) === 46) {
        result.push("");
      }
      string2.replace(rePropName, function(match, number2, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match);
      });
      return result;
    });
    module2.exports = stringToPath;
  }
});

// ../../node_modules/lodash/_arrayMap.js
var require_arrayMap = __commonJS({
  "../../node_modules/lodash/_arrayMap.js"(exports, module2) {
    init_cjs_shims();
    function arrayMap(array2, iteratee) {
      var index2 = -1, length = array2 == null ? 0 : array2.length, result = Array(length);
      while (++index2 < length) {
        result[index2] = iteratee(array2[index2], index2, array2);
      }
      return result;
    }
    module2.exports = arrayMap;
  }
});

// ../../node_modules/lodash/_baseToString.js
var require_baseToString = __commonJS({
  "../../node_modules/lodash/_baseToString.js"(exports, module2) {
    init_cjs_shims();
    var Symbol2 = require_Symbol();
    var arrayMap = require_arrayMap();
    var isArray = require_isArray();
    var isSymbol = require_isSymbol();
    var INFINITY = 1 / 0;
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolToString2 = symbolProto ? symbolProto.toString : void 0;
    function baseToString(value) {
      if (typeof value == "string") {
        return value;
      }
      if (isArray(value)) {
        return arrayMap(value, baseToString) + "";
      }
      if (isSymbol(value)) {
        return symbolToString2 ? symbolToString2.call(value) : "";
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module2.exports = baseToString;
  }
});

// ../../node_modules/lodash/toString.js
var require_toString = __commonJS({
  "../../node_modules/lodash/toString.js"(exports, module2) {
    init_cjs_shims();
    var baseToString = require_baseToString();
    function toString2(value) {
      return value == null ? "" : baseToString(value);
    }
    module2.exports = toString2;
  }
});

// ../../node_modules/lodash/_castPath.js
var require_castPath = __commonJS({
  "../../node_modules/lodash/_castPath.js"(exports, module2) {
    init_cjs_shims();
    var isArray = require_isArray();
    var isKey = require_isKey();
    var stringToPath = require_stringToPath();
    var toString2 = require_toString();
    function castPath(value, object2) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object2) ? [value] : stringToPath(toString2(value));
    }
    module2.exports = castPath;
  }
});

// ../../node_modules/lodash/_baseIsArguments.js
var require_baseIsArguments = __commonJS({
  "../../node_modules/lodash/_baseIsArguments.js"(exports, module2) {
    init_cjs_shims();
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    module2.exports = baseIsArguments;
  }
});

// ../../node_modules/lodash/isArguments.js
var require_isArguments = __commonJS({
  "../../node_modules/lodash/isArguments.js"(exports, module2) {
    init_cjs_shims();
    var baseIsArguments = require_baseIsArguments();
    var isObjectLike = require_isObjectLike();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var isArguments = baseIsArguments(function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    module2.exports = isArguments;
  }
});

// ../../node_modules/lodash/_isIndex.js
var require_isIndex = __commonJS({
  "../../node_modules/lodash/_isIndex.js"(exports, module2) {
    init_cjs_shims();
    var MAX_SAFE_INTEGER = 9007199254740991;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
    }
    module2.exports = isIndex;
  }
});

// ../../node_modules/lodash/isLength.js
var require_isLength = __commonJS({
  "../../node_modules/lodash/isLength.js"(exports, module2) {
    init_cjs_shims();
    var MAX_SAFE_INTEGER = 9007199254740991;
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    module2.exports = isLength;
  }
});

// ../../node_modules/lodash/_toKey.js
var require_toKey = __commonJS({
  "../../node_modules/lodash/_toKey.js"(exports, module2) {
    init_cjs_shims();
    var isSymbol = require_isSymbol();
    var INFINITY = 1 / 0;
    function toKey(value) {
      if (typeof value == "string" || isSymbol(value)) {
        return value;
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module2.exports = toKey;
  }
});

// ../../node_modules/lodash/_hasPath.js
var require_hasPath = __commonJS({
  "../../node_modules/lodash/_hasPath.js"(exports, module2) {
    init_cjs_shims();
    var castPath = require_castPath();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isIndex = require_isIndex();
    var isLength = require_isLength();
    var toKey = require_toKey();
    function hasPath(object2, path, hasFunc) {
      path = castPath(path, object2);
      var index2 = -1, length = path.length, result = false;
      while (++index2 < length) {
        var key = toKey(path[index2]);
        if (!(result = object2 != null && hasFunc(object2, key))) {
          break;
        }
        object2 = object2[key];
      }
      if (result || ++index2 != length) {
        return result;
      }
      length = object2 == null ? 0 : object2.length;
      return !!length && isLength(length) && isIndex(key, length) && (isArray(object2) || isArguments(object2));
    }
    module2.exports = hasPath;
  }
});

// ../../node_modules/lodash/has.js
var require_has2 = __commonJS({
  "../../node_modules/lodash/has.js"(exports, module2) {
    init_cjs_shims();
    var baseHas = require_baseHas();
    var hasPath = require_hasPath();
    function has4(object2, path) {
      return object2 != null && hasPath(object2, path, baseHas);
    }
    module2.exports = has4;
  }
});

// ../../node_modules/lodash/_defineProperty.js
var require_defineProperty = __commonJS({
  "../../node_modules/lodash/_defineProperty.js"(exports, module2) {
    init_cjs_shims();
    var getNative = require_getNative();
    var defineProperty = function() {
      try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
      } catch (e) {
      }
    }();
    module2.exports = defineProperty;
  }
});

// ../../node_modules/lodash/_baseAssignValue.js
var require_baseAssignValue = __commonJS({
  "../../node_modules/lodash/_baseAssignValue.js"(exports, module2) {
    init_cjs_shims();
    var defineProperty = require_defineProperty();
    function baseAssignValue(object2, key, value) {
      if (key == "__proto__" && defineProperty) {
        defineProperty(object2, key, {
          "configurable": true,
          "enumerable": true,
          "value": value,
          "writable": true
        });
      } else {
        object2[key] = value;
      }
    }
    module2.exports = baseAssignValue;
  }
});

// ../../node_modules/lodash/_createBaseFor.js
var require_createBaseFor = __commonJS({
  "../../node_modules/lodash/_createBaseFor.js"(exports, module2) {
    init_cjs_shims();
    function createBaseFor(fromRight) {
      return function(object2, iteratee, keysFunc) {
        var index2 = -1, iterable = Object(object2), props = keysFunc(object2), length = props.length;
        while (length--) {
          var key = props[fromRight ? length : ++index2];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object2;
      };
    }
    module2.exports = createBaseFor;
  }
});

// ../../node_modules/lodash/_baseFor.js
var require_baseFor = __commonJS({
  "../../node_modules/lodash/_baseFor.js"(exports, module2) {
    init_cjs_shims();
    var createBaseFor = require_createBaseFor();
    var baseFor = createBaseFor();
    module2.exports = baseFor;
  }
});

// ../../node_modules/lodash/_baseTimes.js
var require_baseTimes = __commonJS({
  "../../node_modules/lodash/_baseTimes.js"(exports, module2) {
    init_cjs_shims();
    function baseTimes(n, iteratee) {
      var index2 = -1, result = Array(n);
      while (++index2 < n) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    module2.exports = baseTimes;
  }
});

// ../../node_modules/lodash/stubFalse.js
var require_stubFalse = __commonJS({
  "../../node_modules/lodash/stubFalse.js"(exports, module2) {
    init_cjs_shims();
    function stubFalse() {
      return false;
    }
    module2.exports = stubFalse;
  }
});

// ../../node_modules/lodash/isBuffer.js
var require_isBuffer = __commonJS({
  "../../node_modules/lodash/isBuffer.js"(exports, module2) {
    init_cjs_shims();
    var root = require_root();
    var stubFalse = require_stubFalse();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module2 == "object" && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var isBuffer = nativeIsBuffer || stubFalse;
    module2.exports = isBuffer;
  }
});

// ../../node_modules/lodash/_baseIsTypedArray.js
var require_baseIsTypedArray = __commonJS({
  "../../node_modules/lodash/_baseIsTypedArray.js"(exports, module2) {
    init_cjs_shims();
    var baseGetTag = require_baseGetTag();
    var isLength = require_isLength();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var objectTag = "[object Object]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    module2.exports = baseIsTypedArray;
  }
});

// ../../node_modules/lodash/_baseUnary.js
var require_baseUnary = __commonJS({
  "../../node_modules/lodash/_baseUnary.js"(exports, module2) {
    init_cjs_shims();
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    module2.exports = baseUnary;
  }
});

// ../../node_modules/lodash/_nodeUtil.js
var require_nodeUtil = __commonJS({
  "../../node_modules/lodash/_nodeUtil.js"(exports, module2) {
    init_cjs_shims();
    var freeGlobal = require_freeGlobal();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module2 == "object" && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    module2.exports = nodeUtil;
  }
});

// ../../node_modules/lodash/isTypedArray.js
var require_isTypedArray = __commonJS({
  "../../node_modules/lodash/isTypedArray.js"(exports, module2) {
    init_cjs_shims();
    var baseIsTypedArray = require_baseIsTypedArray();
    var baseUnary = require_baseUnary();
    var nodeUtil = require_nodeUtil();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    module2.exports = isTypedArray;
  }
});

// ../../node_modules/lodash/_arrayLikeKeys.js
var require_arrayLikeKeys = __commonJS({
  "../../node_modules/lodash/_arrayLikeKeys.js"(exports, module2) {
    init_cjs_shims();
    var baseTimes = require_baseTimes();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isBuffer = require_isBuffer();
    var isIndex = require_isIndex();
    var isTypedArray = require_isTypedArray();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    module2.exports = arrayLikeKeys;
  }
});

// ../../node_modules/lodash/_isPrototype.js
var require_isPrototype = __commonJS({
  "../../node_modules/lodash/_isPrototype.js"(exports, module2) {
    init_cjs_shims();
    var objectProto = Object.prototype;
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    module2.exports = isPrototype;
  }
});

// ../../node_modules/lodash/_overArg.js
var require_overArg = __commonJS({
  "../../node_modules/lodash/_overArg.js"(exports, module2) {
    init_cjs_shims();
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    module2.exports = overArg;
  }
});

// ../../node_modules/lodash/_nativeKeys.js
var require_nativeKeys = __commonJS({
  "../../node_modules/lodash/_nativeKeys.js"(exports, module2) {
    init_cjs_shims();
    var overArg = require_overArg();
    var nativeKeys = overArg(Object.keys, Object);
    module2.exports = nativeKeys;
  }
});

// ../../node_modules/lodash/_baseKeys.js
var require_baseKeys = __commonJS({
  "../../node_modules/lodash/_baseKeys.js"(exports, module2) {
    init_cjs_shims();
    var isPrototype = require_isPrototype();
    var nativeKeys = require_nativeKeys();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function baseKeys(object2) {
      if (!isPrototype(object2)) {
        return nativeKeys(object2);
      }
      var result = [];
      for (var key in Object(object2)) {
        if (hasOwnProperty.call(object2, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    module2.exports = baseKeys;
  }
});

// ../../node_modules/lodash/isArrayLike.js
var require_isArrayLike = __commonJS({
  "../../node_modules/lodash/isArrayLike.js"(exports, module2) {
    init_cjs_shims();
    var isFunction2 = require_isFunction();
    var isLength = require_isLength();
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction2(value);
    }
    module2.exports = isArrayLike;
  }
});

// ../../node_modules/lodash/keys.js
var require_keys = __commonJS({
  "../../node_modules/lodash/keys.js"(exports, module2) {
    init_cjs_shims();
    var arrayLikeKeys = require_arrayLikeKeys();
    var baseKeys = require_baseKeys();
    var isArrayLike = require_isArrayLike();
    function keys(object2) {
      return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
    }
    module2.exports = keys;
  }
});

// ../../node_modules/lodash/_baseForOwn.js
var require_baseForOwn = __commonJS({
  "../../node_modules/lodash/_baseForOwn.js"(exports, module2) {
    init_cjs_shims();
    var baseFor = require_baseFor();
    var keys = require_keys();
    function baseForOwn(object2, iteratee) {
      return object2 && baseFor(object2, iteratee, keys);
    }
    module2.exports = baseForOwn;
  }
});

// ../../node_modules/lodash/_stackClear.js
var require_stackClear = __commonJS({
  "../../node_modules/lodash/_stackClear.js"(exports, module2) {
    init_cjs_shims();
    var ListCache = require_ListCache();
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    module2.exports = stackClear;
  }
});

// ../../node_modules/lodash/_stackDelete.js
var require_stackDelete = __commonJS({
  "../../node_modules/lodash/_stackDelete.js"(exports, module2) {
    init_cjs_shims();
    function stackDelete(key) {
      var data = this.__data__, result = data["delete"](key);
      this.size = data.size;
      return result;
    }
    module2.exports = stackDelete;
  }
});

// ../../node_modules/lodash/_stackGet.js
var require_stackGet = __commonJS({
  "../../node_modules/lodash/_stackGet.js"(exports, module2) {
    init_cjs_shims();
    function stackGet(key) {
      return this.__data__.get(key);
    }
    module2.exports = stackGet;
  }
});

// ../../node_modules/lodash/_stackHas.js
var require_stackHas = __commonJS({
  "../../node_modules/lodash/_stackHas.js"(exports, module2) {
    init_cjs_shims();
    function stackHas(key) {
      return this.__data__.has(key);
    }
    module2.exports = stackHas;
  }
});

// ../../node_modules/lodash/_stackSet.js
var require_stackSet = __commonJS({
  "../../node_modules/lodash/_stackSet.js"(exports, module2) {
    init_cjs_shims();
    var ListCache = require_ListCache();
    var Map2 = require_Map();
    var MapCache = require_MapCache();
    var LARGE_ARRAY_SIZE = 200;
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    module2.exports = stackSet;
  }
});

// ../../node_modules/lodash/_Stack.js
var require_Stack = __commonJS({
  "../../node_modules/lodash/_Stack.js"(exports, module2) {
    init_cjs_shims();
    var ListCache = require_ListCache();
    var stackClear = require_stackClear();
    var stackDelete = require_stackDelete();
    var stackGet = require_stackGet();
    var stackHas = require_stackHas();
    var stackSet = require_stackSet();
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    module2.exports = Stack;
  }
});

// ../../node_modules/lodash/_setCacheAdd.js
var require_setCacheAdd = __commonJS({
  "../../node_modules/lodash/_setCacheAdd.js"(exports, module2) {
    init_cjs_shims();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }
    module2.exports = setCacheAdd;
  }
});

// ../../node_modules/lodash/_setCacheHas.js
var require_setCacheHas = __commonJS({
  "../../node_modules/lodash/_setCacheHas.js"(exports, module2) {
    init_cjs_shims();
    function setCacheHas(value) {
      return this.__data__.has(value);
    }
    module2.exports = setCacheHas;
  }
});

// ../../node_modules/lodash/_SetCache.js
var require_SetCache = __commonJS({
  "../../node_modules/lodash/_SetCache.js"(exports, module2) {
    init_cjs_shims();
    var MapCache = require_MapCache();
    var setCacheAdd = require_setCacheAdd();
    var setCacheHas = require_setCacheHas();
    function SetCache(values) {
      var index2 = -1, length = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index2 < length) {
        this.add(values[index2]);
      }
    }
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    module2.exports = SetCache;
  }
});

// ../../node_modules/lodash/_arraySome.js
var require_arraySome = __commonJS({
  "../../node_modules/lodash/_arraySome.js"(exports, module2) {
    init_cjs_shims();
    function arraySome(array2, predicate) {
      var index2 = -1, length = array2 == null ? 0 : array2.length;
      while (++index2 < length) {
        if (predicate(array2[index2], index2, array2)) {
          return true;
        }
      }
      return false;
    }
    module2.exports = arraySome;
  }
});

// ../../node_modules/lodash/_cacheHas.js
var require_cacheHas = __commonJS({
  "../../node_modules/lodash/_cacheHas.js"(exports, module2) {
    init_cjs_shims();
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    module2.exports = cacheHas;
  }
});

// ../../node_modules/lodash/_equalArrays.js
var require_equalArrays = __commonJS({
  "../../node_modules/lodash/_equalArrays.js"(exports, module2) {
    init_cjs_shims();
    var SetCache = require_SetCache();
    var arraySome = require_arraySome();
    var cacheHas = require_cacheHas();
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    function equalArrays(array2, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array2.length, othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      var arrStacked = stack.get(array2);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array2;
      }
      var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
      stack.set(array2, other);
      stack.set(other, array2);
      while (++index2 < arrLength) {
        var arrValue = array2[index2], othValue = other[index2];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
        }
        if (compared !== void 0) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        if (seen) {
          if (!arraySome(other, function(othValue2, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array2);
      stack["delete"](other);
      return result;
    }
    module2.exports = equalArrays;
  }
});

// ../../node_modules/lodash/_Uint8Array.js
var require_Uint8Array = __commonJS({
  "../../node_modules/lodash/_Uint8Array.js"(exports, module2) {
    init_cjs_shims();
    var root = require_root();
    var Uint8Array2 = root.Uint8Array;
    module2.exports = Uint8Array2;
  }
});

// ../../node_modules/lodash/_mapToArray.js
var require_mapToArray = __commonJS({
  "../../node_modules/lodash/_mapToArray.js"(exports, module2) {
    init_cjs_shims();
    function mapToArray(map9) {
      var index2 = -1, result = Array(map9.size);
      map9.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    module2.exports = mapToArray;
  }
});

// ../../node_modules/lodash/_setToArray.js
var require_setToArray = __commonJS({
  "../../node_modules/lodash/_setToArray.js"(exports, module2) {
    init_cjs_shims();
    function setToArray(set2) {
      var index2 = -1, result = Array(set2.size);
      set2.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    module2.exports = setToArray;
  }
});

// ../../node_modules/lodash/_equalByTag.js
var require_equalByTag = __commonJS({
  "../../node_modules/lodash/_equalByTag.js"(exports, module2) {
    init_cjs_shims();
    var Symbol2 = require_Symbol();
    var Uint8Array2 = require_Uint8Array();
    var eq = require_eq();
    var equalArrays = require_equalArrays();
    var mapToArray = require_mapToArray();
    var setToArray = require_setToArray();
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var symbolTag = "[object Symbol]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function equalByTag(object2, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
            return false;
          }
          object2 = object2.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          return eq(+object2, +other);
        case errorTag:
          return object2.name == other.name && object2.message == other.message;
        case regexpTag:
        case stringTag:
          return object2 == other + "";
        case mapTag:
          var convert = mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);
          if (object2.size != other.size && !isPartial) {
            return false;
          }
          var stacked = stack.get(object2);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;
          stack.set(object2, other);
          var result = equalArrays(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
          stack["delete"](object2);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object2) == symbolValueOf.call(other);
          }
      }
      return false;
    }
    module2.exports = equalByTag;
  }
});

// ../../node_modules/lodash/_arrayPush.js
var require_arrayPush = __commonJS({
  "../../node_modules/lodash/_arrayPush.js"(exports, module2) {
    init_cjs_shims();
    function arrayPush(array2, values) {
      var index2 = -1, length = values.length, offset2 = array2.length;
      while (++index2 < length) {
        array2[offset2 + index2] = values[index2];
      }
      return array2;
    }
    module2.exports = arrayPush;
  }
});

// ../../node_modules/lodash/_baseGetAllKeys.js
var require_baseGetAllKeys = __commonJS({
  "../../node_modules/lodash/_baseGetAllKeys.js"(exports, module2) {
    init_cjs_shims();
    var arrayPush = require_arrayPush();
    var isArray = require_isArray();
    function baseGetAllKeys(object2, keysFunc, symbolsFunc) {
      var result = keysFunc(object2);
      return isArray(object2) ? result : arrayPush(result, symbolsFunc(object2));
    }
    module2.exports = baseGetAllKeys;
  }
});

// ../../node_modules/lodash/_arrayFilter.js
var require_arrayFilter = __commonJS({
  "../../node_modules/lodash/_arrayFilter.js"(exports, module2) {
    init_cjs_shims();
    function arrayFilter(array2, predicate) {
      var index2 = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array2[index2];
        if (predicate(value, index2, array2)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    module2.exports = arrayFilter;
  }
});

// ../../node_modules/lodash/stubArray.js
var require_stubArray = __commonJS({
  "../../node_modules/lodash/stubArray.js"(exports, module2) {
    init_cjs_shims();
    function stubArray() {
      return [];
    }
    module2.exports = stubArray;
  }
});

// ../../node_modules/lodash/_getSymbols.js
var require_getSymbols = __commonJS({
  "../../node_modules/lodash/_getSymbols.js"(exports, module2) {
    init_cjs_shims();
    var arrayFilter = require_arrayFilter();
    var stubArray = require_stubArray();
    var objectProto = Object.prototype;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var nativeGetSymbols = Object.getOwnPropertySymbols;
    var getSymbols = !nativeGetSymbols ? stubArray : function(object2) {
      if (object2 == null) {
        return [];
      }
      object2 = Object(object2);
      return arrayFilter(nativeGetSymbols(object2), function(symbol) {
        return propertyIsEnumerable.call(object2, symbol);
      });
    };
    module2.exports = getSymbols;
  }
});

// ../../node_modules/lodash/_getAllKeys.js
var require_getAllKeys = __commonJS({
  "../../node_modules/lodash/_getAllKeys.js"(exports, module2) {
    init_cjs_shims();
    var baseGetAllKeys = require_baseGetAllKeys();
    var getSymbols = require_getSymbols();
    var keys = require_keys();
    function getAllKeys(object2) {
      return baseGetAllKeys(object2, keys, getSymbols);
    }
    module2.exports = getAllKeys;
  }
});

// ../../node_modules/lodash/_equalObjects.js
var require_equalObjects = __commonJS({
  "../../node_modules/lodash/_equalObjects.js"(exports, module2) {
    init_cjs_shims();
    var getAllKeys = require_getAllKeys();
    var COMPARE_PARTIAL_FLAG = 1;
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function equalObjects(object2, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index2 = objLength;
      while (index2--) {
        var key = objProps[index2];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var objStacked = stack.get(object2);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object2;
      }
      var result = true;
      stack.set(object2, other);
      stack.set(other, object2);
      var skipCtor = isPartial;
      while (++index2 < objLength) {
        key = objProps[index2];
        var objValue = object2[key], othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
        }
        if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object2.constructor, othCtor = other.constructor;
        if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object2);
      stack["delete"](other);
      return result;
    }
    module2.exports = equalObjects;
  }
});

// ../../node_modules/lodash/_DataView.js
var require_DataView = __commonJS({
  "../../node_modules/lodash/_DataView.js"(exports, module2) {
    init_cjs_shims();
    var getNative = require_getNative();
    var root = require_root();
    var DataView = getNative(root, "DataView");
    module2.exports = DataView;
  }
});

// ../../node_modules/lodash/_Promise.js
var require_Promise = __commonJS({
  "../../node_modules/lodash/_Promise.js"(exports, module2) {
    init_cjs_shims();
    var getNative = require_getNative();
    var root = require_root();
    var Promise2 = getNative(root, "Promise");
    module2.exports = Promise2;
  }
});

// ../../node_modules/lodash/_Set.js
var require_Set = __commonJS({
  "../../node_modules/lodash/_Set.js"(exports, module2) {
    init_cjs_shims();
    var getNative = require_getNative();
    var root = require_root();
    var Set2 = getNative(root, "Set");
    module2.exports = Set2;
  }
});

// ../../node_modules/lodash/_WeakMap.js
var require_WeakMap = __commonJS({
  "../../node_modules/lodash/_WeakMap.js"(exports, module2) {
    init_cjs_shims();
    var getNative = require_getNative();
    var root = require_root();
    var WeakMap = getNative(root, "WeakMap");
    module2.exports = WeakMap;
  }
});

// ../../node_modules/lodash/_getTag.js
var require_getTag = __commonJS({
  "../../node_modules/lodash/_getTag.js"(exports, module2) {
    init_cjs_shims();
    var DataView = require_DataView();
    var Map2 = require_Map();
    var Promise2 = require_Promise();
    var Set2 = require_Set();
    var WeakMap = require_WeakMap();
    var baseGetTag = require_baseGetTag();
    var toSource = require_toSource();
    var mapTag = "[object Map]";
    var objectTag = "[object Object]";
    var promiseTag = "[object Promise]";
    var setTag = "[object Set]";
    var weakMapTag = "[object WeakMap]";
    var dataViewTag = "[object DataView]";
    var dataViewCtorString = toSource(DataView);
    var mapCtorString = toSource(Map2);
    var promiseCtorString = toSource(Promise2);
    var setCtorString = toSource(Set2);
    var weakMapCtorString = toSource(WeakMap);
    var getTag2 = baseGetTag;
    if (DataView && getTag2(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag2(new Map2()) != mapTag || Promise2 && getTag2(Promise2.resolve()) != promiseTag || Set2 && getTag2(new Set2()) != setTag || WeakMap && getTag2(new WeakMap()) != weakMapTag) {
      getTag2 = function(value) {
        var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    module2.exports = getTag2;
  }
});

// ../../node_modules/lodash/_baseIsEqualDeep.js
var require_baseIsEqualDeep = __commonJS({
  "../../node_modules/lodash/_baseIsEqualDeep.js"(exports, module2) {
    init_cjs_shims();
    var Stack = require_Stack();
    var equalArrays = require_equalArrays();
    var equalByTag = require_equalByTag();
    var equalObjects = require_equalObjects();
    var getTag2 = require_getTag();
    var isArray = require_isArray();
    var isBuffer = require_isBuffer();
    var isTypedArray = require_isTypedArray();
    var COMPARE_PARTIAL_FLAG = 1;
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var objectTag = "[object Object]";
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function baseIsEqualDeep(object2, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object2), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag2(object2), othTag = othIsArr ? arrayTag : getTag2(other);
      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;
      var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
      if (isSameTag && isBuffer(object2)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object2, other, bitmask, customizer, equalFunc, stack);
    }
    module2.exports = baseIsEqualDeep;
  }
});

// ../../node_modules/lodash/_baseIsEqual.js
var require_baseIsEqual = __commonJS({
  "../../node_modules/lodash/_baseIsEqual.js"(exports, module2) {
    init_cjs_shims();
    var baseIsEqualDeep = require_baseIsEqualDeep();
    var isObjectLike = require_isObjectLike();
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }
    module2.exports = baseIsEqual;
  }
});

// ../../node_modules/lodash/_baseIsMatch.js
var require_baseIsMatch = __commonJS({
  "../../node_modules/lodash/_baseIsMatch.js"(exports, module2) {
    init_cjs_shims();
    var Stack = require_Stack();
    var baseIsEqual = require_baseIsEqual();
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    function baseIsMatch(object2, source, matchData, customizer) {
      var index2 = matchData.length, length = index2, noCustomizer = !customizer;
      if (object2 == null) {
        return !length;
      }
      object2 = Object(object2);
      while (index2--) {
        var data = matchData[index2];
        if (noCustomizer && data[2] ? data[1] !== object2[data[0]] : !(data[0] in object2)) {
          return false;
        }
      }
      while (++index2 < length) {
        data = matchData[index2];
        var key = data[0], objValue = object2[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
          if (objValue === void 0 && !(key in object2)) {
            return false;
          }
        } else {
          var stack = new Stack();
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object2, source, stack);
          }
          if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
            return false;
          }
        }
      }
      return true;
    }
    module2.exports = baseIsMatch;
  }
});

// ../../node_modules/lodash/_isStrictComparable.js
var require_isStrictComparable = __commonJS({
  "../../node_modules/lodash/_isStrictComparable.js"(exports, module2) {
    init_cjs_shims();
    var isObject4 = require_isObject();
    function isStrictComparable(value) {
      return value === value && !isObject4(value);
    }
    module2.exports = isStrictComparable;
  }
});

// ../../node_modules/lodash/_getMatchData.js
var require_getMatchData = __commonJS({
  "../../node_modules/lodash/_getMatchData.js"(exports, module2) {
    init_cjs_shims();
    var isStrictComparable = require_isStrictComparable();
    var keys = require_keys();
    function getMatchData(object2) {
      var result = keys(object2), length = result.length;
      while (length--) {
        var key = result[length], value = object2[key];
        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }
    module2.exports = getMatchData;
  }
});

// ../../node_modules/lodash/_matchesStrictComparable.js
var require_matchesStrictComparable = __commonJS({
  "../../node_modules/lodash/_matchesStrictComparable.js"(exports, module2) {
    init_cjs_shims();
    function matchesStrictComparable(key, srcValue) {
      return function(object2) {
        if (object2 == null) {
          return false;
        }
        return object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
      };
    }
    module2.exports = matchesStrictComparable;
  }
});

// ../../node_modules/lodash/_baseMatches.js
var require_baseMatches = __commonJS({
  "../../node_modules/lodash/_baseMatches.js"(exports, module2) {
    init_cjs_shims();
    var baseIsMatch = require_baseIsMatch();
    var getMatchData = require_getMatchData();
    var matchesStrictComparable = require_matchesStrictComparable();
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object2) {
        return object2 === source || baseIsMatch(object2, source, matchData);
      };
    }
    module2.exports = baseMatches;
  }
});

// ../../node_modules/lodash/_baseGet.js
var require_baseGet = __commonJS({
  "../../node_modules/lodash/_baseGet.js"(exports, module2) {
    init_cjs_shims();
    var castPath = require_castPath();
    var toKey = require_toKey();
    function baseGet(object2, path) {
      path = castPath(path, object2);
      var index2 = 0, length = path.length;
      while (object2 != null && index2 < length) {
        object2 = object2[toKey(path[index2++])];
      }
      return index2 && index2 == length ? object2 : void 0;
    }
    module2.exports = baseGet;
  }
});

// ../../node_modules/lodash/get.js
var require_get = __commonJS({
  "../../node_modules/lodash/get.js"(exports, module2) {
    init_cjs_shims();
    var baseGet = require_baseGet();
    function get3(object2, path, defaultValue) {
      var result = object2 == null ? void 0 : baseGet(object2, path);
      return result === void 0 ? defaultValue : result;
    }
    module2.exports = get3;
  }
});

// ../../node_modules/lodash/_baseHasIn.js
var require_baseHasIn = __commonJS({
  "../../node_modules/lodash/_baseHasIn.js"(exports, module2) {
    init_cjs_shims();
    function baseHasIn(object2, key) {
      return object2 != null && key in Object(object2);
    }
    module2.exports = baseHasIn;
  }
});

// ../../node_modules/lodash/hasIn.js
var require_hasIn = __commonJS({
  "../../node_modules/lodash/hasIn.js"(exports, module2) {
    init_cjs_shims();
    var baseHasIn = require_baseHasIn();
    var hasPath = require_hasPath();
    function hasIn(object2, path) {
      return object2 != null && hasPath(object2, path, baseHasIn);
    }
    module2.exports = hasIn;
  }
});

// ../../node_modules/lodash/_baseMatchesProperty.js
var require_baseMatchesProperty = __commonJS({
  "../../node_modules/lodash/_baseMatchesProperty.js"(exports, module2) {
    init_cjs_shims();
    var baseIsEqual = require_baseIsEqual();
    var get3 = require_get();
    var hasIn = require_hasIn();
    var isKey = require_isKey();
    var isStrictComparable = require_isStrictComparable();
    var matchesStrictComparable = require_matchesStrictComparable();
    var toKey = require_toKey();
    var COMPARE_PARTIAL_FLAG = 1;
    var COMPARE_UNORDERED_FLAG = 2;
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object2) {
        var objValue = get3(object2, path);
        return objValue === void 0 && objValue === srcValue ? hasIn(object2, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }
    module2.exports = baseMatchesProperty;
  }
});

// ../../node_modules/lodash/identity.js
var require_identity = __commonJS({
  "../../node_modules/lodash/identity.js"(exports, module2) {
    init_cjs_shims();
    function identity(value) {
      return value;
    }
    module2.exports = identity;
  }
});

// ../../node_modules/lodash/_baseProperty.js
var require_baseProperty = __commonJS({
  "../../node_modules/lodash/_baseProperty.js"(exports, module2) {
    init_cjs_shims();
    function baseProperty(key) {
      return function(object2) {
        return object2 == null ? void 0 : object2[key];
      };
    }
    module2.exports = baseProperty;
  }
});

// ../../node_modules/lodash/_basePropertyDeep.js
var require_basePropertyDeep = __commonJS({
  "../../node_modules/lodash/_basePropertyDeep.js"(exports, module2) {
    init_cjs_shims();
    var baseGet = require_baseGet();
    function basePropertyDeep(path) {
      return function(object2) {
        return baseGet(object2, path);
      };
    }
    module2.exports = basePropertyDeep;
  }
});

// ../../node_modules/lodash/property.js
var require_property = __commonJS({
  "../../node_modules/lodash/property.js"(exports, module2) {
    init_cjs_shims();
    var baseProperty = require_baseProperty();
    var basePropertyDeep = require_basePropertyDeep();
    var isKey = require_isKey();
    var toKey = require_toKey();
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }
    module2.exports = property;
  }
});

// ../../node_modules/lodash/_baseIteratee.js
var require_baseIteratee = __commonJS({
  "../../node_modules/lodash/_baseIteratee.js"(exports, module2) {
    init_cjs_shims();
    var baseMatches = require_baseMatches();
    var baseMatchesProperty = require_baseMatchesProperty();
    var identity = require_identity();
    var isArray = require_isArray();
    var property = require_property();
    function baseIteratee(value) {
      if (typeof value == "function") {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == "object") {
        return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
      }
      return property(value);
    }
    module2.exports = baseIteratee;
  }
});

// ../../node_modules/lodash/mapValues.js
var require_mapValues = __commonJS({
  "../../node_modules/lodash/mapValues.js"(exports, module2) {
    init_cjs_shims();
    var baseAssignValue = require_baseAssignValue();
    var baseForOwn = require_baseForOwn();
    var baseIteratee = require_baseIteratee();
    function mapValues3(object2, iteratee) {
      var result = {};
      iteratee = baseIteratee(iteratee, 3);
      baseForOwn(object2, function(value, key, object3) {
        baseAssignValue(result, key, iteratee(value, key, object3));
      });
      return result;
    }
    module2.exports = mapValues3;
  }
});

// ../../node_modules/property-expr/index.js
var require_property_expr = __commonJS({
  "../../node_modules/property-expr/index.js"(exports, module2) {
    "use strict";
    init_cjs_shims();
    function Cache(maxSize) {
      this._maxSize = maxSize;
      this.clear();
    }
    Cache.prototype.clear = function() {
      this._size = 0;
      this._values = /* @__PURE__ */ Object.create(null);
    };
    Cache.prototype.get = function(key) {
      return this._values[key];
    };
    Cache.prototype.set = function(key, value) {
      this._size >= this._maxSize && this.clear();
      if (!(key in this._values))
        this._size++;
      return this._values[key] = value;
    };
    var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g;
    var DIGIT_REGEX = /^\d+$/;
    var LEAD_DIGIT_REGEX = /^\d/;
    var SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g;
    var CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/;
    var MAX_CACHE_SIZE = 512;
    var pathCache = new Cache(MAX_CACHE_SIZE);
    var setCache = new Cache(MAX_CACHE_SIZE);
    var getCache = new Cache(MAX_CACHE_SIZE);
    module2.exports = {
      Cache,
      split: split2,
      normalizePath,
      setter: function(path) {
        var parts = normalizePath(path);
        return setCache.get(path) || setCache.set(path, function setter(obj, value) {
          var index2 = 0;
          var len = parts.length;
          var data = obj;
          while (index2 < len - 1) {
            var part = parts[index2];
            if (part === "__proto__" || part === "constructor" || part === "prototype") {
              return obj;
            }
            data = data[parts[index2++]];
          }
          data[parts[index2]] = value;
        });
      },
      getter: function(path, safe) {
        var parts = normalizePath(path);
        return getCache.get(path) || getCache.set(path, function getter3(data) {
          var index2 = 0, len = parts.length;
          while (index2 < len) {
            if (data != null || !safe)
              data = data[parts[index2++]];
            else
              return;
          }
          return data;
        });
      },
      join: function(segments) {
        return segments.reduce(function(path, part) {
          return path + (isQuoted(part) || DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
      },
      forEach: function(path, cb, thisArg) {
        forEach2(Array.isArray(path) ? path : split2(path), cb, thisArg);
      }
    };
    function normalizePath(path) {
      return pathCache.get(path) || pathCache.set(
        path,
        split2(path).map(function(part) {
          return part.replace(CLEAN_QUOTES_REGEX, "$2");
        })
      );
    }
    function split2(path) {
      return path.match(SPLIT_REGEX) || [""];
    }
    function forEach2(parts, iter, thisArg) {
      var len = parts.length, part, idx, isArray, isBracket;
      for (idx = 0; idx < len; idx++) {
        part = parts[idx];
        if (part) {
          if (shouldBeQuoted(part)) {
            part = '"' + part + '"';
          }
          isBracket = isQuoted(part);
          isArray = !isBracket && /^\d+$/.test(part);
          iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
      }
    }
    function isQuoted(str) {
      return typeof str === "string" && str && ["'", '"'].indexOf(str.charAt(0)) !== -1;
    }
    function hasLeadingNumber(part) {
      return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX);
    }
    function hasSpecialChars(part) {
      return SPEC_CHAR_REGEX.test(part);
    }
    function shouldBeQuoted(part) {
      return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part));
    }
  }
});

// ../../node_modules/lodash/_arrayReduce.js
var require_arrayReduce = __commonJS({
  "../../node_modules/lodash/_arrayReduce.js"(exports, module2) {
    init_cjs_shims();
    function arrayReduce(array2, iteratee, accumulator, initAccum) {
      var index2 = -1, length = array2 == null ? 0 : array2.length;
      if (initAccum && length) {
        accumulator = array2[++index2];
      }
      while (++index2 < length) {
        accumulator = iteratee(accumulator, array2[index2], index2, array2);
      }
      return accumulator;
    }
    module2.exports = arrayReduce;
  }
});

// ../../node_modules/lodash/_basePropertyOf.js
var require_basePropertyOf = __commonJS({
  "../../node_modules/lodash/_basePropertyOf.js"(exports, module2) {
    init_cjs_shims();
    function basePropertyOf(object2) {
      return function(key) {
        return object2 == null ? void 0 : object2[key];
      };
    }
    module2.exports = basePropertyOf;
  }
});

// ../../node_modules/lodash/_deburrLetter.js
var require_deburrLetter = __commonJS({
  "../../node_modules/lodash/_deburrLetter.js"(exports, module2) {
    init_cjs_shims();
    var basePropertyOf = require_basePropertyOf();
    var deburredLetters = {
      "\xC0": "A",
      "\xC1": "A",
      "\xC2": "A",
      "\xC3": "A",
      "\xC4": "A",
      "\xC5": "A",
      "\xE0": "a",
      "\xE1": "a",
      "\xE2": "a",
      "\xE3": "a",
      "\xE4": "a",
      "\xE5": "a",
      "\xC7": "C",
      "\xE7": "c",
      "\xD0": "D",
      "\xF0": "d",
      "\xC8": "E",
      "\xC9": "E",
      "\xCA": "E",
      "\xCB": "E",
      "\xE8": "e",
      "\xE9": "e",
      "\xEA": "e",
      "\xEB": "e",
      "\xCC": "I",
      "\xCD": "I",
      "\xCE": "I",
      "\xCF": "I",
      "\xEC": "i",
      "\xED": "i",
      "\xEE": "i",
      "\xEF": "i",
      "\xD1": "N",
      "\xF1": "n",
      "\xD2": "O",
      "\xD3": "O",
      "\xD4": "O",
      "\xD5": "O",
      "\xD6": "O",
      "\xD8": "O",
      "\xF2": "o",
      "\xF3": "o",
      "\xF4": "o",
      "\xF5": "o",
      "\xF6": "o",
      "\xF8": "o",
      "\xD9": "U",
      "\xDA": "U",
      "\xDB": "U",
      "\xDC": "U",
      "\xF9": "u",
      "\xFA": "u",
      "\xFB": "u",
      "\xFC": "u",
      "\xDD": "Y",
      "\xFD": "y",
      "\xFF": "y",
      "\xC6": "Ae",
      "\xE6": "ae",
      "\xDE": "Th",
      "\xFE": "th",
      "\xDF": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010A": "C",
      "\u010C": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010B": "c",
      "\u010D": "c",
      "\u010E": "D",
      "\u0110": "D",
      "\u010F": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011A": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011B": "e",
      "\u011C": "G",
      "\u011E": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011D": "g",
      "\u011F": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012A": "I",
      "\u012C": "I",
      "\u012E": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012B": "i",
      "\u012D": "i",
      "\u012F": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013B": "L",
      "\u013D": "L",
      "\u013F": "L",
      "\u0141": "L",
      "\u013A": "l",
      "\u013C": "l",
      "\u013E": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014A": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014B": "n",
      "\u014C": "O",
      "\u014E": "O",
      "\u0150": "O",
      "\u014D": "o",
      "\u014F": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015A": "S",
      "\u015C": "S",
      "\u015E": "S",
      "\u0160": "S",
      "\u015B": "s",
      "\u015D": "s",
      "\u015F": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016A": "U",
      "\u016C": "U",
      "\u016E": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016B": "u",
      "\u016D": "u",
      "\u016F": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017B": "Z",
      "\u017D": "Z",
      "\u017A": "z",
      "\u017C": "z",
      "\u017E": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017F": "s"
    };
    var deburrLetter = basePropertyOf(deburredLetters);
    module2.exports = deburrLetter;
  }
});

// ../../node_modules/lodash/deburr.js
var require_deburr = __commonJS({
  "../../node_modules/lodash/deburr.js"(exports, module2) {
    init_cjs_shims();
    var deburrLetter = require_deburrLetter();
    var toString2 = require_toString();
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsCombo = "[" + rsComboRange + "]";
    var reComboMark = RegExp(rsCombo, "g");
    function deburr(string2) {
      string2 = toString2(string2);
      return string2 && string2.replace(reLatin, deburrLetter).replace(reComboMark, "");
    }
    module2.exports = deburr;
  }
});

// ../../node_modules/lodash/_asciiWords.js
var require_asciiWords = __commonJS({
  "../../node_modules/lodash/_asciiWords.js"(exports, module2) {
    init_cjs_shims();
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    function asciiWords(string2) {
      return string2.match(reAsciiWord) || [];
    }
    module2.exports = asciiWords;
  }
});

// ../../node_modules/lodash/_hasUnicodeWord.js
var require_hasUnicodeWord = __commonJS({
  "../../node_modules/lodash/_hasUnicodeWord.js"(exports, module2) {
    init_cjs_shims();
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    function hasUnicodeWord(string2) {
      return reHasUnicodeWord.test(string2);
    }
    module2.exports = hasUnicodeWord;
  }
});

// ../../node_modules/lodash/_unicodeWords.js
var require_unicodeWords = __commonJS({
  "../../node_modules/lodash/_unicodeWords.js"(exports, module2) {
    init_cjs_shims();
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsDingbatRange = "\\u2700-\\u27bf";
    var rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff";
    var rsMathOpRange = "\\xac\\xb1\\xd7\\xf7";
    var rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf";
    var rsPunctuationRange = "\\u2000-\\u206f";
    var rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000";
    var rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde";
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['\u2019]";
    var rsBreak = "[" + rsBreakRange + "]";
    var rsCombo = "[" + rsComboRange + "]";
    var rsDigits = "\\d+";
    var rsDingbat = "[" + rsDingbatRange + "]";
    var rsLower = "[" + rsLowerRange + "]";
    var rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]";
    var rsFitz = "\\ud83c[\\udffb-\\udfff]";
    var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
    var rsNonAstral = "[^" + rsAstralRange + "]";
    var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
    var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
    var rsUpper = "[" + rsUpperRange + "]";
    var rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")";
    var rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")";
    var rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?";
    var rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?";
    var reOptMod = rsModifier + "?";
    var rsOptVar = "[" + rsVarRange + "]?";
    var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
    var rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])";
    var rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])";
    var rsSeq = rsOptVar + reOptMod + rsOptJoin;
    var rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq;
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    function unicodeWords(string2) {
      return string2.match(reUnicodeWord) || [];
    }
    module2.exports = unicodeWords;
  }
});

// ../../node_modules/lodash/words.js
var require_words = __commonJS({
  "../../node_modules/lodash/words.js"(exports, module2) {
    init_cjs_shims();
    var asciiWords = require_asciiWords();
    var hasUnicodeWord = require_hasUnicodeWord();
    var toString2 = require_toString();
    var unicodeWords = require_unicodeWords();
    function words(string2, pattern, guard) {
      string2 = toString2(string2);
      pattern = guard ? void 0 : pattern;
      if (pattern === void 0) {
        return hasUnicodeWord(string2) ? unicodeWords(string2) : asciiWords(string2);
      }
      return string2.match(pattern) || [];
    }
    module2.exports = words;
  }
});

// ../../node_modules/lodash/_createCompounder.js
var require_createCompounder = __commonJS({
  "../../node_modules/lodash/_createCompounder.js"(exports, module2) {
    init_cjs_shims();
    var arrayReduce = require_arrayReduce();
    var deburr = require_deburr();
    var words = require_words();
    var rsApos = "['\u2019]";
    var reApos = RegExp(rsApos, "g");
    function createCompounder(callback) {
      return function(string2) {
        return arrayReduce(words(deburr(string2).replace(reApos, "")), callback, "");
      };
    }
    module2.exports = createCompounder;
  }
});

// ../../node_modules/lodash/snakeCase.js
var require_snakeCase = __commonJS({
  "../../node_modules/lodash/snakeCase.js"(exports, module2) {
    init_cjs_shims();
    var createCompounder = require_createCompounder();
    var snakeCase2 = createCompounder(function(result, word, index2) {
      return result + (index2 ? "_" : "") + word.toLowerCase();
    });
    module2.exports = snakeCase2;
  }
});

// ../../node_modules/lodash/_baseSlice.js
var require_baseSlice = __commonJS({
  "../../node_modules/lodash/_baseSlice.js"(exports, module2) {
    init_cjs_shims();
    function baseSlice(array2, start2, end2) {
      var index2 = -1, length = array2.length;
      if (start2 < 0) {
        start2 = -start2 > length ? 0 : length + start2;
      }
      end2 = end2 > length ? length : end2;
      if (end2 < 0) {
        end2 += length;
      }
      length = start2 > end2 ? 0 : end2 - start2 >>> 0;
      start2 >>>= 0;
      var result = Array(length);
      while (++index2 < length) {
        result[index2] = array2[index2 + start2];
      }
      return result;
    }
    module2.exports = baseSlice;
  }
});

// ../../node_modules/lodash/_castSlice.js
var require_castSlice = __commonJS({
  "../../node_modules/lodash/_castSlice.js"(exports, module2) {
    init_cjs_shims();
    var baseSlice = require_baseSlice();
    function castSlice(array2, start2, end2) {
      var length = array2.length;
      end2 = end2 === void 0 ? length : end2;
      return !start2 && end2 >= length ? array2 : baseSlice(array2, start2, end2);
    }
    module2.exports = castSlice;
  }
});

// ../../node_modules/lodash/_hasUnicode.js
var require_hasUnicode = __commonJS({
  "../../node_modules/lodash/_hasUnicode.js"(exports, module2) {
    init_cjs_shims();
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsZWJ = "\\u200d";
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    function hasUnicode(string2) {
      return reHasUnicode.test(string2);
    }
    module2.exports = hasUnicode;
  }
});

// ../../node_modules/lodash/_asciiToArray.js
var require_asciiToArray = __commonJS({
  "../../node_modules/lodash/_asciiToArray.js"(exports, module2) {
    init_cjs_shims();
    function asciiToArray(string2) {
      return string2.split("");
    }
    module2.exports = asciiToArray;
  }
});

// ../../node_modules/lodash/_unicodeToArray.js
var require_unicodeToArray = __commonJS({
  "../../node_modules/lodash/_unicodeToArray.js"(exports, module2) {
    init_cjs_shims();
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsAstral = "[" + rsAstralRange + "]";
    var rsCombo = "[" + rsComboRange + "]";
    var rsFitz = "\\ud83c[\\udffb-\\udfff]";
    var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
    var rsNonAstral = "[^" + rsAstralRange + "]";
    var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
    var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
    var rsZWJ = "\\u200d";
    var reOptMod = rsModifier + "?";
    var rsOptVar = "[" + rsVarRange + "]?";
    var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
    var rsSeq = rsOptVar + reOptMod + rsOptJoin;
    var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    function unicodeToArray(string2) {
      return string2.match(reUnicode) || [];
    }
    module2.exports = unicodeToArray;
  }
});

// ../../node_modules/lodash/_stringToArray.js
var require_stringToArray = __commonJS({
  "../../node_modules/lodash/_stringToArray.js"(exports, module2) {
    init_cjs_shims();
    var asciiToArray = require_asciiToArray();
    var hasUnicode = require_hasUnicode();
    var unicodeToArray = require_unicodeToArray();
    function stringToArray(string2) {
      return hasUnicode(string2) ? unicodeToArray(string2) : asciiToArray(string2);
    }
    module2.exports = stringToArray;
  }
});

// ../../node_modules/lodash/_createCaseFirst.js
var require_createCaseFirst = __commonJS({
  "../../node_modules/lodash/_createCaseFirst.js"(exports, module2) {
    init_cjs_shims();
    var castSlice = require_castSlice();
    var hasUnicode = require_hasUnicode();
    var stringToArray = require_stringToArray();
    var toString2 = require_toString();
    function createCaseFirst(methodName) {
      return function(string2) {
        string2 = toString2(string2);
        var strSymbols = hasUnicode(string2) ? stringToArray(string2) : void 0;
        var chr = strSymbols ? strSymbols[0] : string2.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string2.slice(1);
        return chr[methodName]() + trailing;
      };
    }
    module2.exports = createCaseFirst;
  }
});

// ../../node_modules/lodash/upperFirst.js
var require_upperFirst = __commonJS({
  "../../node_modules/lodash/upperFirst.js"(exports, module2) {
    init_cjs_shims();
    var createCaseFirst = require_createCaseFirst();
    var upperFirst = createCaseFirst("toUpperCase");
    module2.exports = upperFirst;
  }
});

// ../../node_modules/lodash/capitalize.js
var require_capitalize = __commonJS({
  "../../node_modules/lodash/capitalize.js"(exports, module2) {
    init_cjs_shims();
    var toString2 = require_toString();
    var upperFirst = require_upperFirst();
    function capitalize(string2) {
      return upperFirst(toString2(string2).toLowerCase());
    }
    module2.exports = capitalize;
  }
});

// ../../node_modules/lodash/camelCase.js
var require_camelCase = __commonJS({
  "../../node_modules/lodash/camelCase.js"(exports, module2) {
    init_cjs_shims();
    var capitalize = require_capitalize();
    var createCompounder = require_createCompounder();
    var camelCase2 = createCompounder(function(result, word, index2) {
      word = word.toLowerCase();
      return result + (index2 ? capitalize(word) : word);
    });
    module2.exports = camelCase2;
  }
});

// ../../node_modules/lodash/mapKeys.js
var require_mapKeys = __commonJS({
  "../../node_modules/lodash/mapKeys.js"(exports, module2) {
    init_cjs_shims();
    var baseAssignValue = require_baseAssignValue();
    var baseForOwn = require_baseForOwn();
    var baseIteratee = require_baseIteratee();
    function mapKeys2(object2, iteratee) {
      var result = {};
      iteratee = baseIteratee(iteratee, 3);
      baseForOwn(object2, function(value, key, object3) {
        baseAssignValue(result, iteratee(value, key, object3), value);
      });
      return result;
    }
    module2.exports = mapKeys2;
  }
});

// ../../node_modules/toposort/index.js
var require_toposort = __commonJS({
  "../../node_modules/toposort/index.js"(exports, module2) {
    init_cjs_shims();
    module2.exports = function(edges) {
      return toposort2(uniqueNodes(edges), edges);
    };
    module2.exports.array = toposort2;
    function toposort2(nodes, edges) {
      var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = makeOutgoingEdges(edges), nodesHash = makeNodesHash(nodes);
      edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
          throw new Error("Unknown node. There is an unknown node in the supplied edges.");
        }
      });
      while (i--) {
        if (!visited[i])
          visit(nodes[i], i, /* @__PURE__ */ new Set());
      }
      return sorted;
      function visit(node, i2, predecessors) {
        if (predecessors.has(node)) {
          var nodeRep;
          try {
            nodeRep = ", node was:" + JSON.stringify(node);
          } catch (e) {
            nodeRep = "";
          }
          throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) {
          throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        }
        if (visited[i2])
          return;
        visited[i2] = true;
        var outgoing = outgoingEdges.get(node) || /* @__PURE__ */ new Set();
        outgoing = Array.from(outgoing);
        if (i2 = outgoing.length) {
          predecessors.add(node);
          do {
            var child = outgoing[--i2];
            visit(child, nodesHash.get(child), predecessors);
          } while (i2);
          predecessors.delete(node);
        }
        sorted[--cursor] = node;
      }
    }
    function uniqueNodes(arr) {
      var res = /* @__PURE__ */ new Set();
      for (var i = 0, len = arr.length; i < len; i++) {
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
      }
      return Array.from(res);
    }
    function makeOutgoingEdges(arr) {
      var edges = /* @__PURE__ */ new Map();
      for (var i = 0, len = arr.length; i < len; i++) {
        var edge = arr[i];
        if (!edges.has(edge[0]))
          edges.set(edge[0], /* @__PURE__ */ new Set());
        if (!edges.has(edge[1]))
          edges.set(edge[1], /* @__PURE__ */ new Set());
        edges.get(edge[0]).add(edge[1]);
      }
      return edges;
    }
    function makeNodesHash(arr) {
      var res = /* @__PURE__ */ new Map();
      for (var i = 0, len = arr.length; i < len; i++) {
        res.set(arr[i], i);
      }
      return res;
    }
  }
});

// ../../node_modules/lodash/isString.js
var require_isString = __commonJS({
  "../../node_modules/lodash/isString.js"(exports, module2) {
    init_cjs_shims();
    var baseGetTag = require_baseGetTag();
    var isArray = require_isArray();
    var isObjectLike = require_isObjectLike();
    var stringTag = "[object String]";
    function isString(value) {
      return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
    }
    module2.exports = isString;
  }
});

// ../../node_modules/lodash/_castFunction.js
var require_castFunction = __commonJS({
  "../../node_modules/lodash/_castFunction.js"(exports, module2) {
    init_cjs_shims();
    var identity = require_identity();
    function castFunction(value) {
      return typeof value == "function" ? value : identity;
    }
    module2.exports = castFunction;
  }
});

// ../../node_modules/lodash/forOwn.js
var require_forOwn = __commonJS({
  "../../node_modules/lodash/forOwn.js"(exports, module2) {
    init_cjs_shims();
    var baseForOwn = require_baseForOwn();
    var castFunction = require_castFunction();
    function forOwn(object2, iteratee) {
      return object2 && baseForOwn(object2, castFunction(iteratee));
    }
    module2.exports = forOwn;
  }
});

// ../../node_modules/lodash/_getPrototype.js
var require_getPrototype = __commonJS({
  "../../node_modules/lodash/_getPrototype.js"(exports, module2) {
    init_cjs_shims();
    var overArg = require_overArg();
    var getPrototype = overArg(Object.getPrototypeOf, Object);
    module2.exports = getPrototype;
  }
});

// ../../node_modules/lodash/isPlainObject.js
var require_isPlainObject = __commonJS({
  "../../node_modules/lodash/isPlainObject.js"(exports, module2) {
    init_cjs_shims();
    var baseGetTag = require_baseGetTag();
    var getPrototype = require_getPrototype();
    var isObjectLike = require_isObjectLike();
    var objectTag = "[object Object]";
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var objectCtorString = funcToString.call(Object);
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
      return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }
    module2.exports = isPlainObject;
  }
});

// ../../node_modules/lodash/_createBaseEach.js
var require_createBaseEach = __commonJS({
  "../../node_modules/lodash/_createBaseEach.js"(exports, module2) {
    init_cjs_shims();
    var isArrayLike = require_isArrayLike();
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length, index2 = fromRight ? length : -1, iterable = Object(collection);
        while (fromRight ? index2-- : ++index2 < length) {
          if (iteratee(iterable[index2], index2, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }
    module2.exports = createBaseEach;
  }
});

// ../../node_modules/lodash/_baseEach.js
var require_baseEach = __commonJS({
  "../../node_modules/lodash/_baseEach.js"(exports, module2) {
    init_cjs_shims();
    var baseForOwn = require_baseForOwn();
    var createBaseEach = require_createBaseEach();
    var baseEach = createBaseEach(baseForOwn);
    module2.exports = baseEach;
  }
});

// ../../node_modules/lodash/_baseMap.js
var require_baseMap = __commonJS({
  "../../node_modules/lodash/_baseMap.js"(exports, module2) {
    init_cjs_shims();
    var baseEach = require_baseEach();
    var isArrayLike = require_isArrayLike();
    function baseMap(collection, iteratee) {
      var index2 = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
      baseEach(collection, function(value, key, collection2) {
        result[++index2] = iteratee(value, key, collection2);
      });
      return result;
    }
    module2.exports = baseMap;
  }
});

// ../../node_modules/lodash/map.js
var require_map = __commonJS({
  "../../node_modules/lodash/map.js"(exports, module2) {
    init_cjs_shims();
    var arrayMap = require_arrayMap();
    var baseIteratee = require_baseIteratee();
    var baseMap = require_baseMap();
    var isArray = require_isArray();
    function map9(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, baseIteratee(iteratee, 3));
    }
    module2.exports = map9;
  }
});

// ../../node_modules/reactcss/lib/flattenNames.js
var require_flattenNames = __commonJS({
  "../../node_modules/reactcss/lib/flattenNames.js"(exports) {
    "use strict";
    init_cjs_shims();
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.flattenNames = void 0;
    var _isString2 = require_isString();
    var _isString3 = _interopRequireDefault(_isString2);
    var _forOwn2 = require_forOwn();
    var _forOwn3 = _interopRequireDefault(_forOwn2);
    var _isPlainObject2 = require_isPlainObject();
    var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
    var _map2 = require_map();
    var _map3 = _interopRequireDefault(_map2);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var flattenNames = exports.flattenNames = function flattenNames2() {
      var things = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      var names = [];
      (0, _map3.default)(things, function(thing) {
        if (Array.isArray(thing)) {
          flattenNames2(thing).map(function(name) {
            return names.push(name);
          });
        } else if ((0, _isPlainObject3.default)(thing)) {
          (0, _forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + "-" + value);
          });
        } else if ((0, _isString3.default)(thing)) {
          names.push(thing);
        }
      });
      return names;
    };
    exports.default = flattenNames;
  }
});

// ../../node_modules/lodash/_arrayEach.js
var require_arrayEach = __commonJS({
  "../../node_modules/lodash/_arrayEach.js"(exports, module2) {
    init_cjs_shims();
    function arrayEach(array2, iteratee) {
      var index2 = -1, length = array2 == null ? 0 : array2.length;
      while (++index2 < length) {
        if (iteratee(array2[index2], index2, array2) === false) {
          break;
        }
      }
      return array2;
    }
    module2.exports = arrayEach;
  }
});

// ../../node_modules/lodash/_assignValue.js
var require_assignValue = __commonJS({
  "../../node_modules/lodash/_assignValue.js"(exports, module2) {
    init_cjs_shims();
    var baseAssignValue = require_baseAssignValue();
    var eq = require_eq();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function assignValue(object2, key, value) {
      var objValue = object2[key];
      if (!(hasOwnProperty.call(object2, key) && eq(objValue, value)) || value === void 0 && !(key in object2)) {
        baseAssignValue(object2, key, value);
      }
    }
    module2.exports = assignValue;
  }
});

// ../../node_modules/lodash/_copyObject.js
var require_copyObject = __commonJS({
  "../../node_modules/lodash/_copyObject.js"(exports, module2) {
    init_cjs_shims();
    var assignValue = require_assignValue();
    var baseAssignValue = require_baseAssignValue();
    function copyObject(source, props, object2, customizer) {
      var isNew = !object2;
      object2 || (object2 = {});
      var index2 = -1, length = props.length;
      while (++index2 < length) {
        var key = props[index2];
        var newValue = customizer ? customizer(object2[key], source[key], key, object2, source) : void 0;
        if (newValue === void 0) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object2, key, newValue);
        } else {
          assignValue(object2, key, newValue);
        }
      }
      return object2;
    }
    module2.exports = copyObject;
  }
});

// ../../node_modules/lodash/_baseAssign.js
var require_baseAssign = __commonJS({
  "../../node_modules/lodash/_baseAssign.js"(exports, module2) {
    init_cjs_shims();
    var copyObject = require_copyObject();
    var keys = require_keys();
    function baseAssign(object2, source) {
      return object2 && copyObject(source, keys(source), object2);
    }
    module2.exports = baseAssign;
  }
});

// ../../node_modules/lodash/_nativeKeysIn.js
var require_nativeKeysIn = __commonJS({
  "../../node_modules/lodash/_nativeKeysIn.js"(exports, module2) {
    init_cjs_shims();
    function nativeKeysIn(object2) {
      var result = [];
      if (object2 != null) {
        for (var key in Object(object2)) {
          result.push(key);
        }
      }
      return result;
    }
    module2.exports = nativeKeysIn;
  }
});

// ../../node_modules/lodash/_baseKeysIn.js
var require_baseKeysIn = __commonJS({
  "../../node_modules/lodash/_baseKeysIn.js"(exports, module2) {
    init_cjs_shims();
    var isObject4 = require_isObject();
    var isPrototype = require_isPrototype();
    var nativeKeysIn = require_nativeKeysIn();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function baseKeysIn(object2) {
      if (!isObject4(object2)) {
        return nativeKeysIn(object2);
      }
      var isProto = isPrototype(object2), result = [];
      for (var key in object2) {
        if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object2, key)))) {
          result.push(key);
        }
      }
      return result;
    }
    module2.exports = baseKeysIn;
  }
});

// ../../node_modules/lodash/keysIn.js
var require_keysIn = __commonJS({
  "../../node_modules/lodash/keysIn.js"(exports, module2) {
    init_cjs_shims();
    var arrayLikeKeys = require_arrayLikeKeys();
    var baseKeysIn = require_baseKeysIn();
    var isArrayLike = require_isArrayLike();
    function keysIn(object2) {
      return isArrayLike(object2) ? arrayLikeKeys(object2, true) : baseKeysIn(object2);
    }
    module2.exports = keysIn;
  }
});

// ../../node_modules/lodash/_baseAssignIn.js
var require_baseAssignIn = __commonJS({
  "../../node_modules/lodash/_baseAssignIn.js"(exports, module2) {
    init_cjs_shims();
    var copyObject = require_copyObject();
    var keysIn = require_keysIn();
    function baseAssignIn(object2, source) {
      return object2 && copyObject(source, keysIn(source), object2);
    }
    module2.exports = baseAssignIn;
  }
});

// ../../node_modules/lodash/_cloneBuffer.js
var require_cloneBuffer = __commonJS({
  "../../node_modules/lodash/_cloneBuffer.js"(exports, module2) {
    init_cjs_shims();
    var root = require_root();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module2 == "object" && module2 && !module2.nodeType && module2;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : void 0;
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
      buffer.copy(result);
      return result;
    }
    module2.exports = cloneBuffer;
  }
});

// ../../node_modules/lodash/_copyArray.js
var require_copyArray = __commonJS({
  "../../node_modules/lodash/_copyArray.js"(exports, module2) {
    init_cjs_shims();
    function copyArray(source, array2) {
      var index2 = -1, length = source.length;
      array2 || (array2 = Array(length));
      while (++index2 < length) {
        array2[index2] = source[index2];
      }
      return array2;
    }
    module2.exports = copyArray;
  }
});

// ../../node_modules/lodash/_copySymbols.js
var require_copySymbols = __commonJS({
  "../../node_modules/lodash/_copySymbols.js"(exports, module2) {
    init_cjs_shims();
    var copyObject = require_copyObject();
    var getSymbols = require_getSymbols();
    function copySymbols(source, object2) {
      return copyObject(source, getSymbols(source), object2);
    }
    module2.exports = copySymbols;
  }
});

// ../../node_modules/lodash/_getSymbolsIn.js
var require_getSymbolsIn = __commonJS({
  "../../node_modules/lodash/_getSymbolsIn.js"(exports, module2) {
    init_cjs_shims();
    var arrayPush = require_arrayPush();
    var getPrototype = require_getPrototype();
    var getSymbols = require_getSymbols();
    var stubArray = require_stubArray();
    var nativeGetSymbols = Object.getOwnPropertySymbols;
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object2) {
      var result = [];
      while (object2) {
        arrayPush(result, getSymbols(object2));
        object2 = getPrototype(object2);
      }
      return result;
    };
    module2.exports = getSymbolsIn;
  }
});

// ../../node_modules/lodash/_copySymbolsIn.js
var require_copySymbolsIn = __commonJS({
  "../../node_modules/lodash/_copySymbolsIn.js"(exports, module2) {
    init_cjs_shims();
    var copyObject = require_copyObject();
    var getSymbolsIn = require_getSymbolsIn();
    function copySymbolsIn(source, object2) {
      return copyObject(source, getSymbolsIn(source), object2);
    }
    module2.exports = copySymbolsIn;
  }
});

// ../../node_modules/lodash/_getAllKeysIn.js
var require_getAllKeysIn = __commonJS({
  "../../node_modules/lodash/_getAllKeysIn.js"(exports, module2) {
    init_cjs_shims();
    var baseGetAllKeys = require_baseGetAllKeys();
    var getSymbolsIn = require_getSymbolsIn();
    var keysIn = require_keysIn();
    function getAllKeysIn(object2) {
      return baseGetAllKeys(object2, keysIn, getSymbolsIn);
    }
    module2.exports = getAllKeysIn;
  }
});

// ../../node_modules/lodash/_initCloneArray.js
var require_initCloneArray = __commonJS({
  "../../node_modules/lodash/_initCloneArray.js"(exports, module2) {
    init_cjs_shims();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function initCloneArray(array2) {
      var length = array2.length, result = new array2.constructor(length);
      if (length && typeof array2[0] == "string" && hasOwnProperty.call(array2, "index")) {
        result.index = array2.index;
        result.input = array2.input;
      }
      return result;
    }
    module2.exports = initCloneArray;
  }
});

// ../../node_modules/lodash/_cloneArrayBuffer.js
var require_cloneArrayBuffer = __commonJS({
  "../../node_modules/lodash/_cloneArrayBuffer.js"(exports, module2) {
    init_cjs_shims();
    var Uint8Array2 = require_Uint8Array();
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array2(result).set(new Uint8Array2(arrayBuffer));
      return result;
    }
    module2.exports = cloneArrayBuffer;
  }
});

// ../../node_modules/lodash/_cloneDataView.js
var require_cloneDataView = __commonJS({
  "../../node_modules/lodash/_cloneDataView.js"(exports, module2) {
    init_cjs_shims();
    var cloneArrayBuffer = require_cloneArrayBuffer();
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }
    module2.exports = cloneDataView;
  }
});

// ../../node_modules/lodash/_cloneRegExp.js
var require_cloneRegExp = __commonJS({
  "../../node_modules/lodash/_cloneRegExp.js"(exports, module2) {
    init_cjs_shims();
    var reFlags = /\w*$/;
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }
    module2.exports = cloneRegExp;
  }
});

// ../../node_modules/lodash/_cloneSymbol.js
var require_cloneSymbol = __commonJS({
  "../../node_modules/lodash/_cloneSymbol.js"(exports, module2) {
    init_cjs_shims();
    var Symbol2 = require_Symbol();
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }
    module2.exports = cloneSymbol;
  }
});

// ../../node_modules/lodash/_cloneTypedArray.js
var require_cloneTypedArray = __commonJS({
  "../../node_modules/lodash/_cloneTypedArray.js"(exports, module2) {
    init_cjs_shims();
    var cloneArrayBuffer = require_cloneArrayBuffer();
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    module2.exports = cloneTypedArray;
  }
});

// ../../node_modules/lodash/_initCloneByTag.js
var require_initCloneByTag = __commonJS({
  "../../node_modules/lodash/_initCloneByTag.js"(exports, module2) {
    init_cjs_shims();
    var cloneArrayBuffer = require_cloneArrayBuffer();
    var cloneDataView = require_cloneDataView();
    var cloneRegExp = require_cloneRegExp();
    var cloneSymbol = require_cloneSymbol();
    var cloneTypedArray = require_cloneTypedArray();
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var symbolTag = "[object Symbol]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    function initCloneByTag(object2, tag, isDeep) {
      var Ctor = object2.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object2);
        case boolTag:
        case dateTag:
          return new Ctor(+object2);
        case dataViewTag:
          return cloneDataView(object2, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
          return cloneTypedArray(object2, isDeep);
        case mapTag:
          return new Ctor();
        case numberTag:
        case stringTag:
          return new Ctor(object2);
        case regexpTag:
          return cloneRegExp(object2);
        case setTag:
          return new Ctor();
        case symbolTag:
          return cloneSymbol(object2);
      }
    }
    module2.exports = initCloneByTag;
  }
});

// ../../node_modules/lodash/_baseCreate.js
var require_baseCreate = __commonJS({
  "../../node_modules/lodash/_baseCreate.js"(exports, module2) {
    init_cjs_shims();
    var isObject4 = require_isObject();
    var objectCreate = Object.create;
    var baseCreate = function() {
      function object2() {
      }
      return function(proto) {
        if (!isObject4(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object2.prototype = proto;
        var result = new object2();
        object2.prototype = void 0;
        return result;
      };
    }();
    module2.exports = baseCreate;
  }
});

// ../../node_modules/lodash/_initCloneObject.js
var require_initCloneObject = __commonJS({
  "../../node_modules/lodash/_initCloneObject.js"(exports, module2) {
    init_cjs_shims();
    var baseCreate = require_baseCreate();
    var getPrototype = require_getPrototype();
    var isPrototype = require_isPrototype();
    function initCloneObject(object2) {
      return typeof object2.constructor == "function" && !isPrototype(object2) ? baseCreate(getPrototype(object2)) : {};
    }
    module2.exports = initCloneObject;
  }
});

// ../../node_modules/lodash/_baseIsMap.js
var require_baseIsMap = __commonJS({
  "../../node_modules/lodash/_baseIsMap.js"(exports, module2) {
    init_cjs_shims();
    var getTag2 = require_getTag();
    var isObjectLike = require_isObjectLike();
    var mapTag = "[object Map]";
    function baseIsMap(value) {
      return isObjectLike(value) && getTag2(value) == mapTag;
    }
    module2.exports = baseIsMap;
  }
});

// ../../node_modules/lodash/isMap.js
var require_isMap = __commonJS({
  "../../node_modules/lodash/isMap.js"(exports, module2) {
    init_cjs_shims();
    var baseIsMap = require_baseIsMap();
    var baseUnary = require_baseUnary();
    var nodeUtil = require_nodeUtil();
    var nodeIsMap = nodeUtil && nodeUtil.isMap;
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
    module2.exports = isMap;
  }
});

// ../../node_modules/lodash/_baseIsSet.js
var require_baseIsSet = __commonJS({
  "../../node_modules/lodash/_baseIsSet.js"(exports, module2) {
    init_cjs_shims();
    var getTag2 = require_getTag();
    var isObjectLike = require_isObjectLike();
    var setTag = "[object Set]";
    function baseIsSet(value) {
      return isObjectLike(value) && getTag2(value) == setTag;
    }
    module2.exports = baseIsSet;
  }
});

// ../../node_modules/lodash/isSet.js
var require_isSet = __commonJS({
  "../../node_modules/lodash/isSet.js"(exports, module2) {
    init_cjs_shims();
    var baseIsSet = require_baseIsSet();
    var baseUnary = require_baseUnary();
    var nodeUtil = require_nodeUtil();
    var nodeIsSet = nodeUtil && nodeUtil.isSet;
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
    module2.exports = isSet;
  }
});

// ../../node_modules/lodash/_baseClone.js
var require_baseClone = __commonJS({
  "../../node_modules/lodash/_baseClone.js"(exports, module2) {
    init_cjs_shims();
    var Stack = require_Stack();
    var arrayEach = require_arrayEach();
    var assignValue = require_assignValue();
    var baseAssign = require_baseAssign();
    var baseAssignIn = require_baseAssignIn();
    var cloneBuffer = require_cloneBuffer();
    var copyArray = require_copyArray();
    var copySymbols = require_copySymbols();
    var copySymbolsIn = require_copySymbolsIn();
    var getAllKeys = require_getAllKeys();
    var getAllKeysIn = require_getAllKeysIn();
    var getTag2 = require_getTag();
    var initCloneArray = require_initCloneArray();
    var initCloneByTag = require_initCloneByTag();
    var initCloneObject = require_initCloneObject();
    var isArray = require_isArray();
    var isBuffer = require_isBuffer();
    var isMap = require_isMap();
    var isObject4 = require_isObject();
    var isSet = require_isSet();
    var keys = require_keys();
    var keysIn = require_keysIn();
    var CLONE_DEEP_FLAG = 1;
    var CLONE_FLAT_FLAG = 2;
    var CLONE_SYMBOLS_FLAG = 4;
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var objectTag = "[object Object]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var symbolTag = "[object Symbol]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    function baseClone2(value, bitmask, customizer, key, object2, stack) {
      var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
      if (customizer) {
        result = object2 ? customizer(value, key, object2, stack) : customizer(value);
      }
      if (result !== void 0) {
        return result;
      }
      if (!isObject4(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag2(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || isFunc && !object2) {
          result = isFlat || isFunc ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object2 ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      stack || (stack = new Stack());
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);
      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone2(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key2) {
          result.set(key2, baseClone2(subValue, bitmask, customizer, key2, value, stack));
        });
      }
      var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
      var props = isArr ? void 0 : keysFunc(value);
      arrayEach(props || value, function(subValue, key2) {
        if (props) {
          key2 = subValue;
          subValue = value[key2];
        }
        assignValue(result, key2, baseClone2(subValue, bitmask, customizer, key2, value, stack));
      });
      return result;
    }
    module2.exports = baseClone2;
  }
});

// ../../node_modules/lodash/cloneDeep.js
var require_cloneDeep = __commonJS({
  "../../node_modules/lodash/cloneDeep.js"(exports, module2) {
    init_cjs_shims();
    var baseClone2 = require_baseClone();
    var CLONE_DEEP_FLAG = 1;
    var CLONE_SYMBOLS_FLAG = 4;
    function cloneDeep(value) {
      return baseClone2(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }
    module2.exports = cloneDeep;
  }
});

// ../../node_modules/reactcss/lib/mergeClasses.js
var require_mergeClasses = __commonJS({
  "../../node_modules/reactcss/lib/mergeClasses.js"(exports) {
    "use strict";
    init_cjs_shims();
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.mergeClasses = void 0;
    var _forOwn2 = require_forOwn();
    var _forOwn3 = _interopRequireDefault(_forOwn2);
    var _cloneDeep2 = require_cloneDeep();
    var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
    var _extends14 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var mergeClasses = exports.mergeClasses = function mergeClasses2(classes) {
      var activeNames = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
      var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
      activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) {
          (0, _forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) {
              styles[key] = {};
            }
            styles[key] = _extends14({}, styles[key], toMerge[key]);
          });
        }
        return name;
      });
      return styles;
    };
    exports.default = mergeClasses;
  }
});

// ../../node_modules/reactcss/lib/autoprefix.js
var require_autoprefix = __commonJS({
  "../../node_modules/reactcss/lib/autoprefix.js"(exports) {
    "use strict";
    init_cjs_shims();
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.autoprefix = void 0;
    var _forOwn2 = require_forOwn();
    var _forOwn3 = _interopRequireDefault(_forOwn2);
    var _extends14 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var transforms = {
      borderRadius: function borderRadius(value) {
        return {
          msBorderRadius: value,
          MozBorderRadius: value,
          OBorderRadius: value,
          WebkitBorderRadius: value,
          borderRadius: value
        };
      },
      boxShadow: function boxShadow(value) {
        return {
          msBoxShadow: value,
          MozBoxShadow: value,
          OBoxShadow: value,
          WebkitBoxShadow: value,
          boxShadow: value
        };
      },
      userSelect: function userSelect(value) {
        return {
          WebkitTouchCallout: value,
          KhtmlUserSelect: value,
          MozUserSelect: value,
          msUserSelect: value,
          WebkitUserSelect: value,
          userSelect: value
        };
      },
      flex: function flex(value) {
        return {
          WebkitBoxFlex: value,
          MozBoxFlex: value,
          WebkitFlex: value,
          msFlex: value,
          flex: value
        };
      },
      flexBasis: function flexBasis(value) {
        return {
          WebkitFlexBasis: value,
          flexBasis: value
        };
      },
      justifyContent: function justifyContent(value) {
        return {
          WebkitJustifyContent: value,
          justifyContent: value
        };
      },
      transition: function transition(value) {
        return {
          msTransition: value,
          MozTransition: value,
          OTransition: value,
          WebkitTransition: value,
          transition: value
        };
      },
      transform: function transform(value) {
        return {
          msTransform: value,
          MozTransform: value,
          OTransform: value,
          WebkitTransform: value,
          transform: value
        };
      },
      absolute: function absolute(value) {
        var direction = value && value.split(" ");
        return {
          position: "absolute",
          top: direction && direction[0],
          right: direction && direction[1],
          bottom: direction && direction[2],
          left: direction && direction[3]
        };
      },
      extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) {
          return otherStyle;
        }
        return {
          "extend": name
        };
      }
    };
    var autoprefix = exports.autoprefix = function autoprefix2(elements) {
      var prefixed = {};
      (0, _forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, _forOwn3.default)(styles, function(value, key) {
          var transform = transforms[key];
          if (transform) {
            expanded = _extends14({}, expanded, transform(value));
          } else {
            expanded[key] = value;
          }
        });
        prefixed[element] = expanded;
      });
      return prefixed;
    };
    exports.default = autoprefix;
  }
});

// ../../node_modules/reactcss/lib/components/hover.js
var require_hover = __commonJS({
  "../../node_modules/reactcss/lib/components/hover.js"(exports) {
    "use strict";
    init_cjs_shims();
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.hover = void 0;
    var _extends14 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _react = require("react");
    var _react2 = _interopRequireDefault(_react);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function _classCallCheck9(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn9(self2, call) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self2;
    }
    function _inherits9(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass)
        Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var hover = exports.hover = function hover2(Component7) {
      var Span = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
      return function(_React$Component) {
        _inherits9(Hover, _React$Component);
        function Hover() {
          var _ref;
          var _temp, _this, _ret;
          _classCallCheck9(this, Hover);
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return _ret = (_temp = (_this = _possibleConstructorReturn9(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function() {
            return _this.setState({ hover: true });
          }, _this.handleMouseOut = function() {
            return _this.setState({ hover: false });
          }, _this.render = function() {
            return _react2.default.createElement(
              Span,
              { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
              _react2.default.createElement(Component7, _extends14({}, _this.props, _this.state))
            );
          }, _temp), _possibleConstructorReturn9(_this, _ret);
        }
        return Hover;
      }(_react2.default.Component);
    };
    exports.default = hover;
  }
});

// ../../node_modules/reactcss/lib/components/active.js
var require_active = __commonJS({
  "../../node_modules/reactcss/lib/components/active.js"(exports) {
    "use strict";
    init_cjs_shims();
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.active = void 0;
    var _extends14 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    var _react = require("react");
    var _react2 = _interopRequireDefault(_react);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function _classCallCheck9(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn9(self2, call) {
      if (!self2) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self2;
    }
    function _inherits9(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
      if (superClass)
        Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var active = exports.active = function active2(Component7) {
      var Span = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
      return function(_React$Component) {
        _inherits9(Active, _React$Component);
        function Active() {
          var _ref;
          var _temp, _this, _ret;
          _classCallCheck9(this, Active);
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return _ret = (_temp = (_this = _possibleConstructorReturn9(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function() {
            return _this.setState({ active: true });
          }, _this.handleMouseUp = function() {
            return _this.setState({ active: false });
          }, _this.render = function() {
            return _react2.default.createElement(
              Span,
              { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
              _react2.default.createElement(Component7, _extends14({}, _this.props, _this.state))
            );
          }, _temp), _possibleConstructorReturn9(_this, _ret);
        }
        return Active;
      }(_react2.default.Component);
    };
    exports.default = active;
  }
});

// ../../node_modules/reactcss/lib/loop.js
var require_loop = __commonJS({
  "../../node_modules/reactcss/lib/loop.js"(exports) {
    "use strict";
    init_cjs_shims();
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var loopable = function loopable2(i, length) {
      var props = {};
      var setProp = function setProp2(name) {
        var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        props[name] = value;
      };
      i === 0 && setProp("first-child");
      i === length - 1 && setProp("last-child");
      (i === 0 || i % 2 === 0) && setProp("even");
      Math.abs(i % 2) === 1 && setProp("odd");
      setProp("nth-child", i);
      return props;
    };
    exports.default = loopable;
  }
});

// ../../node_modules/reactcss/lib/index.js
var require_lib = __commonJS({
  "../../node_modules/reactcss/lib/index.js"(exports) {
    "use strict";
    init_cjs_shims();
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = void 0;
    var _flattenNames = require_flattenNames();
    var _flattenNames2 = _interopRequireDefault(_flattenNames);
    var _mergeClasses = require_mergeClasses();
    var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
    var _autoprefix = require_autoprefix();
    var _autoprefix2 = _interopRequireDefault(_autoprefix);
    var _hover2 = require_hover();
    var _hover3 = _interopRequireDefault(_hover2);
    var _active = require_active();
    var _active2 = _interopRequireDefault(_active);
    var _loop2 = require_loop();
    var _loop3 = _interopRequireDefault(_loop2);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    exports.hover = _hover3.default;
    exports.handleHover = _hover3.default;
    exports.handleActive = _active2.default;
    exports.loop = _loop3.default;
    var ReactCSS = exports.ReactCSS = function ReactCSS2(classes) {
      for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        activations[_key - 1] = arguments[_key];
      }
      var activeNames = (0, _flattenNames2.default)(activations);
      var merged = (0, _mergeClasses2.default)(classes, activeNames);
      return (0, _autoprefix2.default)(merged);
    };
    exports.default = ReactCSS;
  }
});

// ../../node_modules/lodash/now.js
var require_now = __commonJS({
  "../../node_modules/lodash/now.js"(exports, module2) {
    init_cjs_shims();
    var root = require_root();
    var now = function() {
      return root.Date.now();
    };
    module2.exports = now;
  }
});

// ../../node_modules/lodash/_trimmedEndIndex.js
var require_trimmedEndIndex = __commonJS({
  "../../node_modules/lodash/_trimmedEndIndex.js"(exports, module2) {
    init_cjs_shims();
    var reWhitespace = /\s/;
    function trimmedEndIndex(string2) {
      var index2 = string2.length;
      while (index2-- && reWhitespace.test(string2.charAt(index2))) {
      }
      return index2;
    }
    module2.exports = trimmedEndIndex;
  }
});

// ../../node_modules/lodash/_baseTrim.js
var require_baseTrim = __commonJS({
  "../../node_modules/lodash/_baseTrim.js"(exports, module2) {
    init_cjs_shims();
    var trimmedEndIndex = require_trimmedEndIndex();
    var reTrimStart = /^\s+/;
    function baseTrim(string2) {
      return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
    }
    module2.exports = baseTrim;
  }
});

// ../../node_modules/lodash/toNumber.js
var require_toNumber = __commonJS({
  "../../node_modules/lodash/toNumber.js"(exports, module2) {
    init_cjs_shims();
    var baseTrim = require_baseTrim();
    var isObject4 = require_isObject();
    var isSymbol = require_isSymbol();
    var NAN = 0 / 0;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    function toNumber2(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject4(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject4(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module2.exports = toNumber2;
  }
});

// ../../node_modules/lodash/debounce.js
var require_debounce = __commonJS({
  "../../node_modules/lodash/debounce.js"(exports, module2) {
    init_cjs_shims();
    var isObject4 = require_isObject();
    var now = require_now();
    var toNumber2 = require_toNumber();
    var FUNC_ERROR_TEXT = "Expected a function";
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    function debounce3(func, wait, options) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber2(wait) || 0;
      if (isObject4(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber2(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    module2.exports = debounce3;
  }
});

// ../../node_modules/lodash/throttle.js
var require_throttle = __commonJS({
  "../../node_modules/lodash/throttle.js"(exports, module2) {
    init_cjs_shims();
    var debounce3 = require_debounce();
    var isObject4 = require_isObject();
    var FUNC_ERROR_TEXT = "Expected a function";
    function throttle2(func, wait, options) {
      var leading = true, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject4(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      return debounce3(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
      });
    }
    module2.exports = throttle2;
  }
});

// ../../node_modules/lodash/forEach.js
var require_forEach = __commonJS({
  "../../node_modules/lodash/forEach.js"(exports, module2) {
    init_cjs_shims();
    var arrayEach = require_arrayEach();
    var baseEach = require_baseEach();
    var castFunction = require_castFunction();
    var isArray = require_isArray();
    function forEach2(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, castFunction(iteratee));
    }
    module2.exports = forEach2;
  }
});

// ../../node_modules/lodash/each.js
var require_each = __commonJS({
  "../../node_modules/lodash/each.js"(exports, module2) {
    init_cjs_shims();
    module2.exports = require_forEach();
  }
});

// ../../node_modules/tinycolor2/tinycolor.js
var require_tinycolor = __commonJS({
  "../../node_modules/tinycolor2/tinycolor.js"(exports, module2) {
    init_cjs_shims();
    (function(Math2) {
      var trimLeft = /^\s+/, trimRight = /\s+$/, tinyCounter = 0, mathRound = Math2.round, mathMin = Math2.min, mathMax = Math2.max, mathRandom = Math2.random;
      function tinycolor2(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        if (color instanceof tinycolor2) {
          return color;
        }
        if (!(this instanceof tinycolor2)) {
          return new tinycolor2(color, opts);
        }
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = mathRound(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        if (this._r < 1) {
          this._r = mathRound(this._r);
        }
        if (this._g < 1) {
          this._g = mathRound(this._g);
        }
        if (this._b < 1) {
          this._b = mathRound(this._b);
        }
        this._ok = rgb.ok;
        this._tc_id = tinyCounter++;
      }
      tinycolor2.prototype = {
        isDark: function() {
          return this.getBrightness() < 128;
        },
        isLight: function() {
          return !this.isDark();
        },
        isValid: function() {
          return this._ok;
        },
        getOriginalInput: function() {
          return this._originalInput;
        },
        getFormat: function() {
          return this._format;
        },
        getAlpha: function() {
          return this._a;
        },
        getBrightness: function() {
          var rgb = this.toRgb();
          return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
        },
        getLuminance: function() {
          var rgb = this.toRgb();
          var RsRGB, GsRGB, BsRGB, R, G, B;
          RsRGB = rgb.r / 255;
          GsRGB = rgb.g / 255;
          BsRGB = rgb.b / 255;
          if (RsRGB <= 0.03928) {
            R = RsRGB / 12.92;
          } else {
            R = Math2.pow((RsRGB + 0.055) / 1.055, 2.4);
          }
          if (GsRGB <= 0.03928) {
            G = GsRGB / 12.92;
          } else {
            G = Math2.pow((GsRGB + 0.055) / 1.055, 2.4);
          }
          if (BsRGB <= 0.03928) {
            B = BsRGB / 12.92;
          } else {
            B = Math2.pow((BsRGB + 0.055) / 1.055, 2.4);
          }
          return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function(value) {
          this._a = boundAlpha(value);
          this._roundA = mathRound(100 * this._a) / 100;
          return this;
        },
        toHsv: function() {
          var hsv = rgbToHsv(this._r, this._g, this._b);
          return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
        },
        toHsvString: function() {
          var hsv = rgbToHsv(this._r, this._g, this._b);
          var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
          return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function() {
          var hsl = rgbToHsl(this._r, this._g, this._b);
          return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
        },
        toHslString: function() {
          var hsl = rgbToHsl(this._r, this._g, this._b);
          var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
          return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function(allow3Char) {
          return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function(allow3Char) {
          return "#" + this.toHex(allow3Char);
        },
        toHex8: function(allow4Char) {
          return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function(allow4Char) {
          return "#" + this.toHex8(allow4Char);
        },
        toRgb: function() {
          return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
        },
        toRgbString: function() {
          return this._a == 1 ? "rgb(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" : "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function() {
          return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
        },
        toPercentageRgbString: function() {
          return this._a == 1 ? "rgb(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" : "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function() {
          if (this._a === 0) {
            return "transparent";
          }
          if (this._a < 1) {
            return false;
          }
          return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function(secondColor) {
          var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
          var secondHex8String = hex8String;
          var gradientType = this._gradientType ? "GradientType = 1, " : "";
          if (secondColor) {
            var s = tinycolor2(secondColor);
            secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
          }
          return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function(format2) {
          var formatSet = !!format2;
          format2 = format2 || this._format;
          var formattedString = false;
          var hasAlpha = this._a < 1 && this._a >= 0;
          var needsAlphaFormat = !formatSet && hasAlpha && (format2 === "hex" || format2 === "hex6" || format2 === "hex3" || format2 === "hex4" || format2 === "hex8" || format2 === "name");
          if (needsAlphaFormat) {
            if (format2 === "name" && this._a === 0) {
              return this.toName();
            }
            return this.toRgbString();
          }
          if (format2 === "rgb") {
            formattedString = this.toRgbString();
          }
          if (format2 === "prgb") {
            formattedString = this.toPercentageRgbString();
          }
          if (format2 === "hex" || format2 === "hex6") {
            formattedString = this.toHexString();
          }
          if (format2 === "hex3") {
            formattedString = this.toHexString(true);
          }
          if (format2 === "hex4") {
            formattedString = this.toHex8String(true);
          }
          if (format2 === "hex8") {
            formattedString = this.toHex8String();
          }
          if (format2 === "name") {
            formattedString = this.toName();
          }
          if (format2 === "hsl") {
            formattedString = this.toHslString();
          }
          if (format2 === "hsv") {
            formattedString = this.toHsvString();
          }
          return formattedString || this.toHexString();
        },
        clone: function() {
          return tinycolor2(this.toString());
        },
        _applyModification: function(fn2, args) {
          var color = fn2.apply(null, [this].concat([].slice.call(args)));
          this._r = color._r;
          this._g = color._g;
          this._b = color._b;
          this.setAlpha(color._a);
          return this;
        },
        lighten: function() {
          return this._applyModification(lighten, arguments);
        },
        brighten: function() {
          return this._applyModification(brighten, arguments);
        },
        darken: function() {
          return this._applyModification(darken, arguments);
        },
        desaturate: function() {
          return this._applyModification(desaturate, arguments);
        },
        saturate: function() {
          return this._applyModification(saturate, arguments);
        },
        greyscale: function() {
          return this._applyModification(greyscale, arguments);
        },
        spin: function() {
          return this._applyModification(spin, arguments);
        },
        _applyCombination: function(fn2, args) {
          return fn2.apply(null, [this].concat([].slice.call(args)));
        },
        analogous: function() {
          return this._applyCombination(analogous, arguments);
        },
        complement: function() {
          return this._applyCombination(complement, arguments);
        },
        monochromatic: function() {
          return this._applyCombination(monochromatic, arguments);
        },
        splitcomplement: function() {
          return this._applyCombination(splitcomplement, arguments);
        },
        triad: function() {
          return this._applyCombination(triad, arguments);
        },
        tetrad: function() {
          return this._applyCombination(tetrad, arguments);
        }
      };
      tinycolor2.fromRatio = function(color, opts) {
        if (typeof color == "object") {
          var newColor = {};
          for (var i in color) {
            if (color.hasOwnProperty(i)) {
              if (i === "a") {
                newColor[i] = color[i];
              } else {
                newColor[i] = convertToPercentage(color[i]);
              }
            }
          }
          color = newColor;
        }
        return tinycolor2(color, opts);
      };
      function inputToRGB(color) {
        var rgb = { r: 0, g: 0, b: 0 };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format2 = false;
        if (typeof color == "string") {
          color = stringInputToObject(color);
        }
        if (typeof color == "object") {
          if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format2 = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
          } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format2 = "hsv";
          } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format2 = "hsl";
          }
          if (color.hasOwnProperty("a")) {
            a = color.a;
          }
        }
        a = boundAlpha(a);
        return {
          ok,
          format: color.format || format2,
          r: mathMin(255, mathMax(rgb.r, 0)),
          g: mathMin(255, mathMax(rgb.g, 0)),
          b: mathMin(255, mathMax(rgb.b, 0)),
          a
        };
      }
      function rgbToRgb(r, g, b) {
        return {
          r: bound01(r, 255) * 255,
          g: bound01(g, 255) * 255,
          b: bound01(b, 255) * 255
        };
      }
      function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max2 = mathMax(r, g, b), min2 = mathMin(r, g, b);
        var h, s, l = (max2 + min2) / 2;
        if (max2 == min2) {
          h = s = 0;
        } else {
          var d = max2 - min2;
          s = l > 0.5 ? d / (2 - max2 - min2) : d / (max2 + min2);
          switch (max2) {
            case r:
              h = (g - b) / d + (g < b ? 6 : 0);
              break;
            case g:
              h = (b - r) / d + 2;
              break;
            case b:
              h = (r - g) / d + 4;
              break;
          }
          h /= 6;
        }
        return { h, s, l };
      }
      function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p2, q2, t) {
          if (t < 0)
            t += 1;
          if (t > 1)
            t -= 1;
          if (t < 1 / 6)
            return p2 + (q2 - p2) * 6 * t;
          if (t < 1 / 2)
            return q2;
          if (t < 2 / 3)
            return p2 + (q2 - p2) * (2 / 3 - t) * 6;
          return p2;
        }
        if (s === 0) {
          r = g = b = l;
        } else {
          var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
          var p = 2 * l - q;
          r = hue2rgb(p, q, h + 1 / 3);
          g = hue2rgb(p, q, h);
          b = hue2rgb(p, q, h - 1 / 3);
        }
        return { r: r * 255, g: g * 255, b: b * 255 };
      }
      function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max2 = mathMax(r, g, b), min2 = mathMin(r, g, b);
        var h, s, v = max2;
        var d = max2 - min2;
        s = max2 === 0 ? 0 : d / max2;
        if (max2 == min2) {
          h = 0;
        } else {
          switch (max2) {
            case r:
              h = (g - b) / d + (g < b ? 6 : 0);
              break;
            case g:
              h = (b - r) / d + 2;
              break;
            case b:
              h = (r - g) / d + 4;
              break;
          }
          h /= 6;
        }
        return { h, s, v };
      }
      function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math2.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [v, q, p, p, t, v][mod], g = [t, v, v, q, p, p][mod], b = [p, p, t, v, v, q][mod];
        return { r: r * 255, g: g * 255, b: b * 255 };
      }
      function rgbToHex(r, g, b, allow3Char) {
        var hex = [
          pad2(mathRound(r).toString(16)),
          pad2(mathRound(g).toString(16)),
          pad2(mathRound(b).toString(16))
        ];
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
          return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        }
        return hex.join("");
      }
      function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
          pad2(mathRound(r).toString(16)),
          pad2(mathRound(g).toString(16)),
          pad2(mathRound(b).toString(16)),
          pad2(convertDecimalToHex(a))
        ];
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
          return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        }
        return hex.join("");
      }
      function rgbaToArgbHex(r, g, b, a) {
        var hex = [
          pad2(convertDecimalToHex(a)),
          pad2(mathRound(r).toString(16)),
          pad2(mathRound(g).toString(16)),
          pad2(mathRound(b).toString(16))
        ];
        return hex.join("");
      }
      tinycolor2.equals = function(color1, color2) {
        if (!color1 || !color2) {
          return false;
        }
        return tinycolor2(color1).toRgbString() == tinycolor2(color2).toRgbString();
      };
      tinycolor2.random = function() {
        return tinycolor2.fromRatio({
          r: mathRandom(),
          g: mathRandom(),
          b: mathRandom()
        });
      };
      function desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor2(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor2(hsl);
      }
      function saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor2(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor2(hsl);
      }
      function greyscale(color) {
        return tinycolor2(color).desaturate(100);
      }
      function lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor2(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor2(hsl);
      }
      function brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor2(color).toRgb();
        rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * -(amount / 100))));
        rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * -(amount / 100))));
        rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * -(amount / 100))));
        return tinycolor2(rgb);
      }
      function darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor2(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor2(hsl);
      }
      function spin(color, amount) {
        var hsl = tinycolor2(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor2(hsl);
      }
      function complement(color) {
        var hsl = tinycolor2(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor2(hsl);
      }
      function triad(color) {
        var hsl = tinycolor2(color).toHsl();
        var h = hsl.h;
        return [
          tinycolor2(color),
          tinycolor2({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
          tinycolor2({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
        ];
      }
      function tetrad(color) {
        var hsl = tinycolor2(color).toHsl();
        var h = hsl.h;
        return [
          tinycolor2(color),
          tinycolor2({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
          tinycolor2({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
          tinycolor2({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
        ];
      }
      function splitcomplement(color) {
        var hsl = tinycolor2(color).toHsl();
        var h = hsl.h;
        return [
          tinycolor2(color),
          tinycolor2({ h: (h + 72) % 360, s: hsl.s, l: hsl.l }),
          tinycolor2({ h: (h + 216) % 360, s: hsl.s, l: hsl.l })
        ];
      }
      function analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor2(color).toHsl();
        var part = 360 / slices;
        var ret = [tinycolor2(color)];
        for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
          hsl.h = (hsl.h + part) % 360;
          ret.push(tinycolor2(hsl));
        }
        return ret;
      }
      function monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor2(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while (results--) {
          ret.push(tinycolor2({ h, s, v }));
          v = (v + modification) % 1;
        }
        return ret;
      }
      tinycolor2.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor2(color1).toRgb();
        var rgb2 = tinycolor2(color2).toRgb();
        var p = amount / 100;
        var rgba = {
          r: (rgb2.r - rgb1.r) * p + rgb1.r,
          g: (rgb2.g - rgb1.g) * p + rgb1.g,
          b: (rgb2.b - rgb1.b) * p + rgb1.b,
          a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor2(rgba);
      };
      tinycolor2.readability = function(color1, color2) {
        var c1 = tinycolor2(color1);
        var c2 = tinycolor2(color2);
        return (Math2.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math2.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
      };
      tinycolor2.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor2.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch (wcag2Parms.level + wcag2Parms.size) {
          case "AAsmall":
          case "AAAlarge":
            out = readability >= 4.5;
            break;
          case "AAlarge":
            out = readability >= 3;
            break;
          case "AAAsmall":
            out = readability >= 7;
            break;
        }
        return out;
      };
      tinycolor2.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for (var i = 0; i < colorList.length; i++) {
          readability = tinycolor2.readability(baseColor, colorList[i]);
          if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor2(colorList[i]);
          }
        }
        if (tinycolor2.isReadable(baseColor, bestColor, { "level": level, "size": size }) || !includeFallbackColors) {
          return bestColor;
        } else {
          args.includeFallbackColors = false;
          return tinycolor2.mostReadable(baseColor, ["#fff", "#000"], args);
        }
      };
      var names = tinycolor2.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
      };
      var hexNames = tinycolor2.hexNames = flip2(names);
      function flip2(o) {
        var flipped = {};
        for (var i in o) {
          if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
          }
        }
        return flipped;
      }
      function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) {
          a = 1;
        }
        return a;
      }
      function bound01(n, max2) {
        if (isOnePointZero(n)) {
          n = "100%";
        }
        var processPercent = isPercentage(n);
        n = mathMin(max2, mathMax(0, parseFloat(n)));
        if (processPercent) {
          n = parseInt(n * max2, 10) / 100;
        }
        if (Math2.abs(n - max2) < 1e-6) {
          return 1;
        }
        return n % max2 / parseFloat(max2);
      }
      function clamp01(val) {
        return mathMin(1, mathMax(0, val));
      }
      function parseIntFromHex(val) {
        return parseInt(val, 16);
      }
      function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
      }
      function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
      }
      function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
      }
      function convertToPercentage(n) {
        if (n <= 1) {
          n = n * 100 + "%";
        }
        return n;
      }
      function convertDecimalToHex(d) {
        return Math2.round(parseFloat(d) * 255).toString(16);
      }
      function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
      }
      var matchers = function() {
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
          CSS_UNIT: new RegExp(CSS_UNIT),
          rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
          rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
          hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
          hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
          hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
          hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
          hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
          hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
      }();
      function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
      }
      function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
          color = names[color];
          named = true;
        } else if (color == "transparent") {
          return { r: 0, g: 0, b: 0, a: 0, format: "name" };
        }
        var match;
        if (match = matchers.rgb.exec(color)) {
          return { r: match[1], g: match[2], b: match[3] };
        }
        if (match = matchers.rgba.exec(color)) {
          return { r: match[1], g: match[2], b: match[3], a: match[4] };
        }
        if (match = matchers.hsl.exec(color)) {
          return { h: match[1], s: match[2], l: match[3] };
        }
        if (match = matchers.hsla.exec(color)) {
          return { h: match[1], s: match[2], l: match[3], a: match[4] };
        }
        if (match = matchers.hsv.exec(color)) {
          return { h: match[1], s: match[2], v: match[3] };
        }
        if (match = matchers.hsva.exec(color)) {
          return { h: match[1], s: match[2], v: match[3], a: match[4] };
        }
        if (match = matchers.hex8.exec(color)) {
          return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
          };
        }
        if (match = matchers.hex6.exec(color)) {
          return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
          };
        }
        if (match = matchers.hex4.exec(color)) {
          return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
          };
        }
        if (match = matchers.hex3.exec(color)) {
          return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
          };
        }
        return false;
      }
      function validateWCAG2Parms(parms) {
        var level, size;
        parms = parms || { "level": "AA", "size": "small" };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") {
          level = "AA";
        }
        if (size !== "small" && size !== "large") {
          size = "small";
        }
        return { "level": level, "size": size };
      }
      if (typeof module2 !== "undefined" && module2.exports) {
        module2.exports = tinycolor2;
      } else if (typeof define === "function" && define.amd) {
        define(function() {
          return tinycolor2;
        });
      } else {
        window.tinycolor = tinycolor2;
      }
    })(Math);
  }
});

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  ActionItemWrapper: () => ActionItemWrapper,
  ColorPickerInput: () => ColorPickerInput_default,
  ContinueButtonPreviewerWrapper: () => ContinueButtonPreviewerWrapper,
  Designer: () => Designer,
  DesignerContext: () => DesignerContext,
  ExplanationTranslatable: () => ExplanationTranslatable,
  ExtraItemDesigner: () => ExtraItemDesigner,
  ExtraItemDesignerPreviewer: () => ExtraItemDesignerPreviewer,
  ExtraItemPreviewer: () => ExtraItemPreviewer,
  FieldPreviewer: () => FieldPreviewer,
  FileUpload: () => FileUpload_default,
  FileUploadMedium: () => FileUploadMedium_default,
  FontFamily: () => fontFamily_default,
  FontSize: () => fontSize_default,
  FontWeight: () => fontWeight_default,
  HeaderWrapper: () => HeaderWrapper,
  IntroItemDesigner: () => IntroItemDesigner,
  IntroItemDesignerPreviewer: () => IntroItemDesignerPreviewer,
  IntroItemPreviewer: () => IntroItemPreviewer,
  LanguageDropdownWrapper: () => LanguageDropdownWrapper,
  LikertQuestionItemDesigner: () => LikertQuestionItemDesigner,
  LinearProgressBar: () => LinearProgressBar_default,
  LoadingOverlay: () => LoadingOverlay_default,
  LogoFieldPreviewer: () => LogoFieldPreviewer,
  MatrixQuestionsWrapper: () => MatrixQuestionsWrapper,
  MatrixSurveyQuestionAndTitleContent: () => MatrixSurveyQuestionAndTitleContent,
  MatrixSurveyWrapper: () => MatrixSurveyWrapper,
  MultiSelectionQuestionItemDesigner: () => MultiSelectionQuestionItemDesigner,
  MultiSelectionQuestionItemDesignerPreviewer: () => MultiSelectionQuestionItemDesignerPreviewer,
  MultiSelectionQuestionItemPreviewer: () => MultiSelectionQuestionItemPreviewer,
  NavigationButtons: () => NavigationButtons,
  OpinionScaleQuestionItemDesigner: () => OpinionScaleQuestionItemDesigner,
  OpinionScaleQuestionItemDesignerPreviewer: () => OpinionScaleQuestionItemDesignerPreviewer,
  OpinionScaleQuestionItemPreviewer: () => OpinionScaleQuestionItemPreviewer,
  OpinionScaleType: () => OpinionScaleType,
  OptionsAndExplanationsWrapper: () => OptionsAndExplanationsWrapper,
  OutroItemPreviewer: () => OutroItemPreviewer,
  PoweredBySeeNext: () => PoweredBySeeNext2,
  Previewer: () => Previewer,
  PreviewerContext: () => PreviewerContext,
  ScaleFieldPreviewer: () => ScaleFieldPreviewer,
  SingleSelectionQuestionItemDesigner: () => SingleSelectionQuestionItemDesigner,
  SingleSelectionQuestionItemDesignerPreviewer: () => SingleSelectionQuestionItemDesignerPreviewer,
  SingleSelectionQuestionItemPreviewer: () => SingleSelectionQuestionItemPreviewer,
  StyledAnswerPreviewerGroup: () => StyledAnswerPreviewerGroup,
  StyledAnswerPreviewerGroupWrapper: () => StyledAnswerPreviewerGroupWrapper,
  StyledAnswerPreviewerOpinionScaleGroup: () => StyledAnswerPreviewerOpinionScaleGroup,
  StyledDesignerPreviewer: () => StyledDesignerPreviewer,
  StyledDesignerPreviewerBackgroundColor: () => StyledDesignerPreviewerBackgroundColor,
  StyledDesignerPreviewerBody: () => StyledDesignerPreviewerBody,
  StyledDesignerPreviewerFooter: () => StyledDesignerPreviewerFooter,
  StyledDesignerPreviewerGroup: () => StyledDesignerPreviewerGroup,
  StyledDesignerPreviewerOpinionScaleGroup: () => StyledDesignerPreviewerOpinionScaleGroup,
  StyledDesignerQuestionPreviewerBody: () => StyledDesignerQuestionPreviewerBody,
  StyledExplanationRow: () => StyledExplanationRow,
  StyledExplanationText: () => StyledExplanationText,
  StyledExplanations: () => StyledExplanations,
  StyledFieldDesignerPreviewer: () => StyledFieldDesignerPreviewer,
  StyledFieldPreviewer: () => StyledFieldPreviewer,
  StyledFormGroupDesignerPreviewer: () => StyledFormGroupDesignerPreviewer,
  StyledFormGroupPreviewer: () => StyledFormGroupPreviewer,
  StyledFormikErrorMessage: () => StyledFormikErrorMessage,
  StyledIconButtonNext: () => StyledIconButtonNext,
  StyledIconButtonPrevious: () => StyledIconButtonPrevious,
  StyledIconStar: () => StyledIconStar,
  StyledInputDesignerPreviewer: () => StyledInputDesignerPreviewer,
  StyledInputDesignerPreviewerWrapper: () => StyledInputDesignerPreviewerWrapper,
  StyledInputFieldDesignerPreviewer: () => StyledInputFieldDesignerPreviewer,
  StyledInputFieldPreviewer: () => StyledInputFieldPreviewer,
  StyledInputPreviewer: () => StyledInputPreviewer,
  StyledInputPreviewerWrapper: () => StyledInputPreviewerWrapper,
  StyledIntroPage: () => StyledIntroPage,
  StyledIntroPagePreviewer: () => StyledIntroPagePreviewer,
  StyledIntroSubtext: () => StyledIntroSubtext,
  StyledLabelDesignerPreviewer: () => StyledLabelDesignerPreviewer,
  StyledLabelPreviewer: () => StyledLabelPreviewer,
  StyledLikertAnswerPreviewerGroupWrapper: () => StyledLikertAnswerPreviewerGroupWrapper,
  StyledLikertDesignerPreviewer: () => StyledLikertDesignerPreviewer,
  StyledLikertFormGroupPreviewer: () => StyledLikertFormGroupPreviewer,
  StyledLikertSelectFieldDesignerPreviewer: () => StyledLikertSelectFieldDesignerPreviewer,
  StyledLikertTitle: () => StyledLikertTitle,
  StyledLogo: () => StyledLogo,
  StyledLogoDesignerPreviewer: () => StyledLogoDesignerPreviewer,
  StyledLogoImageDesignerPreviewer: () => StyledLogoImageDesignerPreviewer,
  StyledLogoImagePreviewer: () => StyledLogoImagePreviewer,
  StyledLogoPreviewer: () => StyledLogoPreviewer,
  StyledMatrixDesignerPreviewer: () => StyledMatrixDesignerPreviewer,
  StyledMatrixDesignerQuestionPreviewerBody: () => StyledMatrixDesignerQuestionPreviewerBody,
  StyledMultiSelect: () => StyledMultiSelect,
  StyledMultiSelectFormGroupPreviewer: () => StyledMultiSelectFormGroupPreviewer,
  StyledNavigationButtons: () => StyledNavigationButtons,
  StyledOpinionScaleAnswerPreviewerGroupWrapper: () => StyledOpinionScaleAnswerPreviewerGroupWrapper,
  StyledOpinionScaleDesignerPreviewer: () => StyledOpinionScaleDesignerPreviewer,
  StyledOutroPreviewerBody: () => StyledOutroPreviewerBody,
  StyledPoweredBySeeNext: () => StyledPoweredBySeeNext,
  StyledPoweredBySeeNextDesignerPreviewer: () => StyledPoweredBySeeNextDesignerPreviewer,
  StyledPoweredBySeeNextImage: () => StyledPoweredBySeeNextImage,
  StyledPoweredBySeeNextImageDesignerPreviewer: () => StyledPoweredBySeeNextImageDesignerPreviewer,
  StyledPreviewer: () => StyledPreviewer,
  StyledPreviewerBody: () => StyledPreviewerBody,
  StyledPreviewerFooter: () => StyledPreviewerFooter,
  StyledPreviewerGroup: () => StyledPreviewerGroup,
  StyledPrivacyPolicy: () => StyledPrivacyPolicy,
  StyledPrivacyPolicySmall: () => StyledPrivacyPolicySmall,
  StyledQuestionTitle: () => StyledQuestionTitle,
  StyledScaleEmotionItemDesignerPreviewer: () => StyledScaleEmotionItemDesignerPreviewer,
  StyledScaleEmotionItemPreviewer: () => StyledScaleEmotionItemPreviewer,
  StyledScaleFieldDesignerPreviewer: () => StyledScaleFieldDesignerPreviewer,
  StyledScaleFieldItemDesignerPreviewerWrapper: () => StyledScaleFieldItemDesignerPreviewerWrapper,
  StyledScaleFieldItemPreviewerWrapper: () => StyledScaleFieldItemPreviewerWrapper,
  StyledScaleFieldPreviewer: () => StyledScaleFieldPreviewer,
  StyledScaleItemDesignerPreviewer: () => StyledScaleItemDesignerPreviewer,
  StyledScaleItemPreviewer: () => StyledScaleItemPreviewer,
  StyledScaleNumberItemDesignerPreviewer: () => StyledScaleNumberItemDesignerPreviewer,
  StyledScaleNumberItemPreviewer: () => StyledScaleNumberItemPreviewer,
  StyledScaleStarItemDesignerPreviewer: () => StyledScaleStarItemDesignerPreviewer,
  StyledScaleStarItemPreviewer: () => StyledScaleStarItemPreviewer,
  StyledSelectFieldDesignerPreviewer: () => StyledSelectFieldDesignerPreviewer,
  StyledSingleSelectDesignerPreviewer: () => StyledSingleSelectDesignerPreviewer,
  StyledSliderItemDesignerPreviewer: () => StyledSliderItemDesignerPreviewer,
  StyledStarScaleFieldDesignerPreviewer: () => StyledStarScaleFieldDesignerPreviewer,
  StyledStarScaleFieldItemDesignerPreviewerWrapper: () => StyledStarScaleFieldItemDesignerPreviewerWrapper,
  StyledSubtext: () => StyledSubtext,
  StyledTextAreaFieldDesignerPreviewer: () => StyledTextAreaFieldDesignerPreviewer,
  StyledTextAreaFieldPreviewer: () => StyledTextAreaFieldPreviewer,
  StyledTextInputPreviewerGroup: () => StyledTextInputPreviewerGroup,
  StyledTitle: () => StyledTitle,
  StyledTranslatableTextAreaFieldPreviewer: () => StyledTranslatableTextAreaFieldPreviewer,
  SubmitButtonPreviewerWrapper: () => SubmitButtonPreviewerWrapper,
  SurveyItemType: () => SurveyItemType,
  SurveyQuestionAndTitleContainer: () => SurveyQuestionAndTitleContainer,
  SurveyQuestionAndTitleContent: () => SurveyQuestionAndTitleContent,
  SurveyQuestionTitleIndex: () => SurveyQuestionTitleIndex,
  SurveyType: () => SurveyType,
  TextQuestionItemDesigner: () => TextQuestionItemDesigner,
  TextQuestionItemDesignerPreviewer: () => TextQuestionItemDesignerPreviewer,
  TextQuestionItemPreviewer: () => TextQuestionItemPreviewer,
  TranslatableFieldPreviewer: () => TranslatableFieldPreviewer,
  TranslatableInputFieldPreviewer: () => TranslatableInputFieldPreviewer,
  TranslatableMultiSelectionFieldPreviewer: () => TranslatableMultiSelectionFieldPreviewer,
  TranslatableSingleSelectionFieldPreviewer: () => TranslatableSingleSelectionFieldPreviewer,
  TranslatableTextAreaFieldPreviewer: () => TranslatableTextAreaFieldPreviewer,
  emptyExtraItemDesignerInitialValues: () => emptyExtraItemDesignerInitialValues,
  emptyExtraItemPreviewerInitialValues: () => emptyExtraItemPreviewerInitialValues,
  emptyIntroItemDesignerInitialValues: () => emptyIntroItemDesignerInitialValues,
  emptyIntroItemPreviewerInitialValues: () => emptyIntroItemPreviewerInitialValues,
  emptyLikertItemDesignerInitialValues: () => emptyLikertItemDesignerInitialValues,
  emptyMultiSelectionItemDesignerInitialValues: () => emptyMultiSelectionItemDesignerInitialValues,
  emptyMultiSelectionItemPreviewerInitialValues: () => emptyMultiSelectionItemPreviewerInitialValues,
  emptyOpinionScaleQuestionItemDesignerInitialValues: () => emptyOpinionScaleQuestionItemDesignerInitialValues,
  emptyOpinionScaleQuestionItemPreviewerInitialValues: () => emptyOpinionScaleQuestionItemPreviewerInitialValues,
  emptyOutroItemPreviewerInitialValues: () => emptyOutroItemPreviewerInitialValues,
  emptySingleSelectionItemDesignerInitialValues: () => emptySingleSelectionItemDesignerInitialValues,
  emptySingleSelectionItemPreviewerInitialValues: () => emptySingleSelectionItemPreviewerInitialValues,
  emptyTextItemPreviewerInitialValues: () => emptyTextItemPreviewerInitialValues,
  emptyTextQuestionItemDesignerInitialValues: () => emptyTextQuestionItemDesignerInitialValues,
  getElementInCenter: () => getElementInCenter,
  getSurveyItemIndex: () => getSurveyItemIndex,
  getSurveyItemsSize: () => getSurveyItemsSize,
  hexToRGB: () => hexToRGB,
  moveItemInArray: () => moveItemInArray,
  useDesigner: () => useDesigner,
  usePreviewer: () => usePreviewer,
  useScrollPosition: () => useScrollPosition,
  useSurveyNavigationStore: () => useSurveyNavigationStore,
  useSurveyPreviewerStore: () => useSurveyPreviewerStore
});
module.exports = __toCommonJS(src_exports);
init_cjs_shims();

// src/components/index.tsx
init_cjs_shims();

// src/components/Survey/Designer/items/ExtraItemDesigner.tsx
init_cjs_shims();
var import_react21 = require("react");
var import_formik22 = require("formik");
var import_formik23 = require("formik");

// src/components/Survey/Designer/DesignerFormatter/elements/DropdownField.tsx
init_cjs_shims();
var import_react_i18next10 = require("react-i18next");
var import_formik11 = require("formik");
var import_ui21 = require("@btc-snxt/ui");

// src/components/Survey/Designer/DesignerFormatter/DesignerFormatter.style.tsx
init_cjs_shims();
var import_styled_components9 = __toESM(require("styled-components"));
var import_ui20 = require("@btc-snxt/ui");

// ../../node_modules/reactstrap/dist/reactstrap.modern.js
init_cjs_shims();
var import_react3 = __toESM(require("react"), 1);
var import_prop_types3 = __toESM(require_prop_types(), 1);
var import_classnames = __toESM(require_classnames(), 1);

// ../../node_modules/react-popper/lib/esm/index.js
init_cjs_shims();

// ../../node_modules/react-popper/lib/esm/Popper.js
init_cjs_shims();
var React4 = __toESM(require("react"));

// ../../node_modules/react-popper/lib/esm/Manager.js
init_cjs_shims();
var React = __toESM(require("react"));
var ManagerReferenceNodeContext = React.createContext();
var ManagerReferenceNodeSetterContext = React.createContext();
function Manager(_ref) {
  var children = _ref.children;
  var _React$useState = React.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
  var hasUnmounted = React.useRef(false);
  React.useEffect(function() {
    return function() {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = React.useCallback(function(node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /* @__PURE__ */ React.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /* @__PURE__ */ React.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}

// ../../node_modules/react-popper/lib/esm/utils.js
init_cjs_shims();
var React2 = __toESM(require("react"));
var unwrapArray = function unwrapArray2(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke2(fn2) {
  if (typeof fn2 === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return fn2.apply(void 0, args);
  }
};
var setRef = function setRef2(ref, node) {
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } else if (ref != null) {
    ref.current = node;
  }
};
var fromEntries = function fromEntries2(entries) {
  return entries.reduce(function(acc, _ref) {
    var key = _ref[0], value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? React2.useLayoutEffect : React2.useEffect;

// ../../node_modules/react-popper/lib/esm/usePopper.js
init_cjs_shims();
var React3 = __toESM(require("react"));
var ReactDOM = __toESM(require("react-dom"));

// ../../node_modules/@popperjs/core/lib/index.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/enums.js
init_cjs_shims();
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

// ../../node_modules/@popperjs/core/lib/modifiers/applyStyles.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
init_cjs_shims();
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}

// ../../node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getWindow.js
init_cjs_shims();
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

// ../../node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// ../../node_modules/@popperjs/core/lib/modifiers/applyStyles.js
function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function(name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function(style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles_default = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect,
  requires: ["computeStyles"]
};

// ../../node_modules/@popperjs/core/lib/modifiers/arrow.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/utils/getBasePlacement.js
init_cjs_shims();
function getBasePlacement(placement) {
  return placement.split("-")[0];
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/utils/math.js
init_cjs_shims();
var max = Math.max;
var min = Math.min;
var round = Math.round;

// ../../node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/utils/userAgent.js
init_cjs_shims();
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function(item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}

// ../../node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window, visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x,
    y
  };
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}

// ../../node_modules/@popperjs/core/lib/dom-utils/contains.js
init_cjs_shims();
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
init_cjs_shims();
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

// ../../node_modules/@popperjs/core/lib/dom-utils/isTableElement.js
init_cjs_shims();
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
init_cjs_shims();
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css6 = getComputedStyle(currentNode);
    if (css6.transform !== "none" || css6.perspective !== "none" || css6.contain === "paint" || ["transform", "perspective"].indexOf(css6.willChange) !== -1 || isFirefox && css6.willChange === "filter" || isFirefox && css6.filter && css6.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}

// ../../node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
init_cjs_shims();
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}

// ../../node_modules/@popperjs/core/lib/utils/within.js
init_cjs_shims();
function within(min2, value, max2) {
  return max(min2, min(value, max2));
}
function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}

// ../../node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
init_cjs_shims();
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

// ../../node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

// ../../node_modules/@popperjs/core/lib/utils/expandToHashMap.js
init_cjs_shims();
function expandToHashMap(value, keys) {
  return keys.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

// ../../node_modules/@popperjs/core/lib/modifiers/arrow.js
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state, name = _ref.name, options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect2(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "));
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
    }
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow_default = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect2,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};

// ../../node_modules/@popperjs/core/lib/modifiers/computeStyles.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/utils/getVariation.js
init_cjs_shims();
function getVariation(placement) {
  return placement.split("-")[1];
}

// ../../node_modules/@popperjs/core/lib/modifiers/computeStyles.js
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref) {
  var x = _ref.x, y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || "";
    if (adaptive && ["transform", "top", "right", "bottom", "left"].some(function(property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', "\n\n", 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", "\n\n", "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
    }
  }
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles_default = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};

// ../../node_modules/@popperjs/core/lib/modifiers/eventListeners.js
init_cjs_shims();
var passive = {
  passive: true
};
function effect3(_ref) {
  var state = _ref.state, instance = _ref.instance, options = _ref.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners_default = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect: effect3,
  data: {}
};

// ../../node_modules/@popperjs/core/lib/modifiers/flip.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
init_cjs_shims();
var hash = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash[matched];
  });
}

// ../../node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
init_cjs_shims();
var hash2 = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash2[matched];
  });
}

// ../../node_modules/@popperjs/core/lib/utils/detectOverflow.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
init_cjs_shims();
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js
function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x + getWindowScrollBarX(element),
    y
  };
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js
init_cjs_shims();
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

// ../../node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
init_cjs_shims();
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}

// ../../node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}

// ../../node_modules/@popperjs/core/lib/utils/rectToClientRect.js
init_cjs_shims();
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

// ../../node_modules/@popperjs/core/lib/utils/computeOffsets.js
init_cjs_shims();
function computeOffsets(_ref) {
  var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
      default:
    }
  }
  return offsets;
}

// ../../node_modules/@popperjs/core/lib/utils/detectOverflow.js
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}

// ../../node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js
init_cjs_shims();
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements2 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements2.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements2;
    if (process.env.NODE_ENV !== "production") {
      console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" "));
    }
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b) {
    return overflows[a] - overflows[b];
  });
}

// ../../node_modules/@popperjs/core/lib/modifiers/flip.js
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip_default = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};

// ../../node_modules/@popperjs/core/lib/modifiers/hide.js
init_cjs_shims();
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state, name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide_default = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};

// ../../node_modules/@popperjs/core/lib/modifiers/offset.js
init_cjs_shims();
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref[0], distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
var offset_default = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};

// ../../node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
init_cjs_shims();
function popperOffsets(_ref) {
  var state = _ref.state, name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets_default = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};

// ../../node_modules/@popperjs/core/lib/modifiers/preventOverflow.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/utils/getAltAxis.js
init_cjs_shims();
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}

// ../../node_modules/@popperjs/core/lib/modifiers/preventOverflow.js
function preventOverflow(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min2 = offset2 + overflow[mainSide];
    var max2 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min2, tetherMin) : min2, offset2, tether ? max(max2, tetherMax) : max2);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
var preventOverflow_default = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};

// ../../node_modules/@popperjs/core/lib/createPopper.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
init_cjs_shims();
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

// ../../node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

// ../../node_modules/@popperjs/core/lib/utils/orderModifiers.js
init_cjs_shims();
function order(modifiers) {
  var map9 = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map9.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map9.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

// ../../node_modules/@popperjs/core/lib/utils/debounce.js
init_cjs_shims();
function debounce(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}

// ../../node_modules/@popperjs/core/lib/utils/validateModifiers.js
init_cjs_shims();

// ../../node_modules/@popperjs/core/lib/utils/format.js
init_cjs_shims();
function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return [].concat(args).reduce(function(p, c) {
    return p.replace(/%s/, c);
  }, str);
}

// ../../node_modules/@popperjs/core/lib/utils/validateModifiers.js
var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function validateModifiers(modifiers) {
  modifiers.forEach(function(modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES).filter(function(value, index2, self2) {
      return self2.indexOf(value) === index2;
    }).forEach(function(key) {
      switch (key) {
        case "name":
          if (typeof modifier.name !== "string") {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', '"' + String(modifier.name) + '"'));
          }
          break;
        case "enabled":
          if (typeof modifier.enabled !== "boolean") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', '"' + String(modifier.enabled) + '"'));
          }
          break;
        case "phase":
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(", "), '"' + String(modifier.phase) + '"'));
          }
          break;
        case "fn":
          if (typeof modifier.fn !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "effect":
          if (modifier.effect != null && typeof modifier.effect !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "requires":
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', '"' + String(modifier.requires) + '"'));
          }
          break;
        case "requiresIfExists":
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', '"' + String(modifier.requiresIfExists) + '"'));
          }
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + modifier.name + '" modifier, valid properties are ' + VALID_PROPERTIES.map(function(s) {
            return '"' + s + '"';
          }).join(", ") + '; but "' + key + '" was provided.');
      }
      modifier.requires && modifier.requires.forEach(function(requirement) {
        if (modifiers.find(function(mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

// ../../node_modules/@popperjs/core/lib/utils/uniqueBy.js
init_cjs_shims();
function uniqueBy(arr, fn2) {
  var identifiers = /* @__PURE__ */ new Set();
  return arr.filter(function(item) {
    var identifier = fn2(item);
    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

// ../../node_modules/@popperjs/core/lib/utils/mergeByName.js
init_cjs_shims();
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}

// ../../node_modules/@popperjs/core/lib/createPopper.js
var INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m) {
          return m.enabled;
        });
        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function(_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);
          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function(_ref2) {
              var name = _ref2.name;
              return name === "flip";
            });
            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
            }
          }
          var _getComputedStyle = getComputedStyle(popper2), marginTop = _getComputedStyle.marginTop, marginRight = _getComputedStyle.marginRight, marginBottom = _getComputedStyle.marginBottom, marginLeft = _getComputedStyle.marginLeft;
          if ([marginTop, marginRight, marginBottom, marginLeft].some(function(margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
          }
        }
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;
            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      update: debounce(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name = _ref3.name, _ref3$options = _ref3.options, options2 = _ref3$options === void 0 ? {} : _ref3$options, effect4 = _ref3.effect;
        if (typeof effect4 === "function") {
          var cleanupFn = effect4({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

// ../../node_modules/@popperjs/core/lib/popper.js
init_cjs_shims();
var defaultModifiers = [eventListeners_default, popperOffsets_default, computeStyles_default, applyStyles_default, offset_default, flip_default, preventOverflow_default, arrow_default, hide_default];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});

// ../../node_modules/react-popper/lib/esm/usePopper.js
var import_react_fast_compare = __toESM(require_react_fast_compare());
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper2(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = React3.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || "bottom",
    strategy: options.strategy || "absolute",
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = React3.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), state = _React$useState[0], setState = _React$useState[1];
  var updateStateModifier = React3.useMemo(function() {
    return {
      name: "updateState",
      enabled: true,
      phase: "write",
      fn: function fn2(_ref) {
        var state2 = _ref.state;
        var elements = Object.keys(state2.elements);
        ReactDOM.flushSync(function() {
          setState({
            styles: fromEntries(elements.map(function(element) {
              return [element, state2.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function(element) {
              return [element, state2.attributes[element]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []);
  var popperOptions = React3.useMemo(function() {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: "applyStyles",
        enabled: false
      }])
    };
    if ((0, import_react_fast_compare.default)(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React3.useRef();
  useIsomorphicLayoutEffect(function() {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function() {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper2 = options.createPopper || createPopper;
    var popperInstance = createPopper2(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function() {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

// ../../node_modules/react-popper/lib/esm/Popper.js
var NOOP = function NOOP2() {
  return void 0;
};
var NOOP_PROMISE = function NOOP_PROMISE2() {
  return Promise.resolve(null);
};
var EMPTY_MODIFIERS2 = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS2 : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
  var referenceNode = React4.useContext(ManagerReferenceNodeContext);
  var _React$useState = React4.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
  var _React$useState2 = React4.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
  React4.useEffect(function() {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = React4.useMemo(function() {
    return {
      placement,
      strategy,
      onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: "arrow",
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);
  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
  var childrenProps = React4.useMemo(function() {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}

// ../../node_modules/react-popper/lib/esm/Reference.js
init_cjs_shims();
var React5 = __toESM(require("react"));
var import_warning = __toESM(require_warning());
function Reference(_ref) {
  var children = _ref.children, innerRef = _ref.innerRef;
  var setReferenceNode = React5.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = React5.useCallback(function(node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]);
  React5.useEffect(function() {
    return function() {
      return setRef(innerRef, null);
    };
  }, []);
  React5.useEffect(function() {
    (0, import_warning.default)(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}

// ../../node_modules/reactstrap/dist/reactstrap.modern.js
var import_react_dom2 = __toESM(require("react-dom"), 1);

// ../../node_modules/react-transition-group/esm/index.js
init_cjs_shims();

// ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
init_cjs_shims();
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}

// ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
init_cjs_shims();

// ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
init_cjs_shims();
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}

// ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

// ../../node_modules/react-transition-group/esm/Transition.js
init_cjs_shims();
var import_prop_types2 = __toESM(require_prop_types());
var import_react2 = __toESM(require("react"));
var import_react_dom = __toESM(require("react-dom"));

// ../../node_modules/react-transition-group/esm/config.js
init_cjs_shims();
var config_default = {
  disabled: false
};

// ../../node_modules/react-transition-group/esm/utils/PropTypes.js
init_cjs_shims();
var import_prop_types = __toESM(require_prop_types());
var timeoutsShape = process.env.NODE_ENV !== "production" ? import_prop_types.default.oneOfType([import_prop_types.default.number, import_prop_types.default.shape({
  enter: import_prop_types.default.number,
  exit: import_prop_types.default.number,
  appear: import_prop_types.default.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== "production" ? import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.shape({
  enter: import_prop_types.default.string,
  exit: import_prop_types.default.string,
  active: import_prop_types.default.string
}), import_prop_types.default.shape({
  enter: import_prop_types.default.string,
  enterDone: import_prop_types.default.string,
  enterActive: import_prop_types.default.string,
  exit: import_prop_types.default.string,
  exitDone: import_prop_types.default.string,
  exitActive: import_prop_types.default.string
})]) : null;

// ../../node_modules/react-transition-group/esm/TransitionGroupContext.js
init_cjs_shims();
var import_react = __toESM(require("react"));
var TransitionGroupContext_default = import_react.default.createContext(null);

// ../../node_modules/react-transition-group/esm/utils/reflow.js
init_cjs_shims();
var forceReflow = function forceReflow2(node) {
  return node.scrollTop;
};

// ../../node_modules/react-transition-group/esm/Transition.js
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
var Transition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(Transition2, _React$Component);
  function Transition2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout2 = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout2;
    if (timeout2 != null && typeof timeout2 !== "number") {
      exit = timeout2.exit;
      enter = timeout2.enter;
      appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
    }
    return {
      exit,
      enter,
      appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : import_react_dom.default.findDOMNode(this);
          if (node)
            forceReflow(node);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [import_react_dom.default.findDOMNode(this), appearing], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config_default.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function() {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function() {
        _this2.safeSetState({
          status: ENTERED
        }, function() {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : import_react_dom.default.findDOMNode(this);
    if (!exit || config_default.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function() {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function() {
        _this3.safeSetState({
          status: EXITED
        }, function() {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function(event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function() {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : import_react_dom.default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout2 != null) {
      setTimeout(this.nextCallback, timeout2);
    }
  };
  _proto.render = function render3() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /* @__PURE__ */ import_react2.default.createElement(TransitionGroupContext_default.Provider, {
      value: null
    }, typeof children === "function" ? children(status, childProps) : import_react2.default.cloneElement(import_react2.default.Children.only(children), childProps));
  };
  return Transition2;
}(import_react2.default.Component);
Transition.contextType = TransitionGroupContext_default;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  nodeRef: import_prop_types2.default.shape({
    current: typeof Element === "undefined" ? import_prop_types2.default.any : function(propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return import_prop_types2.default.instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  children: import_prop_types2.default.oneOfType([import_prop_types2.default.func.isRequired, import_prop_types2.default.element.isRequired]).isRequired,
  in: import_prop_types2.default.bool,
  mountOnEnter: import_prop_types2.default.bool,
  unmountOnExit: import_prop_types2.default.bool,
  appear: import_prop_types2.default.bool,
  enter: import_prop_types2.default.bool,
  exit: import_prop_types2.default.bool,
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener)
      pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  addEndListener: import_prop_types2.default.func,
  onEnter: import_prop_types2.default.func,
  onEntering: import_prop_types2.default.func,
  onEntered: import_prop_types2.default.func,
  onExit: import_prop_types2.default.func,
  onExiting: import_prop_types2.default.func,
  onExited: import_prop_types2.default.func
} : {};
function noop() {
}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition_default = Transition;

// ../../node_modules/reactstrap/dist/reactstrap.modern.js
function ownKeys(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function getScrollbarWidth() {
  let scrollDiv = document.createElement("div");
  scrollDiv.style.position = "absolute";
  scrollDiv.style.top = "-9999px";
  scrollDiv.style.width = "50px";
  scrollDiv.style.height = "50px";
  scrollDiv.style.overflow = "scroll";
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}
function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? `${padding}px` : null;
}
function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}
function getOriginalBodyPadding() {
  const style = window.getComputedStyle(document.body, null);
  return parseInt(style && style.getPropertyValue("padding-right") || 0, 10);
}
function conditionallyUpdateScrollbar() {
  const scrollbarWidth = getScrollbarWidth();
  const fixedContent = document.querySelectorAll(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top")[0];
  const bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;
  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}
var globalCssModule;
function mapToCssModules(className = "", cssModule = globalCssModule) {
  if (!cssModule)
    return className;
  return className.split(" ").map((c) => cssModule[c] || c).join(" ");
}
function omit(obj, omitKeys2) {
  const result = {};
  Object.keys(obj).forEach((key) => {
    if (omitKeys2.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}
function pick(obj, keys) {
  const pickKeys = Array.isArray(keys) ? keys : [keys];
  let {
    length
  } = pickKeys;
  let key;
  const result = {};
  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }
  return result;
}
var warned = {};
function warnOnce(message) {
  if (!warned[message]) {
    if (typeof console !== "undefined") {
      console.error(message);
    }
    warned[message] = true;
  }
}
function deprecated(propType, explanation) {
  return function validate(props, propName, componentName, ...rest) {
    if (props[propName] !== null && typeof props[propName] !== "undefined") {
      warnOnce(`"${propName}" property of "${componentName}" has been deprecated.
${explanation}`);
    }
    return propType(props, propName, componentName, ...rest);
  };
}
var Element2 = typeof window === "object" && window.Element || function() {
};
function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element2)) {
    return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Expected prop to be an instance of Element. Validation failed.");
  }
}
var targetPropType = import_prop_types3.default.oneOfType([import_prop_types3.default.string, import_prop_types3.default.func, DOMElement, import_prop_types3.default.shape({
  current: import_prop_types3.default.any
})]);
var tagPropType = import_prop_types3.default.oneOfType([import_prop_types3.default.func, import_prop_types3.default.string, import_prop_types3.default.shape({
  $$typeof: import_prop_types3.default.symbol,
  render: import_prop_types3.default.func
}), import_prop_types3.default.arrayOf(import_prop_types3.default.oneOfType([import_prop_types3.default.func, import_prop_types3.default.string, import_prop_types3.default.shape({
  $$typeof: import_prop_types3.default.symbol,
  render: import_prop_types3.default.func
})]))]);
var TransitionTimeouts = {
  Fade: 150,
  Collapse: 350,
  Modal: 300,
  Carousel: 600,
  Offcanvas: 300
};
var TransitionPropTypeKeys = ["in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited"];
var TransitionStatuses = {
  ENTERING: "entering",
  ENTERED: "entered",
  EXITING: "exiting",
  EXITED: "exited"
};
var keyCodes = {
  esc: 27,
  space: 32,
  enter: 13,
  tab: 9,
  up: 38,
  down: 40,
  home: 36,
  end: 35,
  n: 78,
  p: 80
};
var PopperPlacements = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"];
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function isReactRefObj(target) {
  if (target && typeof target === "object") {
    return "current" in target;
  }
  return false;
}
function getTag(value) {
  if (value == null) {
    return value === void 0 ? "[object Undefined]" : "[object Null]";
  }
  return Object.prototype.toString.call(value);
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function");
}
function toNumber(value) {
  const type = typeof value;
  const NAN = 0 / 0;
  if (type === "number") {
    return value;
  }
  if (type === "symbol" || type === "object" && getTag(value) === "[object Symbol]") {
    return NAN;
  }
  if (isObject(value)) {
    const other = typeof value.valueOf === "function" ? value.valueOf() : value;
    value = isObject(other) ? `${other}` : other;
  }
  if (type !== "string") {
    return value === 0 ? value : +value;
  }
  value = value.replace(/^\s+|\s+$/g, "");
  const isBinary = /^0b[01]+$/i.test(value);
  return isBinary || /^0o[0-7]+$/i.test(value) ? parseInt(value.slice(2), isBinary ? 2 : 8) : /^[-+]0x[0-9a-f]+$/i.test(value) ? NAN : +value;
}
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  const tag = getTag(value);
  return tag === "[object Function]" || tag === "[object AsyncFunction]" || tag === "[object GeneratorFunction]" || tag === "[object Proxy]";
}
function findDOMElements(target) {
  if (isReactRefObj(target)) {
    return target.current;
  }
  if (isFunction(target)) {
    return target();
  }
  if (typeof target === "string" && canUseDOM) {
    let selection = document.querySelectorAll(target);
    if (!selection.length) {
      selection = document.querySelectorAll(`#${target}`);
    }
    if (!selection.length) {
      throw new Error(`The target '${target}' could not be identified in the dom, tip: check spelling`);
    }
    return selection;
  }
  return target;
}
function isArrayOrNodeList(els) {
  if (els === null) {
    return false;
  }
  return Array.isArray(els) || canUseDOM && typeof els.length === "number";
}
function getTarget(target, allElements) {
  const els = findDOMElements(target);
  if (allElements) {
    if (isArrayOrNodeList(els)) {
      return els;
    }
    if (els === null) {
      return [];
    }
    return [els];
  }
  if (isArrayOrNodeList(els)) {
    return els[0];
  }
  return els;
}
var defaultToggleEvents = ["touchstart", "click"];
function addMultipleEventListeners(_els, handler, _events, useCapture) {
  let els = _els;
  if (!isArrayOrNodeList(els)) {
    els = [els];
  }
  let events = _events;
  if (typeof events === "string") {
    events = events.split(/\s+/);
  }
  if (!isArrayOrNodeList(els) || typeof handler !== "function" || !Array.isArray(events)) {
    throw new Error(`
      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.
      The second must be a function.
      The third is a string or an array of strings that represents DOM events
    `);
  }
  Array.prototype.forEach.call(events, (event) => {
    Array.prototype.forEach.call(els, (el) => {
      el.addEventListener(event, handler, useCapture);
    });
  });
  return function removeEvents() {
    Array.prototype.forEach.call(events, (event) => {
      Array.prototype.forEach.call(els, (el) => {
        el.removeEventListener(event, handler, useCapture);
      });
    });
  };
}
var focusableElements = ["a[href]", "area[href]", "input:not([disabled]):not([type=hidden])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", "object", "embed", "[tabindex]:not(.modal):not(.offcanvas)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'];
var _excluded$1h = ["className", "cssModule", "fluid", "tag"];
var propTypes$1m = {
  tag: tagPropType,
  fluid: import_prop_types3.default.oneOfType([import_prop_types3.default.bool, import_prop_types3.default.string]),
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$1k = {
  tag: "div"
};
function Container(props) {
  const {
    className,
    cssModule,
    fluid,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$1h);
  let containerClass = "container";
  if (fluid === true) {
    containerClass = "container-fluid";
  } else if (fluid) {
    containerClass = `container-${fluid}`;
  }
  const classes = mapToCssModules((0, import_classnames.default)(className, containerClass), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
Container.propTypes = propTypes$1m;
Container.defaultProps = defaultProps$1k;
var _excluded$1g = ["className", "cssModule", "noGutters", "tag", "widths"];
var rowColWidths = ["xs", "sm", "md", "lg", "xl", "xxl"];
var rowColsPropType = import_prop_types3.default.oneOfType([import_prop_types3.default.number, import_prop_types3.default.string]);
var propTypes$1l = {
  tag: tagPropType,
  noGutters: deprecated(import_prop_types3.default.bool, "Please use Bootstrap 5 gutter utility classes. https://getbootstrap.com/docs/5.0/layout/gutters/"),
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  xs: rowColsPropType,
  sm: rowColsPropType,
  md: rowColsPropType,
  lg: rowColsPropType,
  xl: rowColsPropType,
  xxl: rowColsPropType,
  widths: import_prop_types3.default.array
};
var defaultProps$1j = {
  tag: "div",
  widths: rowColWidths
};
function Row(props) {
  const {
    className,
    cssModule,
    noGutters,
    tag: Tag,
    widths
  } = props, attributes = _objectWithoutProperties(props, _excluded$1g);
  const colClasses = [];
  widths.forEach((colWidth, i) => {
    let colSize = props[colWidth];
    delete attributes[colWidth];
    if (!colSize) {
      return;
    }
    const isXs = !i;
    colClasses.push(isXs ? `row-cols-${colSize}` : `row-cols-${colWidth}-${colSize}`);
  });
  const classes = mapToCssModules((0, import_classnames.default)(className, noGutters ? "gx-0" : null, "row", colClasses), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
Row.propTypes = propTypes$1l;
Row.defaultProps = defaultProps$1j;
var _excluded$1f = ["className", "cssModule", "widths", "tag"];
var colWidths$1 = ["xs", "sm", "md", "lg", "xl", "xxl"];
var stringOrNumberProp$1 = import_prop_types3.default.oneOfType([import_prop_types3.default.number, import_prop_types3.default.string]);
var columnProps$1 = import_prop_types3.default.oneOfType([import_prop_types3.default.bool, import_prop_types3.default.number, import_prop_types3.default.string, import_prop_types3.default.shape({
  size: import_prop_types3.default.oneOfType([import_prop_types3.default.bool, import_prop_types3.default.number, import_prop_types3.default.string]),
  order: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);
var propTypes$1k = {
  tag: tagPropType,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1,
  xxl: columnProps$1,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  widths: import_prop_types3.default.array
};
var defaultProps$1i = {
  tag: "div",
  widths: colWidths$1
};
var getColumnSizeClass$1 = (isXs, colWidth, colSize) => {
  if (colSize === true || colSize === "") {
    return isXs ? "col" : `col-${colWidth}`;
  }
  if (colSize === "auto") {
    return isXs ? "col-auto" : `col-${colWidth}-auto`;
  }
  return isXs ? `col-${colSize}` : `col-${colWidth}-${colSize}`;
};
var getColumnClasses = (attributes, cssModule, widths = colWidths$1) => {
  const modifiedAttributes = attributes;
  const colClasses = [];
  widths.forEach((colWidth, i) => {
    let columnProp = modifiedAttributes[colWidth];
    delete modifiedAttributes[colWidth];
    if (!columnProp && columnProp !== "") {
      return;
    }
    const isXs = !i;
    if (isObject(columnProp)) {
      const colSizeInterfix = isXs ? "-" : `-${colWidth}-`;
      const colClass = getColumnSizeClass$1(isXs, colWidth, columnProp.size);
      colClasses.push(mapToCssModules((0, import_classnames.default)({
        [colClass]: columnProp.size || columnProp.size === "",
        [`order${colSizeInterfix}${columnProp.order}`]: columnProp.order || columnProp.order === 0,
        [`offset${colSizeInterfix}${columnProp.offset}`]: columnProp.offset || columnProp.offset === 0
      }), cssModule));
    } else {
      const colClass = getColumnSizeClass$1(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });
  return {
    colClasses,
    modifiedAttributes
  };
};
function Col(props) {
  const {
    className,
    cssModule,
    widths,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$1f);
  let {
    modifiedAttributes,
    colClasses
  } = getColumnClasses(attributes, cssModule, widths);
  if (!colClasses.length) {
    colClasses.push("col");
  }
  const classes = mapToCssModules((0, import_classnames.default)(className, colClasses), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, modifiedAttributes, {
    className: classes
  }));
}
Col.propTypes = propTypes$1k;
Col.defaultProps = defaultProps$1i;
var _excluded$1e = ["expand", "className", "cssModule", "light", "dark", "fixed", "sticky", "color", "container", "tag", "children"];
var propTypes$1j = {
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  color: import_prop_types3.default.string,
  container: import_prop_types3.default.oneOfType([import_prop_types3.default.bool, import_prop_types3.default.string]),
  cssModule: import_prop_types3.default.object,
  dark: import_prop_types3.default.bool,
  expand: import_prop_types3.default.oneOfType([import_prop_types3.default.bool, import_prop_types3.default.string]),
  fixed: import_prop_types3.default.string,
  full: import_prop_types3.default.bool,
  light: import_prop_types3.default.bool,
  role: import_prop_types3.default.string,
  sticky: import_prop_types3.default.string,
  tag: tagPropType
};
var defaultProps$1h = {
  tag: "nav",
  expand: false,
  container: "fluid"
};
var getExpandClass = (expand) => {
  if (expand === false) {
    return false;
  }
  if (expand === true || expand === "xs") {
    return "navbar-expand";
  }
  return `navbar-expand-${expand}`;
};
function Navbar(props) {
  const {
    expand,
    className,
    cssModule,
    light,
    dark,
    fixed,
    sticky,
    color,
    container,
    tag: Tag,
    children
  } = props, attributes = _objectWithoutProperties(props, _excluded$1e);
  const classes = mapToCssModules((0, import_classnames.default)(className, "navbar", getExpandClass(expand), {
    "navbar-light": light,
    "navbar-dark": dark,
    [`bg-${color}`]: color,
    [`fixed-${fixed}`]: fixed,
    [`sticky-${sticky}`]: sticky
  }), cssModule);
  const containerClass = container && container === true ? "container" : `container-${container}`;
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }), container ? /* @__PURE__ */ import_react3.default.createElement("div", {
    className: containerClass
  }, children) : children);
}
Navbar.propTypes = propTypes$1j;
Navbar.defaultProps = defaultProps$1h;
var _excluded$1d = ["className", "cssModule", "tag"];
var propTypes$1i = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$1g = {
  tag: "a"
};
function NavbarBrand(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$1d);
  const classes = mapToCssModules((0, import_classnames.default)(className, "navbar-brand"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
NavbarBrand.propTypes = propTypes$1i;
NavbarBrand.defaultProps = defaultProps$1g;
var _excluded$1c = ["className", "cssModule", "active", "tag"];
var propTypes$1h = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType,
  active: import_prop_types3.default.bool
};
var defaultProps$1f = {
  tag: "span"
};
function NavbarText(props) {
  const {
    className,
    cssModule,
    active,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$1c);
  const classes = mapToCssModules((0, import_classnames.default)(className, "navbar-text"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
NavbarText.propTypes = propTypes$1h;
NavbarText.defaultProps = defaultProps$1f;
var _excluded$1b = ["className", "cssModule", "children", "tag"];
var propTypes$1g = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType,
  type: import_prop_types3.default.string,
  children: import_prop_types3.default.node
};
var defaultProps$1e = {
  tag: "button",
  type: "button"
};
function NavbarToggler(props) {
  const {
    className,
    cssModule,
    children,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$1b);
  const classes = mapToCssModules((0, import_classnames.default)(className, "navbar-toggler"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({
    "aria-label": "Toggle navigation"
  }, attributes, {
    className: classes
  }), children || /* @__PURE__ */ import_react3.default.createElement("span", {
    className: mapToCssModules("navbar-toggler-icon", cssModule)
  }));
}
NavbarToggler.propTypes = propTypes$1g;
NavbarToggler.defaultProps = defaultProps$1e;
var _excluded$1a = ["className", "cssModule", "tabs", "pills", "vertical", "horizontal", "justified", "fill", "navbar", "card", "tag"];
var propTypes$1f = {
  card: import_prop_types3.default.bool,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  fill: import_prop_types3.default.bool,
  horizontal: import_prop_types3.default.oneOf(["center", "end"]),
  justified: import_prop_types3.default.bool,
  navbar: import_prop_types3.default.bool,
  pills: import_prop_types3.default.bool,
  tabs: import_prop_types3.default.bool,
  tag: tagPropType,
  vertical: import_prop_types3.default.oneOfType([import_prop_types3.default.bool, import_prop_types3.default.string])
};
var defaultProps$1d = {
  tag: "ul",
  vertical: false
};
var getVerticalClass = (vertical) => {
  if (vertical === false) {
    return false;
  }
  if (vertical === true || vertical === "xs") {
    return "flex-column";
  }
  return `flex-${vertical}-column`;
};
function Nav(props) {
  const {
    className,
    cssModule,
    tabs,
    pills,
    vertical,
    horizontal,
    justified,
    fill,
    navbar,
    card,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$1a);
  const classes = mapToCssModules((0, import_classnames.default)(className, navbar ? "navbar-nav" : "nav", horizontal ? `justify-content-${horizontal}` : false, getVerticalClass(vertical), {
    "nav-tabs": tabs,
    "card-header-tabs": card && tabs,
    "nav-pills": pills,
    "card-header-pills": card && pills,
    "nav-justified": justified,
    "nav-fill": fill
  }), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
Nav.propTypes = propTypes$1f;
Nav.defaultProps = defaultProps$1d;
var _excluded$19 = ["className", "cssModule", "active", "tag"];
var propTypes$1e = {
  active: import_prop_types3.default.bool,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$1c = {
  tag: "li"
};
function NavItem(props) {
  const {
    className,
    cssModule,
    active,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$19);
  const classes = mapToCssModules((0, import_classnames.default)(className, "nav-item", active ? "active" : false), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
NavItem.propTypes = propTypes$1e;
NavItem.defaultProps = defaultProps$1c;
var _excluded$18 = ["className", "cssModule", "active", "tag", "innerRef"];
var propTypes$1d = {
  active: import_prop_types3.default.bool,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  disabled: import_prop_types3.default.bool,
  href: import_prop_types3.default.any,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.func, import_prop_types3.default.string]),
  onClick: import_prop_types3.default.func,
  tag: tagPropType
};
var defaultProps$1b = {
  tag: "a"
};
var NavLink = class extends import_react3.default.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }
    if (this.props.href === "#") {
      e.preventDefault();
    }
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }
  render() {
    let _this$props = this.props, {
      className,
      cssModule,
      active,
      tag: Tag,
      innerRef
    } = _this$props, attributes = _objectWithoutProperties(_this$props, _excluded$18);
    const classes = mapToCssModules((0, import_classnames.default)(className, "nav-link", {
      disabled: attributes.disabled,
      active
    }), cssModule);
    return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      onClick: this.onClick,
      className: classes
    }));
  }
};
NavLink.propTypes = propTypes$1d;
NavLink.defaultProps = defaultProps$1b;
var _excluded$17 = ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"];
var propTypes$1c = {
  "aria-label": import_prop_types3.default.string,
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  listClassName: import_prop_types3.default.string,
  listTag: tagPropType,
  tag: tagPropType
};
var defaultProps$1a = {
  tag: "nav",
  listTag: "ol",
  "aria-label": "breadcrumb"
};
function Breadcrumb(props) {
  const {
    className,
    listClassName,
    cssModule,
    children,
    tag: Tag,
    listTag: ListTag,
    "aria-label": label
  } = props, attributes = _objectWithoutProperties(props, _excluded$17);
  const classes = mapToCssModules((0, import_classnames.default)(className), cssModule);
  const listClasses = mapToCssModules((0, import_classnames.default)("breadcrumb", listClassName), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    "aria-label": label
  }), /* @__PURE__ */ import_react3.default.createElement(ListTag, {
    className: listClasses
  }, children));
}
Breadcrumb.propTypes = propTypes$1c;
Breadcrumb.defaultProps = defaultProps$1a;
var _excluded$16 = ["className", "cssModule", "active", "tag"];
var propTypes$1b = {
  active: import_prop_types3.default.bool,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$19 = {
  tag: "li"
};
function BreadcrumbItem(props) {
  const {
    className,
    cssModule,
    active,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$16);
  const classes = mapToCssModules((0, import_classnames.default)(className, active ? "active" : false, "breadcrumb-item"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    "aria-current": active ? "page" : void 0
  }));
}
BreadcrumbItem.propTypes = propTypes$1b;
BreadcrumbItem.defaultProps = defaultProps$19;
var _excluded$15 = ["className", "cssModule", "variant", "innerRef"];
var propTypes$1a = {
  active: import_prop_types3.default.bool,
  "aria-label": import_prop_types3.default.string,
  onClick: import_prop_types3.default.func,
  variant: import_prop_types3.default.oneOf(["white"]),
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func])
};
var defaultProps$18 = {
  "aria-label": "close"
};
function CloseButton(props) {
  const {
    className,
    cssModule,
    variant,
    innerRef
  } = props, attributes = _objectWithoutProperties(props, _excluded$15);
  const classes = mapToCssModules((0, import_classnames.default)(className, "btn-close", variant && `btn-close-${variant}`));
  return /* @__PURE__ */ import_react3.default.createElement("button", _extends({
    ref: innerRef,
    type: "button",
    className: classes
  }, attributes));
}
CloseButton.propTypes = propTypes$1a;
CloseButton.defaultProps = defaultProps$18;
var _excluded$14 = ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"];
var propTypes$19 = {
  active: import_prop_types3.default.bool,
  "aria-label": import_prop_types3.default.string,
  block: import_prop_types3.default.bool,
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  close: import_prop_types3.default.bool,
  color: import_prop_types3.default.string,
  disabled: import_prop_types3.default.bool,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.func, import_prop_types3.default.string]),
  onClick: import_prop_types3.default.func,
  outline: import_prop_types3.default.bool,
  size: import_prop_types3.default.string,
  tag: tagPropType
};
var defaultProps$17 = {
  color: "secondary",
  tag: "button"
};
function Button(props) {
  const onClick = (0, import_react3.useCallback)((e) => {
    if (props.disabled) {
      e.preventDefault();
      return;
    }
    if (props.onClick) {
      return props.onClick(e);
    }
  }, [props.onClick, props.disabled]);
  let {
    active,
    "aria-label": ariaLabel,
    block,
    className,
    close,
    cssModule,
    color,
    outline,
    size,
    tag: Tag,
    innerRef
  } = props, attributes = _objectWithoutProperties(props, _excluded$14);
  if (close) {
    return /* @__PURE__ */ import_react3.default.createElement(CloseButton, attributes);
  }
  const btnOutlineColor = `btn${outline ? "-outline" : ""}-${color}`;
  const classes = mapToCssModules((0, import_classnames.default)(className, "btn", btnOutlineColor, size ? `btn-${size}` : false, block ? "d-block w-100" : false, {
    active,
    disabled: props.disabled
  }), cssModule);
  if (attributes.href && Tag === "button") {
    Tag = "a";
  }
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({
    type: Tag === "button" && attributes.onClick ? "button" : void 0
  }, attributes, {
    className: classes,
    ref: innerRef,
    onClick,
    "aria-label": ariaLabel
  }));
}
Button.propTypes = propTypes$19;
Button.defaultProps = defaultProps$17;
var _excluded$13 = ["className"];
var propTypes$18 = {
  onClick: import_prop_types3.default.func,
  onBlur: import_prop_types3.default.func,
  onFocus: import_prop_types3.default.func,
  defaultValue: import_prop_types3.default.bool,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$16 = {
  defaultValue: false
};
function ButtonToggle(props) {
  const [toggled, setToggled] = (0, import_react3.useState)(props.defaultValue);
  const [focus, setFocus] = (0, import_react3.useState)(false);
  const onBlur = (0, import_react3.useCallback)((e) => {
    if (props.onBlur) {
      props.onBlur(e);
    }
    setFocus(false);
  }, [props.onBlur]);
  const onFocus = (0, import_react3.useCallback)((e) => {
    if (props.onFocus) {
      props.onFocus(e);
    }
    setFocus(true);
  }, [props.onFocus]);
  const onClick = (0, import_react3.useCallback)((e) => {
    if (props.onClick) {
      props.onClick(e);
    }
    setToggled(!toggled);
  }, [props.onClick]);
  const {
    className
  } = props, attributes = _objectWithoutProperties(props, _excluded$13);
  const classes = mapToCssModules((0, import_classnames.default)(className, {
    focus
  }), props.cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Button, _extends({
    active: toggled,
    onBlur,
    onFocus,
    onClick,
    className: classes
  }, attributes));
}
ButtonToggle.propTypes = propTypes$18;
ButtonToggle.defaultProps = defaultProps$16;
var DropdownContext = import_react3.default.createContext({});
var InputGroupContext = import_react3.default.createContext({});
var _excluded$12 = ["className", "cssModule", "direction", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "tag", "menuRole"];
var propTypes$17 = {
  a11y: import_prop_types3.default.bool,
  disabled: import_prop_types3.default.bool,
  direction: import_prop_types3.default.oneOf(["up", "down", "start", "end", "left", "right"]),
  group: import_prop_types3.default.bool,
  isOpen: import_prop_types3.default.bool,
  nav: import_prop_types3.default.bool,
  active: import_prop_types3.default.bool,
  size: import_prop_types3.default.string,
  tag: tagPropType,
  toggle: import_prop_types3.default.func,
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  dropup: import_prop_types3.default.bool,
  inNavbar: import_prop_types3.default.bool,
  setActiveFromChild: import_prop_types3.default.bool,
  menuRole: import_prop_types3.default.oneOf(["listbox", "menu"])
};
var defaultProps$15 = {
  a11y: true,
  isOpen: false,
  direction: "down",
  nav: false,
  active: false,
  inNavbar: false,
  setActiveFromChild: false
};
var preventDefaultKeys = [keyCodes.space, keyCodes.enter, keyCodes.up, keyCodes.down, keyCodes.end, keyCodes.home];
var Dropdown = class extends import_react3.default.Component {
  constructor(props) {
    super(props);
    this.addEvents = this.addEvents.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.removeEvents = this.removeEvents.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleMenuRef = this.handleMenuRef.bind(this);
    this.handleToggleRef = this.handleToggleRef.bind(this);
    this.containerRef = import_react3.default.createRef();
    this.menuRef = import_react3.default.createRef();
    this.toggleRef = import_react3.default.createRef();
  }
  componentDidMount() {
    this.handleProps();
  }
  componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.handleProps();
    }
  }
  componentWillUnmount() {
    this.removeEvents();
  }
  handleMenuRef(menuRef) {
    this.menuRef.current = menuRef;
  }
  handleToggleRef(toggleRef) {
    this.toggleRef.current = toggleRef;
  }
  handleDocumentClick(e) {
    if (e && (e.which === 3 || e.type === "keyup" && e.which !== keyCodes.tab))
      return;
    const container = this.getContainer();
    const menu = this.getMenu();
    const toggle = this.getToggle();
    const targetIsToggle = e.target === toggle;
    const clickIsInMenu = menu && menu.contains(e.target) && menu !== e.target;
    let clickIsInInput = false;
    if (container) {
      clickIsInInput = container.classList.contains("input-group") && container.classList.contains("dropdown") && e.target.tagName === "INPUT";
    }
    if ((targetIsToggle && !clickIsInInput || clickIsInMenu) && (e.type !== "keyup" || e.which === keyCodes.tab)) {
      return;
    }
    this.toggle(e);
  }
  handleKeyDown(e) {
    const isTargetMenuItem = e.target.getAttribute("role") === "menuitem" || e.target.getAttribute("role") === "option";
    const isTargetMenuCtrl = this.getMenuCtrl() === e.target;
    const isTab = keyCodes.tab === e.which;
    if (/input|textarea/i.test(e.target.tagName) || isTab && !this.props.a11y || isTab && !(isTargetMenuItem || isTargetMenuCtrl)) {
      return;
    }
    if (preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) {
      e.preventDefault();
    }
    if (this.props.disabled)
      return;
    if (isTargetMenuCtrl) {
      if ([keyCodes.space, keyCodes.enter, keyCodes.up, keyCodes.down].indexOf(e.which) > -1) {
        if (!this.props.isOpen) {
          this.toggle(e);
        }
        setTimeout(() => this.getMenuItems()[0].focus());
      } else if (this.props.isOpen && isTab) {
        e.preventDefault();
        this.getMenuItems()[0].focus();
      } else if (this.props.isOpen && e.which === keyCodes.esc) {
        this.toggle(e);
      }
    }
    if (this.props.isOpen && isTargetMenuItem) {
      if ([keyCodes.tab, keyCodes.esc].indexOf(e.which) > -1) {
        this.toggle(e);
        this.getMenuCtrl().focus();
      } else if ([keyCodes.space, keyCodes.enter].indexOf(e.which) > -1) {
        e.target.click();
        this.getMenuCtrl().focus();
      } else if ([keyCodes.down, keyCodes.up].indexOf(e.which) > -1 || [keyCodes.n, keyCodes.p].indexOf(e.which) > -1 && e.ctrlKey) {
        const $menuitems = this.getMenuItems();
        let index2 = $menuitems.indexOf(e.target);
        if (keyCodes.up === e.which || keyCodes.p === e.which && e.ctrlKey) {
          index2 = index2 !== 0 ? index2 - 1 : $menuitems.length - 1;
        } else if (keyCodes.down === e.which || keyCodes.n === e.which && e.ctrlKey) {
          index2 = index2 === $menuitems.length - 1 ? 0 : index2 + 1;
        }
        $menuitems[index2].focus();
      } else if (keyCodes.end === e.which) {
        const $menuitems = this.getMenuItems();
        $menuitems[$menuitems.length - 1].focus();
      } else if (keyCodes.home === e.which) {
        const $menuitems = this.getMenuItems();
        $menuitems[0].focus();
      } else if (e.which >= 48 && e.which <= 90) {
        const $menuitems = this.getMenuItems();
        const charPressed = String.fromCharCode(e.which).toLowerCase();
        for (let i = 0; i < $menuitems.length; i += 1) {
          const firstLetter = $menuitems[i].textContent && $menuitems[i].textContent[0].toLowerCase();
          if (firstLetter === charPressed) {
            $menuitems[i].focus();
            break;
          }
        }
      }
    }
  }
  handleProps() {
    if (this.props.isOpen) {
      this.addEvents();
    } else {
      this.removeEvents();
    }
  }
  getContextValue() {
    return {
      toggle: this.toggle,
      isOpen: this.props.isOpen,
      direction: this.props.direction === "down" && this.props.dropup ? "up" : this.props.direction,
      inNavbar: this.props.inNavbar,
      disabled: this.props.disabled,
      onMenuRef: this.handleMenuRef,
      onToggleRef: this.handleToggleRef,
      menuRole: this.props.menuRole
    };
  }
  getContainer() {
    return this.containerRef.current;
  }
  getMenu() {
    return this.menuRef.current;
  }
  getToggle() {
    return this.toggleRef.current;
  }
  getMenuCtrl() {
    if (this._$menuCtrl)
      return this._$menuCtrl;
    this._$menuCtrl = this.getToggle();
    return this._$menuCtrl;
  }
  getItemType() {
    if (this.props.menuRole === "listbox") {
      return "option";
    }
    return "menuitem";
  }
  getMenuItems() {
    const menuContainer = this.getMenu() || this.getContainer();
    return [].slice.call(menuContainer.querySelectorAll(`[role="${this.getItemType()}"]`));
  }
  addEvents() {
    ["click", "touchstart", "keyup"].forEach((event) => document.addEventListener(event, this.handleDocumentClick, true));
  }
  removeEvents() {
    ["click", "touchstart", "keyup"].forEach((event) => document.removeEventListener(event, this.handleDocumentClick, true));
  }
  toggle(e) {
    if (this.props.disabled) {
      return e && e.preventDefault();
    }
    return this.props.toggle(e);
  }
  render() {
    const _omit = omit(this.props, ["toggle", "disabled", "inNavbar", "a11y"]), {
      className,
      cssModule,
      direction,
      isOpen,
      group,
      size,
      nav,
      setActiveFromChild,
      active,
      tag,
      menuRole
    } = _omit, attrs = _objectWithoutProperties(_omit, _excluded$12);
    const Tag = tag || (nav ? "li" : "div");
    let subItemIsActive = false;
    if (setActiveFromChild) {
      import_react3.default.Children.map(this.props.children[1].props.children, (dropdownItem) => {
        if (dropdownItem && dropdownItem.props.active)
          subItemIsActive = true;
      });
    }
    const classes = mapToCssModules((0, import_classnames.default)(className, nav && active ? "active" : false, setActiveFromChild && subItemIsActive ? "active" : false, {
      "btn-group": group,
      [`btn-group-${size}`]: !!size,
      dropdown: !group,
      dropup: direction === "up",
      dropstart: direction === "start" || direction === "left",
      dropend: direction === "end" || direction === "right",
      show: isOpen,
      "nav-item": nav
    }), cssModule);
    if (this.context.insideInputGroup) {
      return /* @__PURE__ */ import_react3.default.createElement(DropdownContext.Provider, {
        value: this.getContextValue()
      }, /* @__PURE__ */ import_react3.default.createElement(Manager, null, import_react3.default.Children.map(this.props.children, (child) => import_react3.default.cloneElement(child, {
        onKeyDown: this.handleKeyDown
      }))));
    }
    return /* @__PURE__ */ import_react3.default.createElement(DropdownContext.Provider, {
      value: this.getContextValue()
    }, /* @__PURE__ */ import_react3.default.createElement(Manager, null, /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attrs, {
      [typeof Tag === "string" ? "ref" : "innerRef"]: this.containerRef,
      onKeyDown: this.handleKeyDown,
      className: classes
    }))));
  }
};
Dropdown.propTypes = propTypes$17;
Dropdown.defaultProps = defaultProps$15;
Dropdown.contextType = InputGroupContext;
var Dropdown$1 = Dropdown;
var propTypes$16 = {
  children: import_prop_types3.default.node
};
function ButtonDropdown(props) {
  return /* @__PURE__ */ import_react3.default.createElement(Dropdown$1, _extends({
    group: true
  }, props));
}
ButtonDropdown.propTypes = propTypes$16;
var _excluded$11 = ["className", "cssModule", "size", "vertical", "tag"];
var propTypes$15 = {
  "aria-label": import_prop_types3.default.string,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  role: import_prop_types3.default.string,
  size: import_prop_types3.default.string,
  tag: tagPropType,
  vertical: import_prop_types3.default.bool
};
var defaultProps$14 = {
  tag: "div",
  role: "group"
};
function ButtonGroup(props) {
  const {
    className,
    cssModule,
    size,
    vertical,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$11);
  const classes = mapToCssModules((0, import_classnames.default)(className, size ? "btn-group-" + size : false, vertical ? "btn-group-vertical" : "btn-group"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
ButtonGroup.propTypes = propTypes$15;
ButtonGroup.defaultProps = defaultProps$14;
var _excluded$10 = ["className", "cssModule", "tag"];
var propTypes$14 = {
  "aria-label": import_prop_types3.default.string,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  role: import_prop_types3.default.string,
  tag: tagPropType
};
var defaultProps$13 = {
  tag: "div",
  role: "toolbar"
};
function ButtonToolbar(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$10);
  const classes = mapToCssModules((0, import_classnames.default)(className, "btn-toolbar"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
ButtonToolbar.propTypes = propTypes$14;
ButtonToolbar.defaultProps = defaultProps$13;
var _excluded$$ = ["className", "cssModule", "divider", "tag", "header", "active", "text"];
var propTypes$13 = {
  children: import_prop_types3.default.node,
  active: import_prop_types3.default.bool,
  disabled: import_prop_types3.default.bool,
  divider: import_prop_types3.default.bool,
  tag: tagPropType,
  header: import_prop_types3.default.bool,
  onClick: import_prop_types3.default.func,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  toggle: import_prop_types3.default.bool,
  text: import_prop_types3.default.bool
};
var defaultProps$12 = {
  tag: "button",
  toggle: true
};
var DropdownItem = class extends import_react3.default.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.getTabIndex = this.getTabIndex.bind(this);
  }
  onClick(e) {
    const {
      disabled,
      header,
      divider,
      text
    } = this.props;
    if (disabled || header || divider || text) {
      e.preventDefault();
      return;
    }
    if (this.props.onClick) {
      this.props.onClick(e);
    }
    if (this.props.toggle) {
      this.context.toggle(e);
    }
  }
  getRole() {
    if (this.context.menuRole === "listbox") {
      return "option";
    }
    return "menuitem";
  }
  getTabIndex() {
    const {
      disabled,
      header,
      divider,
      text
    } = this.props;
    if (disabled || header || divider || text) {
      return "-1";
    }
    return "0";
  }
  render() {
    const tabIndex = this.getTabIndex();
    const role = tabIndex > -1 ? this.getRole() : void 0;
    let _omit = omit(this.props, ["toggle"]), {
      className,
      cssModule,
      divider,
      tag: Tag,
      header,
      active,
      text
    } = _omit, props = _objectWithoutProperties(_omit, _excluded$$);
    const classes = mapToCssModules((0, import_classnames.default)(className, {
      disabled: props.disabled,
      "dropdown-item": !divider && !header && !text,
      active,
      "dropdown-header": header,
      "dropdown-divider": divider,
      "dropdown-item-text": text
    }), cssModule);
    if (Tag === "button") {
      if (header) {
        Tag = "h6";
      } else if (divider) {
        Tag = "div";
      } else if (props.href) {
        Tag = "a";
      } else if (text) {
        Tag = "span";
      }
    }
    return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({
      type: Tag === "button" && (props.onClick || this.props.toggle) ? "button" : void 0
    }, props, {
      tabIndex,
      role,
      className: classes,
      onClick: this.onClick
    }));
  }
};
DropdownItem.propTypes = propTypes$13;
DropdownItem.defaultProps = defaultProps$12;
DropdownItem.contextType = DropdownContext;
var _excluded$_ = ["className", "cssModule", "dark", "end", "right", "tag", "flip", "modifiers", "persist", "strategy", "container", "updateOnSelect"];
var propTypes$12 = {
  tag: tagPropType,
  children: import_prop_types3.default.node.isRequired,
  dark: import_prop_types3.default.bool,
  end: import_prop_types3.default.bool,
  flip: import_prop_types3.default.bool,
  modifiers: import_prop_types3.default.array,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  style: import_prop_types3.default.object,
  persist: import_prop_types3.default.bool,
  strategy: import_prop_types3.default.string,
  container: targetPropType,
  updateOnSelect: import_prop_types3.default.bool,
  right: deprecated(import_prop_types3.default.bool, 'Please use "end" instead.')
};
var defaultProps$11 = {
  tag: "div",
  flip: true,
  modifiers: []
};
var directionPositionMap = {
  up: "top",
  left: "left",
  right: "right",
  start: "left",
  end: "right",
  down: "bottom"
};
var DropdownMenu = class extends import_react3.default.Component {
  getRole() {
    if (this.context.menuRole === "listbox") {
      return "listbox";
    }
    return "menu";
  }
  render() {
    const _this$props = this.props, {
      className,
      cssModule,
      dark,
      end: end2,
      right: right2,
      tag,
      flip: flip2,
      modifiers,
      persist,
      strategy,
      container,
      updateOnSelect
    } = _this$props, attrs = _objectWithoutProperties(_this$props, _excluded$_);
    const classes = mapToCssModules((0, import_classnames.default)(className, "dropdown-menu", {
      "dropdown-menu-dark": dark,
      "dropdown-menu-end": end2 || right2,
      show: this.context.isOpen
    }), cssModule);
    const Tag = tag;
    if (persist || this.context.isOpen && !this.context.inNavbar) {
      const position1 = directionPositionMap[this.context.direction] || "bottom";
      const position2 = end2 || right2 ? "end" : "start";
      const poperPlacement = `${position1}-${position2}`;
      const poperModifiers = [...modifiers, {
        name: "flip",
        enabled: !!flip2
      }];
      const popper2 = /* @__PURE__ */ import_react3.default.createElement(Popper, {
        placement: poperPlacement,
        modifiers: poperModifiers,
        strategy
      }, ({
        ref,
        style,
        placement,
        update
      }) => {
        let combinedStyle = _objectSpread2(_objectSpread2({}, this.props.style), style);
        const handleRef = (tagRef) => {
          ref(tagRef);
          const {
            onMenuRef: onMenuRef2
          } = this.context;
          if (onMenuRef2)
            onMenuRef2(tagRef);
        };
        return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({
          tabIndex: "-1",
          role: this.getRole(),
          ref: handleRef
        }, attrs, {
          style: combinedStyle,
          "aria-hidden": !this.context.isOpen,
          className: classes,
          "data-popper-placement": placement,
          onClick: () => updateOnSelect && update()
        }));
      });
      if (container) {
        return import_react_dom2.default.createPortal(popper2, getTarget(container));
      }
      return popper2;
    }
    const {
      onMenuRef
    } = this.context;
    return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({
      tabIndex: "-1",
      role: this.getRole()
    }, attrs, {
      ref: onMenuRef,
      "aria-hidden": !this.context.isOpen,
      className: classes,
      "data-popper-placement": attrs.placement
    }));
  }
};
DropdownMenu.propTypes = propTypes$12;
DropdownMenu.defaultProps = defaultProps$11;
DropdownMenu.contextType = DropdownContext;
var _excluded$Z = ["className", "color", "cssModule", "caret", "split", "nav", "tag", "innerRef"];
var propTypes$11 = {
  caret: import_prop_types3.default.bool,
  color: import_prop_types3.default.string,
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  disabled: import_prop_types3.default.bool,
  onClick: import_prop_types3.default.func,
  "aria-haspopup": import_prop_types3.default.bool,
  split: import_prop_types3.default.bool,
  tag: tagPropType,
  nav: import_prop_types3.default.bool,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func])
};
var defaultProps$10 = {
  color: "secondary",
  "aria-haspopup": true
};
var DropdownToggle = class extends import_react3.default.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  onClick(e) {
    if (this.props.disabled || this.context.disabled) {
      e.preventDefault();
      return;
    }
    if (this.props.nav && !this.props.tag) {
      e.preventDefault();
    }
    if (this.props.onClick) {
      this.props.onClick(e);
    }
    this.context.toggle(e);
  }
  getRole() {
    return this.context.menuRole || this.props["aria-haspopup"];
  }
  render() {
    const _this$props = this.props, {
      className,
      color,
      cssModule,
      caret,
      split: split2,
      nav,
      tag,
      innerRef
    } = _this$props, props = _objectWithoutProperties(_this$props, _excluded$Z);
    const ariaLabel = props["aria-label"] || "Toggle Dropdown";
    const classes = mapToCssModules((0, import_classnames.default)(className, {
      "dropdown-toggle": caret || split2,
      "dropdown-toggle-split": split2,
      "nav-link": nav
    }), cssModule);
    const children = typeof props.children !== "undefined" ? props.children : /* @__PURE__ */ import_react3.default.createElement("span", {
      className: "visually-hidden"
    }, ariaLabel);
    let Tag;
    if (nav && !tag) {
      Tag = "a";
      props.href = "#";
    } else if (!tag) {
      Tag = Button;
      props.color = color;
      props.cssModule = cssModule;
    } else {
      Tag = tag;
    }
    if (this.context.inNavbar) {
      return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, props, {
        className: classes,
        onClick: this.onClick,
        ref: this.context.onToggleRef,
        "aria-expanded": this.context.isOpen,
        "aria-haspopup": this.getRole(),
        children
      }));
    }
    return /* @__PURE__ */ import_react3.default.createElement(Reference, {
      innerRef
    }, ({
      ref
    }) => {
      const handleRef = (tagRef) => {
        ref(tagRef);
        const {
          onToggleRef
        } = this.context;
        if (onToggleRef)
          onToggleRef(tagRef);
      };
      return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, props, {
        [typeof Tag === "string" ? "ref" : "innerRef"]: handleRef,
        className: classes,
        onClick: this.onClick,
        "aria-expanded": this.context.isOpen,
        "aria-haspopup": this.getRole(),
        children
      }));
    });
  }
};
DropdownToggle.propTypes = propTypes$11;
DropdownToggle.defaultProps = defaultProps$10;
DropdownToggle.contextType = DropdownContext;
var _excluded$Y = ["tag", "baseClass", "baseClassActive", "className", "cssModule", "children", "innerRef"];
var propTypes$10 = _objectSpread2(_objectSpread2({}, Transition_default.propTypes), {}, {
  children: import_prop_types3.default.oneOfType([import_prop_types3.default.arrayOf(import_prop_types3.default.node), import_prop_types3.default.node]),
  tag: tagPropType,
  baseClass: import_prop_types3.default.string,
  baseClassActive: import_prop_types3.default.string,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func])
});
var defaultProps$$ = _objectSpread2(_objectSpread2({}, Transition_default.defaultProps), {}, {
  tag: "div",
  baseClass: "fade",
  baseClassActive: "show",
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});
function Fade(props) {
  const {
    tag: Tag,
    baseClass,
    baseClassActive,
    className,
    cssModule,
    children,
    innerRef
  } = props, otherProps = _objectWithoutProperties(props, _excluded$Y);
  const transitionProps = pick(otherProps, TransitionPropTypeKeys);
  const childProps = omit(otherProps, TransitionPropTypeKeys);
  return /* @__PURE__ */ import_react3.default.createElement(Transition_default, transitionProps, (status) => {
    const isActive = status === "entered";
    const classes = mapToCssModules((0, import_classnames.default)(className, baseClass, isActive && baseClassActive), cssModule);
    return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({
      className: classes
    }, childProps, {
      ref: innerRef
    }), children);
  });
}
Fade.propTypes = propTypes$10;
Fade.defaultProps = defaultProps$$;
var AccordionContext = import_react3.default.createContext({});
var _excluded$X = ["flush", "open", "toggle", "className", "cssModule", "tag", "innerRef"];
var propTypes$$ = {
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  flush: import_prop_types3.default.bool,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func]),
  open: import_prop_types3.default.oneOfType([import_prop_types3.default.array, import_prop_types3.default.string]).isRequired,
  tag: tagPropType,
  toggle: import_prop_types3.default.func.isRequired
};
var defaultProps$_ = {
  tag: "div"
};
function Accordion(props) {
  const {
    flush,
    open,
    toggle,
    className,
    cssModule,
    tag: Tag,
    innerRef
  } = props, attributes = _objectWithoutProperties(props, _excluded$X);
  const classes = mapToCssModules((0, import_classnames.default)(className, "accordion", {
    "accordion-flush": flush
  }), cssModule);
  const accordionContext = (0, import_react3.useMemo)(() => ({
    open,
    toggle
  }));
  return /* @__PURE__ */ import_react3.default.createElement(AccordionContext.Provider, {
    value: accordionContext
  }, /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  })));
}
Accordion.propTypes = propTypes$$;
Accordion.defaultProps = defaultProps$_;
var _excluded$W = ["defaultOpen", "stayOpen"];
var propTypes$_ = {
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func]),
  children: import_prop_types3.default.node,
  defaultOpen: import_prop_types3.default.oneOfType([import_prop_types3.default.array, import_prop_types3.default.string]),
  stayOpen: import_prop_types3.default.bool
};
var defaultProps$Z = {
  tag: "div"
};
function UncontrolledAccordion(_ref) {
  let {
    defaultOpen,
    stayOpen
  } = _ref, props = _objectWithoutProperties(_ref, _excluded$W);
  const [open, setOpen] = (0, import_react3.useState)(defaultOpen || (stayOpen ? [] : void 0));
  const toggle = (id) => {
    if (stayOpen) {
      if (open.includes(id)) {
        setOpen(open.filter((accordionId) => accordionId !== id));
      } else {
        setOpen([...open, id]);
      }
    } else if (open === id) {
      setOpen(void 0);
    } else {
      setOpen(id);
    }
  };
  return /* @__PURE__ */ import_react3.default.createElement(Accordion, _extends({}, props, {
    open,
    toggle
  }));
}
UncontrolledAccordion.propTypes = propTypes$_;
UncontrolledAccordion.defaultProps = defaultProps$Z;
var _excluded$V = ["className", "cssModule", "tag", "innerRef", "children", "targetId"];
var propTypes$Z = {
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func]),
  tag: tagPropType,
  targetId: import_prop_types3.default.string.isRequired
};
var defaultProps$Y = {
  tag: "h2"
};
function AccordionHeader(props) {
  const {
    className,
    cssModule,
    tag: Tag,
    innerRef,
    children,
    targetId
  } = props, attributes = _objectWithoutProperties(props, _excluded$V);
  const {
    open,
    toggle
  } = (0, import_react3.useContext)(AccordionContext);
  const classes = mapToCssModules((0, import_classnames.default)(className, "accordion-header"), cssModule);
  const buttonClasses = mapToCssModules((0, import_classnames.default)("accordion-button", {
    collapsed: !(Array.isArray(open) ? open.includes(targetId) : open === targetId)
  }), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }), /* @__PURE__ */ import_react3.default.createElement("button", {
    type: "button",
    className: buttonClasses,
    onClick: () => toggle(targetId)
  }, children));
}
AccordionHeader.propTypes = propTypes$Z;
AccordionHeader.defaultProps = defaultProps$Y;
var _excluded$U = ["className", "cssModule", "tag", "innerRef"];
var propTypes$Y = {
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func]),
  tag: tagPropType
};
var defaultProps$X = {
  tag: "div"
};
function AccordionItem(props) {
  const {
    className,
    cssModule,
    tag: Tag,
    innerRef
  } = props, attributes = _objectWithoutProperties(props, _excluded$U);
  const classes = mapToCssModules((0, import_classnames.default)(className, "accordion-item"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }));
}
AccordionItem.propTypes = propTypes$Y;
AccordionItem.defaultProps = defaultProps$X;
var _excluded$T = ["tag", "horizontal", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"];
var propTypes$X = _objectSpread2(_objectSpread2({}, Transition_default.propTypes), {}, {
  horizontal: import_prop_types3.default.bool,
  isOpen: import_prop_types3.default.bool,
  children: import_prop_types3.default.oneOfType([import_prop_types3.default.arrayOf(import_prop_types3.default.node), import_prop_types3.default.node]),
  tag: tagPropType,
  className: import_prop_types3.default.node,
  navbar: import_prop_types3.default.bool,
  cssModule: import_prop_types3.default.object,
  innerRef: import_prop_types3.default.shape({
    current: import_prop_types3.default.object
  })
});
var defaultProps$W = _objectSpread2(_objectSpread2({}, Transition_default.defaultProps), {}, {
  horizontal: false,
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: "div",
  timeout: TransitionTimeouts.Collapse
});
var transitionStatusToClassHash = {
  [TransitionStatuses.ENTERING]: "collapsing",
  [TransitionStatuses.ENTERED]: "collapse show",
  [TransitionStatuses.EXITING]: "collapsing",
  [TransitionStatuses.EXITED]: "collapse"
};
function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || "collapse";
}
var Collapse = class extends import_react3.Component {
  constructor(props) {
    super(props);
    this.state = {
      dimension: null
    };
    this.nodeRef = props.innerRef || import_react3.default.createRef();
    ["onEntering", "onEntered", "onExit", "onExiting", "onExited"].forEach((name) => {
      this[name] = this[name].bind(this);
    });
  }
  onEntering(_, isAppearing) {
    const node = this.getNode();
    this.setState({
      dimension: this.getDimension(node)
    });
    this.props.onEntering(node, isAppearing);
  }
  onEntered(_, isAppearing) {
    const node = this.getNode();
    this.setState({
      dimension: null
    });
    this.props.onEntered(node, isAppearing);
  }
  onExit() {
    const node = this.getNode();
    this.setState({
      dimension: this.getDimension(node)
    });
    this.props.onExit(node);
  }
  onExiting() {
    const node = this.getNode();
    this.getDimension(node);
    this.setState({
      dimension: 0
    });
    this.props.onExiting(node);
  }
  onExited() {
    const node = this.getNode();
    this.setState({
      dimension: null
    });
    this.props.onExited(node);
  }
  getNode() {
    return this.nodeRef.current;
  }
  getDimension(node) {
    return this.props.horizontal ? node.scrollWidth : node.scrollHeight;
  }
  render() {
    const _this$props = this.props, {
      tag: Tag,
      horizontal,
      isOpen,
      className,
      navbar,
      cssModule,
      children,
      innerRef
    } = _this$props, otherProps = _objectWithoutProperties(_this$props, _excluded$T);
    const {
      dimension
    } = this.state;
    const transitionProps = pick(otherProps, TransitionPropTypeKeys);
    const childProps = omit(otherProps, TransitionPropTypeKeys);
    return /* @__PURE__ */ import_react3.default.createElement(Transition_default, _extends({}, transitionProps, {
      in: isOpen,
      nodeRef: this.nodeRef,
      onEntering: this.onEntering,
      onEntered: this.onEntered,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), (status) => {
      let collapseClass = getTransitionClass(status);
      const classes = mapToCssModules((0, import_classnames.default)(className, horizontal && "collapse-horizontal", collapseClass, navbar && "navbar-collapse"), cssModule);
      const style = dimension === null ? null : {
        [horizontal ? "width" : "height"]: dimension
      };
      return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, childProps, {
        style: _objectSpread2(_objectSpread2({}, childProps.style), style),
        className: classes,
        ref: this.nodeRef
      }), children);
    });
  }
};
Collapse.propTypes = propTypes$X;
Collapse.defaultProps = defaultProps$W;
var Collapse$1 = Collapse;
var _excluded$S = ["className", "cssModule", "tag", "innerRef", "children", "accordionId"];
var propTypes$W = {
  accordionId: import_prop_types3.default.string.isRequired,
  className: import_prop_types3.default.string,
  children: import_prop_types3.default.node,
  cssModule: import_prop_types3.default.object,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func]),
  tag: tagPropType
};
var defaultProps$V = {
  tag: "div"
};
function AccordionBody(props) {
  const {
    className,
    cssModule,
    tag: Tag,
    innerRef,
    children,
    accordionId
  } = props, attributes = _objectWithoutProperties(props, _excluded$S);
  const {
    open
  } = (0, import_react3.useContext)(AccordionContext);
  const classes = mapToCssModules((0, import_classnames.default)(className, "accordion-collapse"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Collapse$1, _extends({}, attributes, {
    className: classes,
    ref: innerRef,
    isOpen: Array.isArray(open) ? open.includes(accordionId) : open === accordionId
  }), /* @__PURE__ */ import_react3.default.createElement(Tag, {
    className: "accordion-body"
  }, children));
}
AccordionBody.propTypes = propTypes$W;
AccordionBody.defaultProps = defaultProps$V;
var _excluded$R = ["className", "cssModule", "color", "innerRef", "pill", "tag"];
var propTypes$V = {
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  color: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.func, import_prop_types3.default.string]),
  pill: import_prop_types3.default.bool,
  tag: tagPropType
};
var defaultProps$U = {
  color: "secondary",
  pill: false,
  tag: "span"
};
function Badge(props) {
  let {
    className,
    cssModule,
    color,
    innerRef,
    pill,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$R);
  const classes = mapToCssModules((0, import_classnames.default)(className, "badge", "bg-" + color, pill ? "rounded-pill" : false), cssModule);
  if (attributes.href && Tag === "span") {
    Tag = "a";
  }
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }));
}
Badge.propTypes = propTypes$V;
Badge.defaultProps = defaultProps$U;
var _excluded$Q = ["className", "cssModule", "color", "body", "inverse", "outline", "tag", "innerRef"];
var propTypes$U = {
  body: import_prop_types3.default.bool,
  className: import_prop_types3.default.string,
  color: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func]),
  inverse: import_prop_types3.default.bool,
  outline: import_prop_types3.default.bool,
  tag: tagPropType
};
var defaultProps$T = {
  tag: "div"
};
function Card(props) {
  const {
    className,
    cssModule,
    color,
    body,
    inverse,
    outline,
    tag: Tag,
    innerRef
  } = props, attributes = _objectWithoutProperties(props, _excluded$Q);
  const classes = mapToCssModules((0, import_classnames.default)(className, "card", inverse ? "text-white" : false, body ? "card-body" : false, color ? `${outline ? "border" : "bg"}-${color}` : false), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }));
}
Card.propTypes = propTypes$U;
Card.defaultProps = defaultProps$T;
var _excluded$P = ["className", "cssModule", "tag"];
var propTypes$T = {
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$S = {
  tag: "div"
};
function CardGroup(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$P);
  const classes = mapToCssModules((0, import_classnames.default)(className, "card-group"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
CardGroup.propTypes = propTypes$T;
CardGroup.defaultProps = defaultProps$S;
var _excluded$O = ["className", "cssModule", "tag"];
var propTypes$S = {
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$R = {
  tag: "div"
};
function CardDeck(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$O);
  const classes = mapToCssModules((0, import_classnames.default)(className, "card-deck"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
CardDeck.propTypes = propTypes$S;
CardDeck.defaultProps = defaultProps$R;
var _excluded$N = ["className", "cssModule", "tag"];
var propTypes$R = {
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$Q = {
  tag: "div"
};
function CardColumns(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$N);
  const classes = mapToCssModules((0, import_classnames.default)(className, "card-columns"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
CardColumns.propTypes = propTypes$R;
CardColumns.defaultProps = defaultProps$Q;
var _excluded$M = ["className", "cssModule", "innerRef", "tag"];
var propTypes$Q = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func]),
  tag: tagPropType
};
var defaultProps$P = {
  tag: "div"
};
function CardBody(props) {
  const {
    className,
    cssModule,
    innerRef,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$M);
  const classes = mapToCssModules((0, import_classnames.default)(className, "card-body"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }));
}
CardBody.propTypes = propTypes$Q;
CardBody.defaultProps = defaultProps$P;
var _excluded$L = ["className", "cssModule", "tag", "innerRef"];
var propTypes$P = {
  tag: tagPropType,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.func, import_prop_types3.default.string]),
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$O = {
  tag: "a"
};
function CardLink(props) {
  const {
    className,
    cssModule,
    tag: Tag,
    innerRef
  } = props, attributes = _objectWithoutProperties(props, _excluded$L);
  const classes = mapToCssModules((0, import_classnames.default)(className, "card-link"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    ref: innerRef,
    className: classes
  }));
}
CardLink.propTypes = propTypes$P;
CardLink.defaultProps = defaultProps$O;
var _excluded$K = ["className", "cssModule", "tag"];
var propTypes$O = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$N = {
  tag: "div"
};
function CardFooter(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$K);
  const classes = mapToCssModules((0, import_classnames.default)(className, "card-footer"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
CardFooter.propTypes = propTypes$O;
CardFooter.defaultProps = defaultProps$N;
var _excluded$J = ["className", "cssModule", "tag"];
var propTypes$N = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$M = {
  tag: "div"
};
function CardHeader(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$J);
  const classes = mapToCssModules((0, import_classnames.default)(className, "card-header"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
CardHeader.propTypes = propTypes$N;
CardHeader.defaultProps = defaultProps$M;
var _excluded$I = ["className", "cssModule", "top", "bottom", "tag"];
var propTypes$M = {
  bottom: import_prop_types3.default.bool,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType,
  top: import_prop_types3.default.bool
};
var defaultProps$L = {
  tag: "img"
};
function CardImg(props) {
  const {
    className,
    cssModule,
    top: top2,
    bottom: bottom2,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$I);
  let cardImgClassName = "card-img";
  if (top2) {
    cardImgClassName = "card-img-top";
  }
  if (bottom2) {
    cardImgClassName = "card-img-bottom";
  }
  const classes = mapToCssModules((0, import_classnames.default)(className, cardImgClassName), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
CardImg.propTypes = propTypes$M;
CardImg.defaultProps = defaultProps$L;
var _excluded$H = ["className", "cssModule", "tag"];
var propTypes$L = {
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$K = {
  tag: "div"
};
function CardImgOverlay(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$H);
  const classes = mapToCssModules((0, import_classnames.default)(className, "card-img-overlay"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
CardImgOverlay.propTypes = propTypes$L;
CardImgOverlay.defaultProps = defaultProps$K;
var CarouselContext = import_react3.default.createContext({});
var _excluded$G = ["in", "children", "cssModule", "slide", "tag", "className"];
var CarouselItem = class extends import_react3.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      startAnimation: false
    };
    this.onEnter = this.onEnter.bind(this);
    this.onEntering = this.onEntering.bind(this);
    this.onExit = this.onExit.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }
  onEnter(node, isAppearing) {
    this.setState({
      startAnimation: false
    });
    this.props.onEnter(node, isAppearing);
  }
  onEntering(node, isAppearing) {
    const {
      offsetHeight
    } = node;
    this.setState({
      startAnimation: true
    });
    this.props.onEntering(node, isAppearing);
    return offsetHeight;
  }
  onExit(node) {
    this.setState({
      startAnimation: false
    });
    this.props.onExit(node);
  }
  onExiting(node) {
    this.setState({
      startAnimation: true
    });
    node.dispatchEvent(new CustomEvent("slide.bs.carousel"));
    this.props.onExiting(node);
  }
  onExited(node) {
    node.dispatchEvent(new CustomEvent("slid.bs.carousel"));
    this.props.onExited(node);
  }
  render() {
    const _this$props = this.props, {
      in: isIn,
      children,
      cssModule,
      slide,
      tag: Tag,
      className
    } = _this$props, transitionProps = _objectWithoutProperties(_this$props, _excluded$G);
    return /* @__PURE__ */ import_react3.default.createElement(Transition_default, _extends({}, transitionProps, {
      enter: slide,
      exit: slide,
      in: isIn,
      onEnter: this.onEnter,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), (status) => {
      const {
        direction
      } = this.context;
      const isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
      const directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && this.state.startAnimation && (direction === "end" ? "carousel-item-start" : "carousel-item-end");
      const orderClassName = status === TransitionStatuses.ENTERING && (direction === "end" ? "carousel-item-next" : "carousel-item-prev");
      const itemClasses = mapToCssModules((0, import_classnames.default)(className, "carousel-item", isActive && "active", directionClassName, orderClassName), cssModule);
      return /* @__PURE__ */ import_react3.default.createElement(Tag, {
        className: itemClasses
      }, children);
    });
  }
};
CarouselItem.propTypes = _objectSpread2(_objectSpread2({}, Transition_default.propTypes), {}, {
  tag: tagPropType,
  in: import_prop_types3.default.bool,
  cssModule: import_prop_types3.default.object,
  children: import_prop_types3.default.node,
  slide: import_prop_types3.default.bool,
  className: import_prop_types3.default.string
});
CarouselItem.defaultProps = _objectSpread2(_objectSpread2({}, Transition_default.defaultProps), {}, {
  tag: "div",
  timeout: TransitionTimeouts.Carousel,
  slide: true
});
CarouselItem.contextType = CarouselContext;
var CarouselItem$1 = CarouselItem;
var SWIPE_THRESHOLD = 40;
var propTypes$K = {
  activeIndex: import_prop_types3.default.number,
  next: import_prop_types3.default.func.isRequired,
  previous: import_prop_types3.default.func.isRequired,
  keyboard: import_prop_types3.default.bool,
  pause: import_prop_types3.default.oneOf(["hover", false]),
  ride: import_prop_types3.default.oneOf(["carousel"]),
  interval: import_prop_types3.default.oneOfType([import_prop_types3.default.number, import_prop_types3.default.string, import_prop_types3.default.bool]),
  children: import_prop_types3.default.array,
  mouseEnter: import_prop_types3.default.func,
  mouseLeave: import_prop_types3.default.func,
  slide: import_prop_types3.default.bool,
  dark: import_prop_types3.default.bool,
  fade: import_prop_types3.default.bool,
  cssModule: import_prop_types3.default.object,
  className: import_prop_types3.default.string,
  enableTouch: import_prop_types3.default.bool
};
var propsToOmit$2 = Object.keys(propTypes$K);
var defaultProps$J = {
  interval: 5e3,
  pause: "hover",
  keyboard: true,
  slide: true,
  enableTouch: true,
  fade: false
};
var Carousel = class extends import_react3.default.Component {
  constructor(props) {
    super(props);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.renderItems = this.renderItems.bind(this);
    this.hoverStart = this.hoverStart.bind(this);
    this.hoverEnd = this.hoverEnd.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.state = {
      activeIndex: this.props.activeIndex,
      direction: "end",
      indicatorClicked: false
    };
  }
  componentDidMount() {
    if (this.props.ride === "carousel") {
      this.setInterval();
    }
    document.addEventListener("keyup", this.handleKeyPress);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let newState = null;
    let {
      activeIndex,
      direction,
      indicatorClicked
    } = prevState;
    if (nextProps.activeIndex !== activeIndex) {
      if (nextProps.activeIndex === activeIndex + 1) {
        direction = "end";
      } else if (nextProps.activeIndex === activeIndex - 1) {
        direction = "start";
      } else if (nextProps.activeIndex < activeIndex) {
        direction = indicatorClicked ? "start" : "end";
      } else if (nextProps.activeIndex !== activeIndex) {
        direction = indicatorClicked ? "end" : "start";
      }
      newState = {
        activeIndex: nextProps.activeIndex,
        direction,
        indicatorClicked: false
      };
    }
    return newState;
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeIndex === this.state.activeIndex)
      return;
    this.setInterval();
  }
  componentWillUnmount() {
    this.clearInterval();
    document.removeEventListener("keyup", this.handleKeyPress);
  }
  handleKeyPress(evt) {
    if (this.props.keyboard) {
      if (evt.keyCode === 37) {
        this.props.previous();
      } else if (evt.keyCode === 39) {
        this.props.next();
      }
    }
  }
  handleTouchStart(e) {
    if (!this.props.enableTouch) {
      return;
    }
    this.touchStartX = e.changedTouches[0].screenX;
    this.touchStartY = e.changedTouches[0].screenY;
  }
  handleTouchEnd(e) {
    if (!this.props.enableTouch) {
      return;
    }
    const currentX = e.changedTouches[0].screenX;
    const currentY = e.changedTouches[0].screenY;
    const diffX = Math.abs(this.touchStartX - currentX);
    const diffY = Math.abs(this.touchStartY - currentY);
    if (diffX < diffY) {
      return;
    }
    if (diffX < SWIPE_THRESHOLD) {
      return;
    }
    if (currentX < this.touchStartX) {
      this.props.next();
    } else {
      this.props.previous();
    }
  }
  getContextValue() {
    return {
      direction: this.state.direction
    };
  }
  setInterval() {
    this.clearInterval();
    if (this.props.interval) {
      this.cycleInterval = setInterval(() => {
        this.props.next();
      }, parseInt(this.props.interval, 10));
    }
  }
  clearInterval() {
    clearInterval(this.cycleInterval);
  }
  hoverStart(...args) {
    if (this.props.pause === "hover") {
      this.clearInterval();
    }
    if (this.props.mouseEnter) {
      this.props.mouseEnter(...args);
    }
  }
  hoverEnd(...args) {
    if (this.props.pause === "hover") {
      this.setInterval();
    }
    if (this.props.mouseLeave) {
      this.props.mouseLeave(...args);
    }
  }
  renderItems(carouselItems, className) {
    const {
      slide
    } = this.props;
    return /* @__PURE__ */ import_react3.default.createElement("div", {
      className
    }, carouselItems.map((item, index2) => {
      const isIn = index2 === this.state.activeIndex;
      return import_react3.default.cloneElement(item, {
        in: isIn,
        slide
      });
    }));
  }
  render() {
    const {
      cssModule,
      slide,
      className,
      dark,
      fade
    } = this.props;
    const attributes = omit(this.props, propsToOmit$2);
    const outerClasses = mapToCssModules((0, import_classnames.default)(className, "carousel", fade && "carousel-fade", slide && "slide", dark && "carousel-dark"), cssModule);
    const innerClasses = mapToCssModules((0, import_classnames.default)("carousel-inner"), cssModule);
    const children = this.props.children.filter((child) => child !== null && child !== void 0 && typeof child !== "boolean");
    const slidesOnly = children.every((child) => child.type === CarouselItem$1);
    if (slidesOnly) {
      return /* @__PURE__ */ import_react3.default.createElement("div", _extends({}, attributes, {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }), /* @__PURE__ */ import_react3.default.createElement(CarouselContext.Provider, {
        value: this.getContextValue()
      }, this.renderItems(children, innerClasses)));
    }
    if (children[0] instanceof Array) {
      const _carouselItems = children[0];
      const _controlLeft = children[1];
      const _controlRight = children[2];
      return /* @__PURE__ */ import_react3.default.createElement("div", _extends({}, attributes, {
        className: outerClasses,
        onMouseEnter: this.hoverStart,
        onMouseLeave: this.hoverEnd
      }), /* @__PURE__ */ import_react3.default.createElement(CarouselContext.Provider, {
        value: this.getContextValue()
      }, this.renderItems(_carouselItems, innerClasses), _controlLeft, _controlRight));
    }
    const indicators = children[0];
    const wrappedOnClick = (e) => {
      if (typeof indicators.props.onClickHandler === "function") {
        this.setState({
          indicatorClicked: true
        }, () => indicators.props.onClickHandler(e));
      }
    };
    const wrappedIndicators = import_react3.default.cloneElement(indicators, {
      onClickHandler: wrappedOnClick
    });
    const carouselItems = children[1];
    const controlLeft = children[2];
    const controlRight = children[3];
    return /* @__PURE__ */ import_react3.default.createElement("div", _extends({}, attributes, {
      className: outerClasses,
      onMouseEnter: this.hoverStart,
      onMouseLeave: this.hoverEnd,
      onTouchStart: this.handleTouchStart,
      onTouchEnd: this.handleTouchEnd
    }), /* @__PURE__ */ import_react3.default.createElement(CarouselContext.Provider, {
      value: this.getContextValue()
    }, wrappedIndicators, this.renderItems(carouselItems, innerClasses), controlLeft, controlRight));
  }
};
Carousel.propTypes = propTypes$K;
Carousel.defaultProps = defaultProps$J;
var Carousel$1 = Carousel;
var _excluded$F = ["direction", "onClickHandler", "cssModule", "directionText", "className"];
function CarouselControl(props) {
  const {
    direction,
    onClickHandler,
    cssModule,
    directionText,
    className
  } = props, attributes = _objectWithoutProperties(props, _excluded$F);
  const anchorClasses = mapToCssModules((0, import_classnames.default)(className, `carousel-control-${direction}`), cssModule);
  const iconClasses = mapToCssModules((0, import_classnames.default)(`carousel-control-${direction}-icon`), cssModule);
  const screenReaderClasses = mapToCssModules((0, import_classnames.default)("visually-hidden"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement("a", _extends({}, attributes, {
    className: anchorClasses,
    style: {
      cursor: "pointer"
    },
    role: "button",
    tabIndex: "0",
    onClick: (e) => {
      e.preventDefault();
      onClickHandler();
    }
  }), /* @__PURE__ */ import_react3.default.createElement("span", {
    className: iconClasses,
    "aria-hidden": "true"
  }), /* @__PURE__ */ import_react3.default.createElement("span", {
    className: screenReaderClasses
  }, directionText || direction));
}
CarouselControl.propTypes = {
  direction: import_prop_types3.default.oneOf(["prev", "next"]).isRequired,
  onClickHandler: import_prop_types3.default.func.isRequired,
  cssModule: import_prop_types3.default.object,
  directionText: import_prop_types3.default.string,
  className: import_prop_types3.default.string
};
var _excluded$E = ["items", "activeIndex", "cssModule", "onClickHandler", "className"];
function CarouselIndicators(props) {
  const {
    items,
    activeIndex,
    cssModule,
    onClickHandler,
    className
  } = props, attributes = _objectWithoutProperties(props, _excluded$E);
  const listClasses = mapToCssModules((0, import_classnames.default)(className, "carousel-indicators"), cssModule);
  const indicators = items.map((item, idx) => {
    const indicatorClasses = mapToCssModules((0, import_classnames.default)({
      active: activeIndex === idx
    }), cssModule);
    return /* @__PURE__ */ import_react3.default.createElement("button", {
      "aria-label": item.caption,
      "data-bs-target": true,
      type: "button",
      key: `${item.key || Object.values(item).join("")}`,
      onClick: (e) => {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });
  return /* @__PURE__ */ import_react3.default.createElement("div", _extends({
    className: listClasses
  }, attributes), indicators);
}
CarouselIndicators.propTypes = {
  activeIndex: import_prop_types3.default.number.isRequired,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  items: import_prop_types3.default.array.isRequired,
  onClickHandler: import_prop_types3.default.func.isRequired
};
function CarouselCaption(props) {
  const {
    captionHeader,
    captionText,
    cssModule,
    className
  } = props;
  const classes = mapToCssModules((0, import_classnames.default)(className, "carousel-caption", "d-none", "d-md-block"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement("div", {
    className: classes
  }, /* @__PURE__ */ import_react3.default.createElement("h3", null, captionHeader), /* @__PURE__ */ import_react3.default.createElement("p", null, captionText));
}
CarouselCaption.propTypes = {
  captionHeader: import_prop_types3.default.node,
  captionText: import_prop_types3.default.node.isRequired,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var _excluded$D = ["defaultActiveIndex", "autoPlay", "indicators", "controls", "items", "goToIndex"];
var propTypes$J = {
  items: import_prop_types3.default.array.isRequired,
  indicators: import_prop_types3.default.bool,
  controls: import_prop_types3.default.bool,
  autoPlay: import_prop_types3.default.bool,
  defaultActiveIndex: import_prop_types3.default.number,
  activeIndex: import_prop_types3.default.number,
  next: import_prop_types3.default.func,
  previous: import_prop_types3.default.func,
  goToIndex: import_prop_types3.default.func
};
var UncontrolledCarousel = class extends import_react3.Component {
  constructor(props) {
    super(props);
    this.animating = false;
    this.state = {
      activeIndex: props.defaultActiveIndex || 0
    };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }
  onExiting() {
    this.animating = true;
  }
  onExited() {
    this.animating = false;
  }
  next() {
    if (this.animating)
      return;
    this.setState((prevState) => {
      const nextIndex = prevState.activeIndex === this.props.items.length - 1 ? 0 : prevState.activeIndex + 1;
      return {
        activeIndex: nextIndex
      };
    });
  }
  previous() {
    if (this.animating)
      return;
    this.setState((prevState) => {
      const nextIndex = prevState.activeIndex === 0 ? this.props.items.length - 1 : prevState.activeIndex - 1;
      return {
        activeIndex: nextIndex
      };
    });
  }
  goToIndex(newIndex) {
    if (this.animating)
      return;
    this.setState({
      activeIndex: newIndex
    });
  }
  render() {
    const _this$props = this.props, {
      defaultActiveIndex,
      autoPlay,
      indicators,
      controls,
      items,
      goToIndex
    } = _this$props, props = _objectWithoutProperties(_this$props, _excluded$D);
    const {
      activeIndex
    } = this.state;
    const slides = items.map((item) => {
      const key = item.key || item.src;
      return /* @__PURE__ */ import_react3.default.createElement(CarouselItem$1, {
        onExiting: this.onExiting,
        onExited: this.onExited,
        key
      }, /* @__PURE__ */ import_react3.default.createElement("img", {
        className: "d-block w-100",
        src: item.src,
        alt: item.altText
      }), /* @__PURE__ */ import_react3.default.createElement(CarouselCaption, {
        captionText: item.caption,
        captionHeader: item.header || item.caption
      }));
    });
    return /* @__PURE__ */ import_react3.default.createElement(Carousel$1, _extends({
      activeIndex,
      next: this.next,
      previous: this.previous,
      ride: autoPlay ? "carousel" : void 0
    }, props), indicators && /* @__PURE__ */ import_react3.default.createElement(CarouselIndicators, {
      items,
      activeIndex: props.activeIndex || activeIndex,
      onClickHandler: goToIndex || this.goToIndex
    }), slides, controls && /* @__PURE__ */ import_react3.default.createElement(CarouselControl, {
      direction: "prev",
      directionText: "Previous",
      onClickHandler: props.previous || this.previous
    }), controls && /* @__PURE__ */ import_react3.default.createElement(CarouselControl, {
      direction: "next",
      directionText: "Next",
      onClickHandler: props.next || this.next
    }));
  }
};
UncontrolledCarousel.propTypes = propTypes$J;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};
var _excluded$C = ["className", "cssModule", "tag"];
var propTypes$I = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$I = {
  tag: "div"
};
function CardSubtitle(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$C);
  const classes = mapToCssModules((0, import_classnames.default)(className, "card-subtitle"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
CardSubtitle.propTypes = propTypes$I;
CardSubtitle.defaultProps = defaultProps$I;
var _excluded$B = ["className", "cssModule", "tag"];
var propTypes$H = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$H = {
  tag: "p"
};
function CardText(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$B);
  const classes = mapToCssModules((0, import_classnames.default)(className, "card-text"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
CardText.propTypes = propTypes$H;
CardText.defaultProps = defaultProps$H;
var _excluded$A = ["className", "cssModule", "tag"];
var propTypes$G = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$G = {
  tag: "div"
};
function CardTitle(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$A);
  const classes = mapToCssModules((0, import_classnames.default)(className, "card-title"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
CardTitle.propTypes = propTypes$G;
CardTitle.defaultProps = defaultProps$G;
var _excluded$z = ["cssModule", "children", "isOpen", "flip", "target", "offset", "fallbackPlacements", "placementPrefix", "arrowClassName", "hideArrow", "popperClassName", "tag", "container", "modifiers", "strategy", "boundariesElement", "onClosed", "fade", "transition", "placement"];
function noop$2() {
}
var propTypes$F = {
  children: import_prop_types3.default.oneOfType([import_prop_types3.default.node, import_prop_types3.default.func]).isRequired,
  popperClassName: import_prop_types3.default.string,
  placement: import_prop_types3.default.string,
  placementPrefix: import_prop_types3.default.string,
  arrowClassName: import_prop_types3.default.string,
  hideArrow: import_prop_types3.default.bool,
  tag: tagPropType,
  isOpen: import_prop_types3.default.bool,
  cssModule: import_prop_types3.default.object,
  offset: import_prop_types3.default.arrayOf(import_prop_types3.default.number),
  fallbackPlacements: import_prop_types3.default.array,
  flip: import_prop_types3.default.bool,
  container: targetPropType,
  target: targetPropType.isRequired,
  modifiers: import_prop_types3.default.array,
  strategy: import_prop_types3.default.string,
  boundariesElement: import_prop_types3.default.oneOfType([import_prop_types3.default.string, DOMElement]),
  onClosed: import_prop_types3.default.func,
  fade: import_prop_types3.default.bool,
  transition: import_prop_types3.default.shape(Fade.propTypes)
};
var defaultProps$F = {
  boundariesElement: "scrollParent",
  placement: "auto",
  hideArrow: false,
  isOpen: false,
  offset: [0, 0],
  flip: true,
  container: "body",
  modifiers: [],
  onClosed: noop$2,
  fade: true,
  transition: _objectSpread2({}, Fade.defaultProps)
};
var PopperContent = class extends import_react3.default.Component {
  constructor(props) {
    super(props);
    this.setTargetNode = this.setTargetNode.bind(this);
    this.getTargetNode = this.getTargetNode.bind(this);
    this.getRef = this.getRef.bind(this);
    this.onClosed = this.onClosed.bind(this);
    this.state = {
      isOpen: props.isOpen
    };
  }
  static getDerivedStateFromProps(props, state) {
    if (props.isOpen && !state.isOpen) {
      return {
        isOpen: props.isOpen
      };
    }
    return null;
  }
  componentDidUpdate() {
    if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
      this._element.childNodes[0].focus();
    }
  }
  onClosed() {
    this.props.onClosed();
    this.setState({
      isOpen: false
    });
  }
  getTargetNode() {
    return this.targetNode;
  }
  getContainerNode() {
    return getTarget(this.props.container);
  }
  getRef(ref) {
    this._element = ref;
  }
  setTargetNode(node) {
    this.targetNode = typeof node === "string" ? getTarget(node) : node;
  }
  renderChildren() {
    const _this$props = this.props, {
      cssModule,
      children,
      isOpen,
      flip: flip2,
      target,
      offset: offset2,
      fallbackPlacements,
      placementPrefix,
      arrowClassName: _arrowClassName,
      hideArrow,
      popperClassName: _popperClassName,
      tag,
      container,
      modifiers,
      strategy,
      boundariesElement,
      onClosed,
      fade,
      transition,
      placement
    } = _this$props, attrs = _objectWithoutProperties(_this$props, _excluded$z);
    const arrowClassName = mapToCssModules((0, import_classnames.default)("arrow", _arrowClassName), cssModule);
    const popperClassName = mapToCssModules((0, import_classnames.default)(_popperClassName, placementPrefix ? `${placementPrefix}-auto` : ""), this.props.cssModule);
    const modifierNames = modifiers.map((m) => m.name);
    const baseModifiers = [{
      name: "offset",
      options: {
        offset: offset2
      }
    }, {
      name: "flip",
      enabled: flip2,
      options: {
        fallbackPlacements
      }
    }, {
      name: "preventOverflow",
      options: {
        boundary: boundariesElement
      }
    }].filter((m) => !modifierNames.includes(m.name));
    const extendedModifiers = [...baseModifiers, ...modifiers];
    const popperTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), transition), {}, {
      baseClass: fade ? transition.baseClass : "",
      timeout: fade ? transition.timeout : 0
    });
    return /* @__PURE__ */ import_react3.default.createElement(Fade, _extends({}, popperTransition, attrs, {
      in: isOpen,
      onExited: this.onClosed,
      tag
    }), /* @__PURE__ */ import_react3.default.createElement(Popper, {
      referenceElement: this.targetNode,
      modifiers: extendedModifiers,
      placement,
      strategy
    }, ({
      ref,
      style,
      placement: popperPlacement,
      isReferenceHidden,
      arrowProps,
      update
    }) => /* @__PURE__ */ import_react3.default.createElement("div", {
      ref,
      style,
      className: popperClassName,
      "data-popper-placement": popperPlacement,
      "data-popper-reference-hidden": isReferenceHidden ? "true" : void 0
    }, typeof children === "function" ? children({
      update
    }) : children, !hideArrow && /* @__PURE__ */ import_react3.default.createElement("span", {
      ref: arrowProps.ref,
      className: arrowClassName,
      style: arrowProps.style
    }))));
  }
  render() {
    this.setTargetNode(this.props.target);
    if (this.state.isOpen) {
      return this.props.container === "inline" ? this.renderChildren() : import_react_dom2.default.createPortal(/* @__PURE__ */ import_react3.default.createElement("div", {
        ref: this.getRef
      }, this.renderChildren()), this.getContainerNode());
    }
    return null;
  }
};
PopperContent.propTypes = propTypes$F;
PopperContent.defaultProps = defaultProps$F;
var PopperContent$1 = PopperContent;
function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(getTarget(props.target));
  return null;
}
PopperTargetHelper.contextTypes = {
  popperManager: import_prop_types3.default.object.isRequired
};
PopperTargetHelper.propTypes = {
  target: targetPropType.isRequired
};
var propTypes$E = {
  children: import_prop_types3.default.oneOfType([import_prop_types3.default.node, import_prop_types3.default.func]),
  placement: import_prop_types3.default.oneOf(PopperPlacements),
  target: targetPropType.isRequired,
  container: targetPropType,
  isOpen: import_prop_types3.default.bool,
  disabled: import_prop_types3.default.bool,
  hideArrow: import_prop_types3.default.bool,
  boundariesElement: import_prop_types3.default.oneOfType([import_prop_types3.default.string, DOMElement]),
  className: import_prop_types3.default.string,
  innerClassName: import_prop_types3.default.string,
  arrowClassName: import_prop_types3.default.string,
  popperClassName: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  toggle: import_prop_types3.default.func,
  autohide: import_prop_types3.default.bool,
  placementPrefix: import_prop_types3.default.string,
  delay: import_prop_types3.default.oneOfType([import_prop_types3.default.shape({
    show: import_prop_types3.default.number,
    hide: import_prop_types3.default.number
  }), import_prop_types3.default.number]),
  modifiers: import_prop_types3.default.array,
  strategy: import_prop_types3.default.string,
  offset: import_prop_types3.default.arrayOf(import_prop_types3.default.number),
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.func, import_prop_types3.default.string, import_prop_types3.default.object]),
  trigger: import_prop_types3.default.string,
  fade: import_prop_types3.default.bool,
  flip: import_prop_types3.default.bool
};
var DEFAULT_DELAYS = {
  show: 0,
  hide: 50
};
var defaultProps$E = {
  isOpen: false,
  hideArrow: false,
  autohide: false,
  delay: DEFAULT_DELAYS,
  toggle: function() {
  },
  trigger: "click",
  fade: true
};
function isInDOMSubtree(element, subtreeRoot) {
  return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}
function isInDOMSubtrees(element, subtreeRoots = []) {
  return subtreeRoots && subtreeRoots.length && subtreeRoots.filter((subTreeRoot) => isInDOMSubtree(element, subTreeRoot))[0];
}
var TooltipPopoverWrapper = class extends import_react3.default.Component {
  constructor(props) {
    super(props);
    this._targets = [];
    this.currentTargetElement = null;
    this.addTargetEvents = this.addTargetEvents.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.removeTargetEvents = this.removeTargetEvents.bind(this);
    this.toggle = this.toggle.bind(this);
    this.showWithDelay = this.showWithDelay.bind(this);
    this.hideWithDelay = this.hideWithDelay.bind(this);
    this.onMouseOverTooltipContent = this.onMouseOverTooltipContent.bind(this);
    this.onMouseLeaveTooltipContent = this.onMouseLeaveTooltipContent.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.onEscKeyDown = this.onEscKeyDown.bind(this);
    this.getRef = this.getRef.bind(this);
    this.state = {
      isOpen: props.isOpen
    };
    this._isMounted = false;
  }
  componentDidMount() {
    this._isMounted = true;
    this.updateTarget();
  }
  componentWillUnmount() {
    this._isMounted = false;
    this.removeTargetEvents();
    this._targets = null;
    this.clearShowTimeout();
    this.clearHideTimeout();
  }
  static getDerivedStateFromProps(props, state) {
    if (props.isOpen && !state.isOpen) {
      return {
        isOpen: props.isOpen
      };
    }
    return null;
  }
  handleDocumentClick(e) {
    const triggers = this.props.trigger.split(" ");
    if (triggers.indexOf("legacy") > -1 && (this.props.isOpen || isInDOMSubtrees(e.target, this._targets))) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
      if (this.props.isOpen && !isInDOMSubtree(e.target, this._popover)) {
        this.hideWithDelay(e);
      } else if (!this.props.isOpen) {
        this.showWithDelay(e);
      }
    } else if (triggers.indexOf("click") > -1 && isInDOMSubtrees(e.target, this._targets)) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
      if (!this.props.isOpen) {
        this.showWithDelay(e);
      } else {
        this.hideWithDelay(e);
      }
    }
  }
  onMouseOverTooltipContent() {
    if (this.props.trigger.indexOf("hover") > -1 && !this.props.autohide) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
      if (this.state.isOpen && !this.props.isOpen) {
        this.toggle();
      }
    }
  }
  onMouseLeaveTooltipContent(e) {
    if (this.props.trigger.indexOf("hover") > -1 && !this.props.autohide) {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      e.persist();
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay("hide"));
    }
  }
  onEscKeyDown(e) {
    if (e.key === "Escape") {
      this.hide(e);
    }
  }
  getRef(ref) {
    const {
      innerRef
    } = this.props;
    if (innerRef) {
      if (typeof innerRef === "function") {
        innerRef(ref);
      } else if (typeof innerRef === "object") {
        innerRef.current = ref;
      }
    }
    this._popover = ref;
  }
  getDelay(key) {
    const {
      delay
    } = this.props;
    if (typeof delay === "object") {
      return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
    }
    return delay;
  }
  getCurrentTarget(target) {
    if (!target)
      return null;
    const index2 = this._targets.indexOf(target);
    if (index2 >= 0)
      return this._targets[index2];
    return this.getCurrentTarget(target.parentElement);
  }
  show(e) {
    if (!this.props.isOpen) {
      this.clearShowTimeout();
      this.currentTargetElement = e ? e.currentTarget || this.getCurrentTarget(e.target) : null;
      if (e && e.composedPath && typeof e.composedPath === "function") {
        const path = e.composedPath();
        this.currentTargetElement = path && path[0] || this.currentTargetElement;
      }
      this.toggle(e);
    }
  }
  showWithDelay(e) {
    if (this._hideTimeout) {
      this.clearHideTimeout();
    }
    this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay("show"));
  }
  hide(e) {
    if (this.props.isOpen) {
      this.clearHideTimeout();
      this.currentTargetElement = null;
      this.toggle(e);
    }
  }
  hideWithDelay(e) {
    if (this._showTimeout) {
      this.clearShowTimeout();
    }
    this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay("hide"));
  }
  clearShowTimeout() {
    clearTimeout(this._showTimeout);
    this._showTimeout = void 0;
  }
  clearHideTimeout() {
    clearTimeout(this._hideTimeout);
    this._hideTimeout = void 0;
  }
  addEventOnTargets(type, handler, isBubble) {
    this._targets.forEach((target) => {
      target.addEventListener(type, handler, isBubble);
    });
  }
  removeEventOnTargets(type, handler, isBubble) {
    this._targets.forEach((target) => {
      target.removeEventListener(type, handler, isBubble);
    });
  }
  addTargetEvents() {
    if (this.props.trigger) {
      let triggers = this.props.trigger.split(" ");
      if (triggers.indexOf("manual") === -1) {
        if (triggers.indexOf("click") > -1 || triggers.indexOf("legacy") > -1) {
          document.addEventListener("click", this.handleDocumentClick, true);
        }
        if (this._targets && this._targets.length) {
          if (triggers.indexOf("hover") > -1) {
            this.addEventOnTargets("mouseover", this.showWithDelay, true);
            this.addEventOnTargets("mouseout", this.hideWithDelay, true);
          }
          if (triggers.indexOf("focus") > -1) {
            this.addEventOnTargets("focusin", this.show, true);
            this.addEventOnTargets("focusout", this.hide, true);
          }
          this.addEventOnTargets("keydown", this.onEscKeyDown, true);
        }
      }
    }
  }
  removeTargetEvents() {
    if (this._targets) {
      this.removeEventOnTargets("mouseover", this.showWithDelay, true);
      this.removeEventOnTargets("mouseout", this.hideWithDelay, true);
      this.removeEventOnTargets("keydown", this.onEscKeyDown, true);
      this.removeEventOnTargets("focusin", this.show, true);
      this.removeEventOnTargets("focusout", this.hide, true);
    }
    document.removeEventListener("click", this.handleDocumentClick, true);
  }
  updateTarget() {
    const newTarget = getTarget(this.props.target, true);
    if (newTarget !== this._targets) {
      this.removeTargetEvents();
      this._targets = newTarget ? Array.from(newTarget) : [];
      this.currentTargetElement = this.currentTargetElement || this._targets[0];
      this.addTargetEvents();
    }
  }
  toggle(e) {
    if (this.props.disabled || !this._isMounted) {
      return e && e.preventDefault();
    }
    return this.props.toggle(e);
  }
  render() {
    if (this.props.isOpen) {
      this.updateTarget();
    }
    const target = this.currentTargetElement || this._targets[0];
    if (!target) {
      return null;
    }
    const {
      className,
      cssModule,
      innerClassName,
      isOpen,
      hideArrow,
      boundariesElement,
      placement,
      placementPrefix,
      arrowClassName,
      popperClassName,
      container,
      modifiers,
      strategy,
      offset: offset2,
      fade,
      flip: flip2,
      children
    } = this.props;
    const attributes = omit(this.props, Object.keys(propTypes$E));
    const popperClasses = mapToCssModules(popperClassName, cssModule);
    const classes = mapToCssModules(innerClassName, cssModule);
    return /* @__PURE__ */ import_react3.default.createElement(PopperContent$1, {
      className,
      target,
      isOpen,
      hideArrow,
      boundariesElement,
      placement,
      placementPrefix,
      arrowClassName,
      popperClassName: popperClasses,
      container,
      modifiers,
      strategy,
      offset: offset2,
      cssModule,
      fade,
      flip: flip2
    }, ({
      update
    }) => /* @__PURE__ */ import_react3.default.createElement("div", _extends({}, attributes, {
      ref: this.getRef,
      className: classes,
      role: "tooltip",
      onMouseOver: this.onMouseOverTooltipContent,
      onMouseLeave: this.onMouseLeaveTooltipContent,
      onKeyDown: this.onEscKeyDown
    }), typeof children === "function" ? children({
      update
    }) : children));
  }
};
TooltipPopoverWrapper.propTypes = propTypes$E;
TooltipPopoverWrapper.defaultProps = defaultProps$E;
var TooltipPopoverWrapper$1 = TooltipPopoverWrapper;
var defaultProps$D = {
  placement: "right",
  placementPrefix: "bs-popover",
  trigger: "click",
  offset: [0, 8]
};
function Popover(props) {
  const popperClasses = (0, import_classnames.default)("popover", "show", props.popperClassName);
  const classes = (0, import_classnames.default)("popover-inner", props.innerClassName);
  return /* @__PURE__ */ import_react3.default.createElement(TooltipPopoverWrapper$1, _extends({}, props, {
    arrowClassName: "popover-arrow",
    popperClassName: popperClasses,
    innerClassName: classes
  }));
}
Popover.propTypes = propTypes$E;
Popover.defaultProps = defaultProps$D;
var omitKeys$4 = ["defaultOpen"];
var UncontrolledPopover = class extends import_react3.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpen || false
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen
    }));
  }
  render() {
    return /* @__PURE__ */ import_react3.default.createElement(Popover, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys$4)));
  }
};
UncontrolledPopover.propTypes = _objectSpread2({
  defaultOpen: import_prop_types3.default.bool
}, Popover.propTypes);
var _excluded$y = ["className", "cssModule", "tag"];
var propTypes$D = {
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$C = {
  tag: "h3"
};
function PopoverHeader(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$y);
  const classes = mapToCssModules((0, import_classnames.default)(className, "popover-header"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
PopoverHeader.propTypes = propTypes$D;
PopoverHeader.defaultProps = defaultProps$C;
var _excluded$x = ["className", "cssModule", "tag"];
var propTypes$C = {
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$B = {
  tag: "div"
};
function PopoverBody(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$x);
  const classes = mapToCssModules((0, import_classnames.default)(className, "popover-body"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
PopoverBody.propTypes = propTypes$C;
PopoverBody.defaultProps = defaultProps$B;
var _excluded$w = ["children", "className", "barClassName", "cssModule", "value", "min", "max", "animated", "striped", "color", "bar", "multi", "tag", "style", "barStyle", "barAriaValueText", "barAriaLabelledBy"];
var propTypes$B = {
  animated: import_prop_types3.default.bool,
  bar: import_prop_types3.default.bool,
  barAriaLabelledBy: import_prop_types3.default.string,
  barAriaValueText: import_prop_types3.default.string,
  barClassName: import_prop_types3.default.string,
  barStyle: import_prop_types3.default.object,
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  color: import_prop_types3.default.string,
  max: import_prop_types3.default.oneOfType([import_prop_types3.default.string, import_prop_types3.default.number]),
  min: import_prop_types3.default.oneOfType([import_prop_types3.default.string, import_prop_types3.default.number]),
  multi: import_prop_types3.default.bool,
  striped: import_prop_types3.default.bool,
  style: import_prop_types3.default.object,
  tag: tagPropType,
  value: import_prop_types3.default.oneOfType([import_prop_types3.default.string, import_prop_types3.default.number])
};
var defaultProps$A = {
  tag: "div",
  value: 0,
  min: 0,
  max: 100,
  style: {},
  barStyle: {}
};
function Progress(props) {
  const {
    children,
    className,
    barClassName,
    cssModule,
    value,
    min: min2,
    max: max2,
    animated,
    striped,
    color,
    bar,
    multi,
    tag: Tag,
    style,
    barStyle,
    barAriaValueText,
    barAriaLabelledBy
  } = props, attributes = _objectWithoutProperties(props, _excluded$w);
  const percent = toNumber(value) / toNumber(max2) * 100;
  const progressClasses = mapToCssModules((0, import_classnames.default)(className, "progress"), cssModule);
  const progressBarClasses = mapToCssModules((0, import_classnames.default)("progress-bar", bar ? className || barClassName : barClassName, animated ? "progress-bar-animated" : null, color ? `bg-${color}` : null, striped || animated ? "progress-bar-striped" : null), cssModule);
  const progressBarProps = {
    className: progressBarClasses,
    style: _objectSpread2(_objectSpread2(_objectSpread2({}, bar ? style : {}), barStyle), {}, {
      width: `${percent}%`
    }),
    role: "progressbar",
    "aria-valuenow": value,
    "aria-valuemin": min2,
    "aria-valuemax": max2,
    "aria-valuetext": barAriaValueText,
    "aria-labelledby": barAriaLabelledBy,
    children
  };
  if (bar) {
    return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, progressBarProps));
  }
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    style,
    className: progressClasses
  }), multi ? children : /* @__PURE__ */ import_react3.default.createElement("div", progressBarProps));
}
Progress.propTypes = propTypes$B;
Progress.defaultProps = defaultProps$A;
var propTypes$A = {
  children: import_prop_types3.default.node.isRequired,
  node: import_prop_types3.default.any
};
var Portal = class extends import_react3.default.Component {
  componentWillUnmount() {
    if (this.defaultNode) {
      document.body.removeChild(this.defaultNode);
    }
    this.defaultNode = null;
  }
  render() {
    if (!canUseDOM) {
      return null;
    }
    if (!this.props.node && !this.defaultNode) {
      this.defaultNode = document.createElement("div");
      document.body.appendChild(this.defaultNode);
    }
    return import_react_dom2.default.createPortal(this.props.children, this.props.node || this.defaultNode);
  }
};
Portal.propTypes = propTypes$A;
var Portal$1 = Portal;
function noop$1() {
}
var FadePropTypes$1 = import_prop_types3.default.shape(Fade.propTypes);
var propTypes$z = {
  autoFocus: import_prop_types3.default.bool,
  backdrop: import_prop_types3.default.oneOfType([import_prop_types3.default.bool, import_prop_types3.default.oneOf(["static"])]),
  backdropClassName: import_prop_types3.default.string,
  backdropTransition: FadePropTypes$1,
  centered: import_prop_types3.default.bool,
  children: import_prop_types3.default.node,
  contentClassName: import_prop_types3.default.string,
  className: import_prop_types3.default.string,
  container: targetPropType,
  cssModule: import_prop_types3.default.object,
  external: import_prop_types3.default.node,
  fade: import_prop_types3.default.bool,
  fullscreen: import_prop_types3.default.oneOfType([import_prop_types3.default.bool, import_prop_types3.default.oneOf(["sm", "md", "lg", "xl"])]),
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func]),
  isOpen: import_prop_types3.default.bool,
  keyboard: import_prop_types3.default.bool,
  labelledBy: import_prop_types3.default.string,
  modalClassName: import_prop_types3.default.string,
  modalTransition: FadePropTypes$1,
  onClosed: import_prop_types3.default.func,
  onEnter: import_prop_types3.default.func,
  onExit: import_prop_types3.default.func,
  onOpened: import_prop_types3.default.func,
  returnFocusAfterClose: import_prop_types3.default.bool,
  role: import_prop_types3.default.string,
  scrollable: import_prop_types3.default.bool,
  size: import_prop_types3.default.string,
  toggle: import_prop_types3.default.func,
  trapFocus: import_prop_types3.default.bool,
  unmountOnClose: import_prop_types3.default.bool,
  wrapClassName: import_prop_types3.default.string,
  zIndex: import_prop_types3.default.oneOfType([import_prop_types3.default.number, import_prop_types3.default.string])
};
var propsToOmit$1 = Object.keys(propTypes$z);
var defaultProps$z = {
  isOpen: false,
  autoFocus: true,
  centered: false,
  scrollable: false,
  role: "dialog",
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop$1,
  onClosed: noop$1,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade
  },
  unmountOnClose: true,
  returnFocusAfterClose: true,
  container: "body",
  trapFocus: false
};
var Modal = class extends import_react3.default.Component {
  constructor(props) {
    super(props);
    this._element = null;
    this._originalBodyPadding = null;
    this.getFocusableChildren = this.getFocusableChildren.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    this.handleBackdropMouseDown = this.handleBackdropMouseDown.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handleStaticBackdropAnimation = this.handleStaticBackdropAnimation.bind(this);
    this.handleTab = this.handleTab.bind(this);
    this.onOpened = this.onOpened.bind(this);
    this.onClosed = this.onClosed.bind(this);
    this.manageFocusAfterClose = this.manageFocusAfterClose.bind(this);
    this.clearBackdropAnimationTimeout = this.clearBackdropAnimationTimeout.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
    this.state = {
      isOpen: false,
      showStaticBackdropAnimation: false
    };
  }
  componentDidMount() {
    const {
      isOpen,
      autoFocus,
      onEnter
    } = this.props;
    if (isOpen) {
      this.init();
      this.setState({
        isOpen: true
      });
      if (autoFocus) {
        this.setFocus();
      }
    }
    if (onEnter) {
      onEnter();
    }
    document.addEventListener("focus", this.trapFocus, true);
    this._isMounted = true;
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.init();
      this.setState({
        isOpen: true
      });
      return;
    }
    if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
      this.setFocus();
    }
    if (this._element && prevProps.zIndex !== this.props.zIndex) {
      this._element.style.zIndex = this.props.zIndex;
    }
  }
  componentWillUnmount() {
    this.clearBackdropAnimationTimeout();
    if (this.props.onExit) {
      this.props.onExit();
    }
    if (this._element) {
      this.destroy();
      if (this.props.isOpen || this.state.isOpen) {
        this.close();
      }
    }
    document.removeEventListener("focus", this.trapFocus, true);
    this._isMounted = false;
  }
  handleBackdropClick(e) {
    if (e.target === this._mouseDownElement) {
      e.stopPropagation();
      const backdrop = this._dialog ? this._dialog.parentNode : null;
      if (backdrop && e.target === backdrop && this.props.backdrop === "static") {
        this.handleStaticBackdropAnimation();
      }
      if (!this.props.isOpen || this.props.backdrop !== true)
        return;
      if (backdrop && e.target === backdrop && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }
  handleTab(e) {
    if (e.which !== 9)
      return;
    if (this.modalIndex < Modal.openCount - 1)
      return;
    const focusableChildren = this.getFocusableChildren();
    const totalFocusable = focusableChildren.length;
    if (totalFocusable === 0)
      return;
    const currentFocus = this.getFocusedChild();
    let focusedIndex = 0;
    for (let i = 0; i < totalFocusable; i += 1) {
      if (focusableChildren[i] === currentFocus) {
        focusedIndex = i;
        break;
      }
    }
    if (e.shiftKey && focusedIndex === 0) {
      e.preventDefault();
      focusableChildren[totalFocusable - 1].focus();
    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
      e.preventDefault();
      focusableChildren[0].focus();
    }
  }
  handleBackdropMouseDown(e) {
    this._mouseDownElement = e.target;
  }
  handleEscape(e) {
    if (this.props.isOpen && e.keyCode === keyCodes.esc && this.props.toggle) {
      if (this.props.keyboard) {
        e.preventDefault();
        e.stopPropagation();
        this.props.toggle(e);
      } else if (this.props.backdrop === "static") {
        e.preventDefault();
        e.stopPropagation();
        this.handleStaticBackdropAnimation();
      }
    }
  }
  handleStaticBackdropAnimation() {
    this.clearBackdropAnimationTimeout();
    this.setState({
      showStaticBackdropAnimation: true
    });
    this._backdropAnimationTimeout = setTimeout(() => {
      this.setState({
        showStaticBackdropAnimation: false
      });
    }, 100);
  }
  onOpened(node, isAppearing) {
    this.props.onOpened();
    (this.props.modalTransition.onEntered || noop$1)(node, isAppearing);
  }
  onClosed(node) {
    const {
      unmountOnClose
    } = this.props;
    this.props.onClosed();
    (this.props.modalTransition.onExited || noop$1)(node);
    if (unmountOnClose) {
      this.destroy();
    }
    this.close();
    if (this._isMounted) {
      this.setState({
        isOpen: false
      });
    }
  }
  setFocus() {
    if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === "function") {
      this._dialog.parentNode.focus();
    }
  }
  getFocusableChildren() {
    return this._element.querySelectorAll(focusableElements.join(", "));
  }
  getFocusedChild() {
    let currentFocus;
    const focusableChildren = this.getFocusableChildren();
    try {
      currentFocus = document.activeElement;
    } catch (err) {
      currentFocus = focusableChildren[0];
    }
    return currentFocus;
  }
  trapFocus(ev) {
    if (!this.props.trapFocus) {
      return;
    }
    if (!this._element) {
      return;
    }
    if (this._dialog && this._dialog.parentNode === ev.target) {
      return;
    }
    if (this.modalIndex < Modal.openCount - 1) {
      return;
    }
    const children = this.getFocusableChildren();
    for (let i = 0; i < children.length; i += 1) {
      if (children[i] === ev.target)
        return;
    }
    if (children.length > 0) {
      ev.preventDefault();
      ev.stopPropagation();
      children[0].focus();
    }
  }
  init() {
    try {
      this._triggeringElement = document.activeElement;
    } catch (err) {
      this._triggeringElement = null;
    }
    if (!this._element) {
      this._element = document.createElement("div");
      this._element.setAttribute("tabindex", "-1");
      this._element.style.position = "relative";
      this._element.style.zIndex = this.props.zIndex;
      this._mountContainer = getTarget(this.props.container);
      this._mountContainer.appendChild(this._element);
    }
    this._originalBodyPadding = getOriginalBodyPadding();
    if (Modal.openCount < 1) {
      Modal.originalBodyOverflow = window.getComputedStyle(document.body).overflow;
    }
    conditionallyUpdateScrollbar();
    if (Modal.openCount === 0) {
      document.body.className = (0, import_classnames.default)(document.body.className, mapToCssModules("modal-open", this.props.cssModule));
      document.body.style.overflow = "hidden";
    }
    this.modalIndex = Modal.openCount;
    Modal.openCount += 1;
  }
  destroy() {
    if (this._element) {
      this._mountContainer.removeChild(this._element);
      this._element = null;
    }
    this.manageFocusAfterClose();
  }
  manageFocusAfterClose() {
    if (this._triggeringElement) {
      const {
        returnFocusAfterClose
      } = this.props;
      if (this._triggeringElement.focus && returnFocusAfterClose)
        this._triggeringElement.focus();
      this._triggeringElement = null;
    }
  }
  close() {
    if (Modal.openCount <= 1) {
      const modalOpenClassName = mapToCssModules("modal-open", this.props.cssModule);
      const modalOpenClassNameRegex = new RegExp(`(^| )${modalOpenClassName}( |$)`);
      document.body.className = document.body.className.replace(modalOpenClassNameRegex, " ").trim();
      document.body.style.overflow = Modal.originalBodyOverflow;
    }
    this.manageFocusAfterClose();
    Modal.openCount = Math.max(0, Modal.openCount - 1);
    setScrollbarWidth(this._originalBodyPadding);
  }
  clearBackdropAnimationTimeout() {
    if (this._backdropAnimationTimeout) {
      clearTimeout(this._backdropAnimationTimeout);
      this._backdropAnimationTimeout = void 0;
    }
  }
  renderModalDialog() {
    const attributes = omit(this.props, propsToOmit$1);
    const dialogBaseClass = "modal-dialog";
    return /* @__PURE__ */ import_react3.default.createElement("div", _extends({}, attributes, {
      className: mapToCssModules((0, import_classnames.default)(dialogBaseClass, this.props.className, {
        [`modal-${this.props.size}`]: this.props.size,
        [`${dialogBaseClass}-centered`]: this.props.centered,
        [`${dialogBaseClass}-scrollable`]: this.props.scrollable,
        "modal-fullscreen": this.props.fullscreen === true,
        [`modal-fullscreen-${this.props.fullscreen}-down`]: typeof this.props.fullscreen === "string"
      }), this.props.cssModule),
      role: "document",
      ref: (c) => {
        this._dialog = c;
      }
    }), /* @__PURE__ */ import_react3.default.createElement("div", {
      className: mapToCssModules((0, import_classnames.default)("modal-content", this.props.contentClassName), this.props.cssModule)
    }, this.props.children));
  }
  render() {
    const {
      unmountOnClose
    } = this.props;
    if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
      const isModalHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
      this._element.style.display = isModalHidden ? "none" : "block";
      const {
        wrapClassName,
        modalClassName,
        backdropClassName,
        cssModule,
        isOpen,
        backdrop,
        role,
        labelledBy,
        external,
        innerRef
      } = this.props;
      const modalAttributes = {
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleBackdropMouseDown,
        onKeyUp: this.handleEscape,
        onKeyDown: this.handleTab,
        style: {
          display: "block"
        },
        "aria-labelledby": labelledBy,
        role,
        tabIndex: "-1"
      };
      const hasTransition = this.props.fade;
      const modalTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), this.props.modalTransition), {}, {
        baseClass: hasTransition ? this.props.modalTransition.baseClass : "",
        timeout: hasTransition ? this.props.modalTransition.timeout : 0
      });
      const backdropTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), this.props.backdropTransition), {}, {
        baseClass: hasTransition ? this.props.backdropTransition.baseClass : "",
        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
      });
      const Backdrop = backdrop && (hasTransition ? /* @__PURE__ */ import_react3.default.createElement(Fade, _extends({}, backdropTransition, {
        in: isOpen && !!backdrop,
        cssModule,
        className: mapToCssModules((0, import_classnames.default)("modal-backdrop", backdropClassName), cssModule)
      })) : /* @__PURE__ */ import_react3.default.createElement("div", {
        className: mapToCssModules((0, import_classnames.default)("modal-backdrop", "show", backdropClassName), cssModule)
      }));
      return /* @__PURE__ */ import_react3.default.createElement(Portal$1, {
        node: this._element
      }, /* @__PURE__ */ import_react3.default.createElement("div", {
        className: mapToCssModules(wrapClassName)
      }, /* @__PURE__ */ import_react3.default.createElement(Fade, _extends({}, modalAttributes, modalTransition, {
        in: isOpen,
        onEntered: this.onOpened,
        onExited: this.onClosed,
        cssModule,
        className: mapToCssModules((0, import_classnames.default)("modal", modalClassName, this.state.showStaticBackdropAnimation && "modal-static"), cssModule),
        innerRef
      }), external, this.renderModalDialog()), Backdrop));
    }
    return null;
  }
};
Modal.propTypes = propTypes$z;
Modal.defaultProps = defaultProps$z;
Modal.openCount = 0;
Modal.originalBodyOverflow = null;
var _excluded$v = ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "close"];
var propTypes$y = {
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  close: import_prop_types3.default.object,
  closeAriaLabel: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType,
  toggle: import_prop_types3.default.func,
  wrapTag: tagPropType
};
var defaultProps$y = {
  tag: "h5",
  wrapTag: "div",
  closeAriaLabel: "Close"
};
function ModalHeader(props) {
  let closeButton;
  const {
    className,
    cssModule,
    children,
    toggle,
    tag: Tag,
    wrapTag: WrapTag,
    closeAriaLabel,
    close
  } = props, attributes = _objectWithoutProperties(props, _excluded$v);
  const classes = mapToCssModules((0, import_classnames.default)(className, "modal-header"), cssModule);
  if (!close && toggle) {
    closeButton = /* @__PURE__ */ import_react3.default.createElement("button", {
      type: "button",
      onClick: toggle,
      className: mapToCssModules("btn-close", cssModule),
      "aria-label": closeAriaLabel
    });
  }
  return /* @__PURE__ */ import_react3.default.createElement(WrapTag, _extends({}, attributes, {
    className: classes
  }), /* @__PURE__ */ import_react3.default.createElement(Tag, {
    className: mapToCssModules("modal-title", cssModule)
  }, children), close || closeButton);
}
ModalHeader.propTypes = propTypes$y;
ModalHeader.defaultProps = defaultProps$y;
var _excluded$u = ["className", "cssModule", "tag"];
var propTypes$x = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$x = {
  tag: "div"
};
function ModalBody(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$u);
  const classes = mapToCssModules((0, import_classnames.default)(className, "modal-body"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
ModalBody.propTypes = propTypes$x;
ModalBody.defaultProps = defaultProps$x;
var _excluded$t = ["className", "cssModule", "tag"];
var propTypes$w = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$w = {
  tag: "div"
};
function ModalFooter(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$t);
  const classes = mapToCssModules((0, import_classnames.default)(className, "modal-footer"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
ModalFooter.propTypes = propTypes$w;
ModalFooter.defaultProps = defaultProps$w;
var defaultProps$v = {
  placement: "top",
  autohide: true,
  placementPrefix: "bs-tooltip",
  trigger: "hover focus"
};
function Tooltip(props) {
  const popperClasses = (0, import_classnames.default)("tooltip", "show", props.popperClassName);
  const classes = (0, import_classnames.default)("tooltip-inner", props.innerClassName);
  return /* @__PURE__ */ import_react3.default.createElement(TooltipPopoverWrapper$1, _extends({}, props, {
    arrowClassName: "tooltip-arrow",
    popperClassName: popperClasses,
    innerClassName: classes
  }));
}
Tooltip.propTypes = propTypes$E;
Tooltip.defaultProps = defaultProps$v;
var _excluded$s = ["className", "cssModule", "size", "bordered", "borderless", "striped", "dark", "hover", "responsive", "tag", "responsiveTag", "innerRef"];
var propTypes$v = {
  bordered: import_prop_types3.default.bool,
  borderless: import_prop_types3.default.bool,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  dark: import_prop_types3.default.bool,
  hover: import_prop_types3.default.bool,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.func, import_prop_types3.default.string, import_prop_types3.default.object]),
  responsive: import_prop_types3.default.oneOfType([import_prop_types3.default.bool, import_prop_types3.default.string]),
  responsiveTag: tagPropType,
  size: import_prop_types3.default.string,
  striped: import_prop_types3.default.bool,
  tag: tagPropType
};
var defaultProps$u = {
  tag: "table",
  responsiveTag: "div"
};
function Table(props) {
  const {
    className,
    cssModule,
    size,
    bordered,
    borderless,
    striped,
    dark,
    hover,
    responsive,
    tag: Tag,
    responsiveTag: ResponsiveTag,
    innerRef
  } = props, attributes = _objectWithoutProperties(props, _excluded$s);
  const classes = mapToCssModules((0, import_classnames.default)(className, "table", size ? "table-" + size : false, bordered ? "table-bordered" : false, borderless ? "table-borderless" : false, striped ? "table-striped" : false, dark ? "table-dark" : false, hover ? "table-hover" : false), cssModule);
  const table = /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    ref: innerRef,
    className: classes
  }));
  if (responsive) {
    const responsiveClassName = mapToCssModules(responsive === true ? "table-responsive" : `table-responsive-${responsive}`, cssModule);
    return /* @__PURE__ */ import_react3.default.createElement(ResponsiveTag, {
      className: responsiveClassName
    }, table);
  }
  return table;
}
Table.propTypes = propTypes$v;
Table.defaultProps = defaultProps$u;
var _excluded$r = ["className", "cssModule", "tag", "flush", "horizontal", "numbered"];
var propTypes$u = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  flush: import_prop_types3.default.bool,
  horizontal: import_prop_types3.default.oneOfType([import_prop_types3.default.bool, import_prop_types3.default.string]),
  numbered: import_prop_types3.default.bool,
  tag: tagPropType
};
var defaultProps$t = {
  tag: "ul",
  horizontal: false,
  numbered: false
};
var getHorizontalClass = (horizontal) => {
  if (horizontal === false) {
    return false;
  }
  if (horizontal === true || horizontal === "xs") {
    return "list-group-horizontal";
  }
  return `list-group-horizontal-${horizontal}`;
};
function ListGroup(props) {
  const {
    className,
    cssModule,
    tag: Tag,
    flush,
    horizontal,
    numbered
  } = props, attributes = _objectWithoutProperties(props, _excluded$r);
  const classes = mapToCssModules((0, import_classnames.default)(
    className,
    "list-group",
    flush ? "list-group-flush" : getHorizontalClass(horizontal),
    {
      "list-group-numbered": numbered
    }
  ), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
ListGroup.propTypes = propTypes$u;
ListGroup.defaultProps = defaultProps$t;
var _excluded$q = ["className", "cssModule", "tag", "innerRef"];
var propTypes$t = {
  children: import_prop_types3.default.node,
  tag: tagPropType,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.func, import_prop_types3.default.string]),
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$s = {
  tag: "form"
};
var Form = class extends import_react3.Component {
  constructor(props) {
    super(props);
    this.getRef = this.getRef.bind(this);
    this.submit = this.submit.bind(this);
  }
  getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }
    this.ref = ref;
  }
  submit() {
    if (this.ref) {
      this.ref.submit();
    }
  }
  render() {
    const _this$props = this.props, {
      className,
      cssModule,
      tag: Tag,
      innerRef
    } = _this$props, attributes = _objectWithoutProperties(_this$props, _excluded$q);
    const classes = mapToCssModules(className, cssModule);
    return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      className: classes
    }));
  }
};
Form.propTypes = propTypes$t;
Form.defaultProps = defaultProps$s;
var _excluded$p = ["className", "cssModule", "valid", "tooltip", "tag"];
var propTypes$s = {
  children: import_prop_types3.default.node,
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  valid: import_prop_types3.default.bool,
  tooltip: import_prop_types3.default.bool
};
var defaultProps$r = {
  tag: "div",
  valid: void 0
};
function FormFeedback(props) {
  const {
    className,
    cssModule,
    valid,
    tooltip,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$p);
  const validMode = tooltip ? "tooltip" : "feedback";
  const classes = mapToCssModules((0, import_classnames.default)(className, valid ? `valid-${validMode}` : `invalid-${validMode}`), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
FormFeedback.propTypes = propTypes$s;
FormFeedback.defaultProps = defaultProps$r;
var _excluded$o = ["className", "cssModule", "row", "disabled", "check", "inline", "floating", "tag", "switch"];
var propTypes$r = {
  children: import_prop_types3.default.node,
  row: import_prop_types3.default.bool,
  check: import_prop_types3.default.bool,
  switch: import_prop_types3.default.bool,
  inline: import_prop_types3.default.bool,
  floating: import_prop_types3.default.bool,
  disabled: import_prop_types3.default.bool,
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$q = {
  tag: "div"
};
function FormGroup(props) {
  const {
    className,
    cssModule,
    row,
    disabled,
    check,
    inline,
    floating,
    tag: Tag,
    switch: switchProp
  } = props, attributes = _objectWithoutProperties(props, _excluded$o);
  const formCheck = check || switchProp;
  const classes = mapToCssModules((0, import_classnames.default)(className, row ? "row" : false, formCheck ? "form-check" : "mb-3", switchProp ? "form-switch" : false, formCheck && inline ? "form-check-inline" : false, formCheck && disabled ? "disabled" : false, floating && "form-floating"), cssModule);
  if (Tag === "fieldset") {
    attributes.disabled = disabled;
  }
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
FormGroup.propTypes = propTypes$r;
FormGroup.defaultProps = defaultProps$q;
var _excluded$n = ["className", "cssModule", "inline", "color", "tag"];
var propTypes$q = {
  children: import_prop_types3.default.node,
  inline: import_prop_types3.default.bool,
  tag: tagPropType,
  color: import_prop_types3.default.string,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$p = {
  tag: "small",
  color: "muted"
};
function FormText(props) {
  const {
    className,
    cssModule,
    inline,
    color,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$n);
  const classes = mapToCssModules((0, import_classnames.default)(className, !inline ? "form-text" : false, color ? `text-${color}` : false), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
FormText.propTypes = propTypes$q;
FormText.defaultProps = defaultProps$p;
var _excluded$m = ["className", "cssModule", "type", "bsSize", "valid", "invalid", "tag", "addon", "plaintext", "innerRef"];
var propTypes$p = {
  children: import_prop_types3.default.node,
  type: import_prop_types3.default.string,
  size: import_prop_types3.default.oneOfType([import_prop_types3.default.number, import_prop_types3.default.string]),
  bsSize: import_prop_types3.default.string,
  valid: import_prop_types3.default.bool,
  invalid: import_prop_types3.default.bool,
  tag: tagPropType,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.func, import_prop_types3.default.string]),
  plaintext: import_prop_types3.default.bool,
  addon: import_prop_types3.default.bool,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$o = {
  type: "text"
};
var Input = class extends import_react3.default.Component {
  constructor(props) {
    super(props);
    this.getRef = this.getRef.bind(this);
    this.focus = this.focus.bind(this);
  }
  getRef(ref) {
    if (this.props.innerRef) {
      this.props.innerRef(ref);
    }
    this.ref = ref;
  }
  focus() {
    if (this.ref) {
      this.ref.focus();
    }
  }
  render() {
    let _this$props = this.props, {
      className,
      cssModule,
      type,
      bsSize,
      valid,
      invalid,
      tag,
      addon,
      plaintext,
      innerRef
    } = _this$props, attributes = _objectWithoutProperties(_this$props, _excluded$m);
    const checkInput = ["switch", "radio", "checkbox"].indexOf(type) > -1;
    const isNotaNumber = /\D/g;
    const textareaInput = type === "textarea";
    const selectInput = type === "select";
    const rangeInput = type === "range";
    let Tag = tag || (selectInput || textareaInput ? type : "input");
    let formControlClass = "form-control";
    if (plaintext) {
      formControlClass = `${formControlClass}-plaintext`;
      Tag = tag || "input";
    } else if (rangeInput) {
      formControlClass = "form-range";
    } else if (selectInput) {
      formControlClass = "form-select";
    } else if (checkInput) {
      if (addon) {
        formControlClass = null;
      } else {
        formControlClass = "form-check-input";
      }
    }
    if (attributes.size && isNotaNumber.test(attributes.size)) {
      warnOnce(`Please use the prop "bsSize" instead of the "size" to bootstrap's input sizing.`);
      bsSize = attributes.size;
      delete attributes.size;
    }
    const classes = mapToCssModules((0, import_classnames.default)(className, invalid && "is-invalid", valid && "is-valid", bsSize ? selectInput ? `form-select-${bsSize}` : `form-control-${bsSize}` : false, formControlClass), cssModule);
    if (Tag === "input" || tag && typeof tag === "function") {
      attributes.type = type === "switch" ? "checkbox" : type;
    }
    if (attributes.children && !(plaintext || type === "select" || typeof Tag !== "string" || Tag === "select")) {
      warnOnce(`Input with a type of "${type}" cannot have children. Please use "value"/"defaultValue" instead.`);
      delete attributes.children;
    }
    return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
      ref: innerRef,
      className: classes,
      "aria-invalid": invalid
    }));
  }
};
Input.propTypes = propTypes$p;
Input.defaultProps = defaultProps$o;
var Input$1 = Input;
var _excluded$l = ["className", "cssModule", "tag", "type", "size"];
var propTypes$o = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  size: import_prop_types3.default.string,
  tag: tagPropType,
  type: import_prop_types3.default.string
};
var defaultProps$n = {
  tag: "div"
};
function InputGroup(props) {
  const {
    className,
    cssModule,
    tag: Tag,
    type,
    size
  } = props, attributes = _objectWithoutProperties(props, _excluded$l);
  const classes = mapToCssModules((0, import_classnames.default)(className, "input-group", size ? `input-group-${size}` : null), cssModule);
  if (props.type === "dropdown") {
    return /* @__PURE__ */ import_react3.default.createElement(Dropdown$1, _extends({}, attributes, {
      className: classes
    }));
  }
  return /* @__PURE__ */ import_react3.default.createElement(InputGroupContext.Provider, {
    value: {
      insideInputGroup: true
    }
  }, /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  })));
}
InputGroup.propTypes = propTypes$o;
InputGroup.defaultProps = defaultProps$n;
var _excluded$k = ["className", "cssModule", "tag"];
var propTypes$n = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$m = {
  tag: "span"
};
function InputGroupText(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$k);
  const classes = mapToCssModules((0, import_classnames.default)(className, "input-group-text"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
InputGroupText.propTypes = propTypes$n;
InputGroupText.defaultProps = defaultProps$m;
var _excluded$j = ["className", "cssModule", "hidden", "widths", "tag", "check", "size", "for"];
var colWidths = ["xs", "sm", "md", "lg", "xl", "xxl"];
var stringOrNumberProp = import_prop_types3.default.oneOfType([import_prop_types3.default.number, import_prop_types3.default.string]);
var columnProps = import_prop_types3.default.oneOfType([import_prop_types3.default.bool, import_prop_types3.default.string, import_prop_types3.default.number, import_prop_types3.default.shape({
  size: stringOrNumberProp,
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);
var propTypes$m = {
  children: import_prop_types3.default.node,
  hidden: import_prop_types3.default.bool,
  check: import_prop_types3.default.bool,
  size: import_prop_types3.default.string,
  for: import_prop_types3.default.string,
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  xxl: columnProps,
  widths: import_prop_types3.default.array
};
var defaultProps$l = {
  tag: "label",
  widths: colWidths
};
var getColumnSizeClass = (isXs, colWidth, colSize) => {
  if (colSize === true || colSize === "") {
    return isXs ? "col" : `col-${colWidth}`;
  }
  if (colSize === "auto") {
    return isXs ? "col-auto" : `col-${colWidth}-auto`;
  }
  return isXs ? `col-${colSize}` : `col-${colWidth}-${colSize}`;
};
function Label(props) {
  const {
    className,
    cssModule,
    hidden,
    widths,
    tag: Tag,
    check,
    size,
    for: htmlFor
  } = props, attributes = _objectWithoutProperties(props, _excluded$j);
  const colClasses = [];
  widths.forEach((colWidth, i) => {
    let columnProp = props[colWidth];
    delete attributes[colWidth];
    if (!columnProp && columnProp !== "") {
      return;
    }
    const isXs = !i;
    let colClass;
    if (isObject(columnProp)) {
      const colSizeInterfix = isXs ? "-" : `-${colWidth}-`;
      colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
      colClasses.push(mapToCssModules((0, import_classnames.default)({
        [colClass]: columnProp.size || columnProp.size === "",
        [`order${colSizeInterfix}${columnProp.order}`]: columnProp.order || columnProp.order === 0,
        [`offset${colSizeInterfix}${columnProp.offset}`]: columnProp.offset || columnProp.offset === 0
      })), cssModule);
    } else {
      colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });
  const colFormLabel = size || colClasses.length;
  const formLabel = !(check || colFormLabel);
  const classes = mapToCssModules((0, import_classnames.default)(className, hidden ? "visually-hidden" : false, check ? "form-check-label" : false, size ? `col-form-label-${size}` : false, colClasses, colFormLabel ? "col-form-label" : false, formLabel ? "form-label" : false), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({
    htmlFor
  }, attributes, {
    className: classes
  }));
}
Label.propTypes = propTypes$m;
Label.defaultProps = defaultProps$l;
var _excluded$i = ["body", "bottom", "className", "cssModule", "heading", "left", "list", "middle", "object", "right", "tag", "top"];
var propTypes$l = {
  body: import_prop_types3.default.bool,
  bottom: import_prop_types3.default.bool,
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  heading: import_prop_types3.default.bool,
  left: import_prop_types3.default.bool,
  list: import_prop_types3.default.bool,
  middle: import_prop_types3.default.bool,
  object: import_prop_types3.default.bool,
  right: import_prop_types3.default.bool,
  tag: tagPropType,
  top: import_prop_types3.default.bool
};
function Media(props) {
  const {
    body,
    bottom: bottom2,
    className,
    cssModule,
    heading,
    left: left2,
    list,
    middle,
    object: object2,
    right: right2,
    tag,
    top: top2
  } = props, attributes = _objectWithoutProperties(props, _excluded$i);
  let defaultTag;
  if (heading) {
    defaultTag = "h4";
  } else if (attributes.href) {
    defaultTag = "a";
  } else if (attributes.src || object2) {
    defaultTag = "img";
  } else if (list) {
    defaultTag = "ul";
  } else {
    defaultTag = "div";
  }
  const Tag = tag || defaultTag;
  const classes = mapToCssModules((0, import_classnames.default)(className, {
    "media-body": body,
    "media-heading": heading,
    "media-left": left2,
    "media-right": right2,
    "media-top": top2,
    "media-bottom": bottom2,
    "media-middle": middle,
    "media-object": object2,
    "media-list": list,
    media: !body && !heading && !left2 && !right2 && !top2 && !bottom2 && !middle && !object2 && !list
  }), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
Media.propTypes = propTypes$l;
function noop2() {
}
var FadePropTypes = import_prop_types3.default.shape(Fade.propTypes);
var propTypes$k = {
  autoFocus: import_prop_types3.default.bool,
  backdrop: import_prop_types3.default.bool,
  backdropClassName: import_prop_types3.default.string,
  backdropTransition: FadePropTypes,
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  container: targetPropType,
  cssModule: import_prop_types3.default.object,
  direction: import_prop_types3.default.oneOf(["start", "end", "bottom", "top"]),
  fade: import_prop_types3.default.bool,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func]),
  isOpen: import_prop_types3.default.bool,
  keyboard: import_prop_types3.default.bool,
  labelledBy: import_prop_types3.default.string,
  offcanvasTransition: FadePropTypes,
  onClosed: import_prop_types3.default.func,
  onEnter: import_prop_types3.default.func,
  onExit: import_prop_types3.default.func,
  style: import_prop_types3.default.object,
  onOpened: import_prop_types3.default.func,
  returnFocusAfterClose: import_prop_types3.default.bool,
  role: import_prop_types3.default.string,
  scrollable: import_prop_types3.default.bool,
  toggle: import_prop_types3.default.func,
  trapFocus: import_prop_types3.default.bool,
  unmountOnClose: import_prop_types3.default.bool,
  zIndex: import_prop_types3.default.oneOfType([import_prop_types3.default.number, import_prop_types3.default.string])
};
var propsToOmit = Object.keys(propTypes$k);
var defaultProps$k = {
  isOpen: false,
  autoFocus: true,
  direction: "start",
  scrollable: false,
  role: "dialog",
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop2,
  onClosed: noop2,
  offcanvasTransition: {
    timeout: TransitionTimeouts.Offcanvas
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade
  },
  unmountOnClose: true,
  returnFocusAfterClose: true,
  container: "body",
  trapFocus: false
};
var Offcanvas = class extends import_react3.default.Component {
  constructor(props) {
    super(props);
    this._element = null;
    this._originalBodyPadding = null;
    this.getFocusableChildren = this.getFocusableChildren.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    this.handleBackdropMouseDown = this.handleBackdropMouseDown.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handleTab = this.handleTab.bind(this);
    this.onOpened = this.onOpened.bind(this);
    this.onClosed = this.onClosed.bind(this);
    this.manageFocusAfterClose = this.manageFocusAfterClose.bind(this);
    this.clearBackdropAnimationTimeout = this.clearBackdropAnimationTimeout.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
    this.state = {
      isOpen: false
    };
  }
  componentDidMount() {
    const {
      isOpen,
      autoFocus,
      onEnter
    } = this.props;
    if (isOpen) {
      this.init();
      this.setState({
        isOpen: true
      });
      if (autoFocus) {
        this.setFocus();
      }
    }
    if (onEnter) {
      onEnter();
    }
    document.addEventListener("focus", this.trapFocus, true);
    this._isMounted = true;
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.init();
      this.setState({
        isOpen: true
      });
      return;
    }
    if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
      this.setFocus();
    }
    if (this._element && prevProps.zIndex !== this.props.zIndex) {
      this._element.style.zIndex = this.props.zIndex;
    }
  }
  componentWillUnmount() {
    this.clearBackdropAnimationTimeout();
    if (this.props.onExit) {
      this.props.onExit();
    }
    if (this._element) {
      this.destroy();
      if (this.props.isOpen || this.state.isOpen) {
        this.close();
      }
    }
    document.removeEventListener("focus", this.trapFocus, true);
    this._isMounted = false;
  }
  handleBackdropClick(e) {
    if (e.target === this._mouseDownElement) {
      e.stopPropagation();
      const backdrop = this._backdrop;
      if (!this.props.isOpen || this.props.backdrop !== true)
        return;
      if (backdrop && e.target === backdrop && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }
  handleTab(e) {
    if (e.which !== 9)
      return;
    if (this.offcanvasIndex < Offcanvas.openCount - 1)
      return;
    const focusableChildren = this.getFocusableChildren();
    const totalFocusable = focusableChildren.length;
    if (totalFocusable === 0)
      return;
    const currentFocus = this.getFocusedChild();
    let focusedIndex = 0;
    for (let i = 0; i < totalFocusable; i += 1) {
      if (focusableChildren[i] === currentFocus) {
        focusedIndex = i;
        break;
      }
    }
    if (e.shiftKey && focusedIndex === 0) {
      e.preventDefault();
      focusableChildren[totalFocusable - 1].focus();
    } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
      e.preventDefault();
      focusableChildren[0].focus();
    }
  }
  handleBackdropMouseDown(e) {
    this._mouseDownElement = e.target;
  }
  handleEscape(e) {
    if (this.props.isOpen && e.keyCode === keyCodes.esc && this.props.toggle) {
      if (this.props.keyboard) {
        e.preventDefault();
        e.stopPropagation();
        this.props.toggle(e);
      }
    }
  }
  onOpened(node, isAppearing) {
    this.props.onOpened();
    (this.props.offcanvasTransition.onEntered || noop2)(node, isAppearing);
  }
  onClosed(node) {
    const {
      unmountOnClose
    } = this.props;
    this.props.onClosed();
    (this.props.offcanvasTransition.onExited || noop2)(node);
    if (unmountOnClose) {
      this.destroy();
    }
    this.close();
    if (this._isMounted) {
      this.setState({
        isOpen: false
      });
    }
  }
  setFocus() {
    if (this._dialog && typeof this._dialog.focus === "function") {
      this._dialog.focus();
    }
  }
  getFocusableChildren() {
    return this._element.querySelectorAll(focusableElements.join(", "));
  }
  getFocusedChild() {
    let currentFocus;
    const focusableChildren = this.getFocusableChildren();
    try {
      currentFocus = document.activeElement;
    } catch (err) {
      currentFocus = focusableChildren[0];
    }
    return currentFocus;
  }
  trapFocus(ev) {
    if (!this.props.trapFocus) {
      return;
    }
    if (!this._element) {
      return;
    }
    if (this._dialog === ev.target) {
      return;
    }
    if (this.offcanvasIndex < Offcanvas.openCount - 1) {
      return;
    }
    const children = this.getFocusableChildren();
    for (let i = 0; i < children.length; i += 1) {
      if (children[i] === ev.target)
        return;
    }
    if (children.length > 0) {
      ev.preventDefault();
      ev.stopPropagation();
      children[0].focus();
    }
  }
  init() {
    try {
      this._triggeringElement = document.activeElement;
    } catch (err) {
      this._triggeringElement = null;
    }
    if (!this._element) {
      this._element = document.createElement("div");
      this._element.setAttribute("tabindex", "-1");
      this._element.style.position = "relative";
      this._element.style.zIndex = this.props.zIndex;
      this._mountContainer = getTarget(this.props.container);
      this._mountContainer.appendChild(this._element);
    }
    this._originalBodyPadding = getOriginalBodyPadding();
    conditionallyUpdateScrollbar();
    if (Offcanvas.openCount === 0 && this.props.backdrop && !this.props.scrollable) {
      document.body.style.overflow = "hidden";
    }
    this.offcanvasIndex = Offcanvas.openCount;
    Offcanvas.openCount += 1;
  }
  destroy() {
    if (this._element) {
      this._mountContainer.removeChild(this._element);
      this._element = null;
    }
    this.manageFocusAfterClose();
  }
  manageFocusAfterClose() {
    if (this._triggeringElement) {
      const {
        returnFocusAfterClose
      } = this.props;
      if (this._triggeringElement.focus && returnFocusAfterClose)
        this._triggeringElement.focus();
      this._triggeringElement = null;
    }
  }
  close() {
    this.manageFocusAfterClose();
    Offcanvas.openCount = Math.max(0, Offcanvas.openCount - 1);
    document.body.style.overflow = null;
    setScrollbarWidth(this._originalBodyPadding);
  }
  clearBackdropAnimationTimeout() {
    if (this._backdropAnimationTimeout) {
      clearTimeout(this._backdropAnimationTimeout);
      this._backdropAnimationTimeout = void 0;
    }
  }
  render() {
    const {
      direction,
      unmountOnClose
    } = this.props;
    if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
      const isOffcanvasHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
      this._element.style.display = isOffcanvasHidden ? "none" : "block";
      const {
        className,
        backdropClassName,
        cssModule,
        isOpen,
        backdrop,
        role,
        labelledBy,
        style
      } = this.props;
      const offcanvasAttributes = {
        onKeyUp: this.handleEscape,
        onKeyDown: this.handleTab,
        "aria-labelledby": labelledBy,
        role,
        tabIndex: "-1"
      };
      const hasTransition = this.props.fade;
      const offcanvasTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), this.props.offcanvasTransition), {}, {
        baseClass: hasTransition ? this.props.offcanvasTransition.baseClass : "",
        timeout: hasTransition ? this.props.offcanvasTransition.timeout : 0
      });
      const backdropTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), this.props.backdropTransition), {}, {
        baseClass: hasTransition ? this.props.backdropTransition.baseClass : "",
        timeout: hasTransition ? this.props.backdropTransition.timeout : 0
      });
      const Backdrop = backdrop && (hasTransition ? /* @__PURE__ */ import_react3.default.createElement(Fade, _extends({}, backdropTransition, {
        in: isOpen && !!backdrop,
        innerRef: (c) => {
          this._backdrop = c;
        },
        cssModule,
        className: mapToCssModules((0, import_classnames.default)("offcanvas-backdrop", backdropClassName), cssModule),
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleBackdropMouseDown
      })) : /* @__PURE__ */ import_react3.default.createElement("div", {
        className: mapToCssModules((0, import_classnames.default)("offcanvas-backdrop", "show", backdropClassName), cssModule),
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleBackdropMouseDown
      }));
      const attributes = omit(this.props, propsToOmit);
      return /* @__PURE__ */ import_react3.default.createElement(Portal$1, {
        node: this._element
      }, /* @__PURE__ */ import_react3.default.createElement(Fade, _extends({}, attributes, offcanvasAttributes, offcanvasTransition, {
        in: isOpen,
        onEntered: this.onOpened,
        onExited: this.onClosed,
        cssModule,
        className: mapToCssModules((0, import_classnames.default)("offcanvas", className, `offcanvas-${direction}`), cssModule),
        innerRef: (c) => {
          this._dialog = c;
        },
        style: _objectSpread2(_objectSpread2({}, style), {}, {
          visibility: isOpen ? "visible" : "hidden"
        })
      }), this.props.children), Backdrop);
    }
    return null;
  }
};
Offcanvas.propTypes = propTypes$k;
Offcanvas.defaultProps = defaultProps$k;
Offcanvas.openCount = 0;
var _excluded$h = ["className", "cssModule", "tag"];
var propTypes$j = {
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$j = {
  tag: "div"
};
function OffcanvasBody(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$h);
  const classes = mapToCssModules((0, import_classnames.default)(className, "offcanvas-body"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
OffcanvasBody.propTypes = propTypes$j;
OffcanvasBody.defaultProps = defaultProps$j;
var _excluded$g = ["children", "className", "close", "closeAriaLabel", "cssModule", "tag", "toggle", "wrapTag"];
var propTypes$i = {
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  close: import_prop_types3.default.object,
  closeAriaLabel: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType,
  toggle: import_prop_types3.default.func,
  wrapTag: tagPropType
};
var defaultProps$i = {
  closeAriaLabel: "Close",
  tag: "h5",
  wrapTag: "div"
};
function OffcanvasHeader(props) {
  let closeButton;
  const {
    children,
    className,
    close,
    closeAriaLabel,
    cssModule,
    tag: Tag,
    toggle,
    wrapTag: WrapTag
  } = props, attributes = _objectWithoutProperties(props, _excluded$g);
  const classes = mapToCssModules((0, import_classnames.default)(className, "offcanvas-header"), cssModule);
  if (!close && toggle) {
    closeButton = /* @__PURE__ */ import_react3.default.createElement("button", {
      type: "button",
      onClick: toggle,
      className: mapToCssModules("btn-close", cssModule),
      "aria-label": closeAriaLabel
    });
  }
  return /* @__PURE__ */ import_react3.default.createElement(WrapTag, _extends({}, attributes, {
    className: classes
  }), /* @__PURE__ */ import_react3.default.createElement(Tag, {
    className: mapToCssModules("offcanvas-title", cssModule)
  }, children), close || closeButton);
}
OffcanvasHeader.propTypes = propTypes$i;
OffcanvasHeader.defaultProps = defaultProps$i;
var _excluded$f = ["className", "listClassName", "cssModule", "size", "tag", "listTag", "aria-label"];
var propTypes$h = {
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  listClassName: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  size: import_prop_types3.default.string,
  tag: tagPropType,
  listTag: tagPropType,
  "aria-label": import_prop_types3.default.string
};
var defaultProps$h = {
  tag: "nav",
  listTag: "ul",
  "aria-label": "pagination"
};
function Pagination(props) {
  const {
    className,
    listClassName,
    cssModule,
    size,
    tag: Tag,
    listTag: ListTag,
    "aria-label": label
  } = props, attributes = _objectWithoutProperties(props, _excluded$f);
  const classes = mapToCssModules((0, import_classnames.default)(className), cssModule);
  const listClasses = mapToCssModules((0, import_classnames.default)(listClassName, "pagination", {
    [`pagination-${size}`]: !!size
  }), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, {
    className: classes,
    "aria-label": label
  }, /* @__PURE__ */ import_react3.default.createElement(ListTag, _extends({}, attributes, {
    className: listClasses
  })));
}
Pagination.propTypes = propTypes$h;
Pagination.defaultProps = defaultProps$h;
var _excluded$e = ["active", "className", "cssModule", "disabled", "tag"];
var propTypes$g = {
  active: import_prop_types3.default.bool,
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  disabled: import_prop_types3.default.bool,
  tag: tagPropType
};
var defaultProps$g = {
  tag: "li"
};
function PaginationItem(props) {
  const {
    active,
    className,
    cssModule,
    disabled,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$e);
  const classes = mapToCssModules((0, import_classnames.default)(className, "page-item", {
    active,
    disabled
  }), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
PaginationItem.propTypes = propTypes$g;
PaginationItem.defaultProps = defaultProps$g;
var _excluded$d = ["className", "cssModule", "next", "previous", "first", "last", "tag"];
var propTypes$f = {
  "aria-label": import_prop_types3.default.string,
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  next: import_prop_types3.default.bool,
  previous: import_prop_types3.default.bool,
  first: import_prop_types3.default.bool,
  last: import_prop_types3.default.bool,
  tag: tagPropType
};
var defaultProps$f = {
  tag: "a"
};
function PaginationLink(props) {
  let {
    className,
    cssModule,
    next,
    previous,
    first,
    last,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$d);
  const classes = mapToCssModules((0, import_classnames.default)(className, "page-link"), cssModule);
  let defaultAriaLabel;
  if (previous) {
    defaultAriaLabel = "Previous";
  } else if (next) {
    defaultAriaLabel = "Next";
  } else if (first) {
    defaultAriaLabel = "First";
  } else if (last) {
    defaultAriaLabel = "Last";
  }
  const ariaLabel = props["aria-label"] || defaultAriaLabel;
  let defaultCaret;
  if (previous) {
    defaultCaret = "\u2039";
  } else if (next) {
    defaultCaret = "\u203A";
  } else if (first) {
    defaultCaret = "\xAB";
  } else if (last) {
    defaultCaret = "\xBB";
  }
  let {
    children
  } = props;
  if (children && Array.isArray(children) && children.length === 0) {
    children = null;
  }
  if (!attributes.href && Tag === "a") {
    Tag = "button";
  }
  if (previous || next || first || last) {
    children = [/* @__PURE__ */ import_react3.default.createElement("span", {
      "aria-hidden": "true",
      key: "caret"
    }, children || defaultCaret), /* @__PURE__ */ import_react3.default.createElement("span", {
      className: "visually-hidden",
      key: "ariaLabel"
    }, ariaLabel)];
  }
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    "aria-label": ariaLabel
  }), children);
}
PaginationLink.propTypes = propTypes$f;
PaginationLink.defaultProps = defaultProps$f;
var TabContext = import_react3.default.createContext({});
var propTypes$e = {
  tag: tagPropType,
  activeTab: import_prop_types3.default.any,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object
};
var defaultProps$e = {
  tag: "div"
};
var TabContent = class extends import_react3.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.activeTab !== nextProps.activeTab) {
      return {
        activeTab: nextProps.activeTab
      };
    }
    return null;
  }
  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.props.activeTab
    };
  }
  render() {
    const {
      className,
      cssModule,
      tag: Tag
    } = this.props;
    const attributes = omit(this.props, Object.keys(propTypes$e));
    const classes = mapToCssModules((0, import_classnames.default)("tab-content", className), cssModule);
    return /* @__PURE__ */ import_react3.default.createElement(TabContext.Provider, {
      value: {
        activeTabId: this.state.activeTab
      }
    }, /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
      className: classes
    })));
  }
};
TabContent.propTypes = propTypes$e;
TabContent.defaultProps = defaultProps$e;
var _excluded$c = ["className", "cssModule", "tabId", "tag"];
var propTypes$d = {
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tabId: import_prop_types3.default.any
};
var defaultProps$d = {
  tag: "div"
};
function TabPane(props) {
  const {
    className,
    cssModule,
    tabId,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$c);
  const getClasses = (activeTabId) => mapToCssModules((0, import_classnames.default)("tab-pane", className, {
    active: tabId === activeTabId
  }), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(TabContext.Consumer, null, ({
    activeTabId
  }) => /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: getClasses(activeTabId)
  })));
}
TabPane.propTypes = propTypes$d;
TabPane.defaultProps = defaultProps$d;
var _excluded$b = ["className", "closeClassName", "closeAriaLabel", "cssModule", "tag", "color", "isOpen", "toggle", "children", "transition", "fade", "innerRef"];
var propTypes$c = {
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  closeClassName: import_prop_types3.default.string,
  closeAriaLabel: import_prop_types3.default.string,
  color: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  fade: import_prop_types3.default.bool,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func]),
  isOpen: import_prop_types3.default.bool,
  tag: tagPropType,
  toggle: import_prop_types3.default.func,
  transition: import_prop_types3.default.shape(Fade.propTypes)
};
var defaultProps$c = {
  color: "success",
  isOpen: true,
  tag: "div",
  closeAriaLabel: "Close",
  fade: true,
  transition: _objectSpread2(_objectSpread2({}, Fade.defaultProps), {}, {
    unmountOnExit: true
  })
};
function Alert(props) {
  const {
    className,
    closeClassName,
    closeAriaLabel,
    cssModule,
    tag: Tag,
    color,
    isOpen,
    toggle,
    children,
    transition,
    fade,
    innerRef
  } = props, attributes = _objectWithoutProperties(props, _excluded$b);
  const classes = mapToCssModules((0, import_classnames.default)(className, "alert", `alert-${color}`, {
    "alert-dismissible": toggle
  }), cssModule);
  const closeClasses = mapToCssModules((0, import_classnames.default)("btn-close", closeClassName), cssModule);
  const alertTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), transition), {}, {
    baseClass: fade ? transition.baseClass : "",
    timeout: fade ? transition.timeout : 0
  });
  return /* @__PURE__ */ import_react3.default.createElement(Fade, _extends({}, attributes, alertTransition, {
    tag: Tag,
    className: classes,
    in: isOpen,
    role: "alert",
    innerRef
  }), toggle ? /* @__PURE__ */ import_react3.default.createElement("button", {
    type: "button",
    className: closeClasses,
    "aria-label": closeAriaLabel,
    onClick: toggle
  }) : null, children);
}
Alert.propTypes = propTypes$c;
Alert.defaultProps = defaultProps$c;
var _excluded$a = ["className", "cssModule", "tag", "isOpen", "children", "transition", "fade", "innerRef"];
var propTypes$b = {
  children: import_prop_types3.default.node,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  fade: import_prop_types3.default.bool,
  isOpen: import_prop_types3.default.bool,
  tag: tagPropType,
  transition: import_prop_types3.default.shape(Fade.propTypes),
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func])
};
var defaultProps$b = {
  isOpen: true,
  tag: "div",
  fade: true,
  transition: _objectSpread2(_objectSpread2({}, Fade.defaultProps), {}, {
    unmountOnExit: true
  })
};
function Toast(props) {
  const {
    className,
    cssModule,
    tag: Tag,
    isOpen,
    children,
    transition,
    fade,
    innerRef
  } = props, attributes = _objectWithoutProperties(props, _excluded$a);
  const classes = mapToCssModules((0, import_classnames.default)(className, "toast"), cssModule);
  const toastTransition = _objectSpread2(_objectSpread2(_objectSpread2({}, Fade.defaultProps), transition), {}, {
    baseClass: fade ? transition.baseClass : "",
    timeout: fade ? transition.timeout : 0
  });
  return /* @__PURE__ */ import_react3.default.createElement(Fade, _extends({}, attributes, toastTransition, {
    tag: Tag,
    className: classes,
    in: isOpen,
    role: "alert",
    innerRef
  }), children);
}
Toast.propTypes = propTypes$b;
Toast.defaultProps = defaultProps$b;
var _excluded$9 = ["className", "cssModule", "innerRef", "tag"];
var propTypes$a = {
  tag: tagPropType,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.string, import_prop_types3.default.func])
};
var defaultProps$a = {
  tag: "div"
};
function ToastBody(props) {
  const {
    className,
    cssModule,
    innerRef,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$9);
  const classes = mapToCssModules((0, import_classnames.default)(className, "toast-body"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }));
}
ToastBody.propTypes = propTypes$a;
ToastBody.defaultProps = defaultProps$a;
var _excluded$8 = ["className", "cssModule", "children", "toggle", "tag", "wrapTag", "closeAriaLabel", "close", "tagClassName", "icon"];
var propTypes$9 = {
  tag: tagPropType,
  icon: import_prop_types3.default.oneOfType([import_prop_types3.default.string, import_prop_types3.default.node]),
  wrapTag: tagPropType,
  toggle: import_prop_types3.default.func,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  children: import_prop_types3.default.node,
  closeAriaLabel: import_prop_types3.default.string,
  charCode: import_prop_types3.default.oneOfType([import_prop_types3.default.string, import_prop_types3.default.number]),
  close: import_prop_types3.default.object,
  tagClassName: import_prop_types3.default.string
};
var defaultProps$9 = {
  tag: "strong",
  wrapTag: "div",
  tagClassName: "me-auto",
  closeAriaLabel: "Close"
};
function ToastHeader(props) {
  let closeButton;
  let icon;
  const {
    className,
    cssModule,
    children,
    toggle,
    tag: Tag,
    wrapTag: WrapTag,
    closeAriaLabel,
    close,
    tagClassName,
    icon: iconProp
  } = props, attributes = _objectWithoutProperties(props, _excluded$8);
  const classes = mapToCssModules((0, import_classnames.default)(className, "toast-header"), cssModule);
  if (!close && toggle) {
    closeButton = /* @__PURE__ */ import_react3.default.createElement("button", {
      type: "button",
      onClick: toggle,
      className: mapToCssModules("btn-close", cssModule),
      "aria-label": closeAriaLabel
    });
  }
  if (typeof iconProp === "string") {
    icon = /* @__PURE__ */ import_react3.default.createElement("svg", {
      className: mapToCssModules(`rounded text-${iconProp}`),
      width: "20",
      height: "20",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMid slice",
      focusable: "false",
      role: "img"
    }, /* @__PURE__ */ import_react3.default.createElement("rect", {
      fill: "currentColor",
      width: "100%",
      height: "100%"
    }));
  } else if (iconProp) {
    icon = iconProp;
  }
  return /* @__PURE__ */ import_react3.default.createElement(WrapTag, _extends({}, attributes, {
    className: classes
  }), icon, /* @__PURE__ */ import_react3.default.createElement(Tag, {
    className: mapToCssModules((0, import_classnames.default)(tagClassName, {
      "ms-2": icon != null
    }), cssModule)
  }, children), close || closeButton);
}
ToastHeader.propTypes = propTypes$9;
ToastHeader.defaultProps = defaultProps$9;
var _excluded$7 = ["className", "cssModule", "tag", "active", "disabled", "action", "color"];
var propTypes$8 = {
  action: import_prop_types3.default.bool,
  active: import_prop_types3.default.bool,
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  color: import_prop_types3.default.string,
  disabled: import_prop_types3.default.bool,
  tag: tagPropType
};
var defaultProps$8 = {
  tag: "li"
};
var handleDisabledOnClick = (e) => {
  e.preventDefault();
};
function ListGroupItem(props) {
  const {
    className,
    cssModule,
    tag: Tag,
    active,
    disabled,
    action,
    color
  } = props, attributes = _objectWithoutProperties(props, _excluded$7);
  const classes = mapToCssModules((0, import_classnames.default)(className, active ? "active" : false, disabled ? "disabled" : false, action ? "list-group-item-action" : false, color ? `list-group-item-${color}` : false, "list-group-item"), cssModule);
  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
ListGroupItem.propTypes = propTypes$8;
ListGroupItem.defaultProps = defaultProps$8;
var _excluded$6 = ["className", "cssModule", "tag"];
var propTypes$7 = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$7 = {
  tag: "h5"
};
function ListGroupItemHeading(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$6);
  const classes = mapToCssModules((0, import_classnames.default)(className, "list-group-item-heading"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
ListGroupItemHeading.propTypes = propTypes$7;
ListGroupItemHeading.defaultProps = defaultProps$7;
var _excluded$5 = ["className", "cssModule", "tag"];
var propTypes$6 = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$6 = {
  tag: "p"
};
function ListGroupItemText(props) {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$5);
  const classes = mapToCssModules((0, import_classnames.default)(className, "list-group-item-text"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
ListGroupItemText.propTypes = propTypes$6;
ListGroupItemText.defaultProps = defaultProps$6;
var _excluded$4 = ["className", "cssModule", "tag", "type"];
var propTypes$5 = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType,
  type: import_prop_types3.default.string
};
var defaultProps$5 = {
  tag: "ul"
};
var List = (0, import_react3.forwardRef)((props, ref) => {
  const {
    className,
    cssModule,
    tag: Tag,
    type
  } = props, attributes = _objectWithoutProperties(props, _excluded$4);
  const classes = mapToCssModules((0, import_classnames.default)(className, type ? `list-${type}` : false), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref
  }));
});
List.name = "List";
List.propTypes = propTypes$5;
List.defaultProps = defaultProps$5;
var _excluded$3 = ["className", "cssModule", "tag"];
var propTypes$4 = {
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  tag: tagPropType
};
var defaultProps$4 = {
  tag: "li"
};
var ListInlineItem = (0, import_react3.forwardRef)((props, ref) => {
  const {
    className,
    cssModule,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$3);
  const classes = mapToCssModules((0, import_classnames.default)(className, "list-inline-item"), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref
  }));
});
ListInlineItem.name = "ListInlineItem";
ListInlineItem.propTypes = propTypes$4;
ListInlineItem.defaultProps = defaultProps$4;
var omitKeys$3 = ["defaultOpen"];
var UncontrolledButtonDropdown = class extends import_react3.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpen || false
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen
    }));
  }
  render() {
    return /* @__PURE__ */ import_react3.default.createElement(ButtonDropdown, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys$3)));
  }
};
UncontrolledButtonDropdown.propTypes = _objectSpread2({
  defaultOpen: import_prop_types3.default.bool
}, ButtonDropdown.propTypes);
var omitKeys$2 = ["toggleEvents", "defaultOpen"];
var propTypes$3 = {
  defaultOpen: import_prop_types3.default.bool,
  toggler: import_prop_types3.default.string.isRequired,
  toggleEvents: import_prop_types3.default.arrayOf(import_prop_types3.default.string)
};
var defaultProps$3 = {
  toggleEvents: defaultToggleEvents
};
var UncontrolledCollapse = class extends import_react3.Component {
  constructor(props) {
    super(props);
    this.togglers = null;
    this.removeEventListeners = null;
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: props.defaultOpen || false
    };
  }
  componentDidMount() {
    this.togglers = findDOMElements(this.props.toggler);
    if (this.togglers.length) {
      this.removeEventListeners = addMultipleEventListeners(this.togglers, this.toggle, this.props.toggleEvents);
    }
  }
  componentWillUnmount() {
    if (this.togglers.length && this.removeEventListeners) {
      this.removeEventListeners();
    }
  }
  toggle(e) {
    this.setState(({
      isOpen
    }) => ({
      isOpen: !isOpen
    }));
    e.preventDefault();
  }
  render() {
    return /* @__PURE__ */ import_react3.default.createElement(Collapse$1, _extends({
      isOpen: this.state.isOpen
    }, omit(this.props, omitKeys$2)));
  }
};
UncontrolledCollapse.propTypes = propTypes$3;
UncontrolledCollapse.defaultProps = defaultProps$3;
var omitKeys$1 = ["defaultOpen"];
var UncontrolledDropdown = class extends import_react3.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpen || false
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle(e) {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen
    }), () => {
      if (this.props.onToggle) {
        this.props.onToggle(e, this.state.isOpen);
      }
    });
  }
  render() {
    return /* @__PURE__ */ import_react3.default.createElement(Dropdown$1, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys$1)));
  }
};
UncontrolledDropdown.propTypes = _objectSpread2({
  defaultOpen: import_prop_types3.default.bool,
  onToggle: import_prop_types3.default.func
}, Dropdown$1.propTypes);
var omitKeys = ["defaultOpen"];
var UncontrolledTooltip = class extends import_react3.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.defaultOpen || false
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen
    }));
  }
  render() {
    return /* @__PURE__ */ import_react3.default.createElement(Tooltip, _extends({
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, omit(this.props, omitKeys)));
  }
};
UncontrolledTooltip.propTypes = _objectSpread2({
  defaultOpen: import_prop_types3.default.bool
}, Tooltip.propTypes);
var _excluded$2 = ["className", "cssModule", "type", "size", "color", "children", "tag"];
var propTypes$2 = {
  tag: tagPropType,
  type: import_prop_types3.default.oneOf(["border", "grow"]),
  size: import_prop_types3.default.oneOf(["sm"]),
  color: import_prop_types3.default.oneOf(["primary", "secondary", "success", "danger", "warning", "info", "light", "dark"]),
  className: import_prop_types3.default.string,
  cssModule: import_prop_types3.default.object,
  children: import_prop_types3.default.string
};
var defaultProps$2 = {
  tag: "div",
  type: "border",
  children: "Loading..."
};
function Spinner(props) {
  const {
    className,
    cssModule,
    type,
    size,
    color,
    children,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded$2);
  const classes = mapToCssModules((0, import_classnames.default)(className, size ? `spinner-${type}-${size}` : false, `spinner-${type}`, color ? `text-${color}` : false), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({
    role: "status"
  }, attributes, {
    className: classes
  }), children && /* @__PURE__ */ import_react3.default.createElement("span", {
    className: mapToCssModules("visually-hidden", cssModule)
  }, children));
}
Spinner.propTypes = propTypes$2;
Spinner.defaultProps = defaultProps$2;
var _excluded$1 = ["className", "cssModule", "color", "innerRef", "tag", "animation", "size", "widths"];
var propTypes$1 = _objectSpread2(_objectSpread2({}, Col.propTypes), {}, {
  color: import_prop_types3.default.string,
  tag: tagPropType,
  animation: import_prop_types3.default.oneOf(["glow", "wave"]),
  innerRef: import_prop_types3.default.oneOfType([import_prop_types3.default.object, import_prop_types3.default.func, import_prop_types3.default.string]),
  size: import_prop_types3.default.oneOf(["lg", "sm", "xs"])
});
var defaultProps$1 = {
  tag: "span"
};
function Placeholder(props) {
  let {
    className,
    cssModule,
    color,
    innerRef,
    tag: Tag,
    animation,
    size,
    widths
  } = props, attributes = _objectWithoutProperties(props, _excluded$1);
  let {
    attributes: modifiedAttributes,
    colClasses
  } = getColumnClasses(attributes, cssModule, widths);
  const classes = mapToCssModules((0, import_classnames.default)(className, colClasses, "placeholder" + (animation ? "-" + animation : ""), size ? "placeholder-" + size : false, color ? "bg-" + color : false), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Tag, _extends({}, modifiedAttributes, {
    className: classes,
    ref: innerRef
  }));
}
Placeholder.propTypes = propTypes$1;
Placeholder.defaultProps = defaultProps$1;
var _excluded = ["cssModule", "className", "tag"];
var propTypes = {
  size: import_prop_types3.default.string,
  color: import_prop_types3.default.string,
  outline: import_prop_types3.default.bool,
  className: import_prop_types3.default.string,
  tag: tagPropType,
  cssModule: import_prop_types3.default.object
};
var defaultProps = {
  color: "primary",
  tag: Button
};
function PlaceholderButton(props) {
  let {
    cssModule,
    className,
    tag: Tag
  } = props, attributes = _objectWithoutProperties(props, _excluded);
  let {
    attributes: modifiedAttributes,
    colClasses
  } = getColumnClasses(attributes, cssModule);
  const classes = mapToCssModules((0, import_classnames.default)("placeholder", className, colClasses), cssModule);
  return /* @__PURE__ */ import_react3.default.createElement(Button, _extends({}, modifiedAttributes, {
    className: classes,
    disabled: true
  }));
}
PlaceholderButton.propTypes = propTypes;
PlaceholderButton.defaultProps = defaultProps;
(() => {
  if (typeof window !== "object" || typeof window.CustomEvent === "function")
    return;
  const CustomEvent2 = (event, params) => {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    let evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };
  window.CustomEvent = CustomEvent2;
})();
(() => {
  if (typeof Object.values === "function")
    return;
  const values = (O) => Object.keys(O).map((key) => O[key]);
  Object.values = values;
})();

// src/components/Survey/Designer/DesignerPreviewer/elements/FieldPreviewer.tsx
init_cjs_shims();
var import_formik = require("formik");

// src/components/Survey/Designer/DesignerPreviewer/Previewer.style.tsx
init_cjs_shims();
var import_styled_components2 = __toESM(require("styled-components"));
var import_ui = require("@btc-snxt/ui");
var import_react_textarea_autosize = __toESM(require_react_textarea_autosize_cjs());

// src/components/Survey/utils.tsx
init_cjs_shims();
var import_styled_components = require("styled-components");
var MobileStyles = (props) => props.$isPreviewModeMobile ? props.$mobileModeCss : import_styled_components.css`
        ${props.$alwaysMobileWhenWidth} {
          ${props.$mobileModeCss}
        }
      `;

// src/components/Survey/Designer/DesignerPreviewer/Previewer.style.tsx
var StyledDesignerPreviewer = import_styled_components2.default.div`
  background-color: ${({ theme }) => theme.colors.white};
  justify-content: center;
  font-family: 'Inter', sans-serif;
`;
var StyledDesignerPreviewerBody = import_styled_components2.default.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(100% - 5.5rem);
`;
var StyledDesignerQuestionPreviewerBody = import_styled_components2.default.div`
  width: 100%;
  height: calc(100% - 2rem);
  padding: 1rem 0;
`;
var StyledMatrixDesignerQuestionPreviewerBody = (0, import_styled_components2.default)(
  StyledDesignerQuestionPreviewerBody
)`
  overflow-y: scroll;
`;
var StyledDesignerPreviewerFooter = import_styled_components2.default.div`
  height: 2.5rem;
  width: 100%;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: ${({ navigation }) => navigation ? "space-between" : "flex-end"};
  gap: 2rem;
`;
var StyledIconButtonPrevious = (0, import_styled_components2.default)(import_ui.IconButtonPrevious)`
  display: flex;
  border-radius: 0.75rem;
  cursor: pointer;
  background-color: ${(props) => props.backgroundColor};
`;
var StyledIconButtonNext = (0, import_styled_components2.default)(import_ui.IconButtonNext)`
  display: flex;
  border-radius: 0.75rem;
  cursor: ${(props) => props.backgroundColor ? "auto" : "pointer"};
  background-color: ${(props) => props.backgroundColor};
`;
var StyledNavigationButtons = import_styled_components2.default.div`
  display: flex;
  gap: 0.75rem;
`;
var StyledPrivacyPolicy = import_styled_components2.default.div`
  cursor: pointer;
`;
var SurveyQuestionAndTitleContainer = import_styled_components2.default.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.75rem;
  color: ${({ theme }) => theme.colors.black};
  width: 100%;
  height: 100%;
  padding-top: 4.375rem;

  ${MobileStyles}
`;
SurveyQuestionAndTitleContainer.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    padding-top: 2.5rem;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.MD
};
var MatrixSurveyWrapper = import_styled_components2.default.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.75rem;
  color: ${({ theme }) => theme.colors.black};
  width: 100%;
  height: 100%;
  padding-top: 4.375rem;
  overflow: overlay;
  thead {
    top: -1px;
  }

  mask-image: ${(props) => props.$ScrollPositionInTheEnd ? "none" : "linear-gradient(180deg, #000 80%, transparent)"};

  @-moz-document url-prefix() {
    overflow: auto;
  }

  ${MobileStyles}
`;
MatrixSurveyWrapper.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    padding-top: 2.5rem;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.MD
};
var MatrixQuestionsWrapper = import_styled_components2.default.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 2.5rem;
  padding-left: 1.5rem;
  padding-right: 2.5rem;

  ${MobileStyles}

  & > *:last-child {
    margin-top: 0;
  }
`;
MatrixQuestionsWrapper.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    padding-left: 0;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.SM
};
var MatrixSurveyQuestionAndTitleContent = import_styled_components2.default.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  margin-left: 1rem;

  ${MobileStyles}
`;
MatrixSurveyQuestionAndTitleContent.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    margin-left: 0;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.MD
};
var SurveyQuestionAndTitleContent = import_styled_components2.default.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: calc(100% - 2rem);
  margin-left: 1rem;

  ${MobileStyles}
`;
SurveyQuestionAndTitleContent.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    margin-left: 0;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.MD
};
var StyledPrivacyPolicySmall = import_styled_components2.default.div`
  height: 2.5rem;
  font-size: 0.875rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
`;
var StyledDesignerPreviewerBackgroundColor = import_styled_components2.default.div`
  background-color: ${(props) => props.backgroundColor};
  font-family: 'Inter', sans-serif;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 1rem;

  ${import_ui.breakpointUp.LG} {
    width: 100%;
  }
  ${import_ui.breakpointUp.LG} {
    aspect-ratio: 4/3;
    max-height: 35rem;
    padding: 3rem 5rem;
  }
`;
var StyledSingleSelectDesignerPreviewer = import_styled_components2.default.div`
  background-color: ${(props) => props.backgroundColor};
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 1rem;
  ${import_ui.breakpointUp.LG} {
    padding: 3rem 5rem;
  }
`;
var StyledLikertDesignerPreviewer = import_styled_components2.default.div`
  background-color: ${(props) => props.backgroundColor};
  height: 100%;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 2rem 1rem;
  ${import_ui.breakpointUp.LG} {
    padding: 3rem 5rem;
  }
`;
var StyledMatrixDesignerPreviewer = import_styled_components2.default.div`
  background-color: ${(props) => props.backgroundColor};
  height: 100%;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 2rem 1rem;
  ${import_ui.breakpointUp.LG} {
    padding: 3rem 5rem;
  }
`;
var StyledOpinionScaleDesignerPreviewer = import_styled_components2.default.div`
  background-color: ${(props) => props.backgroundColor};
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  aspect-ratio: 4/3;
  width: 100%;
  max-height: 29rem;
  min-width: 36rem;
  padding: 2rem 1rem;
  ${import_ui.breakpointUp.LG} {
    padding: 3rem 5rem;
  }
  ${import_ui.breakpointDown.SM} {
    min-width: unset;
    aspect-ratio: unset;
  }
`;
var StyledDesignerPreviewerGroup = import_styled_components2.default.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
`;
var StyledDesignerPreviewerOpinionScaleGroup = import_styled_components2.default.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: flex-start;
`;
var StyledTitle = import_styled_components2.default.div`
  font-weight: 500;
  font-size: 2.25rem;
  line-height: 125%;
  text-align: center;
  padding-bottom: 1rem;

  ${MobileStyles}
`;
StyledTitle.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    font-size: 1.625rem;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.SM
};
var StyledSubtext = import_styled_components2.default.div`
  font-style: normal;
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 125%;
  text-align: center;
  color: #3f4a5a;
`;
var StyledQuestionTitle = import_styled_components2.default.div`
  display: flex;
  font-weight: 500;
  font-size: 2rem;
  line-height: 125%;
  padding-bottom: 2.5rem;
  text-align: left;

  ${MobileStyles}
`;
StyledQuestionTitle.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    font-size: 1.375rem;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.MD
};
var StyledLikertTitle = import_styled_components2.default.div`
  display: flex;
  font-weight: 500;
  font-size: 2rem;
  line-height: 125%;
  padding-bottom: 2rem;
`;
var StyledIntroPage = import_styled_components2.default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-style: normal;
  font-weight: 500;
  font-size: 2.5rem;
  line-height: 125%;
  padding-top: 2rem;

  ${MobileStyles}
`;
var StyledIntroSubtext = import_styled_components2.default.div`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
`;
StyledIntroPage.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    font-size: 1.875rem;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.LG
};
var StyledSelectFieldDesignerPreviewer = import_styled_components2.default.div`
  overflow: overlay;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: ${({ theme }) => theme.colors.black};

  ${MobileStyles}
`;
StyledSelectFieldDesignerPreviewer.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    width: 100%;
    padding-right: 0.5rem;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.SM
};
var StyledLikertSelectFieldDesignerPreviewer = import_styled_components2.default.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  color: ${({ theme }) => theme.colors.black};

  @-moz-document url-prefix() {
    overflow: scroll;
  }

  ${MobileStyles}
`;
StyledLikertSelectFieldDesignerPreviewer.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    padding-right: 2.25rem;
    flex-direction: column;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.XL
};
var StyledFieldDesignerPreviewer = import_styled_components2.default.div`
  color: ${(props) => props.color || props.theme.colors.black};
`;
var StyledInputFieldDesignerPreviewer = import_styled_components2.default.input`
  ${import_ui.noGlow};
  border-radius: 0.25rem;
  padding: 0.5rem 2.5rem;
  border: 1px solid ${(props) => props.backgroundColor || props.theme.colors.gray3};

  ${(props) => import_styled_components2.css`
      color: ${props.color || props.theme.colors.white};
      background-color: ${props.theme.colors.gray3};
    `}

  width: 100%;

  ${import_ui.breakpointUp.MD} {
    width: auto;
  }

  &::placeholder {
    ${(props) => import_styled_components2.css`
        color: ${props.theme.colors.gray3};
        background-color: ${props.backgroundColor || props.theme.colors.white};
      `}
  }
`;
var StyledTextAreaFieldDesignerPreviewer = (0, import_styled_components2.default)(
  import_react_textarea_autosize.default
)`
  ${import_ui.noGlow};
  border: none;
  resize: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray13};
  background-color: transparent;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
  color: ${({ theme }) => theme.colors.gray13};
  width: 100%;
  &::placeholder {
    color: ${({ theme }) => theme.colors.gray13};
  }
`;
StyledTextAreaFieldDesignerPreviewer.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    font-size: 1.5rem;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.SM
};
var StyledInputDesignerPreviewer = (0, import_styled_components2.default)(Input$1)`
  &:hover {
    cursor: pointer;
  }
`;
var StyledLabelDesignerPreviewer = (0, import_styled_components2.default)(Label)`
  text-align: left;
`;
var StyledInputDesignerPreviewerWrapper = import_styled_components2.default.div`
  margin-left: 1rem;
`;
var StyledFormGroupDesignerPreviewer = (0, import_styled_components2.default)(FormGroup)`
  min-height: fit-content;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 1.25rem;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors.black};
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;
  label {
    cursor: pointer;
    padding: 0.5rem 1rem;
  }
  ${StyledInputDesignerPreviewer} {
    cursor: pointer;
    width: 1.5rem;
    height: 1.5rem;
    min-width: 1.5rem;
    min-height: 1.5rem;
    margin-left: 0;
    margin-top: 0;
    border-color: ${({ theme }) => theme.colors.black};
  }

  ${(props) => props.$active && import_styled_components2.css`
      input {
        &:checked {
          background-color: ${props.$backgroundColor};
          border-color: ${({ theme }) => theme.colors.white};
          background-size: 2rem;
        }
        &:focus {
          box-shadow: none;
        }
      }
      border-color: ${props.$backgroundColor};
      background-color: ${props.$backgroundColor};
      color: ${({ theme }) => theme.colors.white};
    `}

  ${(props) => !props.$active && import_styled_components2.css`
      &:hover {
        background-color: rgba(0, 0, 0, 0.05);

        ${StyledInputDesignerPreviewer} {
          background-color: ${({ theme }) => theme.colors.black};
          border: 9px solid rgb(239, 239, 239);
        }
      }

      :not(&:active, :hover) {
        ${StyledInputDesignerPreviewer} {
          border: none;
        }
      }
    `}

  ${StyledInputDesignerPreviewerWrapper} {
    ${({ $active, $checked, theme }) => !$checked && !$active && `
      border: 1px solid ${theme.colors.black};
      border-radius: 1rem;
    `}
  }
`;
var StyledMultiSelect = (0, import_styled_components2.default)(FormGroup)`
  min-height: fit-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4.75rem;
  font-weight: 400;
  font-size: 1.25rem;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors.black};
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;
  label {
    cursor: pointer;
    padding: 0.5rem 1rem;
  }
  ${StyledInputDesignerPreviewer} {
    cursor: pointer;
    width: 1.5rem;
    height: 1.5rem;
    min-width: 1.5rem;
    min-height: 1.5rem;
    margin-right: 1rem;
    margin-top: 0;
    border-color: ${({ theme }) => theme.colors.black};

    &:checked {
      ${(props) => import_styled_components2.css`
          background-image: url(${props.$icon});
        `}
    }
  }

  ${(props) => props.$active && import_styled_components2.css`
      input {
        &:checked {
          background-color: ${props.$backgroundColor};
          border-color: ${({ theme }) => theme.colors.white};
          background-image: none;
        }
        &:focus {
          box-shadow: none;
        }
      }
      border-color: ${props.$backgroundColor};
      background-color: ${props.$backgroundColor};
      color: ${({ theme }) => theme.colors.white};
    `}

  ${(props) => !props.$active && import_styled_components2.css`
      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }
    `}
`;
var StyledLogoDesignerPreviewer = import_styled_components2.default.div`
  ${import_ui.centeredFlexbox};
  flex-basis: 200%;
`;
var StyledLogoImageDesignerPreviewer = import_styled_components2.default.i`
  display: inline-block; 
  width: 18.75rem;
  height: 5.375rem;

  background: url(${(props) => props.url}) no-repeat center;
  background-size: contain;
  background-color: transparent !important;
`;
var StyledPoweredBySeeNextDesignerPreviewer = import_styled_components2.default.div`
  ${import_ui.centeredFlexbox};
  justify-content: flex-end;
  font-size: 0.875rem;
  height: 2rem;
  gap: 0.25rem;
`;
var StyledPoweredBySeeNextImageDesignerPreviewer = import_styled_components2.default.i`
  width: 5.375rem;
  height: 2.25rem;
  cursor: pointer;
  background: url(${(props) => props.url}) no-repeat center;
  background-color: transparent !important;
`;
var OptionsAndExplanationsWrapper = import_styled_components2.default.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
`;
var StyledExplanations = import_styled_components2.default.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 1rem;
  line-height: 125%;
  color: rgba(0, 0, 0, 0.4);
`;
var StyledExplanationText = import_styled_components2.default.span`
  color: rgba(0, 0, 0, 0.4);
`;
var StyledExplanationRow = import_styled_components2.default.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
`;
var StyledScaleFieldDesignerPreviewer = import_styled_components2.default.div`
  ${import_ui.centeredFlexbox};
  width: 100%;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 1rem;
  padding-right: 0.813rem;
`;
var StyledStarScaleFieldDesignerPreviewer = import_styled_components2.default.div`
  ${import_ui.centeredFlexbox};
  width: 100%;
  justify-content: flex-start;
`;
var StyledStarScaleFieldItemDesignerPreviewerWrapper = import_styled_components2.default.div`
  ${import_ui.centeredFlexbox};
  width: 4.375rem;
  height: auto;
  object-fit: contain;
  cursor: pointer;
`;
var StyledScaleFieldItemDesignerPreviewerWrapper = import_styled_components2.default.div`
  ${import_ui.centeredFlexbox};
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.black2};
  border-radius: 1rem;
`;
var SurveyQuestionTitleIndex = import_styled_components2.default.div`
  display: flex;
  justify-content: flex-end;
  max-width: 2.313rem;
  height: 2.188rem;
  font-size: 1.5rem;
  line-height: 145%;
  padding-right: 1rem;

  ${MobileStyles}
`;
SurveyQuestionTitleIndex.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    padding-top: 0.25rem;
    padding-right: 0.75rem;
    min-height: 1.313rem;
    font-size: 0.938rem;
    margin-left: 0.625rem;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.MD
};
var StyledScaleItemDesignerPreviewer = import_styled_components2.default.div`
  display: inline-grid;
  width: 100%;
  height: auto;
  ${import_ui.Icon} {
    width: 100%;
    height: 100%;

    background-color: ${({ theme }) => theme.colors.gray5};
  }

  &.active {
    ${import_ui.Icon} {
      background-color: ${({ theme }) => theme.colors.blue};
    }

    &.hover {
      ${import_ui.Icon} {
        background-color: ${({ theme }) => theme.colors.blue3};
        transition: background-color 0.1s linear;
      }
    }
  }

  &.hover {
    ${import_ui.Icon} {
      background-color: ${({ theme }) => theme.colors.yellow};
      transition: background-color 0.1s linear;
    }
  }
`;
var StyledScaleStarItemDesignerPreviewer = (0, import_styled_components2.default)(
  StyledScaleItemDesignerPreviewer
)`
  stroke: ${({ theme }) => theme.colors.black2};
  fill: none;
  svg {
    width: inherit;
    height: auto;
  }

  ${(props) => import_styled_components2.css`
    &.active {
      stroke: ${props.$activeColor};
      fill: ${props.$activeColor};
      transition: background-color 0.1s linear;

      &.hover {
        stroke: ${props.$activeColor};
        fill: ${props.$activeColor};
      }
    }

    &.hover {
      stroke: ${props.$hoverColor};
      fill: ${props.$hoverColor};
      transition: background-color 0.1s linear;
    }
  `}
  margin: 0 auto;
`;
var StyledSliderItemDesignerPreviewer = import_styled_components2.default.div`
  width: 100%;
  height: 100%;
`;
var StyledScaleEmotionItemDesignerPreviewer = (0, import_styled_components2.default)(StyledScaleItemDesignerPreviewer)`
  padding-right: 0.3rem;

  i {
    width: 100%;
    height: auto;
    mask-size: contain;
    aspect-ratio: 1/1;
  }
  &.click {
    i {
      background-color: unset;
    }
  }
  &.active {
    i {
      mask: none;
      background-color: unset;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
    ${import_ui.IconAngryEmoji} {
      background-image: url(${(props) => props.$iconAngry});
    }
    ${import_ui.IconSadEmoji} {
      background-image: url(${(props) => props.$iconSad});
    }
    ${import_ui.IconNeutralEmoji} {
      background-image: url(${(props) => props.$iconNeutral});
    }
    ${import_ui.IconHappyEmoji} {
      background-image: url(${(props) => props.$iconHappy});
    }
    ${import_ui.IconExcitedEmoji} {
      background-image: url(${(props) => props.$iconExcited});
    }
    &.hover {
      i {
        background-color: unset;
      }
    }
  }

  &.hover {
    i {
      background-color: ${(props) => props.$hoverColor};
    }
  }
`;
var StyledScaleNumberItemDesignerPreviewer = (0, import_styled_components2.default)(
  StyledScaleItemDesignerPreviewer
)`
  ${import_ui.centeredFlexbox};
  border-radius: 1rem;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  cursor: pointer;

  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.5rem;
  width: 6.5rem;
  height: 4.5rem;

  ${import_ui.breakpointDown.MD} {
    width: 3rem;
    height: 3.5rem;
  }

  ${MobileStyles}

  ${(props) => import_styled_components2.css`
    &.active {
      background-color: ${props.$activeColor};
      transition: background-color 0.1s linear;

      &.hover {
        background-color: ${props.$activeColor};
      }
    }

    &.hover {
      background-color: ${props.$hoverColor};
      transition: background-color 0.1s linear;
    }
  `}
`;
StyledScaleNumberItemDesignerPreviewer.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    width: 2.8rem;
    height: 3.3rem;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.SM
};
var StyledTranslatableTextAreaFieldPreviewer = import_styled_components2.default.div`
  display: flex;
  width: 100%;
  padding: 3rem;
  justify-content: center;

  textarea {
    max-width: 37.5rem;
    padding-bottom: 1rem;
    text-align: center;
    &:focus::placeholder {
      color: transparent;
    }
  }

  ${MobileStyles}
`;
StyledTranslatableTextAreaFieldPreviewer.defaultProps = {
  $mobileModeCss: import_styled_components2.css`
    padding: 1rem;
  `,
  $alwaysMobileWhenWidth: import_ui.breakpointDown.MD
};
var StyledIconStar = (0, import_styled_components2.default)(import_ui.IconCustomStar)``;

// src/components/Survey/Designer/DesignerPreviewer/elements/FieldPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var FieldPreviewer = ({ dataName = "data" }) => {
  const [dataField] = (0, import_formik.useField)(dataName);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFieldDesignerPreviewer, {
    children: dataField.value
  });
};

// src/components/Survey/Designer/DesignerPreviewer/elements/LogoFieldPreviewer.tsx
init_cjs_shims();
var import_formik2 = require("formik");

// src/assets/opinico-logo.svg
var opinico_logo_default = "data:image/svg+xml;base64,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";

// src/components/Survey/Designer/DesignerPreviewer/elements/LogoFieldPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var LogoFieldPreviewer = ({
  dataName = "data"
}) => {
  const [nameField] = (0, import_formik2.useField)(dataName);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLogoDesignerPreviewer, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLogoImageDesignerPreviewer, {
      url: nameField.value || opinico_logo_default
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/elements/PoweredBySeeNext.tsx
init_cjs_shims();
var import_react_i18next = require("react-i18next");

// src/components/Survey/Designer/DesignerContext.tsx
init_cjs_shims();
var import_react6 = require("react");

// src/helpers/SurveyItemType.ts
init_cjs_shims();
var SurveyItemType = /* @__PURE__ */ ((SurveyItemType2) => {
  SurveyItemType2["Intro"] = "intro";
  SurveyItemType2["SingleSelectionQuestion"] = "single_selection_question";
  SurveyItemType2["Likert"] = "likert";
  SurveyItemType2["Matrix"] = "matrix";
  SurveyItemType2["MultiSelectionQuestion"] = "multi_selection_question";
  SurveyItemType2["OpinionScaleQuestion"] = "opinion_scale_question";
  SurveyItemType2["TextQuestion"] = "text_question";
  SurveyItemType2["Extra"] = "extra";
  SurveyItemType2["Outro"] = "outro";
  return SurveyItemType2;
})(SurveyItemType || {});

// src/components/Survey/Designer/DesignerContext.tsx
var DesignerContext = (0, import_react6.createContext)({
  id: "0",
  type: "intro" /* Intro */,
  onSubmit: () => {
  },
  locale: "en",
  color: "#000000",
  questionIndex: 0,
  itemIndex: 0,
  size: 0,
  isEditable: false,
  logo: "",
  logoObject: {},
  surveyType: ""
});
var useDesigner = () => {
  return (0, import_react6.useContext)(DesignerContext);
};

// src/components/Survey/Designer/DesignerPreviewer/elements/PoweredBySeeNext.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var PoweredBySeeNext = () => {
  const { t } = (0, import_react_i18next.useTranslation)();
  const context = useDesigner();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledPoweredBySeeNextDesignerPreviewer, {
      children: [
        t("common.powered_by", { lng: context.locale }),
        " ",
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPoweredBySeeNextImageDesignerPreviewer, {
          url: opinico_logo_default
        })
      ]
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/elements/ScaleFieldPreviewer.tsx
init_cjs_shims();
var import_react9 = require("react");
var import_formik4 = require("formik");
var import_ui3 = require("@btc-snxt/ui");

// src/helpers/options/index.ts
init_cjs_shims();

// src/helpers/options/fontFamily.json
var fontFamily_default = {
  Default: [
    "'Ubuntu', sans-serif"
  ],
  "Sans-Serif": [
    "Arial, sans-serif",
    "Helvetica, sans-serif",
    "Gill Sans, sans-serif",
    "Lucida, sans-serif",
    "Helvetica Narrow, sans-serif",
    "sans-serif"
  ],
  Serif: [
    "Times, serif",
    "Times New Roman, serif",
    "Palatino, serif",
    "Bookman, serif",
    "New Century Schoolbook, serif",
    "serif"
  ],
  Monospace: [
    "Andale Mono, monospace",
    "Courier New, monospace",
    "Courier, monospace",
    "Lucidatypewriter, monospace",
    "Fixed, monospace",
    "monospace"
  ],
  Cursive: [
    "Comic Sans, Comic Sans MS, cursive",
    "Zapf Chancery, cursive",
    "Coronetscript, cursive",
    "Florence, cursive",
    "Parkavenue, cursive",
    "cursive"
  ]
};

// src/helpers/options/fontSize.json
var fontSize_default = {
  min: 10,
  max: 36,
  initial: 16
};

// src/helpers/options/fontWeight.json
var fontWeight_default = {
  Light: [
    100,
    200,
    300
  ],
  Normal: [
    400,
    500,
    600
  ],
  Bold: [
    700,
    800,
    900
  ]
};

// src/helpers/moveItemInArray.ts
init_cjs_shims();
function moveItemInArray(array2, fromIndex, toIndex) {
  const arrayCopy = [...array2];
  const itemRemoved = arrayCopy.splice(fromIndex, 1);
  arrayCopy.splice(toIndex, 0, itemRemoved[0]);
  return arrayCopy;
}

// src/helpers/OpinionScaleType.ts
init_cjs_shims();
var OpinionScaleType = /* @__PURE__ */ ((OpinionScaleType2) => {
  OpinionScaleType2["Emotion"] = "emotion";
  OpinionScaleType2["Star"] = "star";
  OpinionScaleType2["Number"] = "number";
  OpinionScaleType2["Slider"] = "slider";
  return OpinionScaleType2;
})(OpinionScaleType || {});

// src/helpers/SurveyItemIndexController.ts
init_cjs_shims();
var getSurveyItemIndex = (items, surveyItemPosition) => {
  const nonQuestionTypes = ["intro" /* Intro */, "extra" /* Extra */];
  const excludedItems = items.slice(0, surveyItemPosition).filter((item) => nonQuestionTypes.includes(item.type));
  const excludeItemsFromIndexing = excludedItems.length;
  return excludeItemsFromIndexing;
};
var getSurveyItemsSize = (items) => {
  const nonQuestionTypes = ["intro" /* Intro */, "extra" /* Extra */];
  const questionItems = items.filter((item) => !nonQuestionTypes.includes(item.type));
  return questionItems.length;
};

// src/helpers/SurveyType.ts
init_cjs_shims();
var SurveyType = /* @__PURE__ */ ((SurveyType2) => {
  SurveyType2["CustomerSatisfaction"] = "customer_satisfaction";
  SurveyType2["CustomerEffort"] = "customer_effort";
  SurveyType2["CustomerExperience"] = "customer_experience";
  SurveyType2["ProductExperience"] = "product_experience";
  SurveyType2["LoyaltyIntentions"] = "loyalty_intentions";
  SurveyType2["EmployeeSatisfaction"] = "employee_satisfaction";
  SurveyType2["NPS"] = "nps";
  SurveyType2["IndividualSurvey"] = "individual_survey";
  return SurveyType2;
})(SurveyType || {});

// src/helpers/HexToRGB.ts
init_cjs_shims();
var hexToRGB = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return `rgb(${r}, ${g}, ${b})`;
};

// src/helpers/useScrollFade.ts
init_cjs_shims();
var import_react7 = require("react");
var useScrollPosition = (containerSelector) => {
  const [scrollPosition, setScrollPosition] = (0, import_react7.useState)(0);
  const [isAtBottom, setIsAtBottom] = (0, import_react7.useState)(false);
  const turnFadingOff = 50;
  const handleScroll = (event) => {
    const scrollTop = event.target.scrollTop;
    setScrollPosition(scrollTop);
  };
  (0, import_react7.useEffect)(() => {
    const container = document.querySelector(containerSelector);
    if (container) {
      if (scrollPosition + turnFadingOff >= container.scrollHeight - container.clientHeight) {
        setIsAtBottom(true);
      } else {
        setIsAtBottom(false);
      }
    }
  }, [scrollPosition, containerSelector]);
  return {
    scrollPosition,
    isAtBottom,
    handleScroll
  };
};

// src/helpers/store/index.tsx
init_cjs_shims();

// src/helpers/store/SurveyNavigation.store.tsx
init_cjs_shims();
var import_zustand = require("zustand");
var useSurveyNavigationStore = (0, import_zustand.create)((set2) => {
  return {
    currentSurveyQuestion: 0,
    setCurrentSurveyQuestion: ({ state }) => {
      set2(() => ({ currentSurveyQuestion: state }));
    },
    reset: () => set2({ currentSurveyQuestion: 0 })
  };
});
var getElementInCenter = () => {
  const elements = document.querySelectorAll("div[id]:not(#root)");
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const viewportCenter = viewportHeight / 2;
  let closestElement = null;
  let closestDistance = Infinity;
  for (let i = 0; i < elements.length; i++) {
    const rect = elements[i].getBoundingClientRect();
    const elementCenter = (rect.top + rect.bottom) / 2;
    const distance = Math.abs(elementCenter - viewportCenter);
    if (distance < closestDistance) {
      closestDistance = distance;
      closestElement = elements[i].id;
    }
  }
  return Number(closestElement);
};

// src/assets/angry-emoji-color.svg
var angry_emoji_color_default = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA3MCA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iOC43NSIgeT0iOC43NSIgd2lkdGg9IjUyLjUiIGhlaWdodD0iNTIuNSIgcng9IjI2LjI1IiBmaWxsPSIjRjg3NjZEIi8+CjxwYXRoIGQ9Ik0zNSA2MS4yNUM0OS40OTc1IDYxLjI1IDYxLjI1IDQ5LjQ5NzUgNjEuMjUgMzVDNjEuMjUgMjAuNTAyNSA0OS40OTc1IDguNzUgMzUgOC43NUMyMC41MDI1IDguNzUgOC43NSAyMC41MDI1IDguNzUgMzVDOC43NSA0OS40OTc1IDIwLjUwMjUgNjEuMjUgMzUgNjEuMjVaIiBzdHJva2U9IiMxRDI0MzAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik00NS45Mzc1IDQ4LjEyNUM0NC43MTQ0IDQ1LjQ2MzUgNDIuOTU5MyA0My4yNTQ0IDQwLjg0NzkgNDEuNzE4OEMzOC43MzY0IDQwLjE4MzIgMzYuMzQyNyAzOS4zNzUgMzMuOTA2MiAzOS4zNzVDMzEuNDY5OCAzOS4zNzUgMjkuMDc2MSA0MC4xODMyIDI2Ljk2NDYgNDEuNzE4OEMyNC44NTMyIDQzLjI1NDQgMjMuMDk4MSA0NS40NjM1IDIxLjg3NSA0OC4xMjUiIHN0cm9rZT0iIzFEMjQzMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTI1LjE1NjIgMzIuODEyNUMyNi45Njg0IDMyLjgxMjUgMjguNDM3NSAzMS4zNDM0IDI4LjQzNzUgMjkuNTMxMkMyOC40Mzc1IDI3LjcxOTEgMjYuOTY4NCAyNi4yNSAyNS4xNTYyIDI2LjI1QzIzLjM0NDEgMjYuMjUgMjEuODc1IDI3LjcxOTEgMjEuODc1IDI5LjUzMTJDMjEuODc1IDMxLjM0MzQgMjMuMzQ0MSAzMi44MTI1IDI1LjE1NjIgMzIuODEyNVoiIGZpbGw9IiMxRDI0MzAiLz4KPHBhdGggZD0iTTQ0Ljg0MzggMzIuODEyNUM0Ni42NTU5IDMyLjgxMjUgNDguMTI1IDMxLjM0MzQgNDguMTI1IDI5LjUzMTJDNDguMTI1IDI3LjcxOTEgNDYuNjU1OSAyNi4yNSA0NC44NDM4IDI2LjI1QzQzLjAzMTYgMjYuMjUgNDEuNTYyNSAyNy43MTkxIDQxLjU2MjUgMjkuNTMxMkM0MS41NjI1IDMxLjM0MzQgNDMuMDMxNiAzMi44MTI1IDQ0Ljg0MzggMzIuODEyNVoiIGZpbGw9IiMxRDI0MzAiLz4KPHBhdGggZD0iTTM5LjY5NzMgMjkuOTMzOEw0Ny4yNzUgMjUuNTU4OCIgc3Ryb2tlPSIjMUQyNDMwIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMi4xOTczIDI1LjU1ODhMMjkuNzc1IDI5LjkzMzgiIHN0cm9rZT0iIzFEMjQzMCIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";

// src/assets/sad-emoji-color.svg
var sad_emoji_color_default = "data:image/svg+xml;base64,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";

// src/assets/neutral-emoji-color.svg
var neutral_emoji_color_default = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA3MCA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iOC43NSIgeT0iOS4yNSIgd2lkdGg9IjUyLjUiIGhlaWdodD0iNTIuNSIgcng9IjI2LjI1IiBmaWxsPSIjRkRFRTk5Ii8+CjxwYXRoIGQ9Ik0zNSA2MS43NUM0OS40OTc1IDYxLjc1IDYxLjI1IDQ5Ljk5NzUgNjEuMjUgMzUuNUM2MS4yNSAyMS4wMDI1IDQ5LjQ5NzUgOS4yNSAzNSA5LjI1QzIwLjUwMjUgOS4yNSA4Ljc1IDIxLjAwMjUgOC43NSAzNS41QzguNzUgNDkuOTk3NSAyMC41MDI1IDYxLjc1IDM1IDYxLjc1WiIgc3Ryb2tlPSIjMUQyNDMwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8cGF0aCBkPSJNMjQuMDYyNSA0NC4yNUg0NS45Mzc1IiBzdHJva2U9IiMxRDI0MzAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNS4xNTYyIDMzLjMxMjVDMjYuOTY4NCAzMy4zMTI1IDI4LjQzNzUgMzEuODQzNCAyOC40Mzc1IDMwLjAzMTJDMjguNDM3NSAyOC4yMTkxIDI2Ljk2ODQgMjYuNzUgMjUuMTU2MiAyNi43NUMyMy4zNDQxIDI2Ljc1IDIxLjg3NSAyOC4yMTkxIDIxLjg3NSAzMC4wMzEyQzIxLjg3NSAzMS44NDM0IDIzLjM0NDEgMzMuMzEyNSAyNS4xNTYyIDMzLjMxMjVaIiBmaWxsPSIjMUQyNDMwIi8+CjxwYXRoIGQ9Ik00NC44NDM4IDMzLjMxMjVDNDYuNjU1OSAzMy4zMTI1IDQ4LjEyNSAzMS44NDM0IDQ4LjEyNSAzMC4wMzEyQzQ4LjEyNSAyOC4yMTkxIDQ2LjY1NTkgMjYuNzUgNDQuODQzOCAyNi43NUM0My4wMzE2IDI2Ljc1IDQxLjU2MjUgMjguMjE5MSA0MS41NjI1IDMwLjAzMTJDNDEuNTYyNSAzMS44NDM0IDQzLjAzMTYgMzMuMzEyNSA0NC44NDM4IDMzLjMxMjVaIiBmaWxsPSIjMUQyNDMwIi8+Cjwvc3ZnPgo=";

// src/assets/happy-emoji-color.svg
var happy_emoji_color_default = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA3MCA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iOC43NSIgeT0iOS4yNSIgd2lkdGg9IjUyLjUiIGhlaWdodD0iNTIuNSIgcng9IjI2LjI1IiBmaWxsPSIjQURGMEM2Ii8+CjxwYXRoIGQ9Ik0zNSA2MS43NUM0OS40OTc1IDYxLjc1IDYxLjI1IDQ5Ljk5NzUgNjEuMjUgMzUuNUM2MS4yNSAyMS4wMDI1IDQ5LjQ5NzUgOS4yNSAzNSA5LjI1QzIwLjUwMjUgOS4yNSA4Ljc1IDIxLjAwMjUgOC43NSAzNS41QzguNzUgNDkuOTk3NSAyMC41MDI1IDYxLjc1IDM1IDYxLjc1WiIgc3Ryb2tlPSIjMUQyNDMwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjUuMTU2MiAzMy4zMTI1QzI2Ljk2ODQgMzMuMzEyNSAyOC40Mzc1IDMxLjg0MzQgMjguNDM3NSAzMC4wMzEyQzI4LjQzNzUgMjguMjE5MSAyNi45Njg0IDI2Ljc1IDI1LjE1NjIgMjYuNzVDMjMuMzQ0MSAyNi43NSAyMS44NzUgMjguMjE5MSAyMS44NzUgMzAuMDMxMkMyMS44NzUgMzEuODQzNCAyMy4zNDQxIDMzLjMxMjUgMjUuMTU2MiAzMy4zMTI1WiIgZmlsbD0iIzFEMjQzMCIvPgo8cGF0aCBkPSJNNDQuODQzOCAzMy4zMTI1QzQ2LjY1NTkgMzMuMzEyNSA0OC4xMjUgMzEuODQzNCA0OC4xMjUgMzAuMDMxMkM0OC4xMjUgMjguMjE5MSA0Ni42NTU5IDI2Ljc1IDQ0Ljg0MzggMjYuNzVDNDMuMDMxNiAyNi43NSA0MS41NjI1IDI4LjIxOTEgNDEuNTYyNSAzMC4wMzEyQzQxLjU2MjUgMzEuODQzNCA0My4wMzE2IDMzLjMxMjUgNDQuODQzOCAzMy4zMTI1WiIgZmlsbD0iIzFEMjQzMCIvPgo8cGF0aCBkPSJNNDYuMzc1IDQyLjA2MjVDNDUuMjE4NiA0NC4wNTQ4IDQzLjU1OTIgNDUuNzA4NCA0MS41NjMgNDYuODU3OEMzOS41NjY3IDQ4LjAwNzMgMzcuMzAzNiA0OC42MTIzIDM1IDQ4LjYxMjNDMzIuNjk2NCA0OC42MTIzIDMwLjQzMzMgNDguMDA3MyAyOC40MzcgNDYuODU3OEMyNi40NDA4IDQ1LjcwODQgMjQuNzgxNCA0NC4wNTQ4IDIzLjYyNSA0Mi4wNjI1IiBzdHJva2U9IiMxRDI0MzAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";

// src/assets/excited-emoji-color.svg
var excited_emoji_color_default = "data:image/svg+xml;base64,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";

// src/helpers/OpinionScaleEmotionItems.tsx
init_cjs_shims();
var import_ui2 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var emotionOrder = [
  [/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {})],
  [/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {})],
  [/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {})],
  [/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}), /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {})],
  [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {})
  ],
  [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {})
  ],
  [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {})
  ],
  [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {})
  ],
  [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {})
  ],
  [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {})
  ],
  [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {})
  ],
  [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconAngryEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconSadEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconNeutralEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconHappyEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui2.IconExcitedEmoji, {})
  ]
];

// src/components/Survey/Designer/DesignerPreviewer/elements/ExplanationTranslatable.tsx
init_cjs_shims();
var import_formik3 = require("formik");
var import_react_i18next2 = require("react-i18next");

// src/components/Survey/Previewer/PreviewerContext.tsx
init_cjs_shims();
var import_react8 = require("react");
var PreviewerContext = (0, import_react8.createContext)({
  id: "0",
  type: "intro" /* Intro */,
  surveyType: "individual_survey" /* IndividualSurvey */,
  onSubmit: () => {
  },
  locale: "en",
  color: "#000000",
  questionIndex: 0,
  itemIndex: 0,
  size: 0,
  logo: "",
  logoObject: {},
  submit: () => {
  },
  setLocale: () => {
  },
  availableLanguages: [],
  value: void 0
});
var usePreviewer = () => {
  return (0, import_react8.useContext)(PreviewerContext);
};

// src/components/Survey/Designer/DesignerPreviewer/elements/ExplanationTranslatable.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ExplanationTranslatable = ({ dataName, mode }) => {
  const { t, i18n } = (0, import_react_i18next2.useTranslation)();
  const previewer = usePreviewer();
  const designer = useDesigner();
  const currentLocale = mode === "designer" ? (designer == null ? void 0 : designer.locale) || i18n.language : mode === "previewer" ? (previewer == null ? void 0 : previewer.locale) || i18n.language : (designer == null ? void 0 : designer.locale) || (previewer == null ? void 0 : previewer.locale) || i18n.language;
  const [nameField] = (0, import_formik3.useField)(`${dataName}.${currentLocale}`);
  if (!nameField.value) {
    if (dataName.includes("min_description")) {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
        children: t("survey.form.disagree")
      });
    } else if (dataName.includes("max_description")) {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
        children: t("survey.form.agree")
      });
    }
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", {
    children: nameField.value
  });
};

// src/components/Survey/Designer/DesignerPreviewer/elements/ScaleFieldPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ScaleFieldPreviewer = ({
  dataName = "count",
  typeName = "type"
}) => {
  const context = useDesigner();
  const [dataNameField] = (0, import_formik4.useField)(dataName);
  const [typeNameField] = (0, import_formik4.useField)(typeName);
  const [items, setItems] = (0, import_react9.useState)([]);
  const [selectedItem, setSelectedItem] = (0, import_react9.useState)(-1);
  const [hoveredItem, setHoveredItem] = (0, import_react9.useState)(-1);
  (0, import_react9.useEffect)(() => {
    let itemsLength = dataNameField.value;
    if (itemsLength < 0) {
      itemsLength = 0;
    }
    setItems([...new Array(itemsLength)]);
  }, [dataNameField.value]);
  const getItemClass = (index2) => {
    let className = "";
    if (index2 <= selectedItem) {
      className += " active";
    }
    if (index2 <= hoveredItem) {
      className += " hover";
    }
    return {
      className
    };
  };
  const renderStarItem = (index2) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledScaleStarItemDesignerPreviewer, {
      ...getItemClass(index2),
      $hoverColor: hexToRGB(context.color, "0.15"),
      $activeColor: context.color,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIconStar, {})
    });
  };
  const renderEmotionItem = (index2) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledScaleEmotionItemDesignerPreviewer, {
      ...getItemClass(index2),
      $iconAngry: angry_emoji_color_default,
      $iconSad: sad_emoji_color_default,
      $iconNeutral: neutral_emoji_color_default,
      $iconHappy: happy_emoji_color_default,
      $iconExcited: excited_emoji_color_default,
      $hoverColor: hexToRGB(context.color, "0.15"),
      children: emotionOrder[items.length - 1][index2]
    });
  };
  const renderNumberItem = (index2) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledScaleNumberItemDesignerPreviewer, {
      ...getItemClass(index2),
      $hoverColor: hexToRGB(context.color, "0.15"),
      $activeColor: context.color,
      children: index2
    });
  };
  const renderSliderItem = (index2) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledSliderItemDesignerPreviewer, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui3.Slider, {
        initialValue: index2,
        max: index2 - 1,
        min: 0,
        step: 1,
        color: context.color
      })
    });
  };
  const renderItem = (index2) => {
    switch (typeNameField.value) {
      case "star" /* Star */:
        return renderStarItem(index2);
      case "emotion" /* Emotion */:
        return renderEmotionItem(index2);
      case "number" /* Number */:
        return renderNumberItem(index2);
      case "slider" /* Slider */:
        return renderSliderItem(index2);
    }
    return null;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: typeNameField.value === "slider" /* Slider */ ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: renderItem(items.length)
    }) : typeNameField.value === "number" /* Number */ ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(OptionsAndExplanationsWrapper, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledScaleFieldDesignerPreviewer, {
          children: items.map((_, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledScaleFieldItemDesignerPreviewerWrapper, {
            onClick: () => setSelectedItem(index2),
            onMouseEnter: () => setHoveredItem(index2),
            onMouseLeave: () => setHoveredItem(-1),
            children: renderItem(index2)
          }, index2))
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledExplanations, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledExplanationRow, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledExplanationText, {
                children: [
                  "0 -",
                  " ",
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExplanationTranslatable, {
                    dataName: `${typeName.replace(".type", "")}.min_description.data`
                  })
                ]
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledExplanationRow, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledExplanationText, {
                children: [
                  items.length - 1,
                  " -",
                  " ",
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExplanationTranslatable, {
                    dataName: `${typeName.replace(".type", "")}.max_description.data`
                  })
                ]
              })
            })
          ]
        })
      ]
    }) : typeNameField.value === "star" /* Star */ || typeNameField.value === "emotion" /* Emotion */ ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledStarScaleFieldDesignerPreviewer, {
      children: items.map((_, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledStarScaleFieldItemDesignerPreviewerWrapper, {
        onClick: () => setSelectedItem(index2),
        onMouseEnter: () => setHoveredItem(index2),
        onMouseLeave: () => setHoveredItem(-1),
        children: renderItem(index2)
      }, index2))
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledScaleFieldDesignerPreviewer, {
      children: items.map((_, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
        onClick: () => setSelectedItem(index2),
        onMouseEnter: () => setHoveredItem(index2),
        onMouseLeave: () => setHoveredItem(-1),
        children: renderItem(index2)
      }, index2))
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/elements/TranslatableFieldPreviewer.tsx
init_cjs_shims();
var import_formik5 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableFieldPreviewer = ({
  dataName = "data"
}) => {
  const context = useDesigner();
  const [nameField] = (0, import_formik5.useField)(`${dataName}.${context.locale}`);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFieldDesignerPreviewer, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
      children: nameField.value
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/elements/TranslatableInputFieldPreviewer.tsx
init_cjs_shims();
var import_formik6 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableInputFieldPreviewer = ({
  dataName = "data"
}) => {
  const context = useDesigner();
  const [nameField] = (0, import_formik6.useField)(`${dataName}.${context.locale}`);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputFieldDesignerPreviewer, {
    value: nameField.value,
    readOnly: true
  });
};

// src/components/Survey/Designer/DesignerPreviewer/elements/TranslatableMultiSelectionFieldPreviewer.tsx
init_cjs_shims();
var import_react10 = require("react");
var import_formik7 = require("formik");

// src/components/Survey/Previewer/Previewer.style.tsx
init_cjs_shims();
var import_ui4 = require("@btc-snxt/ui");
var import_styled_components3 = __toESM(require("styled-components"));
var StyledPreviewer = (0, import_styled_components3.default)(StyledDesignerPreviewer)`
  background-color: ${(props) => props.backgroundColor};
  width: 100%;
  height: 100dvh;
  padding: 3rem 5rem;
  scroll-snap-align: center;
  font-family: 'Inter', sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${MobileStyles}
`;
StyledPreviewer.defaultProps = {
  $mobileModeCss: import_styled_components3.css`
    padding: 2rem 1rem;
  `,
  $alwaysMobileWhenWidth: import_ui4.breakpointDown.LG
};
var StyledIntroPagePreviewer = (0, import_styled_components3.default)(StyledPreviewer)`
  position: relative;
  z-index: 10;
`;
var StyledLogo = import_styled_components3.default.img`
  max-width: 22.5rem;
  max-height: 15rem;
`;
var LanguageDropdownWrapper = import_styled_components3.default.div`
  display: flex;
  justify-content: flex-end;
`;
var HeaderWrapper = import_styled_components3.default.div`
  display: flex;
  justify-content: ${(props) => props.$availableLanguagesLength > 1 ? "space-between" : "end"};
`;
var StyledPreviewerGroup = (0, import_styled_components3.default)(StyledDesignerPreviewerGroup)`
  font-size: 1rem;
`;
var StyledAnswerPreviewerGroupWrapper = import_styled_components3.default.div`
  display: flex;
  overflow: auto;
  width: 100%;
  padding: 0 1.5rem 0 2.125rem;

  ${MobileStyles}
`;
StyledAnswerPreviewerGroupWrapper.defaultProps = {
  $mobileModeCss: import_styled_components3.css`
    margin-left: 0;
  `,
  $alwaysMobileWhenWidth: import_ui4.breakpointDown.SM
};
var StyledOpinionScaleAnswerPreviewerGroupWrapper = import_styled_components3.default.div`
  display: flex;
  width: 100%;
  padding: 0 1.5rem 0 2.125rem;

  ${MobileStyles}
`;
StyledOpinionScaleAnswerPreviewerGroupWrapper.defaultProps = {
  $mobileModeCss: import_styled_components3.css`
    margin-left: 0;
  `,
  $alwaysMobileWhenWidth: import_ui4.breakpointDown.SM
};
var StyledLikertAnswerPreviewerGroupWrapper = import_styled_components3.default.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2.5rem;
  padding: 0 1.5rem 0 1.5rem;

  ${import_ui4.breakpointDown.SM} {
    margin-left: 0;
  }
`;
var StyledAnswerPreviewerGroup = (0, import_styled_components3.default)(StyledDesignerPreviewerGroup)`
  align-items: flex-start;
  font-family: 'Manrope', sans-serif;
  height: 100%;
  width: 100%;
`;
var StyledAnswerPreviewerOpinionScaleGroup = (0, import_styled_components3.default)(
  StyledDesignerPreviewerOpinionScaleGroup
)`
  align-items: flex-start;
  width: 100%;
  font-family: 'Manrope', sans-serif;
`;
var StyledTextInputPreviewerGroup = (0, import_styled_components3.default)(StyledAnswerPreviewerGroup)`
  width: 100%;
`;
var StyledPreviewerBody = (0, import_styled_components3.default)(StyledDesignerPreviewerBody)`
  display: flex;
  flex-direction: column;
`;
var StyledOutroPreviewerBody = (0, import_styled_components3.default)(StyledDesignerPreviewerBody)`
  display: flex;
  flex-direction: column;
  justify-content: unset;
  margin-top: 12.5rem;

  ${MobileStyles}
`;
StyledOutroPreviewerBody.defaultProps = {
  $mobileModeCss: import_styled_components3.css`
    margin-top: 5.5rem;
  `,
  $alwaysMobileWhenWidth: import_ui4.breakpointDown.MD
};
var StyledPreviewerFooter = (0, import_styled_components3.default)(StyledDesignerPreviewerFooter)``;
var StyledFieldPreviewer = (0, import_styled_components3.default)(StyledFieldDesignerPreviewer)`
  text-align: center;
`;
var StyledInputFieldPreviewer = (0, import_styled_components3.default)(StyledInputFieldDesignerPreviewer)``;
var StyledTextAreaFieldPreviewer = (0, import_styled_components3.default)(StyledTextAreaFieldDesignerPreviewer)`
  white-space: nowrap;
  overflow-y: hidden;

  ${MobileStyles}
`;
StyledTextAreaFieldPreviewer.defaultProps = {
  $mobileModeCss: import_styled_components3.css`
    font-size: 1.5rem;
  `,
  $alwaysMobileWhenWidth: import_ui4.breakpointDown.SM
};
var StyledInputPreviewer = (0, import_styled_components3.default)(StyledInputDesignerPreviewer)`
  &:active {
    filter: none;
  }
`;
var StyledLabelPreviewer = (0, import_styled_components3.default)(StyledLabelDesignerPreviewer)``;
var StyledInputPreviewerWrapper = import_styled_components3.default.div`
  margin-left: 1rem;
`;
var StyledFormGroupPreviewer = (0, import_styled_components3.default)(StyledFormGroupDesignerPreviewer)`
  ${StyledInputPreviewerWrapper} {
    ${({ $active, $checked, theme }) => !$checked && !$active && `
      border: 1px solid ${theme.colors.black};
      border-radius: 1rem;
    `}
  }
`;
var StyledLikertFormGroupPreviewer = (0, import_styled_components3.default)(StyledFormGroupDesignerPreviewer)`
  ${StyledInputPreviewerWrapper} {
    ${({ $active, $checked, theme }) => !$checked && !$active && `
      border: 1px solid ${theme.colors.black};
      border-radius: 1rem;
    `}
  }
  width: 100%;
`;
var StyledMultiSelectFormGroupPreviewer = (0, import_styled_components3.default)(StyledMultiSelect)``;
var StyledLogoPreviewer = (0, import_styled_components3.default)(StyledLogoDesignerPreviewer)``;
var StyledLogoImagePreviewer = (0, import_styled_components3.default)(StyledLogoImageDesignerPreviewer)``;
var StyledPoweredBySeeNext = (0, import_styled_components3.default)(StyledPoweredBySeeNextDesignerPreviewer)``;
var StyledPoweredBySeeNextImage = (0, import_styled_components3.default)(StyledPoweredBySeeNextImageDesignerPreviewer)``;
var StyledScaleFieldPreviewer = (0, import_styled_components3.default)(StyledScaleFieldDesignerPreviewer)``;
var StyledScaleFieldItemPreviewerWrapper = (0, import_styled_components3.default)(
  StyledScaleFieldItemDesignerPreviewerWrapper
)``;
var StyledScaleItemPreviewer = (0, import_styled_components3.default)(StyledScaleItemDesignerPreviewer)``;
var StyledScaleStarItemPreviewer = (0, import_styled_components3.default)(StyledScaleItemDesignerPreviewer)``;
var StyledScaleEmotionItemPreviewer = (0, import_styled_components3.default)(StyledScaleEmotionItemDesignerPreviewer)``;
var StyledScaleNumberItemPreviewer = (0, import_styled_components3.default)(StyledScaleNumberItemDesignerPreviewer)``;
var ContinueButtonPreviewerWrapper = import_styled_components3.default.div`
  padding-left: 2.125rem;

  ${MobileStyles}
`;
ContinueButtonPreviewerWrapper.defaultProps = {
  $mobileModeCss: import_styled_components3.css`
    margin-left: 0;
  `,
  $alwaysMobileWhenWidth: import_ui4.breakpointDown.SM
};
var SubmitButtonPreviewerWrapper = import_styled_components3.default.div`
  ${MobileStyles}
`;
SubmitButtonPreviewerWrapper.defaultProps = {
  $mobileModeCss: import_styled_components3.css`
    margin-left: 0;
  `,
  $alwaysMobileWhenWidth: import_ui4.breakpointDown.SM
};
var StyledFormikErrorMessage = import_styled_components3.default.div`
  width: 100%;
  display: flex;
  margin-top: 4.75rem;
  justify-content: center;
  ${import_ui4.breakpointDown.MD} {
    margin-top: 2rem;
  }
  div:first-child {
    width: 100%;
    max-width: 37.5rem;
  }
`;
var ActionItemWrapper = import_styled_components3.default.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;

  ${MobileStyles}
`;
ActionItemWrapper.defaultProps = {
  $mobileModeCss: import_styled_components3.css`
    gap: 2rem;
  `,
  $alwaysMobileWhenWidth: import_ui4.breakpointDown.LG
};

// src/assets/check.svg
var check_default = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI0IiB2aWV3Qm94PSIwIDAgMTYgMTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjU0OTkgMTAuNDc0OEM1LjQ0OTkgMTAuNDc0OCA1LjM1MzkgMTAuNDU4MSA1LjI2MTkgMTAuNDI0OEM1LjE3MDU3IDEwLjM5MTUgNS4wNzQ5IDEwLjMzMzEgNC45NzQ5IDEwLjI0OThMMC45MjQ5MDIgNi4xOTk4QzAuODI0OTAyIDYuMDgzMTQgMC43NzQ5MDIgNS45NjIxNCAwLjc3NDkwMiA1LjgzNjhDMC43NzQ5MDIgNS43MTIxNCAwLjgzMzIzNSA1LjU5MTQ3IDAuOTQ5OTAyIDUuNDc0OEMxLjA0OTkgNS4zNzQ4IDEuMTY2NTcgNS4zMjQ4IDEuMjk5OSA1LjMyNDhDMS40MzMyNCA1LjMyNDggMS41NDk5IDUuMzc0OCAxLjY0OTkgNS40NzQ4TDUuNTQ5OSA5LjM3NDhMMTQuMzQ5OSAwLjU3NDgwNEMxNC40NDk5IDAuNDc0ODA0IDE0LjU2NjYgMC40MjQ4MDUgMTQuNjk5OSAwLjQyNDgwNUMxNC44MzMyIDAuNDI0ODA1IDE0Ljk1ODIgMC40NzQ4MDQgMTUuMDc0OSAwLjU3NDgwNEMxNS4xNzQ5IDAuNjkxNDcxIDE1LjIyNDkgMC44MTI0NzEgMTUuMjI0OSAwLjkzNzgwNUMxNS4yMjQ5IDEuMDYyNDcgMTUuMTc0OSAxLjE4MzE0IDE1LjA3NDkgMS4yOTk4TDYuMTI0OSAxMC4yNDk4QzYuMDI0OSAxMC4zMzMxIDUuOTI5MjQgMTAuMzkxNSA1LjgzNzkgMTAuNDI0OEM1Ljc0NTkgMTAuNDU4MSA1LjY0OTkgMTAuNDc0OCA1LjU0OTkgMTAuNDc0OFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

// src/components/Survey/Designer/DesignerPreviewer/elements/TranslatableMultiSelectionFieldPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableMultiSelectionFieldPreviewer = ({ dataName = "data" }) => {
  const context = useDesigner();
  const [nameField] = (0, import_formik7.useField)(dataName);
  const maxSize = 100;
  const [isItemChecked, setIsItemChecked] = (0, import_react10.useState)(
    Array(maxSize).fill(false)
  );
  const handleOnClickCheckbox = (index2) => {
    const newIsItemChecked = [...isItemChecked];
    newIsItemChecked[index2] = !newIsItemChecked[index2];
    setIsItemChecked(newIsItemChecked);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledSelectFieldDesignerPreviewer, {
    children: nameField.value.map((item, index2) => {
      const id = `${context.id}.${dataName}.${index2}.previewer`;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledMultiSelectFormGroupPreviewer, {
        check: true,
        onClick: () => handleOnClickCheckbox(index2),
        $active: isItemChecked[index2],
        $backgroundColor: context.color,
        $icon: check_default,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLabelDesignerPreviewer, {
            check: true,
            children: item[context.locale]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputDesignerPreviewer, {
            type: "checkbox",
            id,
            checked: isItemChecked[index2],
            readOnly: true
          })
        ]
      }, id);
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/elements/TranslatableSingleSelectionFieldPreviewer.tsx
init_cjs_shims();
var import_react11 = require("react");
var import_formik8 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableSingleSelectionFieldPreviewer = ({ dataName = "data" }) => {
  const context = useDesigner();
  const [nameField] = (0, import_formik8.useField)(dataName);
  const [checkedId, setCheckedId] = (0, import_react11.useState)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledSelectFieldDesignerPreviewer, {
    children: nameField.value.map((item, index2) => {
      const id = `${context.id}.${dataName}.${index2}.previewer`;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormGroupDesignerPreviewer, {
        check: true,
        onClick: () => setCheckedId(index2),
        $active: checkedId == index2,
        $backgroundColor: context.color,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputDesignerPreviewerWrapper, {
            $checked: checkedId == index2,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputDesignerPreviewer, {
              type: "radio",
              id,
              checked: checkedId == index2,
              onChange: () => setCheckedId(index2)
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLabelDesignerPreviewer, {
            check: true,
            for: id,
            children: item[context.locale]
          })
        ]
      }, id);
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/elements/TranslatableTextAreaFieldPreviewer.tsx
init_cjs_shims();
var import_formik9 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableTextAreaFieldPreviewer = ({
  dataName = "data",
  backgroundColorName = "background_color"
}) => {
  const context = useDesigner();
  const [nameField] = (0, import_formik9.useField)(`${dataName}.${context.locale}`);
  const [backgroundColorNameField] = (0, import_formik9.useField)(backgroundColorName);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTextAreaFieldDesignerPreviewer, {
    color: context.color,
    backgroundColor: backgroundColorNameField.value,
    value: nameField.value,
    maxRows: 7,
    readOnly: true
  });
};

// src/components/Survey/Designer/DesignerPreviewer/items/ExtraItemDesignerPreviewer.tsx
init_cjs_shims();
var import_ui6 = require("@btc-snxt/ui");

// src/components/LinearProgressBar/index.ts
init_cjs_shims();

// src/components/LinearProgressBar/LinearProgressBar.tsx
init_cjs_shims();

// src/components/LinearProgressBar/LinearProgressBar.style.tsx
init_cjs_shims();
var import_styled_components4 = __toESM(require("styled-components"));
var StyledProgressBarFull = (0, import_styled_components4.default)(Progress)`
  background-color: ${(props) => props.color};
  border-radius: 0.25rem;
  height: 0.75rem;
`;
var StyledProgressBarCurrent = (0, import_styled_components4.default)(Progress)`
  background-color: ${(props) => props.color};
  border-radius: 0.25rem;
`;
var ProgressBarInfoWrapper = import_styled_components4.default.div`
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.black}; ;
`;
var ProgressBarCount = import_styled_components4.default.div``;
var ProgressBarPercent = import_styled_components4.default.div``;

// src/components/LinearProgressBar/LinearProgressBar.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var LinearProgressBar = (props) => {
  const MAXIMUM_PERCENT = 100;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledProgressBarFull, {
        multi: true,
        max: MAXIMUM_PERCENT,
        color: hexToRGB(props.color, "0.15"),
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledProgressBarCurrent, {
          bar: true,
          value: (props.currentValue + 1) / props.total * MAXIMUM_PERCENT,
          color: props.color
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ProgressBarInfoWrapper, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ProgressBarCount, {
            children: [
              props.currentValue + 1,
              "/",
              props.total
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ProgressBarPercent, {
            children: [
              Math.round((props.currentValue + 1) / props.total * MAXIMUM_PERCENT),
              "%"
            ]
          })
        ]
      })
    ]
  });
};
var LinearProgressBar_default = LinearProgressBar;

// src/components/Survey/Designer/DesignerPreviewer/items/ExtraItemDesignerPreviewer.tsx
var import_react_i18next3 = require("react-i18next");

// src/components/NavigationButtons/NavigationButtons.tsx
init_cjs_shims();
var import_ui5 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var NavigationButtons = () => {
  const context = usePreviewer();
  const surveyItem = useSurveyNavigationStore();
  const handleNextClick = () => {
    const currentElement = getElementInCenter();
    const element = document.getElementById(String(currentElement + 1));
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      surveyItem.setCurrentSurveyQuestion({ state: currentElement + 1 });
    }
  };
  const handlePreviousClick = () => {
    const currentElement = getElementInCenter();
    const element = document.getElementById(String(currentElement - 1));
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      surveyItem.setCurrentSurveyQuestion({
        state: currentElement - 1
      });
    }
  };
  const checkIfLastElement = () => {
    if (context.type === "outro" /* Outro */) {
      return hexToRGB(import_ui5.Theme.colors.black, "0.3");
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledNavigationButtons, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIconButtonPrevious, {
        onClick: handlePreviousClick,
        size: "large"
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIconButtonNext, {
        onClick: handleNextClick,
        size: "large",
        backgroundColor: checkIfLastElement()
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerPreviewer/items/ExtraItemDesignerPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ExtraItemDesignerPreviewer = () => {
  const mainTextName = "main_text";
  const context = useDesigner();
  const { t } = (0, import_react_i18next3.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewer, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerBackgroundColor, {
      backgroundColor: hexToRGB(context.color, import_ui6.Theme.opacity.background),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LinearProgressBar_default, {
          currentValue: context.questionIndex,
          total: context.size,
          color: context.color
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerBody, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewerGroup, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTitle, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                  dataName: `${mainTextName}.data`
                })
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButton, {
              type: "button",
              value: t("common.submit", { lng: context.locale })
            })
          ]
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerFooter, {
          navigation: true,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NavigationButtons, {}),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PoweredBySeeNext, {})
          ]
        })
      ]
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/items/IntroItemDesignerPreviewer.tsx
init_cjs_shims();
var import_react14 = require("react");
var import_ui15 = require("@btc-snxt/ui");
var import_react_i18next5 = require("react-i18next");

// src/components/FileUpload/index.ts
init_cjs_shims();

// src/components/FileUpload/FileUpload.tsx
init_cjs_shims();
var import_react13 = require("react");

// ../../node_modules/react-dropzone/dist/es/index.js
init_cjs_shims();
var import_react12 = __toESM(require("react"));
var import_prop_types4 = __toESM(require_prop_types());

// ../../node_modules/file-selector/dist/es5/index.js
init_cjs_shims();

// ../../node_modules/file-selector/dist/es5/file-selector.js
init_cjs_shims();

// ../../node_modules/tslib/modules/index.js
init_cjs_shims();
var import_tslib = __toESM(require_tslib(), 1);
var {
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __exportStar,
  __createBinding,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn
} = import_tslib.default;

// ../../node_modules/file-selector/dist/es5/file.js
init_cjs_shims();
var COMMON_MIME_TYPES = /* @__PURE__ */ new Map([
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function toFileWithPath(file, path) {
  var f = withMimeType(file);
  if (typeof f.path !== "string") {
    var webkitRelativePath = file.webkitRelativePath;
    Object.defineProperty(f, "path", {
      value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
      writable: false,
      configurable: false,
      enumerable: true
    });
  }
  return f;
}
function withMimeType(file) {
  var name = file.name;
  var hasExtension = name && name.lastIndexOf(".") !== -1;
  if (hasExtension && !file.type) {
    var ext = name.split(".").pop().toLowerCase();
    var type = COMMON_MIME_TYPES.get(ext);
    if (type) {
      Object.defineProperty(file, "type", {
        value: type,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  }
  return file;
}

// ../../node_modules/file-selector/dist/es5/file-selector.js
var FILES_TO_IGNORE = [
  ".DS_Store",
  "Thumbs.db"
];
function fromEvent(evt) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(_a) {
      if (isObject2(evt) && isDataTransfer(evt.dataTransfer)) {
        return [2, getDataTransferFiles(evt.dataTransfer, evt.type)];
      } else if (isChangeEvt(evt)) {
        return [2, getInputFiles(evt)];
      } else if (Array.isArray(evt) && evt.every(function(item) {
        return "getFile" in item && typeof item.getFile === "function";
      })) {
        return [2, getFsHandleFiles(evt)];
      }
      return [2, []];
    });
  });
}
function isDataTransfer(value) {
  return isObject2(value);
}
function isChangeEvt(value) {
  return isObject2(value) && isObject2(value.target);
}
function isObject2(v) {
  return typeof v === "object" && v !== null;
}
function getInputFiles(evt) {
  return fromList(evt.target.files).map(function(file) {
    return toFileWithPath(file);
  });
}
function getFsHandleFiles(handles) {
  return __awaiter(this, void 0, void 0, function() {
    var files;
    return __generator(this, function(_a) {
      switch (_a.label) {
        case 0:
          return [4, Promise.all(handles.map(function(h) {
            return h.getFile();
          }))];
        case 1:
          files = _a.sent();
          return [2, files.map(function(file) {
            return toFileWithPath(file);
          })];
      }
    });
  });
}
function getDataTransferFiles(dt, type) {
  return __awaiter(this, void 0, void 0, function() {
    var items, files;
    return __generator(this, function(_a) {
      switch (_a.label) {
        case 0:
          if (!dt.items)
            return [3, 2];
          items = fromList(dt.items).filter(function(item) {
            return item.kind === "file";
          });
          if (type !== "drop") {
            return [2, items];
          }
          return [4, Promise.all(items.map(toFilePromises))];
        case 1:
          files = _a.sent();
          return [2, noIgnoredFiles(flatten(files))];
        case 2:
          return [2, noIgnoredFiles(fromList(dt.files).map(function(file) {
            return toFileWithPath(file);
          }))];
      }
    });
  });
}
function noIgnoredFiles(files) {
  return files.filter(function(file) {
    return FILES_TO_IGNORE.indexOf(file.name) === -1;
  });
}
function fromList(items) {
  if (items === null) {
    return [];
  }
  var files = [];
  for (var i = 0; i < items.length; i++) {
    var file = items[i];
    files.push(file);
  }
  return files;
}
function toFilePromises(item) {
  if (typeof item.webkitGetAsEntry !== "function") {
    return fromDataTransferItem(item);
  }
  var entry = item.webkitGetAsEntry();
  if (entry && entry.isDirectory) {
    return fromDirEntry(entry);
  }
  return fromDataTransferItem(item);
}
function flatten(items) {
  return items.reduce(function(acc, files) {
    return __spreadArray(__spreadArray([], __read(acc), false), __read(Array.isArray(files) ? flatten(files) : [files]), false);
  }, []);
}
function fromDataTransferItem(item) {
  var file = item.getAsFile();
  if (!file) {
    return Promise.reject("".concat(item, " is not a File"));
  }
  var fwp = toFileWithPath(file);
  return Promise.resolve(fwp);
}
function fromEntry(entry) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(_a) {
      return [2, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
    });
  });
}
function fromDirEntry(entry) {
  var reader = entry.createReader();
  return new Promise(function(resolve, reject) {
    var entries = [];
    function readEntries() {
      var _this = this;
      reader.readEntries(function(batch) {
        return __awaiter(_this, void 0, void 0, function() {
          var files, err_1, items;
          return __generator(this, function(_a) {
            switch (_a.label) {
              case 0:
                if (!!batch.length)
                  return [3, 5];
                _a.label = 1;
              case 1:
                _a.trys.push([1, 3, , 4]);
                return [4, Promise.all(entries)];
              case 2:
                files = _a.sent();
                resolve(files);
                return [3, 4];
              case 3:
                err_1 = _a.sent();
                reject(err_1);
                return [3, 4];
              case 4:
                return [3, 6];
              case 5:
                items = Promise.all(batch.map(fromEntry));
                entries.push(items);
                readEntries();
                _a.label = 6;
              case 6:
                return [2];
            }
          });
        });
      }, function(err) {
        reject(err);
      });
    }
    readEntries();
  });
}
function fromFileEntry(entry) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(_a) {
      return [2, new Promise(function(resolve, reject) {
        entry.file(function(file) {
          var fwp = toFileWithPath(file, entry.fullPath);
          resolve(fwp);
        }, function(err) {
          reject(err);
        });
      })];
    });
  });
}

// ../../node_modules/react-dropzone/dist/es/utils/index.js
init_cjs_shims();
var import_attr_accept = __toESM(require_es());
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function ownKeys2(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys2(Object(source), true).forEach(function(key) {
      _defineProperty2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr2(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr2(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr2(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || (0, import_attr_accept.default)(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize)
        return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize)
        return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize)
      return [false, getTooSmallRejectionErr(minSize)];
    else if (isDefined(maxSize) && file.size > maxSize)
      return [false, getTooLargeRejectionErr(maxSize)];
  }
  return [true, null];
}
function isDefined(value) {
  return value !== void 0 && value !== null;
}
function allFilesAccepted(_ref) {
  var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }
  return files.every(function(file) {
    var _fileAccepted = fileAccepted(file, accept), _fileAccepted2 = _slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
    var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
}
function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }
  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  }
  return Array.prototype.some.call(event.dataTransfer.types, function(type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}
function onDocumentDragOver(event) {
  event.preventDefault();
}
function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function(event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return fns.some(function(fn2) {
      if (!isPropagationStopped(event) && fn2) {
        fn2.apply(void 0, [event].concat(args));
      }
      return isPropagationStopped(event);
    });
  };
}
function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
      var ok = true;
      if (!isMIMEType(mimeType)) {
        console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.'));
        ok = false;
      }
      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
        ok = false;
      }
      return ok;
    }).reduce(function(agg, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
      return _objectSpread(_objectSpread({}, agg), {}, _defineProperty2({}, mimeType, ext));
    }, {});
    return [{
      description: "Files",
      accept: acceptForPicker
    }];
  }
  return accept;
}
function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function(a, _ref6) {
      var _ref7 = _slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
      return [].concat(_toConsumableArray(a), [mimeType], _toConsumableArray(ext));
    }, []).filter(function(v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }
  return void 0;
}
function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}

// ../../node_modules/react-dropzone/dist/es/index.js
var _excluded2 = ["children"];
var _excluded22 = ["open"];
var _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"];
var _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray2(arr) {
  return _arrayWithoutHoles2(arr) || _iterableToArray2(arr) || _unsupportedIterableToArray2(arr) || _nonIterableSpread2();
}
function _nonIterableSpread2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray2(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles2(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray2(arr);
}
function _slicedToArray2(arr, i) {
  return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2();
}
function _nonIterableRest2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray2(o, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit2(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles2(arr) {
  if (Array.isArray(arr))
    return arr;
}
function ownKeys3(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys3(Object(source), true).forEach(function(key) {
      _defineProperty3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties2(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose3(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Dropzone = /* @__PURE__ */ (0, import_react12.forwardRef)(function(_ref, ref) {
  var children = _ref.children, params = _objectWithoutProperties2(_ref, _excluded2);
  var _useDropzone = useDropzone(params), open = _useDropzone.open, props = _objectWithoutProperties2(_useDropzone, _excluded22);
  (0, import_react12.useImperativeHandle)(ref, function() {
    return {
      open
    };
  }, [open]);
  return /* @__PURE__ */ import_react12.default.createElement(import_react12.Fragment, null, children(_objectSpread3(_objectSpread3({}, props), {}, {
    open
  })));
});
Dropzone.displayName = "Dropzone";
var defaultProps2 = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps2;
Dropzone.propTypes = {
  children: import_prop_types4.default.func,
  accept: import_prop_types4.default.objectOf(import_prop_types4.default.arrayOf(import_prop_types4.default.string)),
  multiple: import_prop_types4.default.bool,
  preventDropOnDocument: import_prop_types4.default.bool,
  noClick: import_prop_types4.default.bool,
  noKeyboard: import_prop_types4.default.bool,
  noDrag: import_prop_types4.default.bool,
  noDragEventsBubbling: import_prop_types4.default.bool,
  minSize: import_prop_types4.default.number,
  maxSize: import_prop_types4.default.number,
  maxFiles: import_prop_types4.default.number,
  disabled: import_prop_types4.default.bool,
  getFilesFromEvent: import_prop_types4.default.func,
  onFileDialogCancel: import_prop_types4.default.func,
  onFileDialogOpen: import_prop_types4.default.func,
  useFsAccessApi: import_prop_types4.default.bool,
  autoFocus: import_prop_types4.default.bool,
  onDragEnter: import_prop_types4.default.func,
  onDragLeave: import_prop_types4.default.func,
  onDragOver: import_prop_types4.default.func,
  onDrop: import_prop_types4.default.func,
  onDropAccepted: import_prop_types4.default.func,
  onDropRejected: import_prop_types4.default.func,
  onError: import_prop_types4.default.func,
  validator: import_prop_types4.default.func
};
var es_default = Dropzone;
var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _defaultProps$props = _objectSpread3(_objectSpread3({}, defaultProps2), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
  var acceptAttr = (0, import_react12.useMemo)(function() {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = (0, import_react12.useMemo)(function() {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = (0, import_react12.useMemo)(function() {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop3;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = (0, import_react12.useMemo)(function() {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop3;
  }, [onFileDialogCancel]);
  var rootRef = (0, import_react12.useRef)(null);
  var inputRef = (0, import_react12.useRef)(null);
  var _useReducer = (0, import_react12.useReducer)(reducer, initialState), _useReducer2 = _slicedToArray2(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
  var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = (0, import_react12.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI());
  var onWindowFocus = function onWindowFocus2() {
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function() {
        if (inputRef.current) {
          var files = inputRef.current.files;
          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };
  (0, import_react12.useEffect)(function() {
    window.addEventListener("focus", onWindowFocus, false);
    return function() {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = (0, import_react12.useRef)([]);
  var onDocumentDrop = function onDocumentDrop2(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      return;
    }
    event.preventDefault();
    dragTargetsRef.current = [];
  };
  (0, import_react12.useEffect)(function() {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }
    return function() {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  (0, import_react12.useEffect)(function() {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }
    return function() {
    };
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = (0, import_react12.useCallback)(function(e) {
    if (onError) {
      onError(e);
    } else {
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = (0, import_react12.useCallback)(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray2(dragTargetsRef.current), [event.target]);
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function(files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files,
          accept: acceptAttr,
          minSize,
          maxSize,
          multiple,
          maxFiles,
          validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept,
          isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });
        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function(e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = (0, import_react12.useCallback)(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);
    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {
      }
    }
    if (hasFiles && onDragOver) {
      onDragOver(event);
    }
    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = (0, import_react12.useCallback)(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var targets = dragTargetsRef.current.filter(function(target) {
      return rootRef.current && rootRef.current.contains(target);
    });
    var targetIdx = targets.indexOf(event.target);
    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }
    dragTargetsRef.current = targets;
    if (targets.length > 0) {
      return;
    }
    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });
    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = (0, import_react12.useCallback)(function(files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function(file) {
      var _fileAccepted = fileAccepted(file, acceptAttr), _fileAccepted2 = _slicedToArray2(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
      var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray2(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
      var customErrors = validator ? validator(file) : null;
      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];
        if (customErrors) {
          errors = errors.concat(customErrors);
        }
        fileRejections.push({
          file,
          errors: errors.filter(function(e) {
            return e;
          })
        });
      }
    });
    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      acceptedFiles.forEach(function(file) {
        fileRejections.push({
          file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }
    dispatch({
      acceptedFiles,
      fileRejections,
      type: "setFiles"
    });
    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }
    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }
    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = (0, import_react12.useCallback)(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function(files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        setFiles(files, event);
      }).catch(function(e) {
        return onErrCb(e);
      });
    }
    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]);
  var openFileDialog = (0, import_react12.useCallback)(function() {
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      var opts = {
        multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function(handles) {
        return getFilesFromEvent(handles);
      }).then(function(files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function(e) {
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false;
          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }
    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]);
  var onKeyDownCb = (0, import_react12.useCallback)(function(event) {
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }
    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]);
  var onFocusCb = (0, import_react12.useCallback)(function() {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = (0, import_react12.useCallback)(function() {
    dispatch({
      type: "blur"
    });
  }, []);
  var onClickCb = (0, import_react12.useCallback)(function() {
    if (noClick) {
      return;
    }
    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);
  var composeHandler = function composeHandler2(fn2) {
    return disabled ? null : fn2;
  };
  var composeKeyboardHandler = function composeKeyboardHandler2(fn2) {
    return noKeyboard ? null : composeHandler(fn2);
  };
  var composeDragHandler = function composeDragHandler2(fn2) {
    return noDrag ? null : composeHandler(fn2);
  };
  var stopPropagation = function stopPropagation2(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };
  var getRootProps = (0, import_react12.useMemo)(function() {
    return function() {
      var _ref2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter2 = _ref2.onDragEnter, onDragOver2 = _ref2.onDragOver, onDragLeave2 = _ref2.onDragLeave, onDrop2 = _ref2.onDrop, rest = _objectWithoutProperties2(_ref2, _excluded3);
      return _objectSpread3(_objectSpread3(_defineProperty3({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter2, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver2, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave2, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop2, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = (0, import_react12.useCallback)(function(event) {
    event.stopPropagation();
  }, []);
  var getInputProps = (0, import_react12.useMemo)(function() {
    return function() {
      var _ref3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = _objectWithoutProperties2(_ref3, _excluded4);
      var inputProps = _defineProperty3({
        accept: acceptAttr,
        multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);
      return _objectSpread3(_objectSpread3({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread3(_objectSpread3({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps,
    getInputProps,
    rootRef,
    inputRef,
    open: composeHandler(openFileDialog)
  });
}
function reducer(state, action) {
  switch (action.type) {
    case "focus":
      return _objectSpread3(_objectSpread3({}, state), {}, {
        isFocused: true
      });
    case "blur":
      return _objectSpread3(_objectSpread3({}, state), {}, {
        isFocused: false
      });
    case "openDialog":
      return _objectSpread3(_objectSpread3({}, initialState), {}, {
        isFileDialogActive: true
      });
    case "closeDialog":
      return _objectSpread3(_objectSpread3({}, state), {}, {
        isFileDialogActive: false
      });
    case "setDraggedFiles":
      return _objectSpread3(_objectSpread3({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });
    case "setFiles":
      return _objectSpread3(_objectSpread3({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });
    case "reset":
      return _objectSpread3({}, initialState);
    default:
      return state;
  }
}
function noop3() {
}

// src/components/FileUpload/FileUpload.tsx
var import_ui14 = require("@btc-snxt/ui");

// src/components/FileUpload/FileUploadMedium/FileUploadMedium.tsx
init_cjs_shims();
var import_ui8 = require("@btc-snxt/ui");

// src/components/FileUpload/FileUploadMedium/FileUploadMedium.style.tsx
init_cjs_shims();
var import_styled_components5 = __toESM(require("styled-components"));
var import_ui7 = require("@btc-snxt/ui");
var IconAndTextWrapper = import_styled_components5.default.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 1rem;
  color: ${({ theme }) => theme.colors.black};

  ${import_ui7.Icon} {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.black};
  }

  p {
    margin-bottom: 0;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.black};
  }
`;
var TextWrapper = import_styled_components5.default.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;
var FileType = import_styled_components5.default.p`
  font-size: 0.625rem;
`;

// src/components/FileUpload/FileUploadMedium/FileUploadMedium.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var FileUploadMedium = ({
  title = "Add Logo",
  fileType = "jpeg., png., svg.",
  fileSize = "1920x1080px",
  icon = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui8.IconAdd, {})
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(IconAndTextWrapper, {
    children: [
      icon,
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(TextWrapper, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)("p", {
            children: title
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FileType, {
            children: fileType
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FileType, {
            children: fileSize
          })
        ]
      })
    ]
  });
};
var FileUploadMedium_default = FileUploadMedium;

// src/components/FileUpload/FileUpload.style.tsx
init_cjs_shims();
var import_ui9 = require("@btc-snxt/ui");
var import_styled_components6 = __toESM(require("styled-components"));
var Section = import_styled_components6.default.section`
  width: 100%;
  cursor: pointer;
  border: 1px dashed;
  padding: 0.625rem 1.875rem;
  border-color: ${({ theme }) => theme.colors.black};
  border-width: 0.125rem;

  &.small {
    width: 6.25rem;
    height: 2.25rem;
    border-color: ${({ theme }) => theme.colors.gray1};
    background-color: ${({ theme }) => theme.colors.white};
  }
`;
var StyledImage = import_styled_components6.default.img`
  max-height: 6.25rem;
  position: relative;
`;
var ImageWrapper = import_styled_components6.default.div`
  ${import_ui9.IconClose} {
    display: none;
  }
  &:hover {
    ${import_ui9.IconClose} {
      display: unset;
    }
  }
`;
var StyledIconClose = (0, import_styled_components6.default)(import_ui9.IconClose)`
  cursor: pointer;
  position: absolute;
  background-color: ${({ theme }) => theme.colors.black};
`;

// src/components/FileUpload/FileUpload.tsx
var import_react_i18next4 = require("react-i18next");

// src/components/FileUpload/FileUploadSmall/FileUploadSmall.tsx
init_cjs_shims();
var import_ui11 = require("@btc-snxt/ui");

// src/components/FileUpload/FileUploadSmall/FileUploadSmall.style.tsx
init_cjs_shims();
var import_styled_components7 = __toESM(require("styled-components"));
var import_ui10 = require("@btc-snxt/ui");
var IconAndTextWrapper2 = import_styled_components7.default.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 0.25rem;
  cursor: pointer;

  ${import_ui10.Icon} {
    background-color: ${({ theme }) => theme.colors.gray1};
  }

  p {
    margin-bottom: 0;
    color: ${({ theme }) => theme.colors.gray1};
  }
`;
var TextWrapper2 = import_styled_components7.default.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: 0.5rem;
`;

// src/components/FileUpload/FileUploadSmall/FileUploadSmall.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var FileUploadSmall = ({
  title = "Add background",
  fileType = "jpeg., png., svg.",
  fileSize = "100x100px",
  icon = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui11.IconImage, {})
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(IconAndTextWrapper2, {
    children: [
      icon,
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(TextWrapper2, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)("p", {
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("strong", {
              children: title
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)("p", {
            children: fileType
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)("p", {
            children: fileSize
          })
        ]
      })
    ]
  });
};
var FileUploadSmall_default = FileUploadSmall;

// src/components/FileUpload/FileUploadBig/FileUploadBig.tsx
init_cjs_shims();

// src/components/FileUpload/FileUploadBig/FileUploadBig.style.tsx
init_cjs_shims();
var import_styled_components8 = __toESM(require("styled-components"));
var import_ui12 = require("@btc-snxt/ui");
var IconAndTextWrapper3 = import_styled_components8.default.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 1rem;

  ${import_ui12.Icon} {
    cursor: pointer;
  }

  p {
    margin-bottom: 0;
    cursor: pointer;
  }
`;
var TextWrapper3 = import_styled_components8.default.div`
  display: flex;
  flex-direction: column;
`;
var DownloadText = import_styled_components8.default.p`
  font-weight: bolder;
  text-decoration-line: underline;
`;

// src/components/FileUpload/FileUploadBig/FileUploadBig.tsx
var import_ui13 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var FileUploadBig = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(IconAndTextWrapper3, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui13.IconUpload, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(TextWrapper3, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("p", {
            children: [
              "Drop files here or ",
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)("strong", {
                children: "browse"
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DownloadText, {
            children: "Download a sample file"
          })
        ]
      })
    ]
  });
};
var FileUploadBig_default = FileUploadBig;

// src/components/FileUpload/FileUpload.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var oneFile = 1;
var manyFiles = 10;
var smallDropzone = "small";
var mediumDropzone = "medium";
var FileUpload = (props) => {
  const [files, setFiles] = (0, import_react13.useState)([]);
  const context = useDesigner();
  const { t } = (0, import_react_i18next4.useTranslation)();
  const BodyElement = () => {
    switch (props.type) {
      case smallDropzone:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FileUploadSmall_default, {
          ...props
        });
      case mediumDropzone:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FileUploadMedium_default, {
          ...props
        });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FileUploadBig_default, {});
  };
  const fileCount = () => {
    return props.type ? oneFile : manyFiles;
  };
  const onDrop = (0, import_react13.useCallback)((acceptedFiles, fileRejections) => {
    if (fileRejections.length > 1) {
      return (0, import_ui14.error)(t("survey.error.error_multiple"));
    } else if (fileRejections.length > 0) {
      return (0, import_ui14.error)(t("survey.error.error_type"));
    }
    setFiles(
      acceptedFiles.map(
        (file) => Object.assign(file, {
          preview: URL.createObjectURL(file)
        })
      )
    );
    if (props.uploadedFile) {
      props.uploadedFile(acceptedFiles);
    } else {
      context.setLogo(acceptedFiles);
      context.setLogoObject(acceptedFiles);
    }
  }, []);
  const thumbs = files.map((file, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ImageWrapper, {
      children: [
        context.logoObject.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledImage, {
          src: context.logoObject[0].preview,
          onLoad: () => {
            URL.revokeObjectURL(file.preview);
          }
        }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledImage, {
          src: file.preview,
          onLoad: () => {
            URL.revokeObjectURL(file.preview);
          }
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIconClose, {
          onClick: () => setFiles([])
        })
      ]
    })
  }, index2));
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: context.logoObject.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ImageWrapper, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledImage, {
            src: context.logoObject[0].preview
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIconClose, {
            onClick: () => {
              setFiles([]);
              context.setLogo("");
              context.setLogoObject({});
            }
          })
        ]
      })
    }) : props.emailLogo ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ImageWrapper, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledImage, {
            src: props.emailLogo
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIconClose, {
            onClick: () => {
              props.uploadedFile("");
            }
          })
        ]
      })
    }) : files.length == 0 && context.logo == "" ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ImageWrapper, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIconClose, {
            onClick: () => {
              setFiles([]);
              context.setLogo("");
              context.setLogoObject({});
            }
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(es_default, {
          onDrop,
          maxFiles: fileCount(),
          accept: { "image/*": [".png", ".jpeg", ".jpg"] },
          children: ({ getRootProps, getInputProps }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
            ...getRootProps(),
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Section, {
              className: props.type ? props.type : "",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("input", {
                  ...getInputProps()
                }),
                BodyElement()
              ]
            })
          })
        })
      ]
    }) : context.logo != "" ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ImageWrapper, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledImage, {
          src: context.logo
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIconClose, {
          onClick: () => {
            setFiles([]);
            context.setLogo("");
            context.setLogoObject({});
          }
        })
      ]
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: thumbs
    })
  });
};
var FileUpload_default = FileUpload;

// src/components/Survey/Designer/DesignerPreviewer/items/IntroItemDesignerPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var IntroItemDesignerPreviewer = () => {
  const mainTextName = "main_text";
  const subTextName = "sub_text";
  const { t } = (0, import_react_i18next5.useTranslation)();
  const { innerWidth } = (0, import_ui15.useWindowSize)();
  const context = useDesigner();
  const [logo, setLogo] = (0, import_react14.useState)(context.logo);
  (0, import_react14.useEffect)(() => {
    setLogo(context.logo);
  }, [context.logo]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewer, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewerBackgroundColor, {
      backgroundColor: import_ui15.Theme.colors.white,
      children: innerWidth < import_ui15.BOOTSTRAP_SM_CONTAINER_WIDTH ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PoweredBySeeNext, {}),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerBody, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewerGroup, {
                children: context.logoObject.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FileUpload_default, {
                  type: "medium"
                }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FileUpload_default, {
                    type: "medium"
                  })
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledIntroPage, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                    dataName: `${mainTextName}.data`
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIntroSubtext, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                      dataName: `${subTextName}.data`
                    })
                  })
                ]
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButton, {
                type: "button",
                value: t("survey.form.button_start", { lng: context.locale })
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPrivacyPolicySmall, {
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPrivacyPolicy, {
              children: t("settings.privacy_policy", { lng: context.locale })
            })
          })
        ]
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerBody, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewerGroup, {
                children: context.logoObject.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FileUpload_default, {
                  type: "medium"
                }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FileUpload_default, {
                    type: "medium"
                  })
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledIntroPage, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                    dataName: `${mainTextName}.data`
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIntroSubtext, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                      dataName: `${subTextName}.data`
                    })
                  })
                ]
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButton, {
                type: "button",
                value: t("survey.form.button_start", { lng: context.locale })
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerFooter, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPrivacyPolicy, {
                children: t("settings.privacy_policy", { lng: context.locale })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PoweredBySeeNext, {})
            ]
          })
        ]
      })
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/items/MultiSelectionQuestionItemDesignerPreviewer.tsx
init_cjs_shims();
var import_ui16 = require("@btc-snxt/ui");
var import_react_i18next6 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var MultiSelectionQuestionItemDesignerPreviewer = () => {
  const questionTextName = "question_text";
  const answersName = "answers";
  const context = useDesigner();
  const { t } = (0, import_react_i18next6.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewer, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledSingleSelectDesignerPreviewer, {
      backgroundColor: hexToRGB(context.color, import_ui16.Theme.opacity.background),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LinearProgressBar_default, {
          currentValue: context.questionIndex,
          total: context.size,
          color: context.color
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerQuestionPreviewerBody, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContainer, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionTitleIndex, {
                children: `${context.questionIndex + 1}.`
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContent, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledQuestionTitle, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                      dataName: `${questionTextName}.data`
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledAnswerPreviewerGroup, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableMultiSelectionFieldPreviewer, {
                      dataName: `${answersName}.data`
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButton, {
                    type: "button",
                    value: t("survey.form.button_continue", { lng: context.locale })
                  })
                ]
              })
            ]
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerFooter, {
          navigation: true,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NavigationButtons, {}),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PoweredBySeeNext, {})
          ]
        })
      ]
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/items/OpinionScaleQuestionItemDesignerPreviewer.tsx
init_cjs_shims();
var import_ui17 = require("@btc-snxt/ui");
var import_react_i18next7 = require("react-i18next");
var import_formik10 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var OpinionScaleQuestionItemDesignerPreviewer = () => {
  const questionTextName = "question_text";
  const answersName = "answers";
  const answersDataName = `${answersName}.data`;
  const context = useDesigner();
  const { t } = (0, import_react_i18next7.useTranslation)();
  const [opinionScaleType] = (0, import_formik10.useField)(`${answersDataName}.type`);
  const opinionScaleQuestionBody = () => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LinearProgressBar_default, {
          currentValue: context.questionIndex,
          total: context.size,
          color: context.color
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewerBody, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContainer, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionTitleIndex, {
                children: `${context.questionIndex + 1}.`
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContent, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewerGroup, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledQuestionTitle, {
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                        dataName: `${questionTextName}.data`
                      })
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledAnswerPreviewerOpinionScaleGroup, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ScaleFieldPreviewer, {
                      dataName: `${answersDataName}.count`,
                      typeName: `${answersDataName}.type`
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButton, {
                    type: "button",
                    value: t("survey.form.button_continue", { lng: context.locale })
                  })
                ]
              })
            ]
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerFooter, {
          navigation: true,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NavigationButtons, {}),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PoweredBySeeNext, {})
          ]
        })
      ]
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewer, {
    children: opinionScaleType.value !== "number" /* Number */ ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledOpinionScaleDesignerPreviewer, {
      backgroundColor: hexToRGB(context.color, import_ui17.Theme.opacity.background),
      children: opinionScaleQuestionBody()
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledSingleSelectDesignerPreviewer, {
      backgroundColor: hexToRGB(context.color, import_ui17.Theme.opacity.background),
      children: opinionScaleQuestionBody()
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/items/SingleSelectionQuestionItemDesignerPreviewer.tsx
init_cjs_shims();
var import_ui18 = require("@btc-snxt/ui");
var import_react_i18next8 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var SingleSelectionQuestionItemDesignerPreviewer = () => {
  const questionTextName = "question_text";
  const answersName = "answers";
  const { t } = (0, import_react_i18next8.useTranslation)();
  const context = useDesigner();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewer, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledSingleSelectDesignerPreviewer, {
      backgroundColor: hexToRGB(context.color, import_ui18.Theme.opacity.background),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LinearProgressBar_default, {
          currentValue: context.questionIndex,
          total: context.size,
          color: context.color
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerQuestionPreviewerBody, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContainer, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionTitleIndex, {
                children: `${context.questionIndex + 1}.`
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContent, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledQuestionTitle, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                      dataName: `${questionTextName}.data`
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledAnswerPreviewerGroup, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableSingleSelectionFieldPreviewer, {
                      dataName: `${answersName}.data`
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButton, {
                    type: "button",
                    value: t("survey.form.button_continue", { lng: context.locale })
                  })
                ]
              })
            ]
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerFooter, {
          navigation: true,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NavigationButtons, {}),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PoweredBySeeNext, {})
          ]
        })
      ]
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/items/TextQuestionItemDesignerPreviewer.tsx
init_cjs_shims();
var import_ui19 = require("@btc-snxt/ui");
var import_react_i18next9 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var TextQuestionItemDesignerPreviewer = () => {
  const questionTextName = "question_text";
  const answersName = "answers";
  const context = useDesigner();
  const { t } = (0, import_react_i18next9.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewer, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerBackgroundColor, {
      backgroundColor: hexToRGB(context.color, import_ui19.Theme.opacity.background),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LinearProgressBar_default, {
          currentValue: context.questionIndex,
          total: context.size,
          color: context.color
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerQuestionPreviewerBody, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContainer, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionTitleIndex, {
                children: `${context.questionIndex + 1}.`
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContent, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewerGroup, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledQuestionTitle, {
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                        dataName: `${questionTextName}.data`
                      })
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTextInputPreviewerGroup, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableTextAreaFieldPreviewer, {
                      dataName: `${answersName}.data`
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButton, {
                    type: "button",
                    value: t("survey.form.button_continue", { lng: context.locale })
                  })
                ]
              })
            ]
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerFooter, {
          navigation: true,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NavigationButtons, {}),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PoweredBySeeNext, {})
          ]
        })
      ]
    })
  });
};

// src/components/Survey/Designer/DesignerFormatter/DesignerFormatter.style.tsx
var StyledFormatter = import_styled_components9.default.div`
  background-color: ${({ theme }) => theme.colors.gray5};
  padding: 1rem;

  ${import_ui20.breakpointUp.MD} {
    padding: 0;
    background-color: transparent;
  }
`;
var StyledSwitchLabel = import_styled_components9.default.div`
  display: flex;
  align-items: center;
  margin: 0 0.5rem;
  font-size: 1rem;
`;
var SwitchWrapper = import_styled_components9.default.div`
  display: flex;
  float: right;
  margin-top: 0.5rem;
`;
var StyledFormatterGroup = import_styled_components9.default.div`
  font-size: 1rem;
  display: flex;
  flex-wrap: wrap;

  & > * {
    &:first-child,
    &:nth-child(2) {
      flex-basis: 100%;
    }

    &:nth-child(4n - 1) {
      flex: 1;
    }

    &:nth-child(4n) {
      flex: 1.3;
    }

    &:nth-child(4n + 1),
    &:nth-child(4n + 2) {
      flex-basis: 100%;
    }
  }
`;
var StyledFormatterLabel = import_styled_components9.default.label`
  text-transform: capitalize;
  margin-top: 0.5rem;
  font-size: 1rem;
`;
var StyledFormatterLabelBlock = import_styled_components9.default.label`
  display: block;
  text-transform: capitalize;
  margin-top: 0.5rem;
  font-size: 1rem;
`;
var StyledButton = (0, import_styled_components9.default)(import_ui20.PrimaryButton)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.$backgroundColor || props.theme.colors.blue};
  padding: 0.75rem 2rem;
  gap: 0.75rem;
  min-width: 10rem;
  min-height: 3rem;
  border-radius: 0.75rem;
  font-size: 1.25rem;
  border: none;

  &:hover,
  &:focus,
  &:active {
    border: unset;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${(props) => props.$backgroundColor || props.theme.colors.blue};
  }
`;
var StyledText = import_styled_components9.default.div`
  display: flex;
  gap: 0.25rem;
  color: rgba(0, 0, 0, 0.7);
  font-size: 0.875rem;
`;
var StyledOrPressText = import_styled_components9.default.div`
  font-weight: 400;
`;
var StyledEnterText = import_styled_components9.default.div`
  display: flex;
  gap: 0.5rem;
  font-weight: 500;

  ${import_ui20.IconPressEnter} {
    background-color: ${({ theme }) => theme.colors.black};
  }
`;
var ButtonWrapper = import_styled_components9.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;
var StyledInputFieldWithButton = import_styled_components9.default.div`
  display: flex;
  gap: 0.5rem;

  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
`;
var StyledTitleFormatter = import_styled_components9.default.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;
`;
var StyledIconHelp = (0, import_styled_components9.default)(import_ui20.IconHelp)`
  background-color: ${({ theme }) => theme.colors.red};
  scale: 0.8;
`;
var StyledTooltip = (0, import_styled_components9.default)(UncontrolledTooltip)`
  .tooltip-inner {
    background-color: ${({ theme }) => theme.colors.gray1};
    max-width: 20rem;
  }
  .tooltip .tooltip-arrow::before {
    border-top-color: ${({ theme }) => theme.colors.gray1};
  }
`;
var EmailDataWrapper = import_styled_components9.default.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 1rem;
  gap: 0.2rem;
`;
var EmailLabelWrapper = (0, import_styled_components9.default)(StyledTitleFormatter)`
  padding-top: 0.5rem;
`;
var WysiwygEditorWraper = import_styled_components9.default.div`
  display: ${(props) => props.$switch ? "block" : "none"};
`;
var EmailContentInput = (0, import_styled_components9.default)(StyledTextAreaFieldDesignerPreviewer)`
  padding: 0.5rem;
  border-radius: 0.25rem;
  font-size: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray2};
  max-height: 11.25rem;
  overflow: overlay;
  @-moz-document url-prefix() {
    overflow: auto;
  }
  color: ${({ theme }) => theme.colors.gray};
`;
var StyledLabel = (0, import_styled_components9.default)(StyledFormatterLabel)`
  text-transform: none;
  margin-top: 0;
`;

// src/components/Survey/Designer/DesignerFormatter/elements/DropdownField.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var DropdownField = ({
  dataName = "name",
  enumType
}) => {
  const { t } = (0, import_react_i18next10.useTranslation)();
  const [typeField, , typeFieldHelpers] = (0, import_formik11.useField)(dataName);
  const handleOnChange = (option) => {
    const type = option.value;
    typeFieldHelpers.setValue(type);
  };
  const formatValue = (type) => {
    const key = `${dataName}.${type}`;
    return { value: type, label: t(key) };
  };
  const options = Object.values(enumType).map((value) => {
    return formatValue(value);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatterGroup, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormatterLabel, {
        htmlFor: dataName,
        children: t(dataName)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui21.Select, {
        name: dataName,
        classNamePrefix: "react-select",
        onChange: (option) => {
          handleOnChange(option);
        },
        options,
        value: formatValue(typeField.value)
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/elements/ScaleField.tsx
init_cjs_shims();
var import_react15 = require("react");
var import_react_i18next11 = require("react-i18next");
var import_formik12 = require("formik");
var import_ui22 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var ScaleField = ({
  dataName = "count",
  typeName = "type"
}) => {
  const { t } = (0, import_react_i18next11.useTranslation)();
  const context = useDesigner();
  const [dataNameField, , dataNameFieldHelpers] = (0, import_formik12.useField)(dataName);
  (0, import_react15.useEffect)(() => {
    let itemsLength = dataNameField.value;
    if (itemsLength < 1) {
      itemsLength = 1;
    }
    if (itemsLength > 11) {
      itemsLength = 11;
    }
    dataNameFieldHelpers.setValue(itemsLength);
  }, [dataNameField.value]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormatterGroup, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DropdownField, {
          enumType: OpinionScaleType,
          dataName: typeName
        })
      }),
      context.surveyType !== "nps" /* NPS */ ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatterGroup, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormatterLabel, {
            htmlFor: dataName,
            children: t(dataName)
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik12.Field, {
            as: import_ui22.NumberInput,
            id: dataName,
            name: dataName
          })
        ]
      }) : null
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/elements/TranslatableField.tsx
init_cjs_shims();
var import_react_i18next12 = require("react-i18next");
var import_formik13 = require("formik");
var import_ui23 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableField = ({
  dataName = "data"
}) => {
  const { t } = (0, import_react_i18next12.useTranslation)();
  const context = useDesigner();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatterGroup, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledTitleFormatter, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormatterLabel, {
            htmlFor: dataName,
            children: t(dataName)
          }),
          context.surveyType === "loyalty_intentions" /* LoyaltyIntentions */ && context.type === "single_selection_question" /* SingleSelectionQuestion */ ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIconHelp, {
                id: "my-tooltip" + context.id
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTooltip, {
                placement: "top",
                target: "my-tooltip" + context.id,
                children: t("survey.create.tooltip")
              })
            ]
          }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {})
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik13.Field, {
        as: import_ui23.Input,
        id: dataName,
        name: `${dataName}.${context.locale}`
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/elements/TranslatableInputField.tsx
init_cjs_shims();
var import_react_i18next13 = require("react-i18next");
var import_formik14 = require("formik");
var import_ui24 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableInputField = ({
  dataName = "data"
}) => {
  const { t } = (0, import_react_i18next13.useTranslation)();
  const context = useDesigner();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatterGroup, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormatterLabel, {
        htmlFor: dataName,
        children: t(dataName)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik14.Field, {
        as: import_ui24.Input,
        id: dataName,
        name: `${dataName}.${context.locale}`
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/elements/TranslatableMultiSelectionField.tsx
init_cjs_shims();
var import_react16 = require("react");
var import_react_i18next14 = require("react-i18next");
var import_formik15 = require("formik");
var import_ui25 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableMultiSelectionField = ({
  dataName = "",
  parentName = ""
}) => {
  const { t } = (0, import_react_i18next14.useTranslation)();
  const [options, setOptions] = (0, import_react16.useState)();
  const context = useDesigner();
  const { values } = (0, import_formik15.useFormikContext)();
  const surveyType = "individual_survey" /* IndividualSurvey */;
  (0, import_react16.useEffect)(() => {
    const formikOptions = values[parentName].data;
    setOptions(formikOptions);
  }, [parentName, values[parentName].data]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatterGroup, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormatterLabel, {
        htmlFor: dataName,
        children: t(dataName)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik15.FieldArray, {
          name: dataName,
          render: (arrayHelpers) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
            children: options !== void 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_ui25.SecondaryButton, {
                  onClick: () => arrayHelpers.insert(options.length, { en: "", lt: "", ru: "" }),
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui25.IconAdd, {}),
                    " ",
                    t("common.add")
                  ]
                }),
                options.map((option, index2) => {
                  const key = `${context.id}.${dataName}.${index2}.previewer`;
                  const formikId = `${dataName}.${index2}`;
                  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledInputFieldWithButton, {
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik15.Field, {
                        as: import_ui25.Input,
                        id: formikId,
                        name: `${formikId}.${context.locale}`,
                        value: option[context.locale] || ""
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui25.SecondaryButton, {
                        onClick: () => arrayHelpers.remove(index2),
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui25.IconRemove, {})
                      })
                    ]
                  }, key);
                })
              ]
            })
          })
        })
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/elements/TranslatableSingleSelectionField.tsx
init_cjs_shims();
var import_react17 = require("react");
var import_react_i18next15 = require("react-i18next");
var import_formik16 = require("formik");
var import_ui26 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableSingleSelectionField = ({
  dataName = "",
  parentName = ""
}) => {
  const { t } = (0, import_react_i18next15.useTranslation)();
  const [options, setOptions] = (0, import_react17.useState)();
  const context = useDesigner();
  const { values } = (0, import_formik16.useFormikContext)();
  const surveyType = "individual_survey" /* IndividualSurvey */;
  (0, import_react17.useEffect)(() => {
    const formikOptions = values[parentName].data;
    setOptions(formikOptions);
  }, [parentName, values[parentName].data]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatterGroup, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormatterLabel, {
        htmlFor: dataName,
        children: t(dataName)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik16.FieldArray, {
          name: dataName,
          render: (arrayHelpers) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
            children: options !== void 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_ui26.SecondaryButton, {
                  onClick: () => arrayHelpers.insert(options.length, { en: "", lt: "" }),
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui26.IconAdd, {}),
                    " ",
                    t("common.add")
                  ]
                }),
                options.map((option, index2) => {
                  const key = `${context.id}.${dataName}.${index2}.previewer`;
                  const formikId = `${dataName}.${index2}`;
                  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledInputFieldWithButton, {
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik16.Field, {
                        as: import_ui26.Input,
                        id: formikId,
                        name: `${formikId}.${context.locale}`,
                        value: option[context.locale] || ""
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui26.SecondaryButton, {
                        onClick: () => arrayHelpers.remove(index2),
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui26.IconRemove, {})
                      })
                    ]
                  }, key);
                })
              ]
            })
          })
        })
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/elements/TranslatableTextAreaField.tsx
init_cjs_shims();
var import_react_i18next16 = require("react-i18next");
var import_formik17 = require("formik");
var import_ui27 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableTextAreaField = ({
  dataName = "data"
}) => {
  const { t } = (0, import_react_i18next16.useTranslation)();
  const context = useDesigner();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatterGroup, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormatterLabel, {
        htmlFor: dataName,
        children: t(dataName)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik17.Field, {
        as: import_ui27.Input,
        id: dataName,
        name: `${dataName}.${context.locale}`
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/elements/ContinueButton.tsx
init_cjs_shims();
var import_ui28 = require("@btc-snxt/ui");
var import_react_i18next17 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ContinueButton = (props) => {
  const { t } = (0, import_react_i18next17.useTranslation)();
  const context = useDesigner();
  const { innerWidth } = (0, import_ui28.useWindowSize)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ButtonWrapper, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledButton, {
        $backgroundColor: context.color,
        type: props.type,
        children: props.value
      }),
      innerWidth < import_ui28.BOOTSTRAP_SM_CONTAINER_WIDTH ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {}) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledText, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledOrPressText, {
            children: t("survey.form.button_or_press", { lng: context.locale })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledEnterText, {
            children: [
              t("survey.form.button_enter", { lng: context.locale }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui28.IconPressEnter, {})
            ]
          })
        ]
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/items/ExtraItemFormatter.tsx
init_cjs_shims();
var import_jsx_runtime = require("react/jsx-runtime");
var ExtraItemFormatter = () => {
  const mainText = "main_text";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormatter, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableInputField, {
      dataName: `${mainText}.data`,
      parentName: mainText
    })
  });
};

// src/components/Survey/Designer/DesignerFormatter/items/IntroItemFormatter.tsx
init_cjs_shims();
var import_jsx_runtime = require("react/jsx-runtime");
var IntroItemFormatter = () => {
  const mainTextName = "main_text";
  const subTextName = "sub_text";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatter, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableField, {
        dataName: `${mainTextName}.data`,
        parentName: mainTextName
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableField, {
        dataName: `${subTextName}.data`,
        parentName: subTextName
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/items/MultiSelectionQuestionItemFormatter.tsx
init_cjs_shims();

// src/components/Survey/Designer/DesignerFormatter/elements/RequiredSwitch.tsx
init_cjs_shims();
var import_ui29 = require("@btc-snxt/ui");
var import_formik18 = require("formik");
var import_react18 = require("react");
var import_react_i18next18 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var RequiredSwitch = ({ dataName = "required" }) => {
  var _a;
  const { t } = (0, import_react_i18next18.useTranslation)();
  const [dataNameField, , dataNameFieldHelpers] = (0, import_formik18.useField)(dataName);
  const [required, setrequired] = (0, import_react18.useState)((_a = dataNameField.value) != null ? _a : true);
  (0, import_react18.useEffect)(() => {
    dataNameFieldHelpers.setValue(required);
  }, [dataNameField.value, required]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SwitchWrapper, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledSwitchLabel, {
        children: required ? t("survey.create.required") : t("survey.create.not_required")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui29.Switch, {
        checked: required,
        onChange: () => {
          setrequired(!required);
        }
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/items/MultiSelectionQuestionItemFormatter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var MultiSelectionQuestionItemFormatter = () => {
  const questionTextName = "question_text";
  const answersName = "answers";
  const requiredName = "required";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatter, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableField, {
        dataName: `${questionTextName}.data`,
        parentName: questionTextName
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableMultiSelectionField, {
        dataName: `${answersName}.data`,
        parentName: answersName
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RequiredSwitch, {
        dataName: `${requiredName}.data`
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/items/OpinionScaleQuestionItemFormatter.tsx
init_cjs_shims();
var import_formik19 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var OpinionScaleQuestionItemFormatter = () => {
  const questionTextName = "question_text";
  const answersName = "answers";
  const requiredName = "required";
  const answersDataName = `${answersName}.data`;
  const context = useDesigner();
  const surveyTypes = ["individual_survey" /* IndividualSurvey */, "nps" /* NPS */];
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatter, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableField, {
        dataName: `${questionTextName}.data`,
        parentName: questionTextName
      }),
      surveyTypes.includes(context.surveyType) ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ScaleField, {
            dataName: `${answersDataName}.count`,
            typeName: `${answersDataName}.type`
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik19.Field, {
            name: `${answersDataName}.type`,
            children: ({ field }) => field.value === "number" /* Number */ && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableField, {
                  dataName: `${answersDataName}.min_description.data`,
                  parentName: `${answersDataName}.min_description`
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableField, {
                  dataName: `${answersDataName}.max_description.data`,
                  parentName: `${answersDataName}.max_description`
                })
              ]
            })
          })
        ]
      }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {}),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RequiredSwitch, {
        dataName: `${requiredName}.data`
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/items/SingleSelectionQuestionItemFormatter.tsx
init_cjs_shims();
var import_jsx_runtime = require("react/jsx-runtime");
var SingleSelectionQuestionItemFormatter = () => {
  const questionTextName = "question_text";
  const answersName = "answers";
  const requiredName = "required";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatter, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableField, {
        dataName: `${questionTextName}.data`,
        parentName: questionTextName
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableSingleSelectionField, {
        dataName: `${answersName}.data`,
        parentName: answersName
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RequiredSwitch, {
        dataName: `${requiredName}.data`
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/items/LikertQuestionItemFormatter.tsx
init_cjs_shims();
var import_formik21 = require("formik");

// src/components/Survey/Designer/DesignerFormatter/elements/TranslatableQuestionGroupField.tsx
init_cjs_shims();
var import_react19 = require("react");
var import_react_i18next19 = require("react-i18next");
var import_formik20 = require("formik");
var import_ui30 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableQuestionGroupField = ({
  dataName = "",
  parentName = ""
}) => {
  const { t } = (0, import_react_i18next19.useTranslation)();
  const [options, setOptions] = (0, import_react19.useState)();
  const context = useDesigner();
  const surveyType = "individual_survey" /* IndividualSurvey */;
  const [nameField] = (0, import_formik20.useField)(dataName);
  (0, import_react19.useEffect)(() => {
    const formikOptions = nameField.value;
    setOptions(formikOptions);
  }, [parentName, nameField.value]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatterGroup, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormatterLabel, {
        htmlFor: dataName,
        children: t(dataName)
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik20.FieldArray, {
          name: dataName,
          render: (arrayHelpers) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
            children: options !== void 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_ui30.SecondaryButton, {
                  onClick: () => arrayHelpers.insert(options.length, { en: "", lt: "" }),
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui30.IconAdd, {}),
                    " ",
                    t("common.add")
                  ]
                }),
                options.map((option, index2) => {
                  const key = `${context.id}.${dataName}.${index2}.previewer`;
                  const formikId = `${dataName}.${index2}`;
                  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledInputFieldWithButton, {
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik20.Field, {
                        as: import_ui30.Input,
                        id: formikId,
                        name: `${formikId}.${context.locale}`,
                        value: option[context.locale] || ""
                      }),
                      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui30.SecondaryButton, {
                        onClick: () => arrayHelpers.remove(index2),
                        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui30.IconRemove, {})
                      })
                    ]
                  }, key);
                })
              ]
            })
          })
        })
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/items/LikertQuestionItemFormatter.tsx
var import_ui31 = require("@btc-snxt/ui");
var import_react_i18next20 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var LikertQuestionItemFormatter = () => {
  const questionTextName = "question_text";
  const questionName = "questions";
  const answerName = "answers";
  const requiredName = "required";
  const questionDataName = "design_traits.data.question_text.data";
  const context = useDesigner();
  const { t } = (0, import_react_i18next20.useTranslation)();
  const [nameField] = (0, import_formik21.useField)(`${questionName}`);
  const newQuestionValues = {
    design_traits: {
      data: {
        color: "#FFFFFF",
        question_text: {
          data: {
            en: "Question text",
            lt: "Klausimo tekstas",
            ru: "\u0422\u0435\u043A\u0441\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"
          }
        }
      }
    },
    required: true
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatter, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableField, {
        dataName: `${questionTextName}.data`,
        parentName: questionTextName
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormatterLabelBlock, {
        children: t("question_text.likert_sub_data")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik21.FieldArray, {
        name: questionName,
        render: (arrayHelpers) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_ui31.SecondaryButton, {
              onClick: () => arrayHelpers.insert(nameField.value.length + 1, newQuestionValues),
              type: "button",
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui31.IconAdd, {}),
                " ",
                "add"
              ]
            }),
            nameField.value.map((_question, index2) => {
              return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledInputFieldWithButton, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik21.Field, {
                    as: import_ui31.Input,
                    id: `${questionName}.${index2}.${questionDataName}`,
                    name: `${questionName}.${index2}.${questionDataName}.${context.locale}`
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui31.SecondaryButton, {
                    onClick: () => arrayHelpers.remove(index2),
                    type: "button",
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui31.IconRemove, {})
                  })
                ]
              }, index2);
            })
          ]
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableQuestionGroupField, {
        dataName: `${answerName}.data`,
        parentName: `${answerName}`
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RequiredSwitch, {
        dataName: `${requiredName}.data`
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/items/TextQuestionItemFormatter.tsx
init_cjs_shims();
var import_jsx_runtime = require("react/jsx-runtime");
var TextQuestionItemFormatter = () => {
  const questionTextName = "question_text";
  const answersName = "answers";
  const requiredName = "required";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatter, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableField, {
        dataName: `${questionTextName}.data`,
        parentName: questionTextName
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableTextAreaField, {
        dataName: `${answersName}.data`,
        parentName: answersName
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RequiredSwitch, {
        dataName: `${requiredName}.data`
      })
    ]
  });
};

// src/components/Survey/Designer/items/BaseDesigner.tsx
init_cjs_shims();
var import_react20 = require("react");
var import_ui34 = require("@btc-snxt/ui");

// src/components/SurveyItemTypeSelect/index.ts
init_cjs_shims();

// src/components/SurveyItemTypeSelect/SurveyItemTypeSelect.tsx
init_cjs_shims();
var import_react_i18next21 = require("react-i18next");
var import_ui32 = require("@btc-snxt/ui");

// src/components/SurveyItemTypeSelect/SurveyItemTypeSelect.style.tsx
init_cjs_shims();
var import_styled_components10 = __toESM(require("styled-components"));
var StyledSurveyTypeSelect = import_styled_components10.default.div`
  font-size: 1rem;
`;

// src/components/SurveyItemTypeSelect/SurveyItemTypeSelect.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var SurveyItemTypeSelect = () => {
  const { t } = (0, import_react_i18next21.useTranslation)();
  const context = useDesigner();
  const isOfSurveyItemType = (type) => {
    return (0, import_ui32.getObjectValues)(SurveyItemType).includes(type);
  };
  const handleOnChange = (option) => {
    const questionType = option.value;
    if (!isOfSurveyItemType(questionType)) {
      return;
    }
    if (context.setType) {
      context.setType(context.id, questionType);
    }
  };
  const formatValue = (itemType) => {
    return { value: itemType, label: t(`builder.${itemType}`) };
  };
  const options = Object.values(SurveyItemType).filter((value) => !(value === "intro" /* Intro */ || value === "outro" /* Outro */)).map((value) => {
    return formatValue(value);
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledSurveyTypeSelect, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui32.Select, {
        classNamePrefix: "react-select",
        placeholder: t("survey.label.survey_list"),
        onChange: (option) => {
          handleOnChange(option);
        },
        options,
        value: formatValue(context.type)
      })
    })
  });
};
var SurveyItemTypeSelect_default = SurveyItemTypeSelect;

// src/components/Survey/Designer/Designer.style.tsx
init_cjs_shims();
var import_styled_components11 = __toESM(require("styled-components"));
var import_ui33 = require("@btc-snxt/ui");
var StyledDesigner = import_styled_components11.default.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  border-radius: 0.25rem;
  border: 1px solid ${({ theme }) => theme.colors.gray3};

  ${import_ui33.breakpointUp.MD} {
    flex-direction: row;
    background-color: ${({ theme }) => theme.colors.gray5};
    padding: 1.5rem;

    & > *:first-child {
      flex: 1 1 35%;
      min-width: 300px;
    }

    & > *:nth-child(2) {
      flex: 1 1 65%;
      background-color: ${({ theme }) => theme.colors.white};
    }
  }

  overflow-x: overlay;
  @-moz-document url-prefix() {
    overflow: auto;
  }
`;
var ACCORDION_HEADER = ".accordion-header";
var ACCORDION_BUTTON = ".accordion-button";
var ACCORDION_ITEM = ".accordion-item";
var ACCORDION_COLLAPSE = ".accordion-collapse";
var ACCORDION_BODY = ".accordion-body";
var StyledDesignerAccordion = (0, import_styled_components11.default)(Accordion)`
  ${ACCORDION_BUTTON}, ${ACCORDION_ITEM}, ${ACCORDION_COLLAPSE}, ${ACCORDION_BODY} {
    background-color: transparent;
    padding: 0;
  }

  ${ACCORDION_BUTTON} {
    ${import_ui33.noGlow};

    box-shadow: none;
    background-color: transparent !important;
    color: ${({ theme }) => theme.colors.gray1};
    text-transform: capitalize;

    display: flex;

    & > *:first-child {
      flex: 1;
    }

    & > * {
      margin-bottom: 0;
    }

    &::after {
      margin-left: 1rem;

      ${import_ui33.breakpointUp.MD} {
        display: none;
      }
    }

    ${import_ui33.breakpointUp.MD} {
      pointer-events: none;
    }
  }

  ${ACCORDION_ITEM} {
    border: none;
  }

  ${ACCORDION_COLLAPSE} {
    ${import_ui33.breakpointUp.MD} {
      &:not(.show) {
        display: initial;
      }
    }
  }

  ${ACCORDION_HEADER} {
    margin: 1rem;

    ${import_ui33.breakpointUp.MD} {
      margin: 0;
    }
  }

  ${ACCORDION_BODY} {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;
var StyledSurveyItemTypeSelect = import_styled_components11.default.div`
  margin-left: 1rem;
  margin-right: 1rem;
  width: 100%;
  ${import_ui33.breakpointUp.MD} {
    margin: 0;
  }
`;
var TypeAndActionsSelectWrapper = import_styled_components11.default.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  ${import_ui33.Icon} {
    vertical-align: middle;
  }
`;
var StyledActions = import_styled_components11.default.div`
  display: flex;
  margin-left: 1rem;
  margin-right: 1rem;
  gap: 0.5rem;

  ${import_ui33.breakpointUp.MD} {
    margin: 0;
  }

  ${import_ui33.PrimaryButton} {
    width: 100%;
  }
`;
var StyledErrors = import_styled_components11.default.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.red};
  border: 1px solid ${({ theme }) => theme.colors.red};
  border-radius: 0.25rem;
  color: ${({ theme }) => theme.colors.white};
  gap: 0.5rem;
`;
var StyledError = import_styled_components11.default.div``;

// src/components/Survey/Designer/items/BaseDesigner.tsx
var import_react_i18next22 = require("react-i18next");
var import_ui35 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var BaseDesigner = ({
  name,
  formatter,
  previewer
}) => {
  const [open, setOpen] = (0, import_react20.useState)("1" /* Open */);
  const { t } = (0, import_react_i18next22.useTranslation)();
  const toggle = (id) => {
    open === id ? setOpen("0" /* Closed */) : setOpen(id);
  };
  const context = useDesigner();
  const onMoveUp = context.onMoveUp;
  const onMoveDown = context.onMoveDown;
  const onRemove = context.onRemove;
  const hasErrors = () => {
    return Boolean(context.errors !== void 0 && context.errors.length > 0);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesigner, {
    backgroundColor: hexToRGB(context.color, import_ui35.Theme.opacity.background),
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerAccordion, {
        open,
        ...{ toggle },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AccordionItem, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AccordionHeader, {
              targetId: "1",
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui34.H4, {
                children: name
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(AccordionBody, {
              accordionId: "1",
              children: [
                context.type !== "intro" /* Intro */ && context.type !== "outro" /* Outro */ && context.isEditable ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(TypeAndActionsSelectWrapper, {
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledSurveyItemTypeSelect, {
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyItemTypeSelect_default, {})
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_ui34.Dropdown, {
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui34.DropdownItemWrapper, {
                          children: onMoveUp != void 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
                            onClick: () => onMoveUp(context.id),
                            children: t("common.move_up")
                          })
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui34.DropdownItemWrapper, {
                          children: onMoveDown != void 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
                            onClick: () => onMoveDown(context.id),
                            children: t("common.move_down")
                          })
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui34.DropdownItemWrapper, {
                          children: onRemove != void 0 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
                            onClick: () => onRemove(context.id),
                            children: t("common.remove")
                          })
                        })
                      ]
                    })
                  ]
                }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {}),
                formatter,
                hasErrors() && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledErrors, {
                  children: context.errors && context.errors.map((error2, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledError, {
                    children: error2
                  }, `error.${index2}`))
                })
              ]
            })
          ]
        })
      }),
      previewer
    ]
  });
};

// src/components/Survey/Designer/items/ExtraItemDesigner.tsx
var import_react_i18next23 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var emptyExtraItemDesignerInitialValues = {
  color: "#FFFFFF",
  main_text: {
    data: {
      en: "Text",
      lt: "Tekstas",
      ru: "\u0422\u0435\u043A\u0441\u0442"
    }
  }
};
var ExtraItemDesigner = () => {
  var _a;
  const { t } = (0, import_react_i18next23.useTranslation)();
  const context = useDesigner();
  const formik = (0, import_formik22.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptyExtraItemDesignerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    enableReinitialize: true,
    validateOnChange: false
  });
  (0, import_react21.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values, context.color);
    }
  }, [formik.values, context.color]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik22.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik23.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BaseDesigner, {
        name: t("builder.extra", { lng: context.locale }),
        formatter: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExtraItemFormatter, {}),
        previewer: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExtraItemDesignerPreviewer, {})
      })
    })
  });
};

// src/components/Survey/Designer/items/IntroItemDesigner.tsx
init_cjs_shims();
var import_react22 = require("react");
var import_formik24 = require("formik");
var import_formik25 = require("formik");
var import_react_i18next24 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var emptyIntroItemDesignerInitialValues = {
  color: "#FFFFFF",
  logo: {
    data: ""
  },
  main_text: {
    data: {
      en: "Main text",
      lt: "Pagrindinis tekstas",
      ru: "\u041E\u0441\u043D\u043E\u0432\u043D\u043E\u0439 \u0442\u0435\u043A\u0441\u0442"
    }
  },
  sub_text: {
    data: {
      en: "Additional text",
      lt: "Papildomas tekstas",
      ru: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442"
    }
  }
};
var IntroItemDesigner = () => {
  var _a;
  const context = useDesigner();
  const { t } = (0, import_react_i18next24.useTranslation)();
  const formik = (0, import_formik24.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptyIntroItemDesignerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    enableReinitialize: true,
    validateOnChange: false
  });
  (0, import_react22.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values, context.color);
    }
  }, [formik.values, context.color]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik24.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik25.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BaseDesigner, {
        name: t("builder.intro"),
        formatter: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IntroItemFormatter, {}),
        previewer: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IntroItemDesignerPreviewer, {})
      })
    })
  });
};

// src/components/Survey/Designer/items/MultiSelectionQuestionItemDesigner.tsx
init_cjs_shims();
var import_react23 = require("react");
var import_formik26 = require("formik");
var import_formik27 = require("formik");
var import_react_i18next25 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var emptyMultiSelectionItemDesignerInitialValues = {
  color: "#FFFFFF",
  question_text: {
    data: {
      en: "Question text",
      lt: "Klausimo tekstas",
      ru: "\u0422\u0435\u043A\u0441\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"
    }
  },
  answers: {
    data: [
      { en: "First", lt: "Pirmas", ru: "\u041F\u0435\u0440\u0432\u044B\u0439" },
      { en: "Second", lt: "Antras", ru: "\u0412\u0442\u043E\u0440\u043E\u0439" },
      { en: "Third", lt: "Tre\u010Dias", ru: "\u0422\u0440\u0435\u0442\u0438\u0439" },
      { en: "Fourth", lt: "Ketvirtas", ru: "\u0427\u0435\u0442\u0432\u0435\u0440\u0442\u044B\u0439" },
      { en: "Fifth", lt: "Penktas", ru: "\u041F\u044F\u0442\u044B\u0439" }
    ]
  },
  required: true
};
var MultiSelectionQuestionItemDesigner = () => {
  var _a;
  const context = useDesigner();
  const { t } = (0, import_react_i18next25.useTranslation)();
  const formik = (0, import_formik26.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptyMultiSelectionItemDesignerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    enableReinitialize: true,
    validateOnChange: false
  });
  (0, import_react23.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values, context.color);
    }
  }, [formik.values, context.color]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik26.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik27.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BaseDesigner, {
        name: t("builder.multi_selection_question", { lng: context.locale }),
        formatter: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiSelectionQuestionItemFormatter, {}),
        previewer: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiSelectionQuestionItemDesignerPreviewer, {})
      })
    })
  });
};

// src/components/Survey/Designer/items/OpinionScaleQuestionItemDesigner.tsx
init_cjs_shims();
var import_react24 = require("react");
var import_formik28 = require("formik");
var import_formik29 = require("formik");
var import_react_i18next26 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var emptyOpinionScaleQuestionItemDesignerInitialValues = {
  color: "#FFFFFF",
  question_text: {
    data: {
      en: "Question text",
      lt: "Klausimo tekstas",
      ru: "\u0422\u0435\u043A\u0441\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"
    }
  },
  answers: {
    data: {
      count: 11,
      type: "emotion" /* Emotion */,
      min_description: {
        data: {
          en: "Disagree",
          lt: "Nesutinku",
          ru: "\u041D\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D"
        }
      },
      max_description: {
        data: {
          en: "Agree",
          lt: "Sutinku",
          ru: "\u0421\u043E\u0433\u043B\u0430\u0441\u0435\u043D"
        }
      }
    }
  },
  required: true
};
var OpinionScaleQuestionItemDesigner = () => {
  var _a;
  const { t } = (0, import_react_i18next26.useTranslation)();
  const context = useDesigner();
  const formik = (0, import_formik28.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptyOpinionScaleQuestionItemDesignerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    enableReinitialize: true,
    validateOnChange: false
  });
  (0, import_react24.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values, context.color);
    }
  }, [formik.values, context.color]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik28.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik29.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BaseDesigner, {
        name: t("builder.opinion_scale_question", { lng: context.locale }),
        formatter: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(OpinionScaleQuestionItemFormatter, {}),
        previewer: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(OpinionScaleQuestionItemDesignerPreviewer, {})
      })
    })
  });
};

// src/components/Survey/Designer/items/SingleSelectionQuestionItemDesigner.tsx
init_cjs_shims();
var import_react25 = require("react");
var import_formik30 = require("formik");
var import_formik31 = require("formik");
var import_react_i18next27 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var emptySingleSelectionItemDesignerInitialValues = {
  color: "#FFFFFF",
  question_text: {
    data: {
      en: "Question text",
      lt: "Klausimo tekstas",
      ru: "\u0422\u0435\u043A\u0441\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"
    }
  },
  answers: {
    data: [
      { en: "First", lt: "Pirmas", ru: "\u041F\u0435\u0440\u0432\u044B\u0439" },
      { en: "Second", lt: "Antras", ru: "\u0412\u0442\u043E\u0440\u043E\u0439" },
      { en: "Third", lt: "Tre\u010Dias", ru: "\u0422\u0440\u0435\u0442\u0438\u0439" },
      { en: "Fourth", lt: "Ketvirtas", ru: "\u0427\u0435\u0442\u0432\u0435\u0440\u0442\u044B\u0439" },
      { en: "Fifth", lt: "Penktas", ru: "\u041F\u044F\u0442\u044B\u0439" }
    ]
  },
  required: true
};
var SingleSelectionQuestionItemDesigner = () => {
  var _a;
  const { t } = (0, import_react_i18next27.useTranslation)();
  const context = useDesigner();
  const formik = (0, import_formik30.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptySingleSelectionItemDesignerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    enableReinitialize: true,
    validateOnChange: false
  });
  (0, import_react25.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values, context.color);
    }
  }, [formik.values, context.color]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik30.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik31.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BaseDesigner, {
        name: t("builder.single_selection_question", { lng: context.locale }),
        formatter: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SingleSelectionQuestionItemFormatter, {}),
        previewer: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SingleSelectionQuestionItemDesignerPreviewer, {})
      })
    })
  });
};

// src/components/Survey/Designer/items/TextQuestionItemDesigner.tsx
init_cjs_shims();
var import_react26 = require("react");
var import_formik32 = require("formik");
var import_formik33 = require("formik");
var import_react_i18next28 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var emptyTextQuestionItemDesignerInitialValues = {
  color: "#000000",
  question_text: {
    data: {
      en: "Question text",
      lt: "Klausimo tekstas",
      ru: "\u0422\u0435\u043A\u0441\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"
    }
  },
  answers: {
    data: {
      en: "Answer",
      lt: "Atsakymas",
      ru: "\u041E\u0442\u0432\u0435\u0447\u0430\u0442\u044C"
    }
  },
  required: true
};
var TextQuestionItemDesigner = () => {
  var _a;
  const { t } = (0, import_react_i18next28.useTranslation)();
  const context = useDesigner();
  const formik = (0, import_formik32.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptyTextQuestionItemDesignerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    enableReinitialize: true,
    validateOnChange: false
  });
  (0, import_react26.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values, context.color);
    }
  }, [formik.values, context.color]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik32.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik33.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BaseDesigner, {
        name: t("builder.text_question", { lng: context.locale }),
        formatter: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextQuestionItemFormatter, {}),
        previewer: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextQuestionItemDesignerPreviewer, {})
      })
    })
  });
};

// src/components/Survey/Designer/items/LikertQuestionItemDesigner.tsx
init_cjs_shims();
var import_react39 = require("react");
var import_formik64 = require("formik");
var import_formik65 = require("formik");
var import_react_i18next43 = require("react-i18next");

// src/components/Survey/Designer/DesignerPreviewer/items/LikertQuestionItemDesignerPreviewer.tsx
init_cjs_shims();
var import_ui50 = require("@btc-snxt/ui");
var import_react_i18next42 = require("react-i18next");
var import_formik63 = require("formik");

// src/components/Survey/Designer/DesignerPreviewer/elements/TranslatableLikertFieldPreviewer.tsx
init_cjs_shims();
var import_react38 = require("react");
var import_formik62 = require("formik");

// src/components/Survey/Previewer/items/ExtraItemPreviewer.tsx
init_cjs_shims();
var import_formik40 = require("formik");
var import_formik41 = require("formik");

// src/components/Survey/Previewer/elements/LogoFieldPreviewer.tsx
init_cjs_shims();
var import_formik34 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var LogoFieldPreviewer2 = ({
  dataName = "data"
}) => {
  const [nameField] = (0, import_formik34.useField)(dataName);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLogoPreviewer, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLogoImagePreviewer, {
      url: nameField.value || opinico_logo_default
    })
  });
};

// src/components/Survey/Previewer/elements/PoweredBySeeNext.tsx
init_cjs_shims();
var import_react_i18next29 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var PoweredBySeeNext2 = () => {
  const { t } = (0, import_react_i18next29.useTranslation)();
  const context = usePreviewer();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledPoweredBySeeNext, {
    children: [
      t("common.powered_by", { lng: context.locale }),
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPoweredBySeeNextImage, {
        url: opinico_logo_default
      })
    ]
  });
};

// src/components/Survey/Previewer/elements/ScaleFieldPreviewer.tsx
init_cjs_shims();
var import_react27 = require("react");
var import_formik35 = require("formik");
var import_ui36 = require("@btc-snxt/ui");
var import_react_i18next30 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ScaleFieldPreviewer2 = ({
  dataName = "count",
  typeName = "type",
  valueName = "value"
}) => {
  const [dataNameField] = (0, import_formik35.useField)(dataName);
  const [valueNameField, , valueNameFieldHelpers] = (0, import_formik35.useField)(valueName);
  const [typeNameField] = (0, import_formik35.useField)(typeName);
  const [items, setItems] = (0, import_react27.useState)([]);
  const context = usePreviewer();
  const { t } = (0, import_react_i18next30.useTranslation)();
  const [hoveredItem, setHoveredItem] = (0, import_react27.useState)(-1);
  (0, import_react27.useEffect)(() => {
    let itemsLength = dataNameField.value;
    if (itemsLength < 0) {
      itemsLength = 0;
    }
    setItems([...new Array(itemsLength)]);
  }, [dataNameField.value]);
  const getValue = () => {
    var _a;
    return (_a = valueNameField.value) != null ? _a : -1;
  };
  const setValue = (value) => {
    valueNameFieldHelpers.setValue(value);
  };
  const getItemClass = (index2) => {
    let className = "";
    if (index2 <= getValue()) {
      className += " active";
    }
    if (index2 <= hoveredItem) {
      className += " hover";
    }
    return {
      className
    };
  };
  const renderStarItem = (index2) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledScaleStarItemDesignerPreviewer, {
      ...getItemClass(index2),
      $hoverColor: hexToRGB(context.color, "0.15"),
      $activeColor: context.color,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIconStar, {})
    });
  };
  const renderEmotionItem = (index2) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledScaleEmotionItemPreviewer, {
      ...getItemClass(index2),
      $iconAngry: angry_emoji_color_default,
      $iconSad: sad_emoji_color_default,
      $iconNeutral: neutral_emoji_color_default,
      $iconHappy: happy_emoji_color_default,
      $iconExcited: excited_emoji_color_default,
      $hoverColor: hexToRGB(context.color, "0.15"),
      children: emotionOrder[items.length - 1][index2]
    });
  };
  const renderNumberItem = (index2) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledScaleNumberItemDesignerPreviewer, {
      ...getItemClass(index2),
      $hoverColor: hexToRGB(context.color, "0.15"),
      $activeColor: context.color,
      children: index2
    });
  };
  const renderSliderItem = (index2) => {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledSliderItemDesignerPreviewer, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui36.Slider, {
        initialValue: index2 - 1,
        max: index2 - 1,
        min: 0,
        step: 1,
        color: context.color,
        setCurrentValue: (value) => setValue(value)
      })
    });
  };
  const renderItem = (index2) => {
    switch (typeNameField.value) {
      case "star" /* Star */:
        return renderStarItem(index2);
      case "emotion" /* Emotion */:
        return renderEmotionItem(index2);
      case "number" /* Number */:
        return renderNumberItem(index2);
      case "slider" /* Slider */:
        return renderSliderItem(index2);
    }
    return null;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: typeNameField.value === "slider" /* Slider */ ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
      children: renderItem(items.length)
    }) : typeNameField.value === "number" /* Number */ ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(OptionsAndExplanationsWrapper, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledScaleFieldDesignerPreviewer, {
          children: items.map((_, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledScaleFieldItemDesignerPreviewerWrapper, {
            onClick: () => setValue(index2),
            onMouseEnter: () => setHoveredItem(index2),
            onMouseLeave: () => setHoveredItem(-1),
            children: renderItem(index2)
          }, index2))
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledExplanations, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledExplanationRow, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledExplanationText, {
                children: [
                  "0 -",
                  " ",
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExplanationTranslatable, {
                    dataName: `${typeName.replace(".type", "")}.min_description.data`,
                    mode: "previewer"
                  })
                ]
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledExplanationRow, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledExplanationText, {
                children: [
                  items.length - 1,
                  " -",
                  " ",
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExplanationTranslatable, {
                    dataName: `${typeName.replace(".type", "")}.max_description.data`,
                    mode: "previewer"
                  })
                ]
              })
            })
          ]
        })
      ]
    }) : typeNameField.value === "star" /* Star */ || typeNameField.value === "emotion" /* Emotion */ ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledStarScaleFieldDesignerPreviewer, {
      children: items.map((_, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledStarScaleFieldItemDesignerPreviewerWrapper, {
        onClick: () => setValue(index2),
        onMouseEnter: () => setHoveredItem(index2),
        onMouseLeave: () => setHoveredItem(-1),
        children: renderItem(index2)
      }, index2))
    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledScaleFieldDesignerPreviewer, {
      children: items.map((_, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
        onClick: () => setValue(index2),
        onMouseEnter: () => setHoveredItem(index2),
        onMouseLeave: () => setHoveredItem(-1),
        children: renderItem(index2)
      }, index2))
    })
  });
};

// src/components/Survey/Previewer/elements/TranslatableFieldPreviewer.tsx
init_cjs_shims();
var import_formik36 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableFieldPreviewer2 = ({
  dataName = "data"
}) => {
  const context = usePreviewer();
  const [nameField] = (0, import_formik36.useField)(`${dataName}.${context.locale}`);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFieldDesignerPreviewer, {
    children: nameField.value
  });
};

// src/components/Survey/Previewer/elements/TranslatableMultiSelectionFieldPreviewer.tsx
init_cjs_shims();
var import_react28 = require("react");
var import_formik37 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableMultiSelectionFieldPreviewer2 = ({ dataName = "data", valueName = "value" }) => {
  const context = usePreviewer();
  const [dataField] = (0, import_formik37.useField)(dataName);
  const [valueField, , valueFieldHelpers] = (0, import_formik37.useField)(valueName);
  const maxSize = 100;
  const [isItemChecked, setIsItemChecked] = (0, import_react28.useState)(
    Array(maxSize).fill(false)
  );
  (0, import_react28.useEffect)(() => {
    const newIsItemChecked = [...isItemChecked];
    if (valueField.value !== void 0) {
      valueField.value.forEach((item) => {
        newIsItemChecked[item] = true;
      });
    }
    setIsItemChecked(newIsItemChecked);
  }, [dataField.value]);
  const getCheckedValues = (array2) => {
    return array2.flatMap((value, index2) => value ? index2 : []);
  };
  const handleOnClickCheckbox = (index2) => {
    const newIsItemChecked = [...isItemChecked];
    newIsItemChecked[index2] = !newIsItemChecked[index2];
    valueFieldHelpers.setValue(getCheckedValues(newIsItemChecked));
    setIsItemChecked(newIsItemChecked);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledSelectFieldDesignerPreviewer, {
    $isPreviewModeMobile: context.mobileModeEnabled,
    children: dataField.value.map((item, index2) => {
      const id = `${context.id}.${dataName}.${index2}.previewer`;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledMultiSelectFormGroupPreviewer, {
        check: true,
        onClick: () => handleOnClickCheckbox(index2),
        $active: isItemChecked[index2],
        $backgroundColor: context.color,
        $icon: check_default,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLabelPreviewer, {
            check: true,
            children: item[context.locale]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputPreviewer, {
            type: "checkbox",
            id,
            checked: isItemChecked[index2],
            readOnly: true
          })
        ]
      }, id);
    })
  });
};

// src/components/Survey/Previewer/elements/TranslatableSingleSelectionFieldPreviewer.tsx
init_cjs_shims();
var import_formik38 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableSingleSelectionFieldPreviewer2 = ({ dataName = "data", valueName = "value" }) => {
  const context = usePreviewer();
  const [nameField] = (0, import_formik38.useField)(dataName);
  const [valueField, , valueFieldHelpers] = (0, import_formik38.useField)(valueName);
  const getValue = () => {
    return valueField.value;
  };
  const setValue = (value) => {
    valueFieldHelpers.setValue(value);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledSelectFieldDesignerPreviewer, {
    children: nameField.value.map((item, index2) => {
      const id = `${context.id}.${dataName}.${index2}.previewer`;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormGroupPreviewer, {
        check: true,
        onClick: () => setValue(index2),
        $active: getValue() == index2,
        $backgroundColor: context.color,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputPreviewerWrapper, {
            $checked: getValue() == index2,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputPreviewer, {
              type: "radio",
              id,
              checked: getValue() == index2,
              onChange: () => setValue(index2)
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLabelPreviewer, {
            check: true,
            for: id,
            children: item[context.locale]
          })
        ]
      }, id);
    })
  });
};

// src/components/Survey/Previewer/elements/TranslatableTextAreaFieldPreviewer.tsx
init_cjs_shims();
var import_formik39 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableTextAreaFieldPreviewer2 = ({ dataName = "data", valueName = "value" }) => {
  const context = usePreviewer();
  const [nameField] = (0, import_formik39.useField)(`${dataName}.${context.locale}`);
  const [valueField, , valueFieldHelpers] = (0, import_formik39.useField)(valueName);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTextAreaFieldPreviewer, {
    placeholder: nameField.value,
    value: valueField.value,
    maxRows: 7,
    onChange: (event) => valueFieldHelpers.setValue(event.target.value),
    $isPreviewModeMobile: context.mobileModeEnabled
  });
};

// src/components/Survey/Previewer/items/ExtraItemPreviewer.tsx
var import_ui38 = require("@btc-snxt/ui");

// src/components/Survey/Previewer/elements/ContinueButtonPreviewer.tsx
init_cjs_shims();
var import_ui37 = require("@btc-snxt/ui");
var import_react_i18next31 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ContinueButtonPreviewer = (props) => {
  const { t } = (0, import_react_i18next31.useTranslation)();
  const context = usePreviewer();
  const { innerWidth } = (0, import_ui37.useWindowSize)();
  const surveyItem = useSurveyNavigationStore();
  const handleClickScroll = () => {
    const currentItem = getElementInCenter();
    const element = document.getElementById(String(currentItem + 1));
    if (element) {
      surveyItem.setCurrentSurveyQuestion({
        state: currentItem + 1
      });
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  const handleSubmit = () => {
    context.submit();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ButtonWrapper, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledButton, {
        id: props.submit ? "submit" : "",
        $backgroundColor: context.color,
        onClick: () => {
          props.submit ? handleSubmit() : handleClickScroll();
        },
        children: props.value
      }),
      innerWidth > import_ui37.BOOTSTRAP_SM_CONTAINER_WIDTH && !context.mobileModeEnabled && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledText, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledOrPressText, {
            children: t("survey.form.button_or_press", { lng: context.locale })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledEnterText, {
            children: [
              t("survey.form.button_enter", { lng: context.locale }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui37.IconPressEnter, {})
            ]
          })
        ]
      })
    ]
  });
};

// src/components/Survey/Previewer/items/ExtraItemPreviewer.tsx
var import_react_i18next32 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var emptyExtraItemPreviewerInitialValues = {
  main_text: {
    data: {
      en: "",
      lt: "",
      ru: ""
    }
  }
};
var ExtraItemPreviewer = () => {
  var _a;
  const mainTextName = "main_text";
  const context = usePreviewer();
  const { t } = (0, import_react_i18next32.useTranslation)();
  const formik = (0, import_formik40.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptyExtraItemPreviewerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    enableReinitialize: true
  });
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik40.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik41.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPreviewer, {
        backgroundColor: hexToRGB(context.color, import_ui38.Theme.opacity.background),
        $isPreviewModeMobile: context.mobileModeEnabled,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledPreviewerBody, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPreviewerGroup, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTitle, {
                $isPreviewModeMobile: context.mobileModeEnabled,
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                  dataName: `${mainTextName}.data`
                })
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewer, {
              value: t("survey.form.button_continue", { lng: context.locale })
            })
          ]
        })
      })
    })
  });
};

// src/components/Survey/Previewer/items/IntroItemPreviewer.tsx
init_cjs_shims();
var import_react29 = require("react");
var import_formik42 = require("formik");
var import_formik43 = require("formik");
var import_ui40 = require("@btc-snxt/ui");
var import_react_i18next34 = require("react-i18next");

// src/components/PrivacyPolicyModal/PrivacyPolicyModal.tsx
init_cjs_shims();
var import_react_i18next33 = require("react-i18next");
var import_ui39 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var PrivacyPolicyModal = (props) => {
  const { t } = (0, import_react_i18next33.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui39.Modal, {
    ...props,
    title: t("survey.policy.title"),
    size: "xl",
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {
      children: t("survey.policy.privacy_policy")
    })
  });
};
var PrivacyPolicyModal_default = PrivacyPolicyModal;

// src/components/Survey/Previewer/items/IntroItemPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var emptyIntroItemPreviewerInitialValues = {
  logo: {
    data: ""
  },
  main_text: {
    data: {
      en: "",
      lt: "",
      ru: ""
    }
  },
  sub_text: {
    data: {
      en: "",
      lt: "",
      ru: ""
    }
  }
};
var IntroItemPreviewer = () => {
  var _a;
  const logoName = "logo";
  const mainTextName = "main_text";
  const subTextName = "sub_text";
  const context = usePreviewer();
  const { t } = (0, import_react_i18next34.useTranslation)();
  const { innerWidth } = (0, import_ui40.useWindowSize)();
  const [logo, setLogo] = (0, import_react29.useState)(context.logo);
  const [isPrivacyPolicyModelOpen, setPrivacyPolicyModalOpen] = (0, import_react29.useState)(false);
  const togglePrivacyPolicyModal = () => setPrivacyPolicyModalOpen(!isPrivacyPolicyModelOpen);
  const formik = (0, import_formik42.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptyIntroItemPreviewerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    enableReinitialize: true
  });
  (0, import_react29.useEffect)(() => {
    setLogo(context.logo);
  }, [context.logo]);
  const isMobileScreen = innerWidth < import_ui40.BOOTSTRAP_SM_CONTAINER_WIDTH || context.mobileModeEnabled;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik42.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_formik43.Form, {
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledIntroPagePreviewer, {
          backgroundColor: import_ui40.Theme.colors.white,
          $isPreviewModeMobile: context.mobileModeEnabled,
          children: [
            isMobileScreen ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(HeaderWrapper, {
              $availableLanguagesLength: context.availableLanguages.length,
              children: [
                context.availableLanguages.length > 1 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui40.LanguageDropdown, {
                  setLocale: context.setLocale,
                  availableLanguages: context.availableLanguages
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PoweredBySeeNext2, {})
              ]
            }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
              children: context.availableLanguages.length > 1 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LanguageDropdownWrapper, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui40.LanguageDropdown, {
                  setLocale: context.setLocale,
                  availableLanguages: context.availableLanguages
                })
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledPreviewerBody, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPreviewerGroup, {
                  children: context.logoObject.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLogo, {
                    src: context.logoObject[0].preview
                  }) : context.logo ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLogo, {
                    src: logo
                  }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LogoFieldPreviewer2, {
                    dataName: `${logoName}.data`
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(ActionItemWrapper, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledIntroPage, {
                      $isPreviewModeMobile: context.mobileModeEnabled,
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                          dataName: `${mainTextName}.data`
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIntroSubtext, {
                          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                            dataName: `${subTextName}.data`
                          })
                        })
                      ]
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewer, {
                      value: t("survey.form.button_start", { lng: context.locale })
                    })
                  ]
                })
              ]
            }),
            isMobileScreen ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPrivacyPolicySmall, {
              onClick: () => togglePrivacyPolicyModal(),
              children: t("settings.privacy_policy", { lng: context.locale })
            }) : /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledPreviewerFooter, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPrivacyPolicy, {
                  onClick: () => togglePrivacyPolicyModal(),
                  children: t("settings.privacy_policy", { lng: context.locale })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PoweredBySeeNext2, {})
              ]
            })
          ]
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PrivacyPolicyModal_default, {
          isOpen: isPrivacyPolicyModelOpen,
          setIsOpen: setPrivacyPolicyModalOpen,
          toggle: togglePrivacyPolicyModal
        })
      ]
    })
  });
};

// src/components/Survey/Previewer/items/OutroItemPreviewer.tsx
init_cjs_shims();
var import_react30 = require("react");
var import_formik45 = require("formik");
var import_formik46 = require("formik");
var import_ui41 = require("@btc-snxt/ui");
var import_react_i18next35 = require("react-i18next");

// src/components/Survey/Previewer/elements/EmailAreaFieldPreviewer.tsx
init_cjs_shims();
var import_formik44 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var EmailAreaFieldPreviewer = ({
  dataName = "data",
  valueName = "value"
}) => {
  const context = usePreviewer();
  const [nameField] = (0, import_formik44.useField)(`${dataName}.${context.locale}`);
  const [valueField, , valueFieldHelpers] = (0, import_formik44.useField)(valueName);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTextAreaFieldPreviewer, {
    placeholder: nameField.value,
    value: valueField.value,
    maxRows: 1,
    onChange: (event) => valueFieldHelpers.setValue(event.target.value),
    $isPreviewModeMobile: context.mobileModeEnabled
  });
};

// ../../node_modules/yup/es/index.js
init_cjs_shims();

// ../../node_modules/yup/es/mixed.js
init_cjs_shims();

// ../../node_modules/yup/es/schema.js
init_cjs_shims();

// ../../node_modules/nanoclone/src/index.js
init_cjs_shims();
var map;
try {
  map = Map;
} catch (_) {
}
var set;
try {
  set = Set;
} catch (_) {
}
function baseClone(src, circulars, clones) {
  if (!src || typeof src !== "object" || typeof src === "function") {
    return src;
  }
  if (src.nodeType && "cloneNode" in src) {
    return src.cloneNode(true);
  }
  if (src instanceof Date) {
    return new Date(src.getTime());
  }
  if (src instanceof RegExp) {
    return new RegExp(src);
  }
  if (Array.isArray(src)) {
    return src.map(clone);
  }
  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()));
  }
  if (set && src instanceof set) {
    return new Set(Array.from(src.values()));
  }
  if (src instanceof Object) {
    circulars.push(src);
    var obj = Object.create(src);
    clones.push(obj);
    for (var key in src) {
      var idx = circulars.findIndex(function(i) {
        return i === src[key];
      });
      obj[key] = idx > -1 ? clones[idx] : baseClone(src[key], circulars, clones);
    }
    return obj;
  }
  return src;
}
function clone(src) {
  return baseClone(src, [], []);
}

// ../../node_modules/yup/es/locale.js
init_cjs_shims();

// ../../node_modules/yup/es/util/printValue.js
init_cjs_shims();
var toString = Object.prototype.toString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : () => "";
var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val)
    return "NaN";
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? "-0" : "" + val;
}
function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false)
    return "" + val;
  const typeOf = typeof val;
  if (typeOf === "number")
    return printNumber(val);
  if (typeOf === "string")
    return quoteStrings ? `"${val}"` : val;
  if (typeOf === "function")
    return "[Function " + (val.name || "anonymous") + "]";
  if (typeOf === "symbol")
    return symbolToString.call(val).replace(SYMBOL_REGEXP, "Symbol($1)");
  const tag = toString.call(val).slice(8, -1);
  if (tag === "Date")
    return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
  if (tag === "Error" || val instanceof Error)
    return "[" + errorToString.call(val) + "]";
  if (tag === "RegExp")
    return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null)
    return result;
  return JSON.stringify(value, function(key, value2) {
    let result2 = printSimpleValue(this[key], quoteStrings);
    if (result2 !== null)
      return result2;
    return value2;
  }, 2);
}

// ../../node_modules/yup/es/locale.js
var mixed = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : ".");
    if (value === null) {
      msg += `
 If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }
    return msg;
  },
  defined: "${path} must be defined"
};
var string = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
};
var number = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
};
var date = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
};
var boolean = {
  isValue: "${path} field must be ${value}"
};
var object = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
};
var array = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
var locale_default = Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
});

// ../../node_modules/yup/es/Condition.js
init_cjs_shims();
var import_has = __toESM(require_has2());

// ../../node_modules/yup/es/util/isSchema.js
init_cjs_shims();
var isSchema = (obj) => obj && obj.__isYupSchema__;
var isSchema_default = isSchema;

// ../../node_modules/yup/es/Condition.js
var Condition = class {
  constructor(refs, options) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    if (typeof options === "function") {
      this.fn = options;
      return;
    }
    if (!(0, import_has.default)(options, "is"))
      throw new TypeError("`is:` is required for `when()` conditions");
    if (!options.then && !options.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === "function" ? is : (...values) => values.every((value) => value === is);
    this.fn = function(...args) {
      let options2 = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch)
        return void 0;
      if (typeof branch === "function")
        return branch(schema);
      return schema.concat(branch.resolve(options2));
    };
  }
  resolve(base, options) {
    let values = this.refs.map((ref) => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === void 0 || schema === base)
      return base;
    if (!isSchema_default(schema))
      throw new TypeError("conditions must return a schema object");
    return schema.resolve(options);
  }
};
var Condition_default = Condition;

// ../../node_modules/yup/es/util/runTests.js
init_cjs_shims();

// ../../node_modules/yup/es/ValidationError.js
init_cjs_shims();

// ../../node_modules/yup/es/util/toArray.js
init_cjs_shims();
function toArray(value) {
  return value == null ? [] : [].concat(value);
}

// ../../node_modules/yup/es/ValidationError.js
function _extends2() {
  _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
var strReg = /\$\{\s*(\w+)\s*\}/g;
var ValidationError = class extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || "this";
    if (path !== params.path)
      params = _extends2({}, params, {
        path
      });
    if (typeof message === "string")
      return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === "function")
      return message(params);
    return message;
  }
  static isError(err) {
    return err && err.name === "ValidationError";
  }
  constructor(errorOrErrors, value, field, type) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this.name = "ValidationError";
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach((err) => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace)
      Error.captureStackTrace(this, ValidationError);
  }
};

// ../../node_modules/yup/es/util/runTests.js
var once = (cb) => {
  let fired = false;
  return (...args) => {
    if (fired)
      return;
    fired = true;
    cb(...args);
  };
};
function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count)
    return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);
  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }
        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }
        nestedErrors.push(err);
      }
      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort)
            nestedErrors.sort(sort);
          if (errors.length)
            nestedErrors.push(...errors);
          errors = nestedErrors;
        }
        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }
        callback(null, value);
      }
    });
  }
}

// ../../node_modules/yup/es/util/createValidation.js
init_cjs_shims();
var import_mapValues = __toESM(require_mapValues());

// ../../node_modules/yup/es/Reference.js
init_cjs_shims();
var import_property_expr = __toESM(require_property_expr());
var prefixes = {
  context: "$",
  value: "."
};
var Reference2 = class {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== "string")
      throw new TypeError("ref must be a string, got: " + key);
    this.key = key.trim();
    if (key === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : "";
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && (0, import_property_expr.getter)(this.path, true);
    this.map = options.map;
  }
  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter)
      result = this.getter(result || {});
    if (this.map)
      result = this.map(result);
    return result;
  }
  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
};
Reference2.prototype.__isYupRef = true;

// ../../node_modules/yup/es/util/createValidation.js
function _extends3() {
  _extends3 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends3.apply(this, arguments);
}
function _objectWithoutPropertiesLoose4(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = "",
      label,
      options,
      originalValue,
      sync
    } = _ref, rest = _objectWithoutPropertiesLoose4(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;
    function resolve(item) {
      return Reference2.isRef(item) ? item.getValue(value, parent, context) : item;
    }
    function createError(overrides = {}) {
      const nextParams = (0, import_mapValues.default)(_extends3({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error2 = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error2.params = nextParams;
      return error2;
    }
    let ctx = _extends3({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);
    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then((validOrError) => {
          if (ValidationError.isError(validOrError))
            cb(validOrError);
          else if (!validOrError)
            cb(createError());
          else
            cb(null, validOrError);
        }).catch(cb);
      } catch (err) {
        cb(err);
      }
      return;
    }
    let result;
    try {
      var _ref2;
      result = test.call(ctx, value, ctx);
      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === "function") {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }
    if (ValidationError.isError(result))
      cb(result);
    else if (!result)
      cb(createError());
    else
      cb(null, result);
  }
  validate.OPTIONS = config;
  return validate;
}

// ../../node_modules/yup/es/util/reach.js
init_cjs_shims();
var import_property_expr2 = __toESM(require_property_expr());
var trim = (part) => part.substr(0, part.length - 1).substr(1);
function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug;
  if (!path)
    return {
      parent,
      parentPath: path,
      schema
    };
  (0, import_property_expr2.forEach)(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });
    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;
      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. because there is no value at that index. `);
      }
      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    }
    if (!isArray) {
      if (!schema.fields || !schema.fields[part])
        throw new Error(`The schema does not contain the path: ${path}. (failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

// ../../node_modules/yup/es/util/ReferenceSet.js
init_cjs_shims();
var ReferenceSet = class {
  constructor() {
    this.list = void 0;
    this.refs = void 0;
    this.list = /* @__PURE__ */ new Set();
    this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const description = [];
    for (const item of this.list)
      description.push(item);
    for (const [, ref] of this.refs)
      description.push(ref.describe());
    return description;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(resolve) {
    return this.toArray().reduce((acc, e) => acc.concat(Reference2.isRef(e) ? resolve(e) : e), []);
  }
  add(value) {
    Reference2.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }
  delete(value) {
    Reference2.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }
  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }
  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach((value) => next.add(value));
    newItems.refs.forEach((value) => next.add(value));
    removeItems.list.forEach((value) => next.delete(value));
    removeItems.refs.forEach((value) => next.delete(value));
    return next;
  }
};

// ../../node_modules/yup/es/schema.js
function _extends4() {
  _extends4 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends4.apply(this, arguments);
}
var BaseSchema = class {
  constructor(options) {
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = /* @__PURE__ */ Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || "mixed";
    this.spec = _extends4({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: "optional"
    }, options == null ? void 0 : options.spec);
  }
  get _type() {
    return this.type;
  }
  _typeCheck(_value) {
    return true;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec)
        Object.assign(this.spec, spec);
      return this;
    }
    const next = Object.create(Object.getPrototypeOf(this));
    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = _extends4({}, this.exclusiveTests);
    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(_extends4({}, this.spec, spec));
    return next;
  }
  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }
  meta(...args) {
    if (args.length === 0)
      return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  }
  withMutation(fn2) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn2(this);
    this._mutate = before;
    return result;
  }
  concat(schema) {
    if (!schema || schema === this)
      return this;
    if (schema.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();
    const mergedSpec = _extends4({}, base.spec, combined.spec);
    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError);
    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests;
    combined.withMutation((next) => {
      schema.tests.forEach((fn2) => {
        next.test(fn2.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }
  isType(v) {
    if (this.spec.nullable && v === null)
      return true;
    return this._typeCheck(v);
  }
  resolve(options) {
    let schema = this;
    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema2, condition) => condition.resolve(schema2, options), schema);
      schema = schema.resolve(options);
    }
    return schema;
  }
  cast(value, options = {}) {
    let resolvedSchema = this.resolve(_extends4({
      value
    }, options));
    let result = resolvedSchema._cast(value, options);
    if (value !== void 0 && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value that satisfies the schema type: "${resolvedSchema._type}". 

attempted value: ${formattedValue} 
` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
    }
    return result;
  }
  _cast(rawValue, _options) {
    let value = rawValue === void 0 ? rawValue : this.transforms.reduce((value2, fn2) => fn2.call(this, value2, rawValue, this), rawValue);
    if (value === void 0) {
      value = this.getDefault();
    }
    return value;
  }
  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;
    if (!strict) {
      value = this._cast(value, _extends4({
        assert: false
      }, options));
    }
    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError)
      initialTests.push(this._typeError);
    let finalTests = [];
    if (this._whitelistError)
      finalTests.push(this._whitelistError);
    if (this._blacklistError)
      finalTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, (err) => {
      if (err)
        return void cb(err, value);
      runTests({
        tests: this.tests.concat(finalTests),
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }
  validate(value, options, maybeCb) {
    let schema = this.resolve(_extends4({}, options, {
      value
    }));
    return typeof maybeCb === "function" ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value2) => {
      if (err)
        reject(err);
      else
        resolve(value2);
    }));
  }
  validateSync(value, options) {
    let schema = this.resolve(_extends4({}, options, {
      value
    }));
    let result;
    schema._validate(value, _extends4({}, options, {
      sync: true
    }), (err, value2) => {
      if (err)
        throw err;
      result = value2;
    });
    return result;
  }
  isValid(value, options) {
    return this.validate(value, options).then(() => true, (err) => {
      if (ValidationError.isError(err))
        return false;
      throw err;
    });
  }
  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err))
        return false;
      throw err;
    }
  }
  _getDefault() {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === "function" ? defaultValue.call(this) : clone(defaultValue);
  }
  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next = this.clone({
      default: def
    });
    return next;
  }
  strict(isStrict = true) {
    let next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }
  _isPresent(value) {
    return value != null;
  }
  defined(message = mixed.defined) {
    return this.test({
      message,
      name: "defined",
      exclusive: true,
      test(value) {
        return value !== void 0;
      }
    });
  }
  required(message = mixed.required) {
    return this.clone({
      presence: "required"
    }).withMutation((s) => s.test({
      message,
      name: "required",
      exclusive: true,
      test(value) {
        return this.schema._isPresent(value);
      }
    }));
  }
  notRequired() {
    let next = this.clone({
      presence: "optional"
    });
    next.tests = next.tests.filter((test) => test.OPTIONS.name !== "required");
    return next;
  }
  nullable(isNullable = true) {
    let next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }
  transform(fn2) {
    let next = this.clone();
    next.transforms.push(fn2);
    return next;
  }
  test(...args) {
    let opts;
    if (args.length === 1) {
      if (typeof args[0] === "function") {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }
    if (opts.message === void 0)
      opts.message = mixed.default;
    if (typeof opts.test !== "function")
      throw new TypeError("`test` is a required parameters");
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name)
        throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    }
    if (opts.name)
      next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter((fn2) => {
      if (fn2.OPTIONS.name === opts.name) {
        if (isExclusive)
          return false;
        if (fn2.OPTIONS.test === validate.OPTIONS.test)
          return false;
      }
      return true;
    });
    next.tests.push(validate);
    return next;
  }
  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== "string") {
      options = keys;
      keys = ".";
    }
    let next = this.clone();
    let deps = toArray(keys).map((key) => new Reference2(key));
    deps.forEach((dep) => {
      if (dep.isSibling)
        next.deps.push(dep.key);
    });
    next.conditions.push(new Condition_default(deps, options));
    return next;
  }
  typeError(message) {
    let next = this.clone();
    next._typeError = createValidation({
      message,
      name: "typeError",
      test(value) {
        if (value !== void 0 && !this.schema.isType(value))
          return this.createError({
            params: {
              type: this.schema._type
            }
          });
        return true;
      }
    });
    return next;
  }
  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach((val) => {
      next._whitelist.add(val);
      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: "oneOf",
      test(value) {
        if (value === void 0)
          return true;
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: valids.toArray().join(", "),
            resolved
          }
        });
      }
    });
    return next;
  }
  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach((val) => {
      next._blacklist.add(val);
      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: "notOneOf",
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value))
          return this.createError({
            params: {
              values: invalids.toArray().join(", "),
              resolved
            }
          });
        return true;
      }
    });
    return next;
  }
  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }
  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map((fn2) => ({
        name: fn2.OPTIONS.name,
        params: fn2.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex((c) => c.name === n.name) === idx)
    };
    return description;
  }
};
BaseSchema.prototype.__isYupSchema__ = true;
for (const method of ["validate", "validateSync"])
  BaseSchema.prototype[`${method}At`] = function(path, value, options = {}) {
    const {
      parent,
      parentPath,
      schema
    } = getIn(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], _extends4({}, options, {
      parent,
      path
    }));
  };
for (const alias of ["equals", "is"])
  BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;
for (const alias of ["not", "nope"])
  BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;
BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;

// ../../node_modules/yup/es/mixed.js
var Mixed = BaseSchema;
function create2() {
  return new Mixed();
}
create2.prototype = Mixed.prototype;

// ../../node_modules/yup/es/boolean.js
init_cjs_shims();

// ../../node_modules/yup/es/util/isAbsent.js
init_cjs_shims();
var isAbsent = (value) => value == null;
var isAbsent_default = isAbsent;

// ../../node_modules/yup/es/boolean.js
function create3() {
  return new BooleanSchema();
}
var BooleanSchema = class extends BaseSchema {
  constructor() {
    super({
      type: "boolean"
    });
    this.withMutation(() => {
      this.transform(function(value) {
        if (!this.isType(value)) {
          if (/^(true|1)$/i.test(String(value)))
            return true;
          if (/^(false|0)$/i.test(String(value)))
            return false;
        }
        return value;
      });
    });
  }
  _typeCheck(v) {
    if (v instanceof Boolean)
      v = v.valueOf();
    return typeof v === "boolean";
  }
  isTrue(message = boolean.isValue) {
    return this.test({
      message,
      name: "is-value",
      exclusive: true,
      params: {
        value: "true"
      },
      test(value) {
        return isAbsent_default(value) || value === true;
      }
    });
  }
  isFalse(message = boolean.isValue) {
    return this.test({
      message,
      name: "is-value",
      exclusive: true,
      params: {
        value: "false"
      },
      test(value) {
        return isAbsent_default(value) || value === false;
      }
    });
  }
};
create3.prototype = BooleanSchema.prototype;

// ../../node_modules/yup/es/string.js
init_cjs_shims();
var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
var rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
var rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
var isTrimmed = (value) => isAbsent_default(value) || value === value.trim();
var objStringTag = {}.toString();
function create4() {
  return new StringSchema();
}
var StringSchema = class extends BaseSchema {
  constructor() {
    super({
      type: "string"
    });
    this.withMutation(() => {
      this.transform(function(value) {
        if (this.isType(value))
          return value;
        if (Array.isArray(value))
          return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag)
          return value;
        return strValue;
      });
    });
  }
  _typeCheck(value) {
    if (value instanceof String)
      value = value.valueOf();
    return typeof value === "string";
  }
  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }
  length(length, message = string.length) {
    return this.test({
      message,
      name: "length",
      exclusive: true,
      params: {
        length
      },
      test(value) {
        return isAbsent_default(value) || value.length === this.resolve(length);
      }
    });
  }
  min(min2, message = string.min) {
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min: min2
      },
      test(value) {
        return isAbsent_default(value) || value.length >= this.resolve(min2);
      }
    });
  }
  max(max2, message = string.max) {
    return this.test({
      name: "max",
      exclusive: true,
      message,
      params: {
        max: max2
      },
      test(value) {
        return isAbsent_default(value) || value.length <= this.resolve(max2);
      }
    });
  }
  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;
    if (options) {
      if (typeof options === "object") {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }
    return this.test({
      name: name || "matches",
      message: message || string.matches,
      params: {
        regex
      },
      test: (value) => isAbsent_default(value) || value === "" && excludeEmptyString || value.search(regex) !== -1
    });
  }
  email(message = string.email) {
    return this.matches(rEmail, {
      name: "email",
      message,
      excludeEmptyString: true
    });
  }
  url(message = string.url) {
    return this.matches(rUrl, {
      name: "url",
      message,
      excludeEmptyString: true
    });
  }
  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: "uuid",
      message,
      excludeEmptyString: false
    });
  }
  ensure() {
    return this.default("").transform((val) => val === null ? "" : val);
  }
  trim(message = string.trim) {
    return this.transform((val) => val != null ? val.trim() : val).test({
      message,
      name: "trim",
      test: isTrimmed
    });
  }
  lowercase(message = string.lowercase) {
    return this.transform((value) => !isAbsent_default(value) ? value.toLowerCase() : value).test({
      message,
      name: "string_case",
      exclusive: true,
      test: (value) => isAbsent_default(value) || value === value.toLowerCase()
    });
  }
  uppercase(message = string.uppercase) {
    return this.transform((value) => !isAbsent_default(value) ? value.toUpperCase() : value).test({
      message,
      name: "string_case",
      exclusive: true,
      test: (value) => isAbsent_default(value) || value === value.toUpperCase()
    });
  }
};
create4.prototype = StringSchema.prototype;

// ../../node_modules/yup/es/number.js
init_cjs_shims();
var isNaN2 = (value) => value != +value;
function create5() {
  return new NumberSchema();
}
var NumberSchema = class extends BaseSchema {
  constructor() {
    super({
      type: "number"
    });
    this.withMutation(() => {
      this.transform(function(value) {
        let parsed = value;
        if (typeof parsed === "string") {
          parsed = parsed.replace(/\s/g, "");
          if (parsed === "")
            return NaN;
          parsed = +parsed;
        }
        if (this.isType(parsed))
          return parsed;
        return parseFloat(parsed);
      });
    });
  }
  _typeCheck(value) {
    if (value instanceof Number)
      value = value.valueOf();
    return typeof value === "number" && !isNaN2(value);
  }
  min(min2, message = number.min) {
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min: min2
      },
      test(value) {
        return isAbsent_default(value) || value >= this.resolve(min2);
      }
    });
  }
  max(max2, message = number.max) {
    return this.test({
      message,
      name: "max",
      exclusive: true,
      params: {
        max: max2
      },
      test(value) {
        return isAbsent_default(value) || value <= this.resolve(max2);
      }
    });
  }
  lessThan(less, message = number.lessThan) {
    return this.test({
      message,
      name: "max",
      exclusive: true,
      params: {
        less
      },
      test(value) {
        return isAbsent_default(value) || value < this.resolve(less);
      }
    });
  }
  moreThan(more, message = number.moreThan) {
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        more
      },
      test(value) {
        return isAbsent_default(value) || value > this.resolve(more);
      }
    });
  }
  positive(msg = number.positive) {
    return this.moreThan(0, msg);
  }
  negative(msg = number.negative) {
    return this.lessThan(0, msg);
  }
  integer(message = number.integer) {
    return this.test({
      name: "integer",
      message,
      test: (val) => isAbsent_default(val) || Number.isInteger(val)
    });
  }
  truncate() {
    return this.transform((value) => !isAbsent_default(value) ? value | 0 : value);
  }
  round(method) {
    var _method;
    let avail = ["ceil", "floor", "round", "trunc"];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
    if (method === "trunc")
      return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1)
      throw new TypeError("Only valid options for round() are: " + avail.join(", "));
    return this.transform((value) => !isAbsent_default(value) ? Math[method](value) : value);
  }
};
create5.prototype = NumberSchema.prototype;

// ../../node_modules/yup/es/date.js
init_cjs_shims();

// ../../node_modules/yup/es/util/isodate.js
init_cjs_shims();
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date2) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11], minutesOffset = 0, timestamp, struct;
  if (struct = isoReg.exec(date2)) {
    for (var i = 0, k; k = numericKeys[i]; ++i)
      struct[k] = +struct[k] || 0;
    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1;
    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0;
    if ((struct[8] === void 0 || struct[8] === "") && (struct[9] === void 0 || struct[9] === ""))
      timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
    else {
      if (struct[8] !== "Z" && struct[9] !== void 0) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === "+")
          minutesOffset = 0 - minutesOffset;
      }
      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else
    timestamp = Date.parse ? Date.parse(date2) : NaN;
  return timestamp;
}

// ../../node_modules/yup/es/date.js
var invalidDate = new Date("");
var isDate = (obj) => Object.prototype.toString.call(obj) === "[object Date]";
function create6() {
  return new DateSchema();
}
var DateSchema = class extends BaseSchema {
  constructor() {
    super({
      type: "date"
    });
    this.withMutation(() => {
      this.transform(function(value) {
        if (this.isType(value))
          return value;
        value = parseIsoDate(value);
        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
  }
  _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  }
  prepareParam(ref, name) {
    let param;
    if (!Reference2.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast))
        throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }
    return param;
  }
  min(min2, message = date.min) {
    let limit = this.prepareParam(min2, "min");
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min: min2
      },
      test(value) {
        return isAbsent_default(value) || value >= this.resolve(limit);
      }
    });
  }
  max(max2, message = date.max) {
    let limit = this.prepareParam(max2, "max");
    return this.test({
      message,
      name: "max",
      exclusive: true,
      params: {
        max: max2
      },
      test(value) {
        return isAbsent_default(value) || value <= this.resolve(limit);
      }
    });
  }
};
DateSchema.INVALID_DATE = invalidDate;
create6.prototype = DateSchema.prototype;
create6.INVALID_DATE = invalidDate;

// ../../node_modules/yup/es/object.js
init_cjs_shims();
var import_has3 = __toESM(require_has2());
var import_snakeCase = __toESM(require_snakeCase());
var import_camelCase = __toESM(require_camelCase());
var import_mapKeys = __toESM(require_mapKeys());
var import_mapValues2 = __toESM(require_mapValues());
var import_property_expr4 = __toESM(require_property_expr());

// ../../node_modules/yup/es/util/sortFields.js
init_cjs_shims();
var import_has2 = __toESM(require_has2());
var import_toposort = __toESM(require_toposort());
var import_property_expr3 = __toESM(require_property_expr());
function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = /* @__PURE__ */ new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));
  function addNode(depPath, key) {
    let node = (0, import_property_expr3.split)(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`))
      edges.push([key, node]);
  }
  for (const key in fields)
    if ((0, import_has2.default)(fields, key)) {
      let value = fields[key];
      nodes.add(key);
      if (Reference2.isRef(value) && value.isSibling)
        addNode(value.path, key);
      else if (isSchema_default(value) && "deps" in value)
        value.deps.forEach((path) => addNode(path, key));
    }
  return import_toposort.default.array(Array.from(nodes), edges).reverse();
}

// ../../node_modules/yup/es/util/sortByKeyOrder.js
init_cjs_shims();
function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;
    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

// ../../node_modules/yup/es/object.js
function _extends5() {
  _extends5 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends5.apply(this, arguments);
}
var isObject3 = (obj) => Object.prototype.toString.call(obj) === "[object Object]";
function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter((key) => known.indexOf(key) === -1);
}
var defaultSort = sortByKeyOrder([]);
var ObjectSchema = class extends BaseSchema {
  constructor(spec) {
    super({
      type: "object"
    });
    this.fields = /* @__PURE__ */ Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      this.transform(function coerce(value) {
        if (typeof value === "string") {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }
        if (this.isType(value))
          return value;
        return null;
      });
      if (spec) {
        this.shape(spec);
      }
    });
  }
  _typeCheck(value) {
    return isObject3(value) || typeof value === "function";
  }
  _cast(_value, options = {}) {
    var _options$stripUnknown;
    let value = super._cast(_value, options);
    if (value === void 0)
      return this.getDefault();
    if (!this._typeCheck(value))
      return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
    let props = this._nodes.concat(Object.keys(value).filter((v) => this._nodes.indexOf(v) === -1));
    let intermediateValue = {};
    let innerOptions = _extends5({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });
    let isChanged = false;
    for (const prop of props) {
      let field = fields[prop];
      let exists = (0, import_has3.default)(value, prop);
      if (field) {
        let fieldValue;
        let inputValue = value[prop];
        innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = "spec" in field ? field.spec : void 0;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
        if (fieldSpec == null ? void 0 : fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }
        fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== void 0) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }
      if (intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }
    return isChanged ? intermediateValue : value;
  }
  _validate(_value, opts = {}, callback) {
    let errors = [];
    let {
      sync,
      from = [],
      originalValue = _value,
      abortEarly = this.spec.abortEarly,
      recursive = this.spec.recursive
    } = opts;
    from = [{
      schema: this,
      value: originalValue
    }, ...from];
    opts.__validating = true;
    opts.originalValue = originalValue;
    opts.from = from;
    super._validate(_value, opts, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || abortEarly) {
          return void callback(err, value);
        }
        errors.push(err);
      }
      if (!recursive || !isObject3(value)) {
        callback(errors[0] || null, value);
        return;
      }
      originalValue = originalValue || value;
      let tests = this._nodes.map((key) => (_, cb) => {
        let path = key.indexOf(".") === -1 ? (opts.path ? `${opts.path}.` : "") + key : `${opts.path || ""}["${key}"]`;
        let field = this.fields[key];
        if (field && "validate" in field) {
          field.validate(value[key], _extends5({}, opts, {
            path,
            from,
            strict: true,
            parent: value,
            originalValue: originalValue[key]
          }), cb);
          return;
        }
        cb(null);
      });
      runTests({
        sync,
        tests,
        value,
        errors,
        endEarly: abortEarly,
        sort: this._sortErrors,
        path: opts.path
      }, callback);
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    next.fields = _extends5({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }
  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;
    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];
      if (target === void 0) {
        nextFields[field] = schemaOrRef;
      } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
        nextFields[field] = schemaOrRef.concat(target);
      }
    }
    return next.withMutation(() => next.shape(nextFields, this._excludedEdges));
  }
  getDefaultFromShape() {
    let dft = {};
    this._nodes.forEach((key) => {
      const field = this.fields[key];
      dft[key] = "default" in field ? field.getDefault() : void 0;
    });
    return dft;
  }
  _getDefault() {
    if ("default" in this.spec) {
      return super._getDefault();
    }
    if (!this._nodes.length) {
      return void 0;
    }
    return this.getDefaultFromShape();
  }
  shape(additions, excludes = []) {
    let next = this.clone();
    let fields = Object.assign(next.fields, additions);
    next.fields = fields;
    next._sortErrors = sortByKeyOrder(Object.keys(fields));
    if (excludes.length) {
      if (!Array.isArray(excludes[0]))
        excludes = [excludes];
      next._excludedEdges = [...next._excludedEdges, ...excludes];
    }
    next._nodes = sortFields(fields, next._excludedEdges);
    return next;
  }
  pick(keys) {
    const picked = {};
    for (const key of keys) {
      if (this.fields[key])
        picked[key] = this.fields[key];
    }
    return this.clone().withMutation((next) => {
      next.fields = {};
      return next.shape(picked);
    });
  }
  omit(keys) {
    const next = this.clone();
    const fields = next.fields;
    next.fields = {};
    for (const key of keys) {
      delete fields[key];
    }
    return next.withMutation(() => next.shape(fields));
  }
  from(from, to, alias) {
    let fromGetter = (0, import_property_expr4.getter)(from, true);
    return this.transform((obj) => {
      if (obj == null)
        return obj;
      let newObj = obj;
      if ((0, import_has3.default)(obj, from)) {
        newObj = _extends5({}, obj);
        if (!alias)
          delete newObj[from];
        newObj[to] = fromGetter(obj);
      }
      return newObj;
    });
  }
  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow === "string") {
      message = noAllow;
      noAllow = true;
    }
    let next = this.test({
      name: "noUnknown",
      exclusive: true,
      message,
      test(value) {
        if (value == null)
          return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(", ")
          }
        });
      }
    });
    next.spec.noUnknown = noAllow;
    return next;
  }
  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }
  transformKeys(fn2) {
    return this.transform((obj) => obj && (0, import_mapKeys.default)(obj, (_, key) => fn2(key)));
  }
  camelCase() {
    return this.transformKeys(import_camelCase.default);
  }
  snakeCase() {
    return this.transformKeys(import_snakeCase.default);
  }
  constantCase() {
    return this.transformKeys((key) => (0, import_snakeCase.default)(key).toUpperCase());
  }
  describe() {
    let base = super.describe();
    base.fields = (0, import_mapValues2.default)(this.fields, (value) => value.describe());
    return base;
  }
};
function create7(spec) {
  return new ObjectSchema(spec);
}
create7.prototype = ObjectSchema.prototype;

// ../../node_modules/yup/es/array.js
init_cjs_shims();
function _extends6() {
  _extends6 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends6.apply(this, arguments);
}
function create8(type) {
  return new ArraySchema(type);
}
var ArraySchema = class extends BaseSchema {
  constructor(type) {
    super({
      type: "array"
    });
    this.innerType = void 0;
    this.innerType = type;
    this.withMutation(() => {
      this.transform(function(values) {
        if (typeof values === "string")
          try {
            values = JSON.parse(values);
          } catch (err) {
            values = null;
          }
        return this.isType(values) ? values : null;
      });
    });
  }
  _typeCheck(v) {
    return Array.isArray(v);
  }
  get _subType() {
    return this.innerType;
  }
  _cast(_value, _opts) {
    const value = super._cast(_value, _opts);
    if (!this._typeCheck(value) || !this.innerType)
      return value;
    let isChanged = false;
    const castArray = value.map((v, idx) => {
      const castElement = this.innerType.cast(v, _extends6({}, _opts, {
        path: `${_opts.path || ""}[${idx}]`
      }));
      if (castElement !== v) {
        isChanged = true;
      }
      return castElement;
    });
    return isChanged ? castArray : value;
  }
  _validate(_value, options = {}, callback) {
    var _options$abortEarly, _options$recursive;
    let errors = [];
    let sync = options.sync;
    let path = options.path;
    let innerType = this.innerType;
    let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
    let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
    let originalValue = options.originalValue != null ? options.originalValue : _value;
    super._validate(_value, options, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || endEarly) {
          return void callback(err, value);
        }
        errors.push(err);
      }
      if (!recursive || !innerType || !this._typeCheck(value)) {
        callback(errors[0] || null, value);
        return;
      }
      originalValue = originalValue || value;
      let tests = new Array(value.length);
      for (let idx = 0; idx < value.length; idx++) {
        let item = value[idx];
        let path2 = `${options.path || ""}[${idx}]`;
        let innerOptions = _extends6({}, options, {
          path: path2,
          strict: true,
          parent: value,
          index: idx,
          originalValue: originalValue[idx]
        });
        tests[idx] = (_, cb) => innerType.validate(item, innerOptions, cb);
      }
      runTests({
        sync,
        path,
        value,
        errors,
        endEarly,
        tests
      }, callback);
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    next.innerType = this.innerType;
    return next;
  }
  concat(schema) {
    let next = super.concat(schema);
    next.innerType = this.innerType;
    if (schema.innerType)
      next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
    return next;
  }
  of(schema) {
    let next = this.clone();
    if (!isSchema_default(schema))
      throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + printValue(schema));
    next.innerType = schema;
    return next;
  }
  length(length, message = array.length) {
    return this.test({
      message,
      name: "length",
      exclusive: true,
      params: {
        length
      },
      test(value) {
        return isAbsent_default(value) || value.length === this.resolve(length);
      }
    });
  }
  min(min2, message) {
    message = message || array.min;
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min: min2
      },
      test(value) {
        return isAbsent_default(value) || value.length >= this.resolve(min2);
      }
    });
  }
  max(max2, message) {
    message = message || array.max;
    return this.test({
      message,
      name: "max",
      exclusive: true,
      params: {
        max: max2
      },
      test(value) {
        return isAbsent_default(value) || value.length <= this.resolve(max2);
      }
    });
  }
  ensure() {
    return this.default(() => []).transform((val, original) => {
      if (this._typeCheck(val))
        return val;
      return original == null ? [] : [].concat(original);
    });
  }
  compact(rejector) {
    let reject = !rejector ? (v) => !!v : (v, i, a) => !rejector(v, i, a);
    return this.transform((values) => values != null ? values.filter(reject) : values);
  }
  describe() {
    let base = super.describe();
    if (this.innerType)
      base.innerType = this.innerType.describe();
    return base;
  }
  nullable(isNullable = true) {
    return super.nullable(isNullable);
  }
  defined() {
    return super.defined();
  }
  required(msg) {
    return super.required(msg);
  }
};
create8.prototype = ArraySchema.prototype;

// ../../node_modules/yup/es/Lazy.js
init_cjs_shims();

// ../../node_modules/yup/es/setLocale.js
init_cjs_shims();

// src/helpers/FormFunctions.tsx
init_cjs_shims();
var touchFormFields = (errors, touched) => {
  Object.keys(errors).forEach((errorKey) => {
    const value = errors[errorKey];
    const isObject4 = typeof value === "object" && value !== null && !Array.isArray(value);
    if (isObject4) {
      touched[errorKey] = {};
      touchFormFields(value, touched[errorKey]);
    } else {
      touched[errorKey] = true;
    }
  });
};

// src/components/Survey/Previewer/Previewer.store.tsx
init_cjs_shims();
var import_zustand2 = require("zustand");
var useSurveyPreviewerStore = (0, import_zustand2.create)((set2) => {
  return {
    questions: [],
    addQuestion: (question) => set2((prev) => ({ questions: [...prev.questions, question] })),
    reset: () => set2({ questions: [] })
  };
});

// src/components/Survey/Previewer/items/OutroItemPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var emptyOutroItemPreviewerInitialValues = {
  main_text: {
    data: {
      en: "",
      lt: "",
      ru: ""
    }
  },
  sub_text: {
    data: {
      en: "",
      lt: "",
      ru: ""
    }
  },
  answers: {
    data: {
      en: "",
      lt: "",
      ru: ""
    }
  },
  email: {
    data: {
      required: false
    },
    value: void 0,
    message: void 0
  }
};
var OutroItemPreviewer = () => {
  var _a, _b, _c;
  const mainTextName = "main_text";
  const subTextName = "sub_text";
  const emailTextName = "email_text";
  const emailName = "email.value";
  const context = usePreviewer();
  const { t } = (0, import_react_i18next35.useTranslation)();
  const { addQuestion } = useSurveyPreviewerStore();
  const [initialSubmit, setInitialSubmit] = (0, import_react30.useState)(true);
  const validationSchema = create7().shape({
    email: create7().shape({
      value: create4().email(t("survey.error.invalid_email")).required(t("survey.error.input"))
    })
  });
  const formik = (0, import_formik45.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptyOutroItemPreviewerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    validationSchema: context.values && context.values.email.data.required == true ? validationSchema : null,
    validateOnChange: initialSubmit === false,
    enableReinitialize: true
  });
  (0, import_react30.useEffect)(() => {
    var _a2;
    if ((_a2 = formik.errors.email) == null ? void 0 : _a2.value) {
      setInitialSubmit(false);
    }
  }, [formik.errors]);
  (0, import_react30.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values.email.value);
    }
  }, [formik.values]);
  let added = false;
  (0, import_react30.useEffect)(() => {
    if (added) {
      return;
    }
    addQuestion({
      validate: async () => {
        const errors = await formik.validateForm();
        const touched = {};
        touchFormFields(errors, touched);
        formik.setErrors(errors);
        return errors;
      }
    });
    added = true;
  }, []);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik45.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik46.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPreviewer, {
        backgroundColor: hexToRGB(context.color, import_ui41.Theme.opacity.background),
        $isPreviewModeMobile: context.mobileModeEnabled,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledOutroPreviewerBody, {
          $isPreviewModeMobile: context.mobileModeEnabled,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPreviewerGroup, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTitle, {
                $isPreviewModeMobile: context.mobileModeEnabled,
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                  dataName: `${mainTextName}.data`
                })
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPreviewerGroup, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledSubtext, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                  dataName: `${subTextName}.data`
                })
              })
            }),
            formik.values.email.data.required === true && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTranslatableTextAreaFieldPreviewer, {
              $isPreviewModeMobile: context.mobileModeEnabled,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(EmailAreaFieldPreviewer, {
                dataName: `${emailTextName}.data`,
                valueName: `${emailName}`
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SubmitButtonPreviewerWrapper, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewer, {
                id: "submit",
                value: t("common.submit", { lng: context.locale }),
                submit: true
              })
            }),
            ((_b = formik.errors.email) == null ? void 0 : _b.value) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormikErrorMessage, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui41.ErrorMessageContainer, {
                hidden: ((_c = formik.errors.email) == null ? void 0 : _c.value) === void 0,
                text: formik.errors.email.value
              })
            })
          ]
        })
      })
    })
  });
};

// src/components/Survey/Previewer/items/MultiSelectionQuestionItemPreviewer.tsx
init_cjs_shims();
var import_react31 = require("react");
var import_formik47 = require("formik");
var import_formik48 = require("formik");
var import_ui42 = require("@btc-snxt/ui");
var import_react_i18next36 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var emptyMultiSelectionItemPreviewerInitialValues = {
  question_text: {
    data: {
      en: "",
      lt: "",
      ru: ""
    }
  },
  answers: {
    data: [],
    value: void 0
  }
};
var MultiSelectionQuestionItemPreviewer = () => {
  var _a, _b, _c, _d;
  const questionTextName = "question_text";
  const answersName = "answers";
  const context = usePreviewer();
  const { t } = (0, import_react_i18next36.useTranslation)();
  const { addQuestion } = useSurveyPreviewerStore();
  const isRequired = ((_b = (_a = context.values) == null ? void 0 : _a.required) == null ? void 0 : _b.data) === true;
  const validationSchema = create7().shape({
    answers: create7().shape({
      value: isRequired ? create8().required(t("survey.error.selection")) : create8().nullable()
    })
  });
  let added = false;
  const formik = (0, import_formik47.useFormik)({
    initialValues: (_c = context.values) != null ? _c : emptyMultiSelectionItemPreviewerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    validationSchema,
    enableReinitialize: true
  });
  (0, import_react31.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values.answers.value);
    }
  }, [formik.values]);
  (0, import_react31.useEffect)(() => {
    if (added) {
      return;
    }
    addQuestion({
      validate: async () => {
        const errors = await formik.validateForm();
        const touched = {};
        touchFormFields(errors, touched);
        formik.setErrors(errors);
        return errors;
      }
    });
    added = true;
  }, []);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik47.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik48.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPreviewer, {
        backgroundColor: hexToRGB(context.color, import_ui42.Theme.opacity.background),
        $isPreviewModeMobile: context.mobileModeEnabled,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerQuestionPreviewerBody, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionAndTitleContainer, {
            $isPreviewModeMobile: context.mobileModeEnabled,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContent, {
              $isPreviewModeMobile: context.mobileModeEnabled,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledQuestionTitle, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionTitleIndex, {
                      $isPreviewModeMobile: context.mobileModeEnabled,
                      children: `${context.questionIndex + 1}.`
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                      dataName: `${questionTextName}.data`
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledAnswerPreviewerGroupWrapper, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledAnswerPreviewerGroup, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableMultiSelectionFieldPreviewer2, {
                      dataName: `${answersName}.data`,
                      valueName: `${answersName}.value`
                    })
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewerWrapper, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: ((_d = formik.errors.answers) == null ? void 0 : _d.value) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui42.ErrorMessageContainer, {
                    text: formik.errors.answers.value
                  }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewer, {
                    value: t("survey.form.button_continue", { lng: context.locale })
                  })
                })
              ]
            })
          })
        })
      })
    })
  });
};

// src/components/Survey/Previewer/items/OpinionScaleQuestionItemPreviewer.tsx
init_cjs_shims();
var import_react32 = require("react");
var import_formik49 = require("formik");
var import_formik50 = require("formik");
var import_ui43 = require("@btc-snxt/ui");
var import_react_i18next37 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var emptyOpinionScaleQuestionItemPreviewerInitialValues = {
  question_text: {
    data: {
      en: "",
      lt: "",
      ru: ""
    }
  },
  answers: {
    data: {
      count: 0,
      type: "emotion" /* Emotion */
    },
    value: void 0
  }
};
var OpinionScaleQuestionItemPreviewer = () => {
  var _a, _b;
  const questionTextName = "question_text";
  const answersName = "answers";
  const answersDataName = `${answersName}.data`;
  const context = usePreviewer();
  const { t } = (0, import_react_i18next37.useTranslation)();
  const { addQuestion } = useSurveyPreviewerStore();
  const validationSchema = create7().shape({
    answers: create7().shape({
      value: create2().required(t("survey.error.selection"))
    })
  });
  let added = false;
  const formik = (0, import_formik49.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptyOpinionScaleQuestionItemPreviewerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    validationSchema: context.values.required.data ? validationSchema : null,
    enableReinitialize: true
  });
  (0, import_react32.useEffect)(() => {
    if (added) {
      return;
    }
    addQuestion({
      validate: async () => {
        const errors = await formik.validateForm();
        const touched = {};
        touchFormFields(errors, touched);
        formik.setErrors(errors);
        return errors;
      }
    });
    added = true;
  }, []);
  (0, import_react32.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values.answers.value);
    }
  }, [formik.values]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik49.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik50.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPreviewer, {
        backgroundColor: hexToRGB(context.color, import_ui43.Theme.opacity.background),
        $isPreviewModeMobile: context.mobileModeEnabled,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerQuestionPreviewerBody, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionAndTitleContainer, {
            $isPreviewModeMobile: context.mobileModeEnabled,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContent, {
              $isPreviewModeMobile: context.mobileModeEnabled,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledQuestionTitle, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionTitleIndex, {
                      $isPreviewModeMobile: context.mobileModeEnabled,
                      children: `${context.questionIndex + 1}.`
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                      dataName: `${questionTextName}.data`
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledOpinionScaleAnswerPreviewerGroupWrapper, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledAnswerPreviewerOpinionScaleGroup, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ScaleFieldPreviewer2, {
                      dataName: `${answersDataName}.count`,
                      typeName: `${answersDataName}.type`,
                      valueName: `${answersName}.value`
                    })
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewerWrapper, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: ((_b = formik.errors.answers) == null ? void 0 : _b.value) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui43.ErrorMessageContainer, {
                    text: formik.errors.answers.value
                  }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewer, {
                    value: t("survey.form.button_continue", { lng: context.locale })
                  })
                })
              ]
            })
          })
        })
      })
    })
  });
};

// src/components/Survey/Previewer/items/SingleSelectionQuestionItemPreviewer.tsx
init_cjs_shims();
var import_react33 = require("react");
var import_formik51 = require("formik");
var import_formik52 = require("formik");
var import_ui44 = require("@btc-snxt/ui");
var import_react_i18next38 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var emptySingleSelectionItemPreviewerInitialValues = {
  question_text: {
    data: {
      en: "",
      lt: "",
      ru: ""
    }
  },
  answers: {
    data: [],
    value: void 0
  }
};
var SingleSelectionQuestionItemPreviewer = () => {
  var _a, _b, _c, _d;
  const questionTextName = "question_text";
  const answersName = "answers";
  const { t } = (0, import_react_i18next38.useTranslation)();
  const context = usePreviewer();
  const { addQuestion } = useSurveyPreviewerStore();
  const isRequired = ((_b = (_a = context.values) == null ? void 0 : _a.required) == null ? void 0 : _b.data) === true;
  const validationSchema = create7().shape({
    answers: create7().shape({
      value: isRequired ? create4().required(t("survey.error.selection")) : create4().nullable()
    })
  });
  let added = false;
  const formik = (0, import_formik51.useFormik)({
    initialValues: (_c = context.values) != null ? _c : emptySingleSelectionItemPreviewerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    validationSchema,
    enableReinitialize: true
  });
  (0, import_react33.useEffect)(() => {
    if (added) {
      return;
    }
    addQuestion({
      validate: async () => {
        const errors = await formik.validateForm();
        const touched = {};
        touchFormFields(errors, touched);
        formik.setErrors(errors);
        return errors;
      }
    });
    added = true;
  }, []);
  (0, import_react33.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values.answers.value);
    }
  }, [formik.values]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik51.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik52.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPreviewer, {
        backgroundColor: hexToRGB(context.color, import_ui44.Theme.opacity.background),
        $isPreviewModeMobile: context.mobileModeEnabled,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerQuestionPreviewerBody, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionAndTitleContainer, {
            $isPreviewModeMobile: context.mobileModeEnabled,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContent, {
              $isPreviewModeMobile: context.mobileModeEnabled,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledQuestionTitle, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionTitleIndex, {
                      $isPreviewModeMobile: context.mobileModeEnabled,
                      children: `${context.questionIndex + 1}.`
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                      dataName: `${questionTextName}.data`
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledAnswerPreviewerGroupWrapper, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledAnswerPreviewerGroup, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableSingleSelectionFieldPreviewer2, {
                      dataName: `${answersName}.data`,
                      valueName: `${answersName}.value`
                    })
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewerWrapper, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: ((_d = formik.errors.answers) == null ? void 0 : _d.value) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui44.ErrorMessageContainer, {
                    text: formik.errors.answers.value
                  }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewer, {
                    value: t("survey.form.button_continue", { lng: context.locale })
                  })
                })
              ]
            })
          })
        })
      })
    })
  });
};

// src/components/Survey/Previewer/items/TextQuestionItemPreviewer.tsx
init_cjs_shims();
var import_react34 = require("react");
var import_formik53 = require("formik");
var import_formik54 = require("formik");
var import_ui45 = require("@btc-snxt/ui");
var import_react_i18next39 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var emptyTextItemPreviewerInitialValues = {
  question_text: {
    data: {
      en: "",
      lt: "",
      ru: ""
    }
  },
  answers: {
    data: {
      en: "",
      lt: "",
      ru: ""
    },
    value: void 0
  }
};
var TextQuestionItemPreviewer = () => {
  var _a, _b, _c, _d;
  const questionTextName = "question_text";
  const answersName = "answers";
  const context = usePreviewer();
  const { t } = (0, import_react_i18next39.useTranslation)();
  const { addQuestion } = useSurveyPreviewerStore();
  const isRequired = ((_b = (_a = context.values) == null ? void 0 : _a.required) == null ? void 0 : _b.data) === true;
  const validationSchema = create7().shape({
    answers: create7().shape({
      value: isRequired ? create4().required(t("survey.error.input")) : create4().nullable()
    })
  });
  let added = false;
  const formik = (0, import_formik53.useFormik)({
    initialValues: (_c = context.values) != null ? _c : emptyTextItemPreviewerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    validationSchema,
    enableReinitialize: true
  });
  (0, import_react34.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values.answers.value);
    }
  }, [formik.values]);
  (0, import_react34.useEffect)(() => {
    if (added) {
      return;
    }
    addQuestion({
      validate: async () => {
        const errors = await formik.validateForm();
        const touched = {};
        touchFormFields(errors, touched);
        formik.setErrors(errors);
        return errors;
      }
    });
    added = true;
  }, []);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik53.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik54.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPreviewer, {
        backgroundColor: hexToRGB(context.color, import_ui45.Theme.opacity.background),
        $isPreviewModeMobile: context.mobileModeEnabled,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerQuestionPreviewerBody, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionAndTitleContainer, {
            $isPreviewModeMobile: context.mobileModeEnabled,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContent, {
              $isPreviewModeMobile: context.mobileModeEnabled,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledQuestionTitle, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionTitleIndex, {
                      $isPreviewModeMobile: context.mobileModeEnabled,
                      children: `${context.questionIndex + 1}.`
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                      dataName: `${questionTextName}.data`
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledAnswerPreviewerGroupWrapper, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTextInputPreviewerGroup, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableTextAreaFieldPreviewer2, {
                      dataName: `${answersName}.data`,
                      valueName: `${answersName}.value`
                    })
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewerWrapper, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: ((_d = formik.errors.answers) == null ? void 0 : _d.value) ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui45.ErrorMessageContainer, {
                    text: formik.errors.answers.value
                  }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewer, {
                    value: t("survey.form.button_continue", { lng: context.locale })
                  })
                })
              ]
            })
          })
        })
      })
    })
  });
};

// src/components/Survey/Previewer/Previewer.tsx
init_cjs_shims();
var import_react37 = require("react");

// src/components/Survey/Previewer/items/LikertQuestionItemPreviewer.tsx
init_cjs_shims();
var import_react35 = require("react");
var import_formik56 = require("formik");
var import_formik57 = require("formik");
var import_ui47 = require("@btc-snxt/ui");
var import_react_i18next40 = require("react-i18next");

// src/components/Survey/Previewer/elements/TranslatableLikertFieldPreviewer.tsx
init_cjs_shims();
var import_formik55 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableQuestionGroupFieldPreviewer = ({ dataName = "data", valueName = "value" }) => {
  const context = usePreviewer();
  const [nameField] = (0, import_formik55.useField)(dataName);
  const [valueField, , valueFieldHelpers] = (0, import_formik55.useField)(valueName);
  const getValue = () => {
    return valueField.value;
  };
  const setValue = (value) => {
    valueFieldHelpers.setValue(value);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLikertSelectFieldDesignerPreviewer, {
    $isPreviewModeMobile: context.mobileModeEnabled,
    children: nameField.value.map((item, index2) => {
      const id = `${context.id}.${dataName}.${index2}.previewer`;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledLikertFormGroupPreviewer, {
        check: true,
        onClick: () => setValue(index2),
        $active: getValue() == index2,
        $backgroundColor: context.color,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputPreviewerWrapper, {
            $checked: getValue() == index2,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputPreviewer, {
              type: "radio",
              id,
              checked: getValue() == index2,
              onChange: () => setValue(index2)
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLabelPreviewer, {
            check: true,
            children: item[context.locale]
          })
        ]
      }, id);
    })
  });
};

// src/components/Survey/Previewer/styles/LikertQuestionItemPreviewer.style.tsx
init_cjs_shims();
var import_styled_components12 = __toESM(require("styled-components"));
var import_ui46 = require("@btc-snxt/ui");
var LikertSurveyWrapper = import_styled_components12.default.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.75rem;
  color: ${({ theme }) => theme.colors.black};
  width: 100%;
  height: 100%;
  overflow: overlay;
  padding-top: 4.375rem;
  padding-right: 0.5rem;

  mask-image: ${(props) => props.$ScrollPositionInTheEnd ? "none" : "linear-gradient(180deg, #000 80%, transparent)"};

  @-moz-document url-prefix() {
    overflow: auto;
  }

  ${MobileStyles}
`;
LikertSurveyWrapper.defaultProps = {
  $mobileModeCss: import_styled_components12.css`
    background-color: red;
    padding-top: 2.5rem;
  `,
  $alwaysMobileWhenWidth: import_ui46.breakpointDown.MD
};
var LikertSurveyQuestionAndTitleContent = import_styled_components12.default.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 1rem;
  width: 100%;

  ${MobileStyles}
`;
LikertSurveyWrapper.defaultProps = {
  $mobileModeCss: import_styled_components12.css`
    margin-left: 0;
  `,
  $alwaysMobileWhenWidth: import_ui46.breakpointDown.MD
};
var LikertAnswerMeaning = import_styled_components12.default.div`
  display: flex;
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 125%;
  padding-top: 0.5rem;
  color: rgba(0, 0, 0, 0.4);
  white-space: pre-wrap;
  flex-wrap: wrap;
`;
var LikertQuestionsWrapper = import_styled_components12.default.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 2.5rem;
  padding-left: 1.5rem;

  & > *:last-child {
    margin-top: 0;
  }
`;
var LikertQuestionAndTitleContainer = import_styled_components12.default.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  color: ${({ theme }) => theme.colors.black};
  width: 100%;
  height: 100%;
`;
var LikertIndex = import_styled_components12.default.div`
  font-family: 'Manrope', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 125%;
  text-align: right;
  color: ${({ theme }) => theme.colors.black2};

  ${MobileStyles}
`;
LikertIndex.defaultProps = {
  $mobileModeCss: import_styled_components12.css`
    padding-top: 0.25rem;
    padding-right: 0.75rem;
    min-height: 1.313rem;
    font-size: 1rem;
    margin-left: 0.625rem;
  `,
  $alwaysMobileWhenWidth: import_ui46.breakpointDown.MD
};
var LikertQuestionAndTitleContent = import_styled_components12.default.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 1.5rem;
  margin-left: 1rem;

  ${MobileStyles}
`;
LikertQuestionAndTitleContent.defaultProps = {
  $mobileModeCss: import_styled_components12.css`
    margin-left: 0;
  `,
  $alwaysMobileWhenWidth: import_ui46.breakpointDown.MD
};
var LikertQuestionTitle = import_styled_components12.default.div`
  display: flex;
  font-style: normal;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 125%;
  color: ${({ theme }) => theme.colors.black2};

  ${MobileStyles}
`;
LikertQuestionTitle.defaultProps = {
  $mobileModeCss: import_styled_components12.css`
    font-size: 1.125rem;
  `,
  $alwaysMobileWhenWidth: import_ui46.breakpointDown.SM
};

// src/components/Survey/Previewer/items/LikertQuestionItemPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var emptySingleSelectionItemPreviewerInitialValues2 = {
  question_text: {
    data: {
      en: "",
      lt: "",
      ru: ""
    }
  },
  questions: [],
  answers: {
    data: [],
    value: void 0
  }
};
var LikertQuestionItemPreviewer = () => {
  var _a;
  const questionTextName = "question_text";
  const questionDataName = "design_traits.data.question_text.data";
  const { t } = (0, import_react_i18next40.useTranslation)();
  const context = usePreviewer();
  const { addQuestion } = useSurveyPreviewerStore();
  const { isAtBottom, handleScroll } = useScrollPosition(".scroll-container");
  const [allQuestionsSelected, setAllQuestionsSelected] = (0, import_react35.useState)(false);
  const questionName = "questions";
  const validationSchema = create7().shape({
    questions: create8().of(
      create7().shape({
        value: create4().required(t("survey.error.selection"))
      })
    )
  });
  let added = false;
  const formik = (0, import_formik56.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptySingleSelectionItemPreviewerInitialValues2,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    validationSchema: context.values.required.data ? validationSchema : null,
    enableReinitialize: true
  });
  (0, import_react35.useEffect)(() => {
    if (added) {
      return;
    }
    addQuestion({
      validate: async () => {
        const errors = await formik.validateForm();
        const touched = {};
        touchFormFields(errors, touched);
        formik.setErrors(errors);
        setAllQuestionsSelected(true);
        return errors;
      }
    });
    added = true;
  }, []);
  (0, import_react35.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values.questions);
    }
  }, [formik.values]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik56.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik57.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPreviewer, {
        backgroundColor: hexToRGB(context.color, import_ui47.Theme.opacity.background),
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerQuestionPreviewerBody, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LikertSurveyWrapper, {
            className: `scroll-container`,
            onScroll: handleScroll,
            $ScrollPositionInTheEnd: isAtBottom,
            $isPreviewModeMobile: context.mobileModeEnabled,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(LikertSurveyQuestionAndTitleContent, {
              $isPreviewModeMobile: context.mobileModeEnabled,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledQuestionTitle, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionTitleIndex, {
                      $isPreviewModeMobile: context.mobileModeEnabled,
                      children: `${context.questionIndex + 1}.`
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                          dataName: `${questionTextName}.data`
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LikertAnswerMeaning, {
                          children: context.values.answers.data.map((answer, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
                            children: [
                              `${index2 + 1} - ${answer[context.locale]}`,
                              index2 !== context.values.answers.data.length - 1 && "; "
                            ]
                          }, index2))
                        })
                      ]
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(LikertQuestionsWrapper, {
                  children: [
                    context.values.questions.map((_question, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(LikertQuestionAndTitleContainer, {
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LikertIndex, {
                          $isPreviewModeMobile: context.mobileModeEnabled,
                          children: `${String.fromCharCode(97 + index2).toUpperCase()}.`
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(LikertQuestionAndTitleContent, {
                          $isPreviewModeMobile: context.mobileModeEnabled,
                          children: [
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LikertQuestionTitle, {
                              $isPreviewModeMobile: context.mobileModeEnabled,
                              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                                dataName: `${questionName}.${index2}.${questionDataName}`
                              })
                            }),
                            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledAnswerPreviewerGroup, {
                              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableQuestionGroupFieldPreviewer, {
                                dataName: `answers.data`,
                                valueName: `questions.${index2}.value`
                              })
                            })
                          ]
                        })
                      ]
                    }, index2)),
                    formik.errors.questions && allQuestionsSelected ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui47.ErrorMessageContainer, {
                      text: t("survey.error.selection")
                    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewer, {
                      value: t("survey.form.button_continue", { lng: context.locale })
                    })
                  ]
                })
              ]
            })
          })
        })
      })
    })
  });
};

// src/components/Survey/Previewer/items/MatrixQuestionItemPreviewer.tsx
init_cjs_shims();
var import_react36 = require("react");
var import_formik60 = require("formik");
var import_formik61 = require("formik");
var import_ui49 = require("@btc-snxt/ui");
var import_react_i18next41 = require("react-i18next");

// src/components/Survey/Previewer/elements/TranslatableMatrixFieldPreviewer.tsx
init_cjs_shims();
var import_formik59 = require("formik");

// src/components/Survey/Designer/DesignerPreviewer/MatrixPreviewer.style.tsx
init_cjs_shims();
var import_styled_components13 = __toESM(require("styled-components"));
var import_ui48 = require("@btc-snxt/ui");
var StyledMatrixInputDesignerPreviewerWrapper = import_styled_components13.default.div``;
var StyledQuestionTitle2 = import_styled_components13.default.td`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 125%;
  position: sticky;
  left: 0;
  width: auto;

  > div {
    width: 100%;
    min-width: 13.25rem;
    padding: 1.5rem 0.75rem 1.5rem 1.5rem;
    height: 100%;
    background-color: ${(props) => props.$backgroundColor};
    display: flex;
    align-items: center;

    ${import_ui48.breakpointDown.SM} {
      min-width: 43vw;
    }

    ${(props) => props.$isPreviewModeMobile && import_styled_components13.css`
        min-width: 0;
      `}
  }

  ${import_ui48.breakpointDown.LG} {
    font-size: 0.938rem;

    div {
      min-height: 5rem;
    }
  }

  ${(props) => props.$isPreviewModeMobile && import_styled_components13.css`
      font-size: 0.938rem;
    `}

  color: ${({ theme }) => theme.colors.black2}; ;
`;
var StyledMatrixTable = (0, import_styled_components13.default)(Table)`
  height: 100%;
  padding-right: 2.5rem;

  thead {
    tr {
      position: sticky;
      top: ${(props) => props.$demoMode ? "-4.375rem" : "-0.375rem"};
      z-index: 1;
    }
  }

  thead tr th {
    font-family: 'Manrope', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 1.375rem;
    line-height: 1.875rem;
    min-width: 5.625rem;
    text-align: center;
    color: ${({ theme }) => theme.colors.black2};
    text-transform: initial;
    padding: 1.25rem;
    vertical-align: middle;
    border: none;

    &:hover {
      color: ${({ theme }) => theme.colors.black2};
    }

    :not(:first-child) {
      background-color: ${({ theme }) => theme.colors.white};
    }
  }

  tbody {
    td:first-child {
      max-width: 31.75rem;
      background-color: ${({ theme }) => theme.colors.white};
    }

    td {
      border: none;
      padding: 0;
      vertical-align: middle;

      div {
        border-width: 1px;
        border-style: solid;
        border-color: rgba(0, 0, 0, 0.05);
      }
    }
  }
`;
var StyledMatrixFormGroupPreviewer = (0, import_styled_components13.default)(StyledFormGroupDesignerPreviewer)`
  border: none;
  justify-content: center;
  border-radius: 0;
  min-height: 4.875rem;
  height: 100%;
  ${StyledMatrixInputDesignerPreviewerWrapper} {
    ${({ $active, $checked, theme }) => !$checked && !$active && `
      border: 1px solid ${theme.colors.black};
      border-radius: 1rem;
    `}
  }
  width: 100%;
`;
var StyledDesignerMatrixTable = (0, import_styled_components13.default)(Table)`
  height: 100%;
  thead {
    background-color: ${({ theme }) => theme.colors.white};
  }
  thead tr th {
    background-color: ${(props) => props.$backgroundColor};
    font-family: 'Manrope', sans-serif;
    font-style: normal;
    font-weight: 400;
    line-height: 1.875rem;
    max-width: 6.25rem;
    min-width: 5.625rem;
    font-size: 1rem;
    padding: 0.5rem;
    text-align: center;
    color: ${({ theme }) => theme.colors.black2};
    text-transform: initial;
    vertical-align: middle;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      color: ${({ theme }) => theme.colors.black2};
    }
  }
  tbody {
    td:first-child {
      max-width: 31.75rem;
      background-color: ${({ theme }) => theme.colors.white};
    }
    td {
      border: none;
      padding: 0;
      vertical-align: middle;
      div {
        border-width: 1px;
        border-style: solid;
        border-color: rgba(0, 0, 0, 0.05);
      }
    }
  }
`;
var StyledDesignerQuestionTitle = (0, import_styled_components13.default)(StyledQuestionTitle2)`
  font-size: 0.938rem;
`;
var ContinueButtonWrapper = import_styled_components13.default.div`
  ${import_ui48.breakpointDown.LG} {
    padding-bottom: 1rem;
  }
`;
var QuestionTitleWrapper = import_styled_components13.default.div`
  background-color: ${({ theme }) => theme.colors.white};
`;
var TopLeftTableCell = import_styled_components13.default.th`
  border-color: rgba(0, 0, 0, 0.05);
  border-style: solid;
  border-width: 0 1px 1px 0;
  left: 0;
  padding: 0;
  position: sticky;
  top: -4.375rem;
  width: 100%;
  z-index: 3;
`;
var TopLeftTableCellColorFill = import_styled_components13.default.div`
  height: 100%;
  width: 100%;
  background-color: ${(props) => props.$backgroundColor};
`;
var TableAnswerCell = import_styled_components13.default.div`
  min-height: 7rem;
  width: 100%;
  background-color: ${(props) => props.$backgroundColor};
  border-width: 1px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.05);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;

  ${import_ui48.breakpointDown.XXL} {
    font-size: 1.125rem;
    padding: 0.75rem;
  }

  ${MobileStyles}
`;
TableAnswerCell.defaultProps = {
  $mobileModeCss: import_styled_components13.css`
    font-size: 1rem;
    padding: 0.5rem;
  `,
  $alwaysMobileWhenWidth: import_ui48.breakpointDown.LG
};

// src/components/Survey/Previewer/elements/MatrixTableRow.tsx
init_cjs_shims();
var import_formik58 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var MatrixTableRow = ({
  dataName = "data",
  valueName = "value"
}) => {
  const context = usePreviewer();
  const [nameField] = (0, import_formik58.useField)(dataName);
  const [valueField, , valueFieldHelpers] = (0, import_formik58.useField)(valueName);
  const getValue = () => {
    return valueField.value;
  };
  const setValue = (value) => {
    valueFieldHelpers.setValue(value);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: nameField.value.map((_answer, index2) => {
      const id = `${context.id}.${dataName}.${index2}.previewer`;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("td", {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledMatrixFormGroupPreviewer, {
          check: true,
          onClick: () => setValue(index2),
          $active: getValue() == index2,
          $backgroundColor: context.color,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledMatrixInputDesignerPreviewerWrapper, {
            $checked: getValue() == index2,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputDesignerPreviewer, {
              type: "radio",
              id,
              checked: getValue() == index2,
              onChange: () => setValue(index2)
            })
          })
        }, id)
      }, index2);
    })
  });
};

// src/components/Survey/Previewer/elements/TranslatableMatrixFieldPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableMatrixFieldPreviewer = () => {
  const context = usePreviewer();
  const questionName = "questions";
  const [questionNameField] = (0, import_formik59.useField)(`${questionName}`);
  const questionAnswers = "answers.data";
  const [answersNameField] = (0, import_formik59.useField)(`${questionAnswers}`);
  const questionDataName = "design_traits.data.question_text.data";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledMatrixTable, {
    $backgroundColor: hexToRGB(context.color, "0.03"),
    $demoMode: context.demoMode,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("thead", {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("tr", {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TopLeftTableCell, {
              style: { padding: "0" },
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TopLeftTableCellColorFill, {
                $backgroundColor: hexToRGB(context.color, "0.03")
              })
            }),
            answersNameField.value.map((_answer, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("th", {
              style: { padding: "0" },
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TableAnswerCell, {
                $backgroundColor: hexToRGB(context.color, "0.03"),
                $isPreviewModeMobile: context.mobileModeEnabled,
                children: _answer[context.locale]
              })
            }, index2))
          ]
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("tbody", {
        children: questionNameField.value.map((_question, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("tr", {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledQuestionTitle2, {
              $backgroundColor: hexToRGB(context.color, "0.03"),
              $isPreviewModeMobile: context.mobileModeEnabled,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                dataName: `${questionName}.${index2}.${questionDataName}`
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MatrixTableRow, {
              dataName: `${questionAnswers}`,
              valueName: `questions.${index2}.value`
            })
          ]
        }, index2))
      })
    ]
  });
};

// src/components/Survey/Previewer/items/MatrixQuestionItemPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var emptySingleSelectionItemPreviewerInitialValues3 = {
  question_text: {
    data: {
      en: "",
      lt: "",
      ru: ""
    }
  },
  questions: [],
  answers: {
    data: [],
    value: void 0
  }
};
var MatrixQuestionItemPreviewer = () => {
  var _a;
  const questionTextName = "question_text";
  const { t } = (0, import_react_i18next41.useTranslation)();
  const context = usePreviewer();
  const { addQuestion } = useSurveyPreviewerStore();
  const { isAtBottom, handleScroll } = useScrollPosition(".scroll-container");
  const [allQuestionsSelected, setAllQuestionsSelected] = (0, import_react36.useState)(false);
  const validationSchema = create7().shape({
    questions: create8().of(
      create7().shape({
        value: create4().required(t("survey.error.selection"))
      })
    )
  });
  let added = false;
  const formik = (0, import_formik60.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptySingleSelectionItemPreviewerInitialValues3,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    validationSchema: context.values.required.data ? validationSchema : null,
    enableReinitialize: true
  });
  (0, import_react36.useEffect)(() => {
    if (added) {
      return;
    }
    addQuestion({
      validate: async () => {
        const errors = await formik.validateForm();
        const touched = {};
        touchFormFields(errors, touched);
        formik.setErrors(errors);
        setAllQuestionsSelected(true);
        return errors;
      }
    });
    added = true;
  }, []);
  (0, import_react36.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values.questions);
    }
  }, [formik.values]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik60.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik61.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledPreviewer, {
        backgroundColor: hexToRGB(context.color, import_ui49.Theme.opacity.background),
        $isPreviewModeMobile: context.mobileModeEnabled,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerQuestionPreviewerBody, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MatrixSurveyWrapper, {
            className: `scroll-container`,
            onScroll: handleScroll,
            $ScrollPositionInTheEnd: isAtBottom,
            $isPreviewModeMobile: context.mobileModeEnabled,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(MatrixSurveyQuestionAndTitleContent, {
              $isPreviewModeMobile: context.mobileModeEnabled,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledQuestionTitle, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionTitleIndex, {
                      $isPreviewModeMobile: context.mobileModeEnabled,
                      children: `${context.questionIndex + 1}.`
                    }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
                      children: [
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer2, {
                          dataName: `${questionTextName}.data`
                        }),
                        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LikertAnswerMeaning, {
                          children: context.values.answers.data.map((answer, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", {
                            children: [
                              `${index2 + 1} - ${answer[context.locale]}`,
                              index2 !== context.values.answers.data.length - 1 && "; "
                            ]
                          }, index2))
                        })
                      ]
                    })
                  ]
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(MatrixQuestionsWrapper, {
                  $isPreviewModeMobile: context.mobileModeEnabled,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableMatrixFieldPreviewer, {}),
                    formik.errors.questions && allQuestionsSelected ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui49.ErrorMessageContainer, {
                      text: t("survey.error.selection")
                    }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonWrapper, {
                      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButtonPreviewer, {
                        value: t("survey.form.button_continue", { lng: context.locale })
                      })
                    })
                  ]
                })
              ]
            })
          })
        })
      })
    })
  });
};

// src/components/Survey/Previewer/Previewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Previewer = (props) => {
  const state = (0, import_react37.useMemo)(() => {
    return {
      ...props
    };
  }, [props]);
  const getDesigner = (type) => {
    switch (type) {
      case "intro" /* Intro */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IntroItemPreviewer, {});
      case "likert" /* Likert */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LikertQuestionItemPreviewer, {});
      case "matrix" /* Matrix */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MatrixQuestionItemPreviewer, {});
      case "single_selection_question" /* SingleSelectionQuestion */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SingleSelectionQuestionItemPreviewer, {});
      case "multi_selection_question" /* MultiSelectionQuestion */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiSelectionQuestionItemPreviewer, {});
      case "opinion_scale_question" /* OpinionScaleQuestion */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(OpinionScaleQuestionItemPreviewer, {});
      case "text_question" /* TextQuestion */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextQuestionItemPreviewer, {});
      case "extra" /* Extra */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExtraItemPreviewer, {});
      case "outro" /* Outro */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(OutroItemPreviewer, {});
    }
    return null;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PreviewerContext.Provider, {
    value: state,
    children: getDesigner(state.type)
  });
};

// src/components/Survey/Designer/DesignerPreviewer/elements/TranslatableLikertFieldPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableQuestionGroupFieldPreviewer2 = ({ dataName = "data" }) => {
  const context = useDesigner();
  const [nameField] = (0, import_formik62.useField)(dataName);
  const [checkedId, setCheckedId] = (0, import_react38.useState)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLikertSelectFieldDesignerPreviewer, {
    children: nameField.value.map((item, index2) => {
      const id = `${context.id}.${dataName}.${index2}.previewer`;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledLikertFormGroupPreviewer, {
        check: true,
        onClick: () => setCheckedId(index2),
        $active: checkedId == index2,
        $backgroundColor: context.color,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputDesignerPreviewerWrapper, {
            $checked: checkedId == index2,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputDesignerPreviewer, {
              type: "radio",
              id,
              checked: checkedId == index2,
              onChange: () => setCheckedId(index2)
            })
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLabelDesignerPreviewer, {
            check: true,
            children: item[context.locale]
          })
        ]
      }, id);
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/items/LikertQuestionItemDesignerPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var LikertQuestionItemDesignerPreviewer = () => {
  const questionTextName = "question_text";
  const questionName = "questions";
  const questionDataName = "design_traits.data.question_text.data";
  const { t } = (0, import_react_i18next42.useTranslation)();
  const context = useDesigner();
  const [nameField] = (0, import_formik63.useField)(`${questionName}`);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewer, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledLikertDesignerPreviewer, {
      backgroundColor: hexToRGB(context.color, import_ui50.Theme.opacity.background),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LinearProgressBar_default, {
          currentValue: context.questionIndex,
          total: context.size,
          color: context.color
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerQuestionPreviewerBody, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContainer, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionTitleIndex, {
                children: `${context.questionIndex + 1}.`
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContent, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledQuestionTitle, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                      dataName: `${questionTextName}.data`
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LikertQuestionsWrapper, {
                    children: nameField.value.map((_question, index2) => {
                      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(LikertQuestionAndTitleContainer, {
                        children: [
                          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LikertIndex, {
                            children: `${String.fromCharCode(
                              97 + index2
                            ).toUpperCase()}.`
                          }),
                          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(LikertQuestionAndTitleContent, {
                            children: [
                              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LikertQuestionTitle, {
                                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                                  dataName: `${questionName}.${index2}.${questionDataName}`
                                })
                              }),
                              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledAnswerPreviewerGroup, {
                                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableQuestionGroupFieldPreviewer2, {
                                  dataName: `answers.data`
                                })
                              })
                            ]
                          })
                        ]
                      }, index2);
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButton, {
                    type: "button",
                    value: t("survey.form.button_continue", { lng: context.locale })
                  })
                ]
              })
            ]
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerFooter, {
          navigation: true,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NavigationButtons, {}),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PoweredBySeeNext, {})
          ]
        })
      ]
    })
  });
};

// src/components/Survey/Designer/items/LikertQuestionItemDesigner.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var emptyLikertItemDesignerInitialValues = {
  color: "#FFFFFF",
  question_text: {
    data: {
      en: "Main Question text",
      lt: "Pagrindinio Klausimo tekstas",
      ru: "\u0422\u0435\u043A\u0441\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"
    }
  },
  questions: [
    {
      design_traits: {
        data: {
          color: "#FFFFFF",
          question_text: {
            data: {
              en: "First Question text",
              lt: "Pirmo Klausimo tekstas",
              ru: "\u0422\u0435\u043A\u0441\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"
            }
          }
        },
        required: true
      }
    },
    {
      design_traits: {
        data: {
          color: "#FFFFFF",
          question_text: {
            data: {
              en: "Second Question text",
              lt: "Antro Klausimo tekstas",
              ru: "\u0422\u0435\u043A\u0441\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"
            }
          }
        },
        required: true
      }
    }
  ],
  answers: {
    data: [
      { en: "Strongly disagree", lt: "Labai nesutinku", ru: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0447\u0435\u0441\u043A\u0438 \u043D\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D" },
      { en: "Disagree", lt: "Nesutinku", ru: "\u041D\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D" },
      { en: "Neutral", lt: "Neutralu", ru: "\u041D\u0435\u0439\u0442\u0440\u0430\u043B\u044C\u043D\u044B\u0439" },
      { en: "Agree", lt: "Sutinku", ru: "\u0421\u043E\u0433\u043B\u0430\u0448\u0430\u0442\u044C\u0441\u044F" },
      { en: "Strongly agree", lt: "Labai sutinku", ru: "\u041F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D" }
    ]
  },
  required: true
};
var LikertQuestionItemDesigner = () => {
  var _a;
  const { t } = (0, import_react_i18next43.useTranslation)();
  const context = useDesigner();
  const formik = (0, import_formik64.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptyLikertItemDesignerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    enableReinitialize: true,
    validateOnChange: false
  });
  (0, import_react39.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values, context.color);
    }
  }, [formik.values, context.color]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik64.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik65.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BaseDesigner, {
        name: t("builder.likert", { lng: context.locale }),
        formatter: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LikertQuestionItemFormatter, {}),
        previewer: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LikertQuestionItemDesignerPreviewer, {})
      })
    })
  });
};

// src/components/Survey/Designer/Designer.tsx
init_cjs_shims();
var import_react44 = require("react");

// src/components/Survey/Designer/items/OutroItemDesigner.tsx
init_cjs_shims();
var import_react41 = require("react");
var import_formik68 = require("formik");
var import_formik69 = require("formik");
var import_react_i18next46 = require("react-i18next");

// src/components/Survey/Designer/DesignerFormatter/items/OutroItemFormatter.tsx
init_cjs_shims();

// src/components/Survey/Designer/DesignerFormatter/elements/IncludeEmailField.tsx
init_cjs_shims();
var import_react40 = require("react");
var import_draft_js = require("draft-js");
var import_draftjs_to_html = __toESM(require("draftjs-to-html"));
var import_html_to_draftjs = __toESM(require("html-to-draftjs"));
var import_formik66 = require("formik");
var import_react_i18next44 = require("react-i18next");
var import_ui51 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var IncludeEmailField = ({
  dataName = "data"
}) => {
  const { t } = (0, import_react_i18next44.useTranslation)();
  const context = useDesigner();
  const formik = (0, import_formik66.useFormikContext)();
  const [isEnabled, setEnabled] = (0, import_react40.useState)(
    context.values && context.values.email && context.values.email.data ? context.values.email.data.required : false
  );
  const [editorState, setEditorState] = (0, import_react40.useState)(import_draft_js.EditorState.createEmpty());
  (0, import_react40.useEffect)(() => {
    if (editorState) {
      formik.setFieldValue(
        "email.message",
        (0, import_draftjs_to_html.default)((0, import_draft_js.convertToRaw)(editorState.getCurrentContent())),
        false
      );
    }
  }, [editorState]);
  (0, import_react40.useEffect)(() => {
    if (formik.values.email.message) {
      const blockFromHtml = (0, import_html_to_draftjs.default)(formik.values.email.message);
      const { contentBlocks, entityMap } = blockFromHtml;
      const contentState = import_draft_js.ContentState.createFromBlockArray(contentBlocks, entityMap);
      setEditorState(import_draft_js.EditorState.createWithContent(contentState));
    }
  }, []);
  const toggleEnabled = () => setTimeout(() => {
    const newValue = !isEnabled;
    setEnabled(newValue);
    formik.setFieldValue(dataName, newValue);
  }, 0);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(EmailDataWrapper, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(EmailLabelWrapper, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLabel, {
            children: t("survey.create.include_email")
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik66.Field, {
            as: import_ui51.Switch,
            id: dataName,
            name: dataName,
            value: isEnabled,
            checked: isEnabled,
            onChange: toggleEnabled
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(WysiwygEditorWraper, {
        $switch: isEnabled,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(EmailLabelWrapper, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledLabel, {
                children: t("survey.create.email_content")
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledIconHelp, {
                id: "my-tooltip"
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTooltip, {
                placement: "top",
                target: "my-tooltip",
                children: t("survey.create.email_content_tooltip")
              })
            ]
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui51.WysiwygEditor, {
            editorState,
            setEditorState
          })
        ]
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerFormatter/items/OutroItemFormatter.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var OutroItemFormatter = () => {
  const mainTextName = "main_text";
  const subTextName = "sub_text";
  const switchName = "email.data.required";
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatter, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableField, {
        dataName: `${mainTextName}.data`,
        parentName: mainTextName
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableField, {
        dataName: `${subTextName}.data`,
        parentName: subTextName
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IncludeEmailField, {
        dataName: switchName
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerPreviewer/items/OutroItemDesignerPreviewer.tsx
init_cjs_shims();
var import_ui52 = require("@btc-snxt/ui");
var import_react_i18next45 = require("react-i18next");
var import_formik67 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var OutroItemDesignerPreviewer = () => {
  const mainTextName = "main_text";
  const subTextName = "sub_text";
  const emailTextName = "email_text";
  const context = useDesigner();
  const [field] = (0, import_formik67.useField)("email.data.required");
  const { t } = (0, import_react_i18next45.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewer, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerBackgroundColor, {
      backgroundColor: hexToRGB(context.color, import_ui52.Theme.opacity.background),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LinearProgressBar_default, {
          color: context.color,
          currentValue: context.questionIndex,
          total: context.size
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerBody, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewerGroup, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTitle, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                  dataName: `${mainTextName}.data`
                })
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewerGroup, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledSubtext, {
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                  dataName: `${subTextName}.data`
                })
              })
            }),
            field.value && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledTranslatableTextAreaFieldPreviewer, {
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableTextAreaFieldPreviewer, {
                dataName: `${emailTextName}.data`
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButton, {
              type: "submit",
              value: t("common.submit", { lng: context.locale })
            })
          ]
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerFooter, {
          navigation: true,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NavigationButtons, {}),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PoweredBySeeNext, {})
          ]
        })
      ]
    })
  });
};

// src/components/Survey/Designer/items/OutroItemDesigner.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var emptyOutroItemDesignerInitialValues = {
  color: "#FFFFFF",
  logo: {
    data: ""
  },
  main_text: {
    data: {
      en: "Main text",
      lt: "Pagrindinis tekstas",
      ru: "\u041E\u0441\u043D\u043E\u0432\u043D\u043E\u0439 \u0442\u0435\u043A\u0441\u0442"
    }
  },
  sub_text: {
    data: {
      en: "Additional text",
      lt: "Papildomas tekstas",
      ru: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442"
    }
  },
  email_text: {
    data: {
      en: "name@example.com",
      lt: "vardas@pavyzdys.com",
      ru: "\u0438\u043C\u044F@\u043F\u0440\u0438\u043C\u0435\u0440.com"
    }
  },
  answers: {
    data: {
      en: "Answer",
      lt: "Atsakymas",
      ru: "\u041E\u0442\u0432\u0435\u0447\u0430\u0442\u044C"
    }
  },
  email: {
    data: {
      required: false
    },
    value: void 0,
    message: void 0
  }
};
var OutroItemDesigner = () => {
  var _a;
  const context = useDesigner();
  const { t } = (0, import_react_i18next46.useTranslation)();
  const formik = (0, import_formik68.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptyOutroItemDesignerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    enableReinitialize: true,
    validateOnChange: false
  });
  (0, import_react41.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values, context.color);
    }
  }, [formik.values, context.color]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik68.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik69.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BaseDesigner, {
        name: t("builder.outro", { lng: context.locale }),
        formatter: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(OutroItemFormatter, {}),
        previewer: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(OutroItemDesignerPreviewer, {})
      })
    })
  });
};

// src/components/Survey/Designer/items/MatrixQuestionItemDesigner.tsx
init_cjs_shims();
var import_react43 = require("react");
var import_formik73 = require("formik");
var import_formik74 = require("formik");
var import_react_i18next49 = require("react-i18next");

// src/components/Survey/Designer/DesignerPreviewer/items/MatrixQuestionItemDesignerPreviewer.tsx
init_cjs_shims();
var import_ui53 = require("@btc-snxt/ui");
var import_react_i18next47 = require("react-i18next");

// src/components/Survey/Designer/DesignerPreviewer/elements/TranslatableMatrixFieldPreviewer.tsx
init_cjs_shims();
var import_formik71 = require("formik");

// src/components/Survey/Designer/DesignerPreviewer/elements/MatrixTableRow.tsx
init_cjs_shims();
var import_react42 = require("react");
var import_formik70 = require("formik");
var import_jsx_runtime = require("react/jsx-runtime");
var MatrixTableRow2 = ({
  dataName = "data"
}) => {
  const context = useDesigner();
  const [nameField] = (0, import_formik70.useField)(dataName);
  const [checkedId, setCheckedId] = (0, import_react42.useState)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: nameField.value.map((_answer, index2) => {
      const id = `${context.id}.${dataName}.${index2}.previewer`;
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("td", {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledMatrixFormGroupPreviewer, {
          check: true,
          onClick: () => setCheckedId(index2),
          $active: checkedId == index2,
          $backgroundColor: context.color,
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledMatrixInputDesignerPreviewerWrapper, {
            $checked: checkedId == index2,
            children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledInputDesignerPreviewer, {
              type: "radio",
              id,
              checked: checkedId == index2,
              onChange: () => setCheckedId(index2)
            })
          })
        }, id)
      }, index2);
    })
  });
};

// src/components/Survey/Designer/DesignerPreviewer/elements/TranslatableMatrixFieldPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var TranslatableMatrixFieldPreviewer2 = () => {
  const context = useDesigner();
  const questionName = "questions";
  const questionAnswers = "answers.data";
  const questionDataName = "design_traits.data.question_text.data";
  const [questionNameField] = (0, import_formik71.useField)(`${questionName}`);
  const [answersNameField] = (0, import_formik71.useField)(`${questionAnswers}`);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerMatrixTable, {
    $backgroundColor: hexToRGB(context.color, "0.03"),
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("thead", {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("tr", {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("th", {
              style: { border: "none" },
              children: " "
            }),
            answersNameField.value.map((_answer, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("th", {
              children: _answer[context.locale]
            }, index2))
          ]
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("tbody", {
        children: questionNameField.value.map((_question, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("tr", {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerQuestionTitle, {
              $backgroundColor: hexToRGB(context.color, "0.03"),
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                dataName: `${questionName}.${index2}.${questionDataName}`
              })
            }),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MatrixTableRow2, {
              dataName: `${questionAnswers}`
            })
          ]
        }, index2))
      })
    ]
  });
};

// src/components/Survey/Designer/DesignerPreviewer/items/MatrixQuestionItemDesignerPreviewer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var MatrixQuestionItemDesignerPreviewer = () => {
  const questionTextName = "question_text";
  const { t } = (0, import_react_i18next47.useTranslation)();
  const context = useDesigner();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledDesignerPreviewer, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledMatrixDesignerPreviewer, {
      backgroundColor: hexToRGB(context.color, import_ui53.Theme.opacity.background),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LinearProgressBar_default, {
          currentValue: context.questionIndex,
          total: context.size,
          color: context.color
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledMatrixDesignerQuestionPreviewerBody, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContainer, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SurveyQuestionTitleIndex, {
                children: `${context.questionIndex + 1}.`
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SurveyQuestionAndTitleContent, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledQuestionTitle, {
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableFieldPreviewer, {
                      dataName: `${questionTextName}.data`
                    })
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableMatrixFieldPreviewer2, {}),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ContinueButton, {
                    type: "button",
                    value: t("survey.form.button_continue", { lng: context.locale })
                  })
                ]
              })
            ]
          })
        }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledDesignerPreviewerFooter, {
          navigation: true,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NavigationButtons, {}),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PoweredBySeeNext, {})
          ]
        })
      ]
    })
  });
};

// src/components/Survey/Designer/DesignerFormatter/items/MatrixQuestionItemFormatter.tsx
init_cjs_shims();
var import_formik72 = require("formik");
var import_ui54 = require("@btc-snxt/ui");
var import_react_i18next48 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var MatrixQuestionItemFormatter = () => {
  const questionTextName = "question_text";
  const questionName = "questions";
  const answerName = "answers";
  const requiredName = "required";
  const questionDataName = "design_traits.data.question_text.data";
  const context = useDesigner();
  const { t } = (0, import_react_i18next48.useTranslation)();
  const [nameField] = (0, import_formik72.useField)(`${questionName}`);
  const newQuestionValues = {
    design_traits: {
      data: {
        color: "#FFFFFF",
        question_text: {
          data: {
            en: "Question text",
            lt: "Klausimo tekstas",
            ru: "\u0422\u0435\u043A\u0441\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"
          }
        }
      }
    },
    required: true
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormatter, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableField, {
        dataName: `${questionTextName}.data`,
        parentName: questionTextName
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledFormatterLabelBlock, {
        children: t("question_text.matrix_sub_data")
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik72.FieldArray, {
        name: questionName,
        render: (arrayHelpers) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_ui54.SecondaryButton, {
              onClick: () => arrayHelpers.insert(nameField.value.length + 1, newQuestionValues),
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui54.IconAdd, {}),
                " ",
                "add"
              ]
            }),
            nameField.value.map((_question, index2) => {
              return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledInputFieldWithButton, {
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik72.Field, {
                    as: import_ui54.Input,
                    id: `${questionName}.${index2}.${questionDataName}`,
                    name: `${questionName}.${index2}.${questionDataName}.${context.locale}`
                  }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui54.SecondaryButton, {
                    onClick: () => arrayHelpers.remove(index2),
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui54.IconRemove, {})
                  })
                ]
              }, index2);
            })
          ]
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TranslatableQuestionGroupField, {
        dataName: `${answerName}.data`,
        parentName: `${answerName}`
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RequiredSwitch, {
        dataName: `${requiredName}.data`
      })
    ]
  });
};

// src/components/Survey/Designer/items/MatrixQuestionItemDesigner.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var emptyMatrixItemDesignerInitialValues = {
  color: "#FFFFFF",
  question_text: {
    data: {
      en: "Main Question text",
      lt: "Pagrindinio Klausimo tekstas",
      ru: "\u0422\u0435\u043A\u0441\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"
    }
  },
  questions: [
    {
      design_traits: {
        data: {
          color: "#FFFFFF",
          question_text: {
            data: {
              en: "First Question text",
              lt: "Pirmo Klausimo tekstas",
              ru: "\u0422\u0435\u043A\u0441\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"
            }
          }
        },
        required: true
      }
    },
    {
      design_traits: {
        data: {
          color: "#FFFFFF",
          question_text: {
            data: {
              en: "Second Question text",
              lt: "Antro Klausimo tekstas",
              ru: "\u0422\u0435\u043A\u0441\u0442 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"
            }
          }
        },
        required: true
      }
    }
  ],
  answers: {
    data: [
      { en: "Strongly disagree", lt: "Labai nesutinku", ru: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0447\u0435\u0441\u043A\u0438 \u043D\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D" },
      { en: "Disagree", lt: "Nesutinku", ru: "\u041D\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D" },
      { en: "Neutral", lt: "Neutralu", ru: "\u041D\u0435\u0439\u0442\u0440\u0430\u043B\u044C\u043D\u044B\u0439" },
      { en: "Agree", lt: "Sutinku", ru: "\u0421\u043E\u0433\u043B\u0430\u0448\u0430\u0442\u044C\u0441\u044F" },
      { en: "Strongly agree", lt: "Labai sutinku", ru: "\u041F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0441\u043E\u0433\u043B\u0430\u0441\u0435\u043D" }
    ]
  },
  required: true
};
var MatrixQuestionItemDesigner = () => {
  var _a;
  const { t } = (0, import_react_i18next49.useTranslation)();
  const context = useDesigner();
  const formik = (0, import_formik73.useFormik)({
    initialValues: (_a = context.values) != null ? _a : emptyMatrixItemDesignerInitialValues,
    onSubmit: context.onSubmit ? context.onSubmit : () => {
    },
    enableReinitialize: true,
    validateOnChange: false
  });
  (0, import_react43.useEffect)(() => {
    if (onValuesChanged) {
      onValuesChanged(context.id, formik.values, context.color);
    }
  }, [formik.values, context.color]);
  const onValuesChanged = context.onValuesChanged;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik73.FormikProvider, {
    value: formik,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_formik74.Form, {
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(BaseDesigner, {
        name: t("builder.matrix", { lng: context.locale }),
        formatter: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MatrixQuestionItemFormatter, {}),
        previewer: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MatrixQuestionItemDesignerPreviewer, {})
      })
    })
  });
};

// src/components/Survey/Designer/Designer.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Designer = (props) => {
  const state = (0, import_react44.useMemo)(() => {
    return {
      ...props
    };
  }, [props]);
  const getDesigner = (type) => {
    switch (type) {
      case "intro" /* Intro */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IntroItemDesigner, {});
      case "single_selection_question" /* SingleSelectionQuestion */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SingleSelectionQuestionItemDesigner, {});
      case "multi_selection_question" /* MultiSelectionQuestion */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MultiSelectionQuestionItemDesigner, {});
      case "opinion_scale_question" /* OpinionScaleQuestion */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(OpinionScaleQuestionItemDesigner, {});
      case "text_question" /* TextQuestion */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextQuestionItemDesigner, {});
      case "likert" /* Likert */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(LikertQuestionItemDesigner, {});
      case "matrix" /* Matrix */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MatrixQuestionItemDesigner, {});
      case "extra" /* Extra */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ExtraItemDesigner, {});
      case "outro" /* Outro */:
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(OutroItemDesigner, {});
    }
    return null;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DesignerContext.Provider, {
    value: state,
    children: getDesigner(state.type)
  });
};

// src/components/ColorPickerInput/index.ts
init_cjs_shims();

// src/components/ColorPickerInput/ColorPickerInput.tsx
init_cjs_shims();
var import_react90 = require("react");
var import_ui57 = require("@btc-snxt/ui");

// src/components/ColorPicker/index.ts
init_cjs_shims();

// src/components/ColorPicker/ColorPicker.tsx
init_cjs_shims();
var import_react89 = require("react");
var import_react_i18next50 = require("react-i18next");
var import_ui55 = require("@btc-snxt/ui");

// src/components/ColorPicker/ColorPicker.style.tsx
init_cjs_shims();
var import_styled_components14 = __toESM(require("styled-components"));

// ../../node_modules/react-color/lib/index.js
init_cjs_shims();

// ../../node_modules/react-color/lib/components/alpha/Alpha.js
init_cjs_shims();
var import_react55 = __toESM(require("react"));
var import_reactcss9 = __toESM(require_lib());

// ../../node_modules/react-color/lib/components/common/index.js
init_cjs_shims();

// ../../node_modules/react-color/lib/components/common/Alpha.js
init_cjs_shims();
var import_react46 = __toESM(require("react"));
var import_reactcss2 = __toESM(require_lib());

// ../../node_modules/react-color/lib/helpers/alpha.js
init_cjs_shims();
var calculateChange = function calculateChange2(e, skip, props, container) {
  e.preventDefault();
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
  var left2 = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top2 = y - (container.getBoundingClientRect().top + window.pageYOffset);
  if (props.direction === "vertical") {
    var a = void 0;
    if (top2 < 0) {
      a = 0;
    } else if (top2 > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top2 * 100 / containerHeight) / 100;
    }
    if (props.hsl.a !== a) {
      return {
        h: props.hsl.h,
        s: props.hsl.s,
        l: props.hsl.l,
        a,
        source: "rgb"
      };
    }
  } else {
    var _a = void 0;
    if (left2 < 0) {
      _a = 0;
    } else if (left2 > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left2 * 100 / containerWidth) / 100;
    }
    if (props.a !== _a) {
      return {
        h: props.hsl.h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: _a,
        source: "rgb"
      };
    }
  }
  return null;
};

// ../../node_modules/react-color/lib/components/common/Checkboard.js
init_cjs_shims();
var import_react45 = __toESM(require("react"));
var import_reactcss = __toESM(require_lib());

// ../../node_modules/react-color/lib/helpers/checkboard.js
init_cjs_shims();
var checkboardCache = {};
var render = function render2(c1, c2, size, serverCanvas) {
  if (typeof document === "undefined" && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement("canvas");
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext("2d");
  if (!ctx) {
    return null;
  }
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};
var get = function get2(c1, c2, size, serverCanvas) {
  var key = c1 + "-" + c2 + "-" + size + (serverCanvas ? "-server" : "");
  var checkboard = render(c1, c2, size, serverCanvas);
  if (checkboardCache[key]) {
    return checkboardCache[key];
  }
  checkboardCache[key] = checkboard;
  return checkboard;
};

// ../../node_modules/react-color/lib/components/common/Checkboard.js
var Checkboard = function Checkboard2(_ref) {
  var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow;
  var styles = (0, import_reactcss.default)({
    "default": {
      grid: {
        borderRadius,
        boxShadow,
        absolute: "0px 0px 0px 0px",
        background: "url(" + get(white, grey, size, renderers.canvas) + ") center left"
      }
    }
  });
  return import_react45.default.createElement("div", { style: styles.grid });
};
Checkboard.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var Checkboard_default = Checkboard;

// ../../node_modules/react-color/lib/components/common/Alpha.js
var _extends7 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Alpha = function(_ref) {
  _inherits(Alpha2, _ref);
  function Alpha2() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck(this, Alpha2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha2.__proto__ || Object.getPrototypeOf(Alpha2)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function(e, skip) {
      var change = calculateChange(e, skip, _this.props, _this.container);
      change && _this.props.onChange && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function(e) {
      _this.handleChange(e, true);
      window.addEventListener("mousemove", _this.handleChange);
      window.addEventListener("mouseup", _this.handleMouseUp);
    }, _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function() {
      window.removeEventListener("mousemove", _this.handleChange);
      window.removeEventListener("mouseup", _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Alpha2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var rgb = this.props.rgb;
      var styles = (0, import_reactcss2.default)({
        "default": {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden"
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: rgb.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        "vertical": {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + "%"
          }
        },
        "overwrite": _extends7({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: true
      });
      return import_react46.default.createElement(
        "div",
        { style: styles.alpha },
        import_react46.default.createElement(
          "div",
          { style: styles.checkboard },
          import_react46.default.createElement(Checkboard_default, { renderers: this.props.renderers })
        ),
        import_react46.default.createElement("div", { style: styles.gradient }),
        import_react46.default.createElement(
          "div",
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          import_react46.default.createElement(
            "div",
            { style: styles.pointer },
            this.props.pointer ? import_react46.default.createElement(this.props.pointer, this.props) : import_react46.default.createElement("div", { style: styles.slider })
          )
        )
      );
    }
  }]);
  return Alpha2;
}(import_react46.PureComponent || import_react46.Component);
var Alpha_default = Alpha;

// ../../node_modules/react-color/lib/components/common/EditableInput.js
init_cjs_shims();
var import_react47 = __toESM(require("react"));
var import_reactcss3 = __toESM(require_lib());
var _createClass2 = function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _defineProperty4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn2(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var EditableInput = function(_ref) {
  _inherits2(EditableInput2, _ref);
  function EditableInput2(props) {
    _classCallCheck2(this, EditableInput2);
    var _this = _possibleConstructorReturn2(this, (EditableInput2.__proto__ || Object.getPrototypeOf(EditableInput2)).call(this));
    _this.handleBlur = function() {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };
    _this.handleChange = function(e) {
      if (_this.props.label) {
        _this.props.onChange && _this.props.onChange(_defineProperty4({}, _this.props.label, e.target.value), e);
      } else {
        _this.props.onChange && _this.props.onChange(e.target.value, e);
      }
      _this.setState({ value: e.target.value });
    };
    _this.handleKeyDown = function(e) {
      var stringValue = String(e.target.value);
      var isPercentage = stringValue.indexOf("%") > -1;
      var number2 = Number(stringValue.replace(/%/g, ""));
      if (!isNaN(number2)) {
        var amount = _this.props.arrowOffset || 1;
        if (e.keyCode === 38) {
          if (_this.props.label !== null) {
            _this.props.onChange && _this.props.onChange(_defineProperty4({}, _this.props.label, number2 + amount), e);
          } else {
            _this.props.onChange && _this.props.onChange(number2 + amount, e);
          }
          if (isPercentage) {
            _this.setState({ value: number2 + amount + "%" });
          } else {
            _this.setState({ value: number2 + amount });
          }
        }
        if (e.keyCode === 40) {
          if (_this.props.label !== null) {
            _this.props.onChange && _this.props.onChange(_defineProperty4({}, _this.props.label, number2 - amount), e);
          } else {
            _this.props.onChange && _this.props.onChange(number2 - amount, e);
          }
          if (isPercentage) {
            _this.setState({ value: number2 - amount + "%" });
          } else {
            _this.setState({ value: number2 - amount });
          }
        }
      }
    };
    _this.handleDrag = function(e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_defineProperty4({}, _this.props.label, newValue), e);
        }
      }
    };
    _this.handleMouseDown = function(e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener("mousemove", _this.handleDrag);
        window.addEventListener("mouseup", _this.handleMouseUp);
      }
    };
    _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    };
    _this.unbindEventListeners = function() {
      window.removeEventListener("mousemove", _this.handleDrag);
      window.removeEventListener("mouseup", _this.handleMouseUp);
    };
    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };
    return _this;
  }
  _createClass2(EditableInput2, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var input = this.input;
      if (nextProps.value !== this.state.value) {
        if (input === document.activeElement) {
          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
        } else {
          this.setState({ value: String(nextProps.value).toUpperCase(), blurValue: !this.state.blurValue && String(nextProps.value).toUpperCase() });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var styles = (0, import_reactcss3.default)({
        "default": {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": true
      }, this.props);
      return import_react47.default.createElement(
        "div",
        { style: styles.wrap },
        import_react47.default.createElement("input", {
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: "false"
        }),
        this.props.label ? import_react47.default.createElement(
          "span",
          { style: styles.label, onMouseDown: this.handleMouseDown },
          this.props.label
        ) : null
      );
    }
  }]);
  return EditableInput2;
}(import_react47.PureComponent || import_react47.Component);
var EditableInput_default = EditableInput;

// ../../node_modules/react-color/lib/components/common/Hue.js
init_cjs_shims();
var import_react48 = __toESM(require("react"));
var import_reactcss4 = __toESM(require_lib());

// ../../node_modules/react-color/lib/helpers/hue.js
init_cjs_shims();
var calculateChange3 = function calculateChange4(e, skip, props, container) {
  e.preventDefault();
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
  var left2 = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top2 = y - (container.getBoundingClientRect().top + window.pageYOffset);
  if (props.direction === "vertical") {
    var h = void 0;
    if (top2 < 0) {
      h = 359;
    } else if (top2 > containerHeight) {
      h = 0;
    } else {
      var percent = -(top2 * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }
    if (props.hsl.h !== h) {
      return {
        h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: props.hsl.a,
        source: "rgb"
      };
    }
  } else {
    var _h = void 0;
    if (left2 < 0) {
      _h = 0;
    } else if (left2 > containerWidth) {
      _h = 359;
    } else {
      var _percent = left2 * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }
    if (props.hsl.h !== _h) {
      return {
        h: _h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: props.hsl.a,
        source: "rgb"
      };
    }
  }
  return null;
};

// ../../node_modules/react-color/lib/components/common/Hue.js
var _createClass3 = function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn3(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Hue = function(_ref) {
  _inherits3(Hue2, _ref);
  function Hue2() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck3(this, Hue2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn3(this, (_ref2 = Hue2.__proto__ || Object.getPrototypeOf(Hue2)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function(e, skip) {
      var change = calculateChange3(e, skip, _this.props, _this.container);
      change && _this.props.onChange && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function(e) {
      _this.handleChange(e, true);
      window.addEventListener("mousemove", _this.handleChange);
      window.addEventListener("mouseup", _this.handleMouseUp);
    }, _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn3(_this, _ret);
  }
  _createClass3(Hue2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function unbindEventListeners() {
      window.removeEventListener("mousemove", this.handleChange);
      window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var _props$direction = this.props.direction, direction = _props$direction === void 0 ? "horizontal" : _props$direction;
      var styles = (0, import_reactcss4.default)({
        "default": {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%"
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        "vertical": {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, { vertical: direction === "vertical" });
      return import_react48.default.createElement(
        "div",
        { style: styles.hue },
        import_react48.default.createElement(
          "div",
          {
            className: "hue-" + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          import_react48.default.createElement(
            "style",
            null,
            "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "
          ),
          import_react48.default.createElement(
            "div",
            { style: styles.pointer },
            this.props.pointer ? import_react48.default.createElement(this.props.pointer, this.props) : import_react48.default.createElement("div", { style: styles.slider })
          )
        )
      );
    }
  }]);
  return Hue2;
}(import_react48.PureComponent || import_react48.Component);
var Hue_default = Hue;

// ../../node_modules/react-color/lib/components/common/Raised.js
init_cjs_shims();
var import_react49 = __toESM(require("react"));
var import_prop_types5 = __toESM(require_prop_types());
var import_reactcss5 = __toESM(require_lib());
var Raised = function Raised2(_ref) {
  var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children;
  var styles = (0, import_reactcss5.default)({
    "default": {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + zDepth + "px " + zDepth * 4 + "px rgba(0,0,0,.24)",
        borderRadius: radius,
        background
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    "square": {
      bg: {
        borderRadius: "0"
      }
    },
    "circle": {
      bg: {
        borderRadius: "50%"
      }
    }
  }, { "zDepth-1": zDepth === 1 });
  return import_react49.default.createElement(
    "div",
    { style: styles.wrap },
    import_react49.default.createElement("div", { style: styles.bg }),
    import_react49.default.createElement(
      "div",
      { style: styles.content },
      children
    )
  );
};
Raised.propTypes = {
  background: import_prop_types5.default.string,
  zDepth: import_prop_types5.default.oneOf([0, 1, 2, 3, 4, 5]),
  radius: import_prop_types5.default.number
};
Raised.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2
};
var Raised_default = Raised;

// ../../node_modules/react-color/lib/components/common/Saturation.js
init_cjs_shims();
var import_react50 = __toESM(require("react"));
var import_reactcss6 = __toESM(require_lib());
var import_throttle = __toESM(require_throttle());

// ../../node_modules/react-color/lib/helpers/saturation.js
init_cjs_shims();
var calculateChange5 = function calculateChange6(e, skip, props, container) {
  e.preventDefault();
  var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
  var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
  var left2 = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top2 = y - (container.getBoundingClientRect().top + window.pageYOffset);
  if (left2 < 0) {
    left2 = 0;
  } else if (left2 > containerWidth) {
    left2 = containerWidth;
  } else if (top2 < 0) {
    top2 = 0;
  } else if (top2 > containerHeight) {
    top2 = containerHeight;
  }
  var saturation = left2 * 100 / containerWidth;
  var bright = -(top2 * 100 / containerHeight) + 100;
  return {
    h: props.hsl.h,
    s: saturation,
    v: bright,
    a: props.hsl.a,
    source: "rgb"
  };
};

// ../../node_modules/react-color/lib/components/common/Saturation.js
var _createClass4 = function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn4(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Saturation = function(_ref) {
  _inherits4(Saturation2, _ref);
  function Saturation2(props) {
    _classCallCheck4(this, Saturation2);
    var _this = _possibleConstructorReturn4(this, (Saturation2.__proto__ || Object.getPrototypeOf(Saturation2)).call(this, props));
    _this.handleChange = function(e, skip) {
      _this.props.onChange && _this.throttle(_this.props.onChange, calculateChange5(e, skip, _this.props, _this.container), e);
    };
    _this.handleMouseDown = function(e) {
      _this.handleChange(e, true);
      window.addEventListener("mousemove", _this.handleChange);
      window.addEventListener("mouseup", _this.handleMouseUp);
    };
    _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    };
    _this.throttle = (0, import_throttle.default)(function(fn2, data, e) {
      fn2(data, e);
    }, 50);
    return _this;
  }
  _createClass4(Saturation2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function unbindEventListeners() {
      window.removeEventListener("mousemove", this.handleChange);
      window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
      var styles = (0, import_reactcss6.default)({
        "default": {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        "custom": {
          color,
          white,
          black,
          pointer,
          circle
        }
      }, { "custom": !!this.props.style });
      return import_react50.default.createElement(
        "div",
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        import_react50.default.createElement(
          "style",
          null,
          "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "
        ),
        import_react50.default.createElement(
          "div",
          { style: styles.white, className: "saturation-white" },
          import_react50.default.createElement("div", { style: styles.black, className: "saturation-black" }),
          import_react50.default.createElement(
            "div",
            { style: styles.pointer },
            this.props.pointer ? import_react50.default.createElement(this.props.pointer, this.props) : import_react50.default.createElement("div", { style: styles.circle })
          )
        )
      );
    }
  }]);
  return Saturation2;
}(import_react50.PureComponent || import_react50.Component);
var Saturation_default = Saturation;

// ../../node_modules/react-color/lib/components/common/ColorWrap.js
init_cjs_shims();
var import_react51 = __toESM(require("react"));
var import_debounce2 = __toESM(require_debounce());

// ../../node_modules/react-color/lib/helpers/color.js
init_cjs_shims();
var import_each = __toESM(require_each());
var import_tinycolor2 = __toESM(require_tinycolor());
var color_default = {
  simpleCheckForValidColor: function simpleCheckForValidColor(data) {
    var keysToCheck = ["r", "g", "b", "a", "h", "s", "l", "v"];
    var checked = 0;
    var passed = 0;
    (0, import_each.default)(keysToCheck, function(letter) {
      if (data[letter]) {
        checked += 1;
        if (!isNaN(data[letter])) {
          passed += 1;
        }
        if (letter === "s" || letter === "l") {
          var percentPatt = /^\d+%$/;
          if (percentPatt.test(data[letter])) {
            passed += 1;
          }
        }
      }
    });
    return checked === passed ? data : false;
  },
  toState: function toState(data, oldHue) {
    var color = data.hex ? (0, import_tinycolor2.default)(data.hex) : (0, import_tinycolor2.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
      hsl.h = oldHue || 0;
      hsv.h = oldHue || 0;
    }
    var transparent = hex === "000000" && rgb.a === 0;
    return {
      hsl,
      hex: transparent ? "transparent" : "#" + hex,
      rgb,
      hsv,
      oldHue: data.h || oldHue || hsl.h,
      source: data.source
    };
  },
  isValidHex: function isValidHex(hex) {
    return (0, import_tinycolor2.default)(hex).isValid();
  },
  getContrastingColor: function getContrastingColor(data) {
    if (!data) {
      return "#fff";
    }
    var col = this.toState(data);
    if (col.hex === "transparent") {
      return "rgba(0,0,0,0.4)";
    }
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1e3;
    return yiq >= 128 ? "#000" : "#fff";
  }
};

// ../../node_modules/react-color/lib/components/common/ColorWrap.js
var _extends8 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass5 = function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn5(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ColorWrap = function ColorWrap2(Picker) {
  var ColorPicker2 = function(_ref) {
    _inherits5(ColorPicker3, _ref);
    function ColorPicker3(props) {
      _classCallCheck5(this, ColorPicker3);
      var _this = _possibleConstructorReturn5(this, (ColorPicker3.__proto__ || Object.getPrototypeOf(ColorPicker3)).call(this));
      _this.handleChange = function(data, event) {
        var isValidColor = color_default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = color_default.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };
      _this.handleSwatchHover = function(data, event) {
        var isValidColor = color_default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = color_default.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };
      _this.state = _extends8({}, color_default.toState(props.color, 0));
      _this.debounce = (0, import_debounce2.default)(function(fn2, data, event) {
        fn2(data, event);
      }, 100);
      return _this;
    }
    _createClass5(ColorPicker3, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        this.setState(_extends8({}, color_default.toState(nextProps.color, this.state.oldHue)));
      }
    }, {
      key: "render",
      value: function render3() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }
        return import_react51.default.createElement(Picker, _extends8({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }]);
    return ColorPicker3;
  }(import_react51.PureComponent || import_react51.Component);
  ColorPicker2.propTypes = _extends8({}, Picker.propTypes);
  ColorPicker2.defaultProps = _extends8({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  });
  return ColorPicker2;
};
var ColorWrap_default = ColorWrap;

// ../../node_modules/react-color/lib/components/common/Swatch.js
init_cjs_shims();
var import_react53 = __toESM(require("react"));
var import_reactcss7 = __toESM(require_lib());

// ../../node_modules/react-color/lib/helpers/interaction.js
init_cjs_shims();
var import_react52 = __toESM(require("react"));
var _extends9 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _classCallCheck6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn6(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus2(Component7) {
  var Span = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(_React$Component) {
    _inherits6(Focus, _React$Component);
    function Focus() {
      var _ref;
      var _temp, _this, _ret;
      _classCallCheck6(this, Focus);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn6(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function() {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function() {
        return _this.setState({ focus: false });
      }, _this.render = function() {
        return import_react52.default.createElement(
          Span,
          { onFocus: _this.handleFocus, onBlur: _this.handleBlur },
          import_react52.default.createElement(Component7, _extends9({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn6(_this, _ret);
    }
    return Focus;
  }(import_react52.default.Component);
};

// ../../node_modules/react-color/lib/components/common/Swatch.js
var _extends10 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var ENTER = 13;
var Swatch = function Swatch2(_ref) {
  var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === void 0 ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === void 0 ? {} : _ref$focusStyle;
  var transparent = color === "transparent";
  var styles = (0, import_reactcss7.default)({
    default: {
      swatch: _extends10({
        background: color,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, style, focus ? focusStyle : {})
    }
  });
  var handleClick = function handleClick2(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown2(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover3 = function handleHover4(e) {
    return onHover(color, e);
  };
  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover3;
  }
  return import_react53.default.createElement(
    "div",
    _extends10({
      style: styles.swatch,
      onClick: handleClick,
      title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && import_react53.default.createElement(Checkboard_default, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    })
  );
};
var Swatch_default = handleFocus(Swatch);

// ../../node_modules/react-color/lib/components/alpha/AlphaPointer.js
init_cjs_shims();
var import_react54 = __toESM(require("react"));
var import_reactcss8 = __toESM(require_lib());
var AlphaPointer = function AlphaPointer2(_ref) {
  var direction = _ref.direction;
  var styles = (0, import_reactcss8.default)({
    "default": {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    "vertical": {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: direction === "vertical" });
  return import_react54.default.createElement("div", { style: styles.picker });
};
var AlphaPointer_default = AlphaPointer;

// ../../node_modules/react-color/lib/components/alpha/Alpha.js
var _extends11 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var AlphaPicker = function AlphaPicker2(_ref) {
  var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles = (0, import_reactcss9.default)({
    "default": {
      picker: {
        position: "relative",
        width,
        height
      },
      alpha: {
        radius: "2px",
        style
      }
    }
  });
  return import_react55.default.createElement(
    "div",
    { style: styles.picker, className: "alpha-picker " + className },
    import_react55.default.createElement(Alpha_default, _extends11({}, styles.alpha, {
      rgb,
      hsl,
      pointer,
      renderers,
      onChange,
      direction
    }))
  );
};
AlphaPicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: AlphaPointer_default
};
var Alpha_default2 = ColorWrap_default(AlphaPicker);

// ../../node_modules/react-color/lib/components/block/Block.js
init_cjs_shims();
var import_react57 = __toESM(require("react"));
var import_prop_types6 = __toESM(require_prop_types());
var import_reactcss11 = __toESM(require_lib());

// ../../node_modules/react-color/lib/components/block/BlockSwatches.js
init_cjs_shims();
var import_react56 = __toESM(require("react"));
var import_reactcss10 = __toESM(require_lib());
var import_map = __toESM(require_map());
var BlockSwatches = function BlockSwatches2(_ref) {
  var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
  var styles = (0, import_reactcss10.default)({
    "default": {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return import_react56.default.createElement(
    "div",
    { style: styles.swatches },
    (0, import_map.default)(colors, function(c) {
      return import_react56.default.createElement(Swatch_default, {
        key: c,
        color: c,
        style: styles.swatch,
        onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: "0 0 4px " + c
        }
      });
    }),
    import_react56.default.createElement("div", { style: styles.clear })
  );
};
var BlockSwatches_default = BlockSwatches;

// ../../node_modules/react-color/lib/components/block/Block.js
var Block = function Block2(_ref) {
  var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var transparent = hex === "transparent";
  var handleChange = function handleChange2(hexCode, e) {
    color_default.isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: "hex"
    }, e);
  };
  var styles = (0, import_reactcss11.default)({
    "default": {
      card: {
        width,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: hex,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: color_default.getContrastingColor(hex),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + hex + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, { "hide-triangle": triangle === "hide" });
  return import_react57.default.createElement(
    "div",
    { style: styles.card, className: "block-picker " + className },
    import_react57.default.createElement("div", { style: styles.triangle }),
    import_react57.default.createElement(
      "div",
      { style: styles.head },
      transparent && import_react57.default.createElement(Checkboard_default, { borderRadius: "6px 6px 0 0" }),
      import_react57.default.createElement(
        "div",
        { style: styles.label },
        hex
      )
    ),
    import_react57.default.createElement(
      "div",
      { style: styles.body },
      import_react57.default.createElement(BlockSwatches_default, { colors, onClick: handleChange, onSwatchHover }),
      import_react57.default.createElement(EditableInput_default, {
        style: { input: styles.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};
Block.propTypes = {
  width: import_prop_types6.default.oneOfType([import_prop_types6.default.string, import_prop_types6.default.number]),
  colors: import_prop_types6.default.arrayOf(import_prop_types6.default.string),
  triangle: import_prop_types6.default.oneOf(["top", "hide"])
};
Block.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top"
};
var Block_default = ColorWrap_default(Block);

// ../../node_modules/react-color/lib/components/circle/Circle.js
init_cjs_shims();
var import_react59 = __toESM(require("react"));
var import_prop_types7 = __toESM(require_prop_types());
var import_reactcss13 = __toESM(require_lib());
var import_map2 = __toESM(require_map());

// ../../node_modules/material-colors/dist/colors.es2015.js
init_cjs_shims();
var red = { "50": "#ffebee", "100": "#ffcdd2", "200": "#ef9a9a", "300": "#e57373", "400": "#ef5350", "500": "#f44336", "600": "#e53935", "700": "#d32f2f", "800": "#c62828", "900": "#b71c1c", "a100": "#ff8a80", "a200": "#ff5252", "a400": "#ff1744", "a700": "#d50000" };
var pink = { "50": "#fce4ec", "100": "#f8bbd0", "200": "#f48fb1", "300": "#f06292", "400": "#ec407a", "500": "#e91e63", "600": "#d81b60", "700": "#c2185b", "800": "#ad1457", "900": "#880e4f", "a100": "#ff80ab", "a200": "#ff4081", "a400": "#f50057", "a700": "#c51162" };
var purple = { "50": "#f3e5f5", "100": "#e1bee7", "200": "#ce93d8", "300": "#ba68c8", "400": "#ab47bc", "500": "#9c27b0", "600": "#8e24aa", "700": "#7b1fa2", "800": "#6a1b9a", "900": "#4a148c", "a100": "#ea80fc", "a200": "#e040fb", "a400": "#d500f9", "a700": "#aa00ff" };
var deepPurple = { "50": "#ede7f6", "100": "#d1c4e9", "200": "#b39ddb", "300": "#9575cd", "400": "#7e57c2", "500": "#673ab7", "600": "#5e35b1", "700": "#512da8", "800": "#4527a0", "900": "#311b92", "a100": "#b388ff", "a200": "#7c4dff", "a400": "#651fff", "a700": "#6200ea" };
var indigo = { "50": "#e8eaf6", "100": "#c5cae9", "200": "#9fa8da", "300": "#7986cb", "400": "#5c6bc0", "500": "#3f51b5", "600": "#3949ab", "700": "#303f9f", "800": "#283593", "900": "#1a237e", "a100": "#8c9eff", "a200": "#536dfe", "a400": "#3d5afe", "a700": "#304ffe" };
var blue = { "50": "#e3f2fd", "100": "#bbdefb", "200": "#90caf9", "300": "#64b5f6", "400": "#42a5f5", "500": "#2196f3", "600": "#1e88e5", "700": "#1976d2", "800": "#1565c0", "900": "#0d47a1", "a100": "#82b1ff", "a200": "#448aff", "a400": "#2979ff", "a700": "#2962ff" };
var lightBlue = { "50": "#e1f5fe", "100": "#b3e5fc", "200": "#81d4fa", "300": "#4fc3f7", "400": "#29b6f6", "500": "#03a9f4", "600": "#039be5", "700": "#0288d1", "800": "#0277bd", "900": "#01579b", "a100": "#80d8ff", "a200": "#40c4ff", "a400": "#00b0ff", "a700": "#0091ea" };
var cyan = { "50": "#e0f7fa", "100": "#b2ebf2", "200": "#80deea", "300": "#4dd0e1", "400": "#26c6da", "500": "#00bcd4", "600": "#00acc1", "700": "#0097a7", "800": "#00838f", "900": "#006064", "a100": "#84ffff", "a200": "#18ffff", "a400": "#00e5ff", "a700": "#00b8d4" };
var teal = { "50": "#e0f2f1", "100": "#b2dfdb", "200": "#80cbc4", "300": "#4db6ac", "400": "#26a69a", "500": "#009688", "600": "#00897b", "700": "#00796b", "800": "#00695c", "900": "#004d40", "a100": "#a7ffeb", "a200": "#64ffda", "a400": "#1de9b6", "a700": "#00bfa5" };
var green = { "50": "#e8f5e9", "100": "#c8e6c9", "200": "#a5d6a7", "300": "#81c784", "400": "#66bb6a", "500": "#4caf50", "600": "#43a047", "700": "#388e3c", "800": "#2e7d32", "900": "#1b5e20", "a100": "#b9f6ca", "a200": "#69f0ae", "a400": "#00e676", "a700": "#00c853" };
var lightGreen = { "50": "#f1f8e9", "100": "#dcedc8", "200": "#c5e1a5", "300": "#aed581", "400": "#9ccc65", "500": "#8bc34a", "600": "#7cb342", "700": "#689f38", "800": "#558b2f", "900": "#33691e", "a100": "#ccff90", "a200": "#b2ff59", "a400": "#76ff03", "a700": "#64dd17" };
var lime = { "50": "#f9fbe7", "100": "#f0f4c3", "200": "#e6ee9c", "300": "#dce775", "400": "#d4e157", "500": "#cddc39", "600": "#c0ca33", "700": "#afb42b", "800": "#9e9d24", "900": "#827717", "a100": "#f4ff81", "a200": "#eeff41", "a400": "#c6ff00", "a700": "#aeea00" };
var yellow = { "50": "#fffde7", "100": "#fff9c4", "200": "#fff59d", "300": "#fff176", "400": "#ffee58", "500": "#ffeb3b", "600": "#fdd835", "700": "#fbc02d", "800": "#f9a825", "900": "#f57f17", "a100": "#ffff8d", "a200": "#ffff00", "a400": "#ffea00", "a700": "#ffd600" };
var amber = { "50": "#fff8e1", "100": "#ffecb3", "200": "#ffe082", "300": "#ffd54f", "400": "#ffca28", "500": "#ffc107", "600": "#ffb300", "700": "#ffa000", "800": "#ff8f00", "900": "#ff6f00", "a100": "#ffe57f", "a200": "#ffd740", "a400": "#ffc400", "a700": "#ffab00" };
var orange = { "50": "#fff3e0", "100": "#ffe0b2", "200": "#ffcc80", "300": "#ffb74d", "400": "#ffa726", "500": "#ff9800", "600": "#fb8c00", "700": "#f57c00", "800": "#ef6c00", "900": "#e65100", "a100": "#ffd180", "a200": "#ffab40", "a400": "#ff9100", "a700": "#ff6d00" };
var deepOrange = { "50": "#fbe9e7", "100": "#ffccbc", "200": "#ffab91", "300": "#ff8a65", "400": "#ff7043", "500": "#ff5722", "600": "#f4511e", "700": "#e64a19", "800": "#d84315", "900": "#bf360c", "a100": "#ff9e80", "a200": "#ff6e40", "a400": "#ff3d00", "a700": "#dd2c00" };
var brown = { "50": "#efebe9", "100": "#d7ccc8", "200": "#bcaaa4", "300": "#a1887f", "400": "#8d6e63", "500": "#795548", "600": "#6d4c41", "700": "#5d4037", "800": "#4e342e", "900": "#3e2723" };
var blueGrey = { "50": "#eceff1", "100": "#cfd8dc", "200": "#b0bec5", "300": "#90a4ae", "400": "#78909c", "500": "#607d8b", "600": "#546e7a", "700": "#455a64", "800": "#37474f", "900": "#263238" };

// ../../node_modules/react-color/lib/components/circle/CircleSwatch.js
init_cjs_shims();
var import_react58 = __toESM(require("react"));
var import_reactcss12 = __toESM(require_lib());
var CircleSwatch = function CircleSwatch2(_ref) {
  var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
  var styles = (0, import_reactcss12.default)({
    "default": {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + circleSize / 2 + "px " + color,
        transition: "100ms box-shadow ease"
      }
    },
    "hover": {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    "active": {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + color
      }
    }
  }, { hover, active });
  return import_react58.default.createElement(
    "div",
    { style: styles.swatch },
    import_react58.default.createElement(Swatch_default, {
      style: styles.Swatch,
      color,
      onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ", 0 0 5px " + color }
    })
  );
};
CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
var CircleSwatch_default = (0, import_reactcss12.handleHover)(CircleSwatch);

// ../../node_modules/react-color/lib/components/circle/Circle.js
var Circle = function Circle2(_ref) {
  var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles = (0, import_reactcss13.default)({
    "default": {
      card: {
        width,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  });
  var handleChange = function handleChange2(hexCode, e) {
    return onChange({ hex: hexCode, source: "hex" }, e);
  };
  return import_react59.default.createElement(
    "div",
    { style: styles.card, className: "circle-picker " + className },
    (0, import_map2.default)(colors, function(c) {
      return import_react59.default.createElement(CircleSwatch_default, {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize,
        circleSpacing
      });
    })
  );
};
Circle.propTypes = {
  width: import_prop_types7.default.oneOfType([import_prop_types7.default.string, import_prop_types7.default.number]),
  circleSize: import_prop_types7.default.number,
  circleSpacing: import_prop_types7.default.number
};
Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [red["500"], pink["500"], purple["500"], deepPurple["500"], indigo["500"], blue["500"], lightBlue["500"], cyan["500"], teal["500"], green["500"], lightGreen["500"], lime["500"], yellow["500"], amber["500"], orange["500"], deepOrange["500"], brown["500"], blueGrey["500"]]
};
var Circle_default = ColorWrap_default(Circle);

// ../../node_modules/react-color/lib/components/chrome/Chrome.js
init_cjs_shims();
var import_react63 = __toESM(require("react"));
var import_prop_types8 = __toESM(require_prop_types());
var import_reactcss17 = __toESM(require_lib());

// ../../node_modules/react-color/lib/components/chrome/ChromeFields.js
init_cjs_shims();
var import_react60 = __toESM(require("react"));
var import_reactcss14 = __toESM(require_lib());
var _createClass6 = function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn7(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ChromeFields = function(_React$Component) {
  _inherits7(ChromeFields2, _React$Component);
  function ChromeFields2() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck7(this, ChromeFields2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn7(this, (_ref = ChromeFields2.__proto__ || Object.getPrototypeOf(ChromeFields2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      view: ""
    }, _this.toggleViews = function() {
      if (_this.state.view === "hex") {
        _this.setState({ view: "rgb" });
      } else if (_this.state.view === "rgb") {
        _this.setState({ view: "hsl" });
      } else if (_this.state.view === "hsl") {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: "hex" });
        } else {
          _this.setState({ view: "rgb" });
        }
      }
    }, _this.handleChange = function(data, e) {
      if (data.hex) {
        color_default.isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: "hex"
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: "rgb"
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }
        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: "rgb"
        }, e);
      } else if (data.h || data.s || data.l) {
        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(data.s && data.s || _this.props.hsl.s),
          l: Number(data.l && data.l || _this.props.hsl.l),
          source: "hsl"
        }, e);
      }
    }, _this.showHighlight = function(e) {
      e.target.style.background = "#eee";
    }, _this.hideHighlight = function(e) {
      e.target.style.background = "transparent";
    }, _temp), _possibleConstructorReturn7(_this, _ret);
  }
  _createClass6(ChromeFields2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.hsl.a === 1 && this.state.view !== "hex") {
        this.setState({ view: "hex" });
      } else if (this.state.view !== "rgb" && this.state.view !== "hsl") {
        this.setState({ view: "rgb" });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hsl.a !== 1 && this.state.view === "hex") {
        this.setState({ view: "rgb" });
      }
    }
  }, {
    key: "render",
    value: function render3() {
      var _this2 = this;
      var styles = (0, import_reactcss14.default)({
        "default": {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        "disableAlpha": {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state);
      var fields = void 0;
      if (this.state.view === "hex") {
        fields = import_react60.default.createElement(
          "div",
          { style: styles.fields, className: "flexbox-fix" },
          import_react60.default.createElement(
            "div",
            { style: styles.field },
            import_react60.default.createElement(EditableInput_default, {
              style: { input: styles.input, label: styles.label },
              label: "hex",
              value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === "rgb") {
        fields = import_react60.default.createElement(
          "div",
          { style: styles.fields, className: "flexbox-fix" },
          import_react60.default.createElement(
            "div",
            { style: styles.field },
            import_react60.default.createElement(EditableInput_default, {
              style: { input: styles.input, label: styles.label },
              label: "r",
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          import_react60.default.createElement(
            "div",
            { style: styles.field },
            import_react60.default.createElement(EditableInput_default, {
              style: { input: styles.input, label: styles.label },
              label: "g",
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          import_react60.default.createElement(
            "div",
            { style: styles.field },
            import_react60.default.createElement(EditableInput_default, {
              style: { input: styles.input, label: styles.label },
              label: "b",
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          import_react60.default.createElement(
            "div",
            { style: styles.alpha },
            import_react60.default.createElement(EditableInput_default, {
              style: { input: styles.input, label: styles.label },
              label: "a",
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === "hsl") {
        fields = import_react60.default.createElement(
          "div",
          { style: styles.fields, className: "flexbox-fix" },
          import_react60.default.createElement(
            "div",
            { style: styles.field },
            import_react60.default.createElement(EditableInput_default, {
              style: { input: styles.input, label: styles.label },
              label: "h",
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          import_react60.default.createElement(
            "div",
            { style: styles.field },
            import_react60.default.createElement(EditableInput_default, {
              style: { input: styles.input, label: styles.label },
              label: "s",
              value: Math.round(this.props.hsl.s * 100) + "%",
              onChange: this.handleChange
            })
          ),
          import_react60.default.createElement(
            "div",
            { style: styles.field },
            import_react60.default.createElement(EditableInput_default, {
              style: { input: styles.input, label: styles.label },
              label: "l",
              value: Math.round(this.props.hsl.l * 100) + "%",
              onChange: this.handleChange
            })
          ),
          import_react60.default.createElement(
            "div",
            { style: styles.alpha },
            import_react60.default.createElement(EditableInput_default, {
              style: { input: styles.input, label: styles.label },
              label: "a",
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }
      return import_react60.default.createElement(
        "div",
        { style: styles.wrap, className: "flexbox-fix" },
        fields,
        import_react60.default.createElement(
          "div",
          { style: styles.toggle },
          import_react60.default.createElement(
            "div",
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
              return _this2.icon = icon;
            } },
            import_react60.default.createElement(
              "svg",
              {
                style: styles.svg,
                viewBox: "0 0 24 24",
                onMouseOver: this.showHighlight,
                onMouseEnter: this.showHighlight,
                onMouseOut: this.hideHighlight
              },
              import_react60.default.createElement("path", {
                ref: function ref(iconUp) {
                  return _this2.iconUp = iconUp;
                },
                fill: "#333",
                d: "M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
              }),
              import_react60.default.createElement("path", {
                ref: function ref(iconDown) {
                  return _this2.iconDown = iconDown;
                },
                fill: "#333",
                d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15Z"
              })
            )
          )
        )
      );
    }
  }]);
  return ChromeFields2;
}(import_react60.default.Component);
var ChromeFields_default = ChromeFields;

// ../../node_modules/react-color/lib/components/chrome/ChromePointer.js
init_cjs_shims();
var import_react61 = __toESM(require("react"));
var import_reactcss15 = __toESM(require_lib());
var ChromePointer = function ChromePointer2() {
  var styles = (0, import_reactcss15.default)({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return import_react61.default.createElement("div", { style: styles.picker });
};
var ChromePointer_default = ChromePointer;

// ../../node_modules/react-color/lib/components/chrome/ChromePointerCircle.js
init_cjs_shims();
var import_react62 = __toESM(require("react"));
var import_reactcss16 = __toESM(require_lib());
var ChromePointerCircle = function ChromePointerCircle2() {
  var styles = (0, import_reactcss16.default)({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return import_react62.default.createElement("div", { style: styles.picker });
};
var ChromePointerCircle_default = ChromePointerCircle;

// ../../node_modules/react-color/lib/components/chrome/Chrome.js
var Chrome = function Chrome2(_ref) {
  var onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles = (0, import_reactcss17.default)({
    "default": {
      picker: {
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        width: "225px",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + rgb.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    "disableAlpha": {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, { disableAlpha });
  return import_react63.default.createElement(
    "div",
    { style: styles.picker, className: "chrome-picker " + className },
    import_react63.default.createElement(
      "div",
      { style: styles.saturation },
      import_react63.default.createElement(Saturation_default, {
        style: styles.Saturation,
        hsl,
        hsv,
        pointer: ChromePointerCircle_default,
        onChange
      })
    ),
    import_react63.default.createElement(
      "div",
      { style: styles.body },
      import_react63.default.createElement(
        "div",
        { style: styles.controls, className: "flexbox-fix" },
        import_react63.default.createElement(
          "div",
          { style: styles.color },
          import_react63.default.createElement(
            "div",
            { style: styles.swatch },
            import_react63.default.createElement("div", { style: styles.active }),
            import_react63.default.createElement(Checkboard_default, { renderers })
          )
        ),
        import_react63.default.createElement(
          "div",
          { style: styles.toggles },
          import_react63.default.createElement(
            "div",
            { style: styles.hue },
            import_react63.default.createElement(Hue_default, {
              style: styles.Hue,
              hsl,
              pointer: ChromePointer_default,
              onChange
            })
          ),
          import_react63.default.createElement(
            "div",
            { style: styles.alpha },
            import_react63.default.createElement(Alpha_default, {
              style: styles.Alpha,
              rgb,
              hsl,
              pointer: ChromePointer_default,
              renderers,
              onChange
            })
          )
        )
      ),
      import_react63.default.createElement(ChromeFields_default, {
        rgb,
        hsl,
        hex,
        onChange,
        disableAlpha
      })
    )
  );
};
Chrome.propTypes = {
  disableAlpha: import_prop_types8.default.bool
};
Chrome.defaultProps = {
  disableAlpha: false
};
var Chrome_default = ColorWrap_default(Chrome);

// ../../node_modules/react-color/lib/components/compact/Compact.js
init_cjs_shims();
var import_react66 = __toESM(require("react"));
var import_prop_types9 = __toESM(require_prop_types());
var import_reactcss20 = __toESM(require_lib());
var import_map3 = __toESM(require_map());

// ../../node_modules/react-color/lib/components/compact/CompactColor.js
init_cjs_shims();
var import_react64 = __toESM(require("react"));
var import_reactcss18 = __toESM(require_lib());
var CompactColor = function CompactColor2(_ref) {
  var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
  var styles = (0, import_reactcss18.default)({
    "default": {
      color: {
        background: color,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: color_default.getContrastingColor(color),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    "active": {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    "transparent": {
      dot: {
        background: "#000"
      }
    }
  }, { active, "color-#FFFFFF": color === "#FFFFFF", "transparent": color === "transparent" });
  return import_react64.default.createElement(
    Swatch_default,
    {
      style: styles.color,
      color,
      onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: "0 0 4px " + color }
    },
    import_react64.default.createElement("div", { style: styles.dot })
  );
};
var CompactColor_default = CompactColor;

// ../../node_modules/react-color/lib/components/compact/CompactFields.js
init_cjs_shims();
var import_react65 = __toESM(require("react"));
var import_reactcss19 = __toESM(require_lib());
var CompactFields = function CompactFields2(_ref) {
  var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
  var styles = (0, import_reactcss19.default)({
    "default": {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: hex
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  });
  var handleChange = function handleChange2(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: "rgb"
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: "hex"
      }, e);
    }
  };
  return import_react65.default.createElement(
    "div",
    { style: styles.fields, className: "flexbox-fix" },
    import_react65.default.createElement("div", { style: styles.active }),
    import_react65.default.createElement(EditableInput_default, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: "hex",
      value: hex,
      onChange: handleChange
    }),
    import_react65.default.createElement(EditableInput_default, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: "r",
      value: rgb.r,
      onChange: handleChange
    }),
    import_react65.default.createElement(EditableInput_default, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: "g",
      value: rgb.g,
      onChange: handleChange
    }),
    import_react65.default.createElement(EditableInput_default, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: "b",
      value: rgb.b,
      onChange: handleChange
    })
  );
};
var CompactFields_default = CompactFields;

// ../../node_modules/react-color/lib/components/compact/Compact.js
var Compact = function Compact2(_ref) {
  var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles = (0, import_reactcss20.default)({
    "default": {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  var handleChange = function handleChange2(data, e) {
    if (data.hex) {
      color_default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: "hex"
      }, e);
    } else {
      onChange(data, e);
    }
  };
  return import_react66.default.createElement(
    Raised_default,
    { style: styles.Compact },
    import_react66.default.createElement(
      "div",
      { style: styles.compact, className: "compact-picker " + className },
      import_react66.default.createElement(
        "div",
        null,
        (0, import_map3.default)(colors, function(c) {
          return import_react66.default.createElement(CompactColor_default, {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover
          });
        }),
        import_react66.default.createElement("div", { style: styles.clear })
      ),
      import_react66.default.createElement(CompactFields_default, { hex, rgb, onChange: handleChange })
    )
  );
};
Compact.propTypes = {
  colors: import_prop_types9.default.arrayOf(import_prop_types9.default.string)
};
Compact.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"]
};
var Compact_default = ColorWrap_default(Compact);

// ../../node_modules/react-color/lib/components/github/Github.js
init_cjs_shims();
var import_react68 = __toESM(require("react"));
var import_prop_types10 = __toESM(require_prop_types());
var import_reactcss22 = __toESM(require_lib());
var import_map4 = __toESM(require_map());

// ../../node_modules/react-color/lib/components/github/GithubSwatch.js
init_cjs_shims();
var import_react67 = __toESM(require("react"));
var import_reactcss21 = __toESM(require_lib());
var GithubSwatch = function GithubSwatch2(_ref) {
  var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
  var hoverSwatch = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  };
  var styles = (0, import_reactcss21.default)({
    "default": {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    "hover": {
      swatch: hoverSwatch
    }
  }, { hover });
  return import_react67.default.createElement(
    "div",
    { style: styles.swatch },
    import_react67.default.createElement(Swatch_default, {
      color,
      onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};
var GithubSwatch_default = (0, import_reactcss21.handleHover)(GithubSwatch);

// ../../node_modules/react-color/lib/components/github/Github.js
var Github = function Github2(_ref) {
  var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles = (0, import_reactcss22.default)({
    "default": {
      card: {
        width,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, {
    "hide-triangle": triangle === "hide",
    "top-left-triangle": triangle === "top-left",
    "top-right-triangle": triangle === "top-right",
    "bottom-right-triangle": triangle === "bottom-right"
  });
  var handleChange = function handleChange2(hex, e) {
    return onChange({ hex, source: "hex" }, e);
  };
  return import_react68.default.createElement(
    "div",
    { style: styles.card, className: "github-picker " + className },
    import_react68.default.createElement("div", { style: styles.triangleShadow }),
    import_react68.default.createElement("div", { style: styles.triangle }),
    (0, import_map4.default)(colors, function(c) {
      return import_react68.default.createElement(GithubSwatch_default, {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover
      });
    })
  );
};
Github.propTypes = {
  width: import_prop_types10.default.oneOfType([import_prop_types10.default.string, import_prop_types10.default.number]),
  colors: import_prop_types10.default.arrayOf(import_prop_types10.default.string),
  triangle: import_prop_types10.default.oneOf(["hide", "top-left", "top-right"])
};
Github.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left"
};
var Github_default = ColorWrap_default(Github);

// ../../node_modules/react-color/lib/components/hue/Hue.js
init_cjs_shims();
var import_react70 = __toESM(require("react"));
var import_reactcss24 = __toESM(require_lib());

// ../../node_modules/react-color/lib/components/hue/HuePointer.js
init_cjs_shims();
var import_react69 = __toESM(require("react"));
var import_reactcss23 = __toESM(require_lib());
var SliderPointer = function SliderPointer2(_ref) {
  var direction = _ref.direction;
  var styles = (0, import_reactcss23.default)({
    "default": {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    "vertical": {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: direction === "vertical" });
  return import_react69.default.createElement("div", { style: styles.picker });
};
var HuePointer_default = SliderPointer;

// ../../node_modules/react-color/lib/components/hue/Hue.js
var _extends12 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var HuePicker = function HuePicker2(_ref) {
  var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles = (0, import_reactcss24.default)({
    "default": {
      picker: {
        position: "relative",
        width,
        height
      },
      hue: {
        radius: "2px"
      }
    }
  });
  var handleChange = function handleChange2(data) {
    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
  };
  return import_react70.default.createElement(
    "div",
    { style: styles.picker, className: "hue-picker " + className },
    import_react70.default.createElement(Hue_default, _extends12({}, styles.hue, {
      hsl,
      pointer,
      onChange: handleChange,
      direction
    }))
  );
};
HuePicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: HuePointer_default
};
var Hue_default2 = ColorWrap_default(HuePicker);

// ../../node_modules/react-color/lib/components/material/Material.js
init_cjs_shims();
var import_react71 = __toESM(require("react"));
var import_reactcss25 = __toESM(require_lib());
var Material = function Material2(_ref) {
  var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles = (0, import_reactcss25.default)({
    "default": {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + hex,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  });
  var handleChange = function handleChange2(data, e) {
    if (data.hex) {
      color_default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: "hex"
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: "rgb"
      }, e);
    }
  };
  return import_react71.default.createElement(
    Raised_default,
    null,
    import_react71.default.createElement(
      "div",
      { style: styles.material, className: "material-picker " + className },
      import_react71.default.createElement(EditableInput_default, {
        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
        label: "hex",
        value: hex,
        onChange: handleChange
      }),
      import_react71.default.createElement(
        "div",
        { style: styles.split, className: "flexbox-fix" },
        import_react71.default.createElement(
          "div",
          { style: styles.third },
          import_react71.default.createElement(EditableInput_default, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: "r",
            value: rgb.r,
            onChange: handleChange
          })
        ),
        import_react71.default.createElement(
          "div",
          { style: styles.third },
          import_react71.default.createElement(EditableInput_default, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: "g",
            value: rgb.g,
            onChange: handleChange
          })
        ),
        import_react71.default.createElement(
          "div",
          { style: styles.third },
          import_react71.default.createElement(EditableInput_default, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: "b",
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};
var Material_default = ColorWrap_default(Material);

// ../../node_modules/react-color/lib/components/photoshop/Photoshop.js
init_cjs_shims();
var import_react77 = __toESM(require("react"));
var import_prop_types11 = __toESM(require_prop_types());
var import_reactcss31 = __toESM(require_lib());

// ../../node_modules/react-color/lib/components/photoshop/PhotoshopFields.js
init_cjs_shims();
var import_react72 = __toESM(require("react"));
var import_reactcss26 = __toESM(require_lib());
var PhotoshopPicker = function PhotoshopPicker2(_ref) {
  var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
  var styles = (0, import_reactcss26.default)({
    "default": {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  });
  var handleChange = function handleChange2(data, e) {
    if (data["#"]) {
      color_default.isValidHex(data["#"]) && onChange({
        hex: data["#"],
        source: "hex"
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: "rgb"
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: "hsv"
      }, e);
    }
  };
  return import_react72.default.createElement(
    "div",
    { style: styles.fields },
    import_react72.default.createElement(EditableInput_default, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: "h",
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    import_react72.default.createElement(EditableInput_default, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: "s",
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    import_react72.default.createElement(EditableInput_default, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: "v",
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    import_react72.default.createElement("div", { style: styles.divider }),
    import_react72.default.createElement(EditableInput_default, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: "r",
      value: rgb.r,
      onChange: handleChange
    }),
    import_react72.default.createElement(EditableInput_default, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: "g",
      value: rgb.g,
      onChange: handleChange
    }),
    import_react72.default.createElement(EditableInput_default, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: "b",
      value: rgb.b,
      onChange: handleChange
    }),
    import_react72.default.createElement("div", { style: styles.divider }),
    import_react72.default.createElement(EditableInput_default, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: "#",
      value: hex.replace("#", ""),
      onChange: handleChange
    }),
    import_react72.default.createElement(
      "div",
      { style: styles.fieldSymbols },
      import_react72.default.createElement(
        "div",
        { style: styles.symbol },
        "\xB0"
      ),
      import_react72.default.createElement(
        "div",
        { style: styles.symbol },
        "%"
      ),
      import_react72.default.createElement(
        "div",
        { style: styles.symbol },
        "%"
      )
    )
  );
};
var PhotoshopFields_default = PhotoshopPicker;

// ../../node_modules/react-color/lib/components/photoshop/PhotoshopPointerCircle.js
init_cjs_shims();
var import_react73 = __toESM(require("react"));
var import_reactcss27 = __toESM(require_lib());
var PhotoshopPointerCircle = function PhotoshopPointerCircle2(_ref) {
  var hsl = _ref.hsl;
  var styles = (0, import_reactcss27.default)({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, { "black-outline": hsl.l > 0.5 });
  return import_react73.default.createElement("div", { style: styles.picker });
};
var PhotoshopPointerCircle_default = PhotoshopPointerCircle;

// ../../node_modules/react-color/lib/components/photoshop/PhotoshopPointer.js
init_cjs_shims();
var import_react74 = __toESM(require("react"));
var import_reactcss28 = __toESM(require_lib());
var PhotoshopPointerCircle3 = function PhotoshopPointerCircle4() {
  var styles = (0, import_reactcss28.default)({
    "default": {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return import_react74.default.createElement(
    "div",
    { style: styles.pointer },
    import_react74.default.createElement(
      "div",
      { style: styles.left },
      import_react74.default.createElement("div", { style: styles.leftInside })
    ),
    import_react74.default.createElement(
      "div",
      { style: styles.right },
      import_react74.default.createElement("div", { style: styles.rightInside })
    )
  );
};
var PhotoshopPointer_default = PhotoshopPointerCircle3;

// ../../node_modules/react-color/lib/components/photoshop/PhotoshopButton.js
init_cjs_shims();
var import_react75 = __toESM(require("react"));
var import_reactcss29 = __toESM(require_lib());
var PhotoshopBotton = function PhotoshopBotton2(_ref) {
  var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
  var styles = (0, import_reactcss29.default)({
    "default": {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    "active": {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, { active });
  return import_react75.default.createElement(
    "div",
    { style: styles.button, onClick },
    label || children
  );
};
var PhotoshopButton_default = PhotoshopBotton;

// ../../node_modules/react-color/lib/components/photoshop/PhotoshopPreviews.js
init_cjs_shims();
var import_react76 = __toESM(require("react"));
var import_reactcss30 = __toESM(require_lib());
var PhotoshopPreviews = function PhotoshopPreviews2(_ref) {
  var rgb = _ref.rgb, currentColor = _ref.currentColor;
  var styles = (0, import_reactcss30.default)({
    "default": {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + rgb.r + "," + rgb.g + ", " + rgb.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: currentColor,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return import_react76.default.createElement(
    "div",
    null,
    import_react76.default.createElement(
      "div",
      { style: styles.label },
      "new"
    ),
    import_react76.default.createElement(
      "div",
      { style: styles.swatches },
      import_react76.default.createElement("div", { style: styles.new }),
      import_react76.default.createElement("div", { style: styles.current })
    ),
    import_react76.default.createElement(
      "div",
      { style: styles.label },
      "current"
    )
  );
};
var PhotoshopPreviews_default = PhotoshopPreviews;

// ../../node_modules/react-color/lib/components/photoshop/Photoshop.js
var _createClass7 = function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn8(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Photoshop = function(_React$Component) {
  _inherits8(Photoshop2, _React$Component);
  function Photoshop2(props) {
    _classCallCheck8(this, Photoshop2);
    var _this = _possibleConstructorReturn8(this, (Photoshop2.__proto__ || Object.getPrototypeOf(Photoshop2)).call(this));
    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }
  _createClass7(Photoshop2, [{
    key: "render",
    value: function render3() {
      var _props$className = this.props.className, className = _props$className === void 0 ? "" : _props$className;
      var styles = (0, import_reactcss31.default)({
        "default": {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      });
      return import_react77.default.createElement(
        "div",
        { style: styles.picker, className: "photoshop-picker " + className },
        import_react77.default.createElement(
          "div",
          { style: styles.head },
          this.props.header
        ),
        import_react77.default.createElement(
          "div",
          { style: styles.body, className: "flexbox-fix" },
          import_react77.default.createElement(
            "div",
            { style: styles.saturation },
            import_react77.default.createElement(Saturation_default, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: PhotoshopPointerCircle_default,
              onChange: this.props.onChange
            })
          ),
          import_react77.default.createElement(
            "div",
            { style: styles.hue },
            import_react77.default.createElement(Hue_default, {
              direction: "vertical",
              hsl: this.props.hsl,
              pointer: PhotoshopPointer_default,
              onChange: this.props.onChange
            })
          ),
          import_react77.default.createElement(
            "div",
            { style: styles.controls },
            import_react77.default.createElement(
              "div",
              { style: styles.top, className: "flexbox-fix" },
              import_react77.default.createElement(
                "div",
                { style: styles.previews },
                import_react77.default.createElement(PhotoshopPreviews_default, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              import_react77.default.createElement(
                "div",
                { style: styles.actions },
                import_react77.default.createElement(PhotoshopButton_default, { label: "OK", onClick: this.props.onAccept, active: true }),
                import_react77.default.createElement(PhotoshopButton_default, { label: "Cancel", onClick: this.props.onCancel }),
                import_react77.default.createElement(PhotoshopFields_default, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);
  return Photoshop2;
}(import_react77.default.Component);
Photoshop.propTypes = {
  header: import_prop_types11.default.string
};
Photoshop.defaultProps = {
  header: "Color Picker"
};
var Photoshop_default = ColorWrap_default(Photoshop);

// ../../node_modules/react-color/lib/components/sketch/Sketch.js
init_cjs_shims();
var import_react80 = __toESM(require("react"));
var import_prop_types13 = __toESM(require_prop_types());
var import_reactcss34 = __toESM(require_lib());

// ../../node_modules/react-color/lib/components/sketch/SketchFields.js
init_cjs_shims();
var import_react78 = __toESM(require("react"));
var import_reactcss32 = __toESM(require_lib());
var SketchFields = function SketchFields2(_ref) {
  var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
  var styles = (0, import_reactcss32.default)({
    "default": {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    "disableAlpha": {
      alpha: {
        display: "none"
      }
    }
  }, { disableAlpha });
  var handleChange = function handleChange2(data, e) {
    if (data.hex) {
      color_default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: "hex"
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: "rgb"
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }
      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: "rgb"
      }, e);
    }
  };
  return import_react78.default.createElement(
    "div",
    { style: styles.fields, className: "flexbox-fix" },
    import_react78.default.createElement(
      "div",
      { style: styles.double },
      import_react78.default.createElement(EditableInput_default, {
        style: { input: styles.input, label: styles.label },
        label: "hex",
        value: hex.replace("#", ""),
        onChange: handleChange
      })
    ),
    import_react78.default.createElement(
      "div",
      { style: styles.single },
      import_react78.default.createElement(EditableInput_default, {
        style: { input: styles.input, label: styles.label },
        label: "r",
        value: rgb.r,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    import_react78.default.createElement(
      "div",
      { style: styles.single },
      import_react78.default.createElement(EditableInput_default, {
        style: { input: styles.input, label: styles.label },
        label: "g",
        value: rgb.g,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    import_react78.default.createElement(
      "div",
      { style: styles.single },
      import_react78.default.createElement(EditableInput_default, {
        style: { input: styles.input, label: styles.label },
        label: "b",
        value: rgb.b,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    import_react78.default.createElement(
      "div",
      { style: styles.alpha },
      import_react78.default.createElement(EditableInput_default, {
        style: { input: styles.input, label: styles.label },
        label: "a",
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "100"
      })
    )
  );
};
var SketchFields_default = SketchFields;

// ../../node_modules/react-color/lib/components/sketch/SketchPresetColors.js
init_cjs_shims();
var import_react79 = __toESM(require("react"));
var import_prop_types12 = __toESM(require_prop_types());
var import_reactcss33 = __toESM(require_lib());
var _extends13 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var SketchPresetColors = function SketchPresetColors2(_ref) {
  var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
  var styles = (0, import_reactcss33.default)({
    "default": {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !colors || !colors.length
  });
  var handleClick = function handleClick2(hex, e) {
    onClick({
      hex,
      source: "hex"
    }, e);
  };
  return import_react79.default.createElement(
    "div",
    { style: styles.colors, className: "flexbox-fix" },
    colors.map(function(colorObjOrString) {
      var c = typeof colorObjOrString === "string" ? { color: colorObjOrString } : colorObjOrString;
      return import_react79.default.createElement(
        "div",
        { key: c.color, style: styles.swatchWrap },
        import_react79.default.createElement(Swatch_default, _extends13({}, c, {
          style: styles.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
          }
        }))
      );
    })
  );
};
SketchPresetColors.propTypes = {
  colors: import_prop_types12.default.arrayOf(import_prop_types12.default.oneOfType([import_prop_types12.default.string, import_prop_types12.default.shape({
    color: import_prop_types12.default.string,
    title: import_prop_types12.default.string
  })])).isRequired
};
var SketchPresetColors_default = SketchPresetColors;

// ../../node_modules/react-color/lib/components/sketch/Sketch.js
var Sketch = function Sketch2(_ref) {
  var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles = (0, import_reactcss34.default)({
    "default": {
      picker: {
        width,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    },
    "disableAlpha": {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, { disableAlpha });
  return import_react80.default.createElement(
    "div",
    { style: styles.picker, className: "sketch-picker " + className },
    import_react80.default.createElement(
      "div",
      { style: styles.saturation },
      import_react80.default.createElement(Saturation_default, {
        style: styles.Saturation,
        hsl,
        hsv,
        onChange
      })
    ),
    import_react80.default.createElement(
      "div",
      { style: styles.controls, className: "flexbox-fix" },
      import_react80.default.createElement(
        "div",
        { style: styles.sliders },
        import_react80.default.createElement(
          "div",
          { style: styles.hue },
          import_react80.default.createElement(Hue_default, {
            style: styles.Hue,
            hsl,
            onChange
          })
        ),
        import_react80.default.createElement(
          "div",
          { style: styles.alpha },
          import_react80.default.createElement(Alpha_default, {
            style: styles.Alpha,
            rgb,
            hsl,
            renderers,
            onChange
          })
        )
      ),
      import_react80.default.createElement(
        "div",
        { style: styles.color },
        import_react80.default.createElement(Checkboard_default, null),
        import_react80.default.createElement("div", { style: styles.activeColor })
      )
    ),
    import_react80.default.createElement(SketchFields_default, {
      rgb,
      hsl,
      hex,
      onChange,
      disableAlpha
    }),
    import_react80.default.createElement(SketchPresetColors_default, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover
    })
  );
};
Sketch.propTypes = {
  disableAlpha: import_prop_types13.default.bool,
  width: import_prop_types13.default.oneOfType([import_prop_types13.default.string, import_prop_types13.default.number])
};
Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
var Sketch_default = ColorWrap_default(Sketch);

// ../../node_modules/react-color/lib/components/slider/Slider.js
init_cjs_shims();
var import_react84 = __toESM(require("react"));
var import_reactcss38 = __toESM(require_lib());

// ../../node_modules/react-color/lib/components/slider/SliderSwatches.js
init_cjs_shims();
var import_react82 = __toESM(require("react"));
var import_reactcss36 = __toESM(require_lib());

// ../../node_modules/react-color/lib/components/slider/SliderSwatch.js
init_cjs_shims();
var import_react81 = __toESM(require("react"));
var import_reactcss35 = __toESM(require_lib());
var SliderSwatch = function SliderSwatch2(_ref) {
  var hsl = _ref.hsl, offset2 = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
  var styles = (0, import_reactcss35.default)({
    "default": {
      swatch: {
        height: "12px",
        background: "hsl(" + hsl.h + ", 50%, " + offset2 * 100 + "%)",
        cursor: "pointer"
      }
    },
    "first": {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    "last": {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    "active": {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, { active, first, last });
  var handleClick = function handleClick2(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset2,
      source: "hsl"
    }, e);
  };
  return import_react81.default.createElement("div", { style: styles.swatch, onClick: handleClick });
};
var SliderSwatch_default = SliderSwatch;

// ../../node_modules/react-color/lib/components/slider/SliderSwatches.js
var SliderSwatches = function SliderSwatches2(_ref) {
  var onClick = _ref.onClick, hsl = _ref.hsl;
  var styles = (0, import_reactcss36.default)({
    "default": {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return import_react82.default.createElement(
    "div",
    { style: styles.swatches },
    import_react82.default.createElement(
      "div",
      { style: styles.swatch },
      import_react82.default.createElement(SliderSwatch_default, {
        hsl,
        offset: ".80",
        active: Math.round(hsl.l * 100) / 100 === 0.8 && Math.round(hsl.s * 100) / 100 === 0.5,
        onClick,
        first: true
      })
    ),
    import_react82.default.createElement(
      "div",
      { style: styles.swatch },
      import_react82.default.createElement(SliderSwatch_default, {
        hsl,
        offset: ".65",
        active: Math.round(hsl.l * 100) / 100 === 0.65 && Math.round(hsl.s * 100) / 100 === 0.5,
        onClick
      })
    ),
    import_react82.default.createElement(
      "div",
      { style: styles.swatch },
      import_react82.default.createElement(SliderSwatch_default, {
        hsl,
        offset: ".50",
        active: Math.round(hsl.l * 100) / 100 === 0.5 && Math.round(hsl.s * 100) / 100 === 0.5,
        onClick
      })
    ),
    import_react82.default.createElement(
      "div",
      { style: styles.swatch },
      import_react82.default.createElement(SliderSwatch_default, {
        hsl,
        offset: ".35",
        active: Math.round(hsl.l * 100) / 100 === 0.35 && Math.round(hsl.s * 100) / 100 === 0.5,
        onClick
      })
    ),
    import_react82.default.createElement(
      "div",
      { style: styles.swatch },
      import_react82.default.createElement(SliderSwatch_default, {
        hsl,
        offset: ".20",
        active: Math.round(hsl.l * 100) / 100 === 0.2 && Math.round(hsl.s * 100) / 100 === 0.5,
        onClick,
        last: true
      })
    ),
    import_react82.default.createElement("div", { style: styles.clear })
  );
};
var SliderSwatches_default = SliderSwatches;

// ../../node_modules/react-color/lib/components/slider/SliderPointer.js
init_cjs_shims();
var import_react83 = __toESM(require("react"));
var import_reactcss37 = __toESM(require_lib());
var SliderPointer3 = function SliderPointer4() {
  var styles = (0, import_reactcss37.default)({
    "default": {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return import_react83.default.createElement("div", { style: styles.picker });
};
var SliderPointer_default = SliderPointer3;

// ../../node_modules/react-color/lib/components/slider/Slider.js
var Slider3 = function Slider4(_ref) {
  var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles = (0, import_reactcss38.default)({
    "default": {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  });
  return import_react84.default.createElement(
    "div",
    { className: "slider-picker " + className },
    import_react84.default.createElement(
      "div",
      { style: styles.hue },
      import_react84.default.createElement(Hue_default, {
        style: styles.Hue,
        hsl,
        pointer,
        onChange
      })
    ),
    import_react84.default.createElement(
      "div",
      { style: styles.swatches },
      import_react84.default.createElement(SliderSwatches_default, { hsl, onClick: onChange })
    )
  );
};
Slider3.defaultProps = {
  pointer: SliderPointer_default
};
var Slider_default = ColorWrap_default(Slider3);

// ../../node_modules/react-color/lib/components/swatches/Swatches.js
init_cjs_shims();
var import_react87 = __toESM(require("react"));
var import_prop_types14 = __toESM(require_prop_types());
var import_reactcss41 = __toESM(require_lib());
var import_map6 = __toESM(require_map());

// ../../node_modules/react-color/lib/components/swatches/SwatchesGroup.js
init_cjs_shims();
var import_react86 = __toESM(require("react"));
var import_reactcss40 = __toESM(require_lib());
var import_map5 = __toESM(require_map());

// ../../node_modules/react-color/lib/components/swatches/SwatchesColor.js
init_cjs_shims();
var import_react85 = __toESM(require("react"));
var import_reactcss39 = __toESM(require_lib());
var SwatchesColor = function SwatchesColor2(_ref) {
  var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
  var styles = (0, import_reactcss39.default)({
    "default": {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: color,
        marginBottom: "1px"
      },
      check: {
        fill: color_default.getContrastingColor(color),
        marginLeft: "8px",
        display: "none"
      }
    },
    "first": {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    "last": {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    "active": {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        fill: "#333"
      }
    },
    "transparent": {
      check: {
        fill: "#333"
      }
    }
  }, {
    first,
    last,
    active,
    "color-#FFFFFF": color === "#FFFFFF",
    "transparent": color === "transparent"
  });
  return import_react85.default.createElement(
    Swatch_default,
    {
      color,
      style: styles.color,
      onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: "0 0 4px " + color }
    },
    import_react85.default.createElement(
      "div",
      { style: styles.check },
      import_react85.default.createElement(
        "svg",
        { style: { width: "24px", height: "24px" }, viewBox: "0 0 24 24" },
        import_react85.default.createElement("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
      )
    )
  );
};
var SwatchesColor_default = SwatchesColor;

// ../../node_modules/react-color/lib/components/swatches/SwatchesGroup.js
var SwatchesGroup = function SwatchesGroup2(_ref) {
  var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
  var styles = (0, import_reactcss40.default)({
    "default": {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return import_react86.default.createElement(
    "div",
    { style: styles.group },
    (0, import_map5.default)(group, function(color, i) {
      return import_react86.default.createElement(SwatchesColor_default, {
        key: color,
        color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick,
        onSwatchHover
      });
    })
  );
};
var SwatchesGroup_default = SwatchesGroup;

// ../../node_modules/react-color/lib/components/swatches/Swatches.js
var Swatches = function Swatches2(_ref) {
  var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles = (0, import_reactcss41.default)({
    "default": {
      picker: {
        width,
        height
      },
      overflow: {
        height,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  var handleChange = function handleChange2(data, e) {
    color_default.isValidHex(data) && onChange({
      hex: data,
      source: "hex"
    }, e);
  };
  return import_react87.default.createElement(
    "div",
    { style: styles.picker, className: "swatches-picker " + className },
    import_react87.default.createElement(
      Raised_default,
      null,
      import_react87.default.createElement(
        "div",
        { style: styles.overflow },
        import_react87.default.createElement(
          "div",
          { style: styles.body },
          (0, import_map6.default)(colors, function(group) {
            return import_react87.default.createElement(SwatchesGroup_default, {
              key: group.toString(),
              group,
              active: hex,
              onClick: handleChange,
              onSwatchHover
            });
          }),
          import_react87.default.createElement("div", { style: styles.clear })
        )
      )
    )
  );
};
Swatches.propTypes = {
  width: import_prop_types14.default.oneOfType([import_prop_types14.default.string, import_prop_types14.default.number]),
  height: import_prop_types14.default.oneOfType([import_prop_types14.default.string, import_prop_types14.default.number]),
  colors: import_prop_types14.default.arrayOf(import_prop_types14.default.arrayOf(import_prop_types14.default.string))
};
Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[red["900"], red["700"], red["500"], red["300"], red["100"]], [pink["900"], pink["700"], pink["500"], pink["300"], pink["100"]], [purple["900"], purple["700"], purple["500"], purple["300"], purple["100"]], [deepPurple["900"], deepPurple["700"], deepPurple["500"], deepPurple["300"], deepPurple["100"]], [indigo["900"], indigo["700"], indigo["500"], indigo["300"], indigo["100"]], [blue["900"], blue["700"], blue["500"], blue["300"], blue["100"]], [lightBlue["900"], lightBlue["700"], lightBlue["500"], lightBlue["300"], lightBlue["100"]], [cyan["900"], cyan["700"], cyan["500"], cyan["300"], cyan["100"]], [teal["900"], teal["700"], teal["500"], teal["300"], teal["100"]], ["#194D33", green["700"], green["500"], green["300"], green["100"]], [lightGreen["900"], lightGreen["700"], lightGreen["500"], lightGreen["300"], lightGreen["100"]], [lime["900"], lime["700"], lime["500"], lime["300"], lime["100"]], [yellow["900"], yellow["700"], yellow["500"], yellow["300"], yellow["100"]], [amber["900"], amber["700"], amber["500"], amber["300"], amber["100"]], [orange["900"], orange["700"], orange["500"], orange["300"], orange["100"]], [deepOrange["900"], deepOrange["700"], deepOrange["500"], deepOrange["300"], deepOrange["100"]], [brown["900"], brown["700"], brown["500"], brown["300"], brown["100"]], [blueGrey["900"], blueGrey["700"], blueGrey["500"], blueGrey["300"], blueGrey["100"]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]]
};
var Swatches_default = ColorWrap_default(Swatches);

// ../../node_modules/react-color/lib/components/twitter/Twitter.js
init_cjs_shims();
var import_react88 = __toESM(require("react"));
var import_prop_types15 = __toESM(require_prop_types());
var import_reactcss42 = __toESM(require_lib());
var import_map7 = __toESM(require_map());
var Twitter = function Twitter2(_ref) {
  var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles = (0, import_reactcss42.default)({
    "default": {
      card: {
        width,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, {
    "hide-triangle": triangle === "hide",
    "top-left-triangle": triangle === "top-left",
    "top-right-triangle": triangle === "top-right"
  });
  var handleChange = function handleChange2(hexcode, e) {
    color_default.isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: "hex"
    }, e);
  };
  return import_react88.default.createElement(
    "div",
    { style: styles.card, className: "twitter-picker " + className },
    import_react88.default.createElement("div", { style: styles.triangleShadow }),
    import_react88.default.createElement("div", { style: styles.triangle }),
    import_react88.default.createElement(
      "div",
      { style: styles.body },
      (0, import_map7.default)(colors, function(c, i) {
        return import_react88.default.createElement(Swatch_default, {
          key: i,
          color: c,
          hex: c,
          style: styles.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: "0 0 4px " + c
          }
        });
      }),
      import_react88.default.createElement(
        "div",
        { style: styles.hash },
        "#"
      ),
      import_react88.default.createElement(EditableInput_default, {
        style: { input: styles.input },
        value: hex.replace("#", ""),
        onChange: handleChange
      }),
      import_react88.default.createElement("div", { style: styles.clear })
    )
  );
};
Twitter.propTypes = {
  width: import_prop_types15.default.oneOfType([import_prop_types15.default.string, import_prop_types15.default.number]),
  triangle: import_prop_types15.default.oneOf(["hide", "top-left", "top-right"]),
  colors: import_prop_types15.default.arrayOf(import_prop_types15.default.string)
};
Twitter.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left"
};
var Twitter_default = ColorWrap_default(Twitter);

// src/components/ColorPicker/ColorPicker.style.tsx
var StyledChromePicker = (0, import_styled_components14.default)(Chrome_default)`
  width: 100% !important;
  padding: 0 !important;
  box-shadow: none !important;
  font-family: ${({ theme }) => theme.typography.fontFamily} !important;

  &.chrome-picker {
    // controls wrapper
    div:nth-child(2) {
      padding-left: 0 !important;
      padding-right: 0 !important;
      // color type switch wrapper
      & > div:nth-child(2) {
        // color type switch
        & > div:nth-child(1) {
          margin-right: -0.6rem !important;
          margin-top: 0 !important;
        }
      }
    }
  }
`;
var StyledColorPicker = import_styled_components14.default.div``;

// src/components/ColorPicker/ColorPicker.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var ColorPicker = ({
  toggler: Toggler = import_ui55.PrimaryButton,
  initialColor = "",
  ...props
}) => {
  const [color, setColor] = (0, import_react89.useState)(initialColor);
  const { t } = (0, import_react_i18next50.useTranslation)();
  const close = () => {
    props.setIsOpen(false);
    props.onClose && props.onClose();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledColorPicker, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Toggler, {
        onClick: () => {
          props.setIsOpen(true);
          props.onOpen && props.onOpen();
        },
        children: props.children
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui55.Modal, {
        setIsOpen: props.setIsOpen,
        isOpen: props.isOpen,
        toggle: close,
        size: props.size,
        backdrop: props.backdrop,
        components: !props.onSave ? void 0 : {
          Footer: () => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui55.PrimaryButton, {
            onClick: () => props.onSave(color, close),
            children: t("common.save")
          })
        },
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledChromePicker, {
          className: props.className,
          disableAlpha: true,
          color: color || void 0,
          onChangeComplete: ({ hex }) => {
            setColor(hex);
            props.onChangeComplete && props.onChangeComplete(hex, close);
          },
          onChange: ({ hex }) => {
            setColor(hex);
            props.onChange && props.onChange(hex);
          }
        })
      })
    ]
  });
};
var ColorPicker_default = (0, import_ui55.withModal)(ColorPicker);

// src/components/ColorPickerInput/ColorPickerInput.style.tsx
init_cjs_shims();
var import_styled_components15 = __toESM(require("styled-components"));
var import_ui56 = require("@btc-snxt/ui");
var COLORS_PER_ROW = 6;
var GAPS_PER_ROW = COLORS_PER_ROW - 1;
var COLORS_GAP = "0.4rem";
var DROPDOWN_MENU_HORIZONTAL_PADDING = "2rem";
var StyledFormDropdown = (0, import_styled_components15.default)(import_ui56.FormDropdown)`
  .dropdown-menu {
    min-width: calc(
      (${import_ui56.COLOR_INPUT_SIZE} + ${COLORS_GAP}) * ${COLORS_PER_ROW} +
        ${DROPDOWN_MENU_HORIZONTAL_PADDING}
    );
  }
`;
var FlexLabel = import_styled_components15.default.span`
  ${import_ui56.centeredFlexbox};
  gap: 0.4rem;
`;
var SelectedColorTextInput = (0, import_styled_components15.default)(import_ui56.Input)`
  border-radius: 0.2rem;
`;
var SelectedColorRadioInput = (0, import_styled_components15.default)(import_ui56.ColorRadioInput)`
  height: 2.438rem;
  flex: 0 0 2.438rem;
`;
var SelectedColorRow = import_styled_components15.default.div`
  display: flex;
  gap: 0.4rem;
`;
var CommonColorsWrapper = import_styled_components15.default.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${COLORS_GAP};
  padding-top: 2rem;

  & > * {
    flex-basis: calc((100% - ${GAPS_PER_ROW} * ${COLORS_GAP}) / ${COLORS_PER_ROW});
  }
`;
var CommonColorWrapper = import_styled_components15.default.div`
  ${import_ui56.centeredFlexbox};
`;
var MoreColorsWrapper = import_styled_components15.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
`;

// src/components/ColorPickerInput/ColorPickerInput.tsx
var import_react_i18next51 = require("react-i18next");
var import_jsx_runtime = require("react/jsx-runtime");
var ColorPickerInput = ({
  name,
  onChange,
  onBlur,
  value,
  ...props
}) => {
  const [color, setColor] = (0, import_react90.useState)(value ? value.toString() : "");
  const [isColorPickerOpen, setIsColorPickerOpen] = (0, import_react90.useState)(false);
  (0, import_react90.useEffect)(() => {
    setColor(value);
  }, [value]);
  const hiddenRef = (0, import_react90.useRef)(null);
  const { t } = (0, import_react_i18next51.useTranslation)();
  const toggle = () => {
    if (isColorPickerOpen) {
      return;
    }
    props.setIsOpen(!props.isOpen);
  };
  const handleColorChange = (hex) => {
    setColor(hex);
    if (props.setGlobalColor)
      props.setGlobalColor(hex);
    if (hiddenRef.current) {
      (0, import_ui57.setNativeHtmlInputValue)(hiddenRef.current, hex);
      hiddenRef.current.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };
  const commonColors = Object.values(import_ui57.Theme.colors);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledFormDropdown, {
    label: () => {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(FlexLabel, {
        children: [
          props.children,
          !!color && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui57.ColorRadioInput, {
            value: color,
            readOnly: true
          })
        ]
      });
    },
    isOpen: props.isOpen,
    toggle,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SelectedColorRow, {
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectedColorRadioInput, {
            value: color,
            readOnly: true
          }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SelectedColorTextInput, {
            readOnly: true,
            value: color
          })
        ]
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CommonColorsWrapper, {
        children: commonColors.map((hex, index2) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CommonColorWrapper, {
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui57.ColorRadioInput, {
            value: hex,
            onClick: () => handleColorChange(hex)
          })
        }, index2))
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(MoreColorsWrapper, {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorPicker_default, {
          initialColor: color,
          toggler: import_ui57.FunctionalButton,
          onSave: (hex, close) => {
            handleColorChange(hex);
            close();
          },
          onOpen: () => {
            setIsColorPickerOpen(true);
          },
          onClose: () => {
            setIsColorPickerOpen(false);
          },
          children: t("survey.form.more_colors")
        })
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("input", {
        className: "d-none",
        name,
        onChange,
        onBlur,
        value,
        type: "text",
        ref: hiddenRef
      })
    ]
  });
};
var ColorPickerInput_default = (0, import_ui57.withModal)(ColorPickerInput);

// src/components/LoadingOverlay/index.ts
init_cjs_shims();

// src/components/LoadingOverlay/LoadingOverlay.tsx
init_cjs_shims();

// src/components/LoadingOverlay/LoadingOverlay.style.tsx
init_cjs_shims();
var import_ui58 = require("@btc-snxt/ui");
var import_styled_components16 = __toESM(require("styled-components"));
var StyledModal = (0, import_styled_components16.default)(import_ui58.Modal)`
  .modal-content {
    background: transparent;
    box-shadow: none;
    border: none;
  }
`;

// src/components/LoadingOverlay/LoadingOverlay.tsx
var import_ui59 = require("@btc-snxt/ui");
var import_jsx_runtime = require("react/jsx-runtime");
var LoadingOverlay = (props) => {
  const handleOpen = async () => {
    props.setIsLoading(true);
    props.setIsLoading(false);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, {
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(StyledModal, {
      ...props,
      onOpened: handleOpen,
      centered: true,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui59.CenteredSpinner, {})
    })
  });
};
var LoadingOverlay_default = (0, import_ui59.withLoader)(LoadingOverlay);

// src/components/NavigationButtons/index.ts
init_cjs_shims();
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ActionItemWrapper,
  ColorPickerInput,
  ContinueButtonPreviewerWrapper,
  Designer,
  DesignerContext,
  ExplanationTranslatable,
  ExtraItemDesigner,
  ExtraItemDesignerPreviewer,
  ExtraItemPreviewer,
  FieldPreviewer,
  FileUpload,
  FileUploadMedium,
  FontFamily,
  FontSize,
  FontWeight,
  HeaderWrapper,
  IntroItemDesigner,
  IntroItemDesignerPreviewer,
  IntroItemPreviewer,
  LanguageDropdownWrapper,
  LikertQuestionItemDesigner,
  LinearProgressBar,
  LoadingOverlay,
  LogoFieldPreviewer,
  MatrixQuestionsWrapper,
  MatrixSurveyQuestionAndTitleContent,
  MatrixSurveyWrapper,
  MultiSelectionQuestionItemDesigner,
  MultiSelectionQuestionItemDesignerPreviewer,
  MultiSelectionQuestionItemPreviewer,
  NavigationButtons,
  OpinionScaleQuestionItemDesigner,
  OpinionScaleQuestionItemDesignerPreviewer,
  OpinionScaleQuestionItemPreviewer,
  OpinionScaleType,
  OptionsAndExplanationsWrapper,
  OutroItemPreviewer,
  PoweredBySeeNext,
  Previewer,
  PreviewerContext,
  ScaleFieldPreviewer,
  SingleSelectionQuestionItemDesigner,
  SingleSelectionQuestionItemDesignerPreviewer,
  SingleSelectionQuestionItemPreviewer,
  StyledAnswerPreviewerGroup,
  StyledAnswerPreviewerGroupWrapper,
  StyledAnswerPreviewerOpinionScaleGroup,
  StyledDesignerPreviewer,
  StyledDesignerPreviewerBackgroundColor,
  StyledDesignerPreviewerBody,
  StyledDesignerPreviewerFooter,
  StyledDesignerPreviewerGroup,
  StyledDesignerPreviewerOpinionScaleGroup,
  StyledDesignerQuestionPreviewerBody,
  StyledExplanationRow,
  StyledExplanationText,
  StyledExplanations,
  StyledFieldDesignerPreviewer,
  StyledFieldPreviewer,
  StyledFormGroupDesignerPreviewer,
  StyledFormGroupPreviewer,
  StyledFormikErrorMessage,
  StyledIconButtonNext,
  StyledIconButtonPrevious,
  StyledIconStar,
  StyledInputDesignerPreviewer,
  StyledInputDesignerPreviewerWrapper,
  StyledInputFieldDesignerPreviewer,
  StyledInputFieldPreviewer,
  StyledInputPreviewer,
  StyledInputPreviewerWrapper,
  StyledIntroPage,
  StyledIntroPagePreviewer,
  StyledIntroSubtext,
  StyledLabelDesignerPreviewer,
  StyledLabelPreviewer,
  StyledLikertAnswerPreviewerGroupWrapper,
  StyledLikertDesignerPreviewer,
  StyledLikertFormGroupPreviewer,
  StyledLikertSelectFieldDesignerPreviewer,
  StyledLikertTitle,
  StyledLogo,
  StyledLogoDesignerPreviewer,
  StyledLogoImageDesignerPreviewer,
  StyledLogoImagePreviewer,
  StyledLogoPreviewer,
  StyledMatrixDesignerPreviewer,
  StyledMatrixDesignerQuestionPreviewerBody,
  StyledMultiSelect,
  StyledMultiSelectFormGroupPreviewer,
  StyledNavigationButtons,
  StyledOpinionScaleAnswerPreviewerGroupWrapper,
  StyledOpinionScaleDesignerPreviewer,
  StyledOutroPreviewerBody,
  StyledPoweredBySeeNext,
  StyledPoweredBySeeNextDesignerPreviewer,
  StyledPoweredBySeeNextImage,
  StyledPoweredBySeeNextImageDesignerPreviewer,
  StyledPreviewer,
  StyledPreviewerBody,
  StyledPreviewerFooter,
  StyledPreviewerGroup,
  StyledPrivacyPolicy,
  StyledPrivacyPolicySmall,
  StyledQuestionTitle,
  StyledScaleEmotionItemDesignerPreviewer,
  StyledScaleEmotionItemPreviewer,
  StyledScaleFieldDesignerPreviewer,
  StyledScaleFieldItemDesignerPreviewerWrapper,
  StyledScaleFieldItemPreviewerWrapper,
  StyledScaleFieldPreviewer,
  StyledScaleItemDesignerPreviewer,
  StyledScaleItemPreviewer,
  StyledScaleNumberItemDesignerPreviewer,
  StyledScaleNumberItemPreviewer,
  StyledScaleStarItemDesignerPreviewer,
  StyledScaleStarItemPreviewer,
  StyledSelectFieldDesignerPreviewer,
  StyledSingleSelectDesignerPreviewer,
  StyledSliderItemDesignerPreviewer,
  StyledStarScaleFieldDesignerPreviewer,
  StyledStarScaleFieldItemDesignerPreviewerWrapper,
  StyledSubtext,
  StyledTextAreaFieldDesignerPreviewer,
  StyledTextAreaFieldPreviewer,
  StyledTextInputPreviewerGroup,
  StyledTitle,
  StyledTranslatableTextAreaFieldPreviewer,
  SubmitButtonPreviewerWrapper,
  SurveyItemType,
  SurveyQuestionAndTitleContainer,
  SurveyQuestionAndTitleContent,
  SurveyQuestionTitleIndex,
  SurveyType,
  TextQuestionItemDesigner,
  TextQuestionItemDesignerPreviewer,
  TextQuestionItemPreviewer,
  TranslatableFieldPreviewer,
  TranslatableInputFieldPreviewer,
  TranslatableMultiSelectionFieldPreviewer,
  TranslatableSingleSelectionFieldPreviewer,
  TranslatableTextAreaFieldPreviewer,
  emptyExtraItemDesignerInitialValues,
  emptyExtraItemPreviewerInitialValues,
  emptyIntroItemDesignerInitialValues,
  emptyIntroItemPreviewerInitialValues,
  emptyLikertItemDesignerInitialValues,
  emptyMultiSelectionItemDesignerInitialValues,
  emptyMultiSelectionItemPreviewerInitialValues,
  emptyOpinionScaleQuestionItemDesignerInitialValues,
  emptyOpinionScaleQuestionItemPreviewerInitialValues,
  emptyOutroItemPreviewerInitialValues,
  emptySingleSelectionItemDesignerInitialValues,
  emptySingleSelectionItemPreviewerInitialValues,
  emptyTextItemPreviewerInitialValues,
  emptyTextQuestionItemDesignerInitialValues,
  getElementInCenter,
  getSurveyItemIndex,
  getSurveyItemsSize,
  hexToRGB,
  moveItemInArray,
  useDesigner,
  usePreviewer,
  useScrollPosition,
  useSurveyNavigationStore,
  useSurveyPreviewerStore
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
